import {
  Duration__minus_impl_q5cfm73tf66w97h2wg9 as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f2as9k1ghoc0eo as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f1g201z2whmah8 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  Duration__toString_impl_8d916b1rke7yypzm7mk as Duration__toString_impl_8d916b,
  constructCallableReference23y65rf941mch as constructCallableReference,
  ValueTimeMark__elapsedNow_impl_eonqvs593ou6p5l5hu as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  Monotonic_instance2att21stfwfpk as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Enum3alwj03lh1n41 as Enum,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  toString336ienavfnzn0 as toString_0,
  Char__hashCode_impl_otmys90ye9a3qq8t6 as Char__hashCode_impl_otmys,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  StringBuildermazzzhj6kkai as StringBuilder,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1ztf3w4az04w2 as Companion_getInstance_0,
  fromInt1lka3ktyu79a4 as fromInt,
  bitwiseAnd2g7wmsfd45l12 as bitwiseAnd,
  shiftLeft1ck77p6vapyra as shiftLeft,
  bitwiseOr1ita6dahwp8zb as bitwiseOr,
  equalsLong28bsrfhwvd686 as equalsLong,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong345n6tb1n1i71 as numberToLong,
  add85si75olwt6n as add,
  println2shhhgwwt4c61 as println,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  charCodeAt1yspne1d8erbm as charCodeAt,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  subtract16cg4lfi29fq9 as subtract,
  compare2uud5j30pw5xc as compare,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance2wsqunjuleo79 as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  mapOf1xd03cq9cnmy8 as mapOf,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instance168r08gkbpepf as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance2moeotkerjghe as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp17ek9bs2u9cd6 as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  toNumberlmbpvqo27r53 as toNumber,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  KProperty02ce7r476m8633 as KProperty0,
  PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
  getKClass3t8tygqu4lcxf as getKClass,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  convertToIntofdoxh9bstof as convertToInt,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstanceuu53upbo641n as Console_getInstance,
  Companion_getInstance3f9e8v90vvgdj as Companion_getInstance_1,
  Level_INFO_getInstance2u0wredwjoo6m as Level_INFO_getInstance,
  Level_ERROR_getInstance1195cgr5fzwj1 as Level_ERROR_getInstance,
  Level_TRACE_getInstance3nszimn1b6jmz as Level_TRACE_getInstance,
  Level_DEBUG_getInstance1gtvuokzl9cp4 as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstance2on3idagepyxv as Level_WARN_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance2cv0yc0w9i6vs as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  Companion_getInstance1ju3fwn4mt9wh as Companion_getInstance_2,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instanceubj3e1ju0kss as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstancel0h9d9tr3c15 as Companion_getInstance_3,
  Os_UNKNOWN_getInstance3c2e0nugjslqw as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  DenoPointerpb0vypijx63v as DenoPointer,
  get_pointerlkbwhoqlhapz as get_pointer,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Companion_getInstance1mhteccb9s8gp as Companion_getInstance_4,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstancepzu5ca8urjqj as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  BoundsBuilder__plus_impl_cz7f7xgidk87zsybva as BoundsBuilder__plus_impl_cz7f7x,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1ath7o4bn4ut as Companion_getInstance_6,
  Companion_getInstance45f4wj6tp63r as Companion_getInstance_7,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instance29i2v8geu7jl9 as Companion_instance_2,
  interpolatewhd2sgxffql5 as interpolate,
  interpolateAngleNormalized3h8mzdshuvgea as interpolateAngleNormalized,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y23l6wmhpsc1jdf as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance9zqhf8dpcsyh as Companion_getInstance_8,
  DateTime__hashCode_impl_yf0bc91uk36yk65yixv as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr1l01ah1ruothm as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va1resq1b2qoqfm as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs2371up2plcsbrg6i as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj7xnw2bvpwwoqp as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance3359c3vnzyc2p as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab2deeoiodbc4f9 as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration__hashCode_impl_y13la63qm2cv3kcb34r as FastDuration__hashCode_impl_y13la6,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  FastDuration__minus_impl_evs2373tu2z52vjijn3 as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  minus2npwq73u0d9yx as minus,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab3kdm0b7szm5xr as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb1l0tyd64jtg5n as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  Companion_getInstance2birn9imkruen as Companion_getInstance_9,
  clonelcrqoxe4ne5i as clone,
  Companion_instance3nd7lb5y5x9nc as Companion_instance_4,
  _Int8Buffer___init__impl__e20lvc1uxb02cec5h7 as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulb212vj8jj34yk6 as _Int8Buffer___get_buffer__impl__q0gulb,
  _Float32Buffer___init__impl__403k2m26kpmn3jn9766 as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9x318r0i4ytjupn as _Float32Buffer___get_buffer__impl__x5nu9x,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  ByteUnits__toString_impl_ox2ku214nbr4e7vbgkn as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  arrayequal25g4om83vd8w1 as arrayequal,
  getS8Array37elyr0qhrpi8 as getS8Array,
  getF32Array3bpq574bgh35w as getF32Array,
  getS32Array38egwts6rsd12 as getS32Array,
  copyOfnqvdm0sc8lk as copyOf,
  setArrayLEwil75hzlfusu as setArrayLE,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliulc5gukztwaxh as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu1x3dejetpls19 as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34szne3r2rr4ely4rlt as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  insert32d422lnha9g5r as insert3,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  insert8f3zk23r8x9da as insert8,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  min1z074tc6jeruz as min,
  max1izmzj76cv5b4 as max_0,
  insert42sy0xc4ax89g9 as insert4,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstancevp821koktwyg as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn23v7lk04jh8pl2 as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate35pbs3ac913y4 as interpolate_0,
  interpolate2g7wzskc23f1q as interpolate_1,
  interpolate27vw5eh8zjnyi as interpolate_2,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dphy5yaenoheku as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf61f7mvf3brfggb as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k3ulh4acu9ex4c as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1yixpj8zlhxfr as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5ygo6edauwytiyj as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv2yz7cenba06b7 as _RGBA___get_af__impl__vu36qv,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaArray___init__impl__oib4y43p8q13pykzb2a as _RgbaArray___init__impl__oib4y4,
  _RGBAPremultiplied___get_rf__impl__pt0c4y37rs1zhk1filf as _RGBAPremultiplied___get_rf__impl__pt0c4y,
  _RGBAPremultiplied___get_gf__impl__ivron73pq6ucw516uw5 as _RGBAPremultiplied___get_gf__impl__ivron7,
  _RGBAPremultiplied___get_bf__impl__qa3on2147hgy4bstouc as _RGBAPremultiplied___get_bf__impl__qa3on2,
  _RGBAPremultiplied___get_af__impl__euwcjnisi9w6didku3 as _RGBAPremultiplied___get_af__impl__euwcjn,
  Colors_getInstance3pptco3oesytn as Colors_getInstance,
  Companion_instance3mv764rpympbk as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmapo6nrz66d4x8p as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instance32vng4qkr3hdi as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8v1qo6hdnmg6vpg as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  Bitmaps_instance7rskgm1vqxdg as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  Companion_getInstance3k5cs6pucdtn7 as Companion_getInstance_11,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance1wxuudhag44vb as Companion_getInstance_12,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay96dneiach7wb as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  cancelChildrennwartoz0yn6c as cancelChildren,
  delayvyed5wvki0ic as delay_0,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin21f2rd386nyt8 as cancelAndJoin,
  MainScope1gi1r4abhrtmm as MainScope,
  await3gx2tubo6ckuc as await_0,
} from './kotlinx-coroutines-core.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance18r9kjg2unqei as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance1wsp92tul7oln as Companion_getInstance_13,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  interpolatekgpa594f7x8f as interpolate_3,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-inject-root-korlibs-inject.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance1nd7bgkclrcrv as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  FFILiby83bova0zjfy as FFILib,
  Companion_getInstance3ngdpmt48px2k as Companion_getInstance_14,
  FuncInfocud0a7bce10z as FuncInfo,
  CreateFFIPointernsr7ilwulbub as CreateFFIPointer,
  get_pointer2afz2rc14joly as get_pointer_0,
  CreateFFIMemoryv82e6jbfcdze as CreateFFIMemory,
  set3216gyp8r69gas8 as set32,
  CreateFFIMemory2iekizxdvtyvt as CreateFFIMemory_0,
  setFFIPointerjzarmbova4sm as setFFIPointer,
  getS32284qh8a5ldxzn as getS32,
} from './korlibs-ffi-root-korlibs-ffi-legacy.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.xe5_1 = eventLoop;
    this.ye5_1 = now;
    this.ze5_1 = time;
    this.ae6_1 = interval;
    this.be6_1 = callback;
  }
  ce6(value) {
    this.ye5_1 = Duration__minus_impl_q5cfm7(value, this.ze5_1);
  }
  de6() {
    return Duration__plus_impl_yu9v8f(this.ye5_1, this.ze5_1);
  }
  ee6(other) {
    return Duration__compareTo_impl_pchp0f(this.de6(), other.de6());
  }
  d(other) {
    return this.ee6(other instanceof TimedTask ? other : THROW_CCE());
  }
  f7() {
    this.ae6_1 = false;
    this.xe5_1.oe6_1.qa4(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.xe6_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.ge6_1 = immediateRun;
    this.he6_1 = new SyncPauseable();
    var tmp = this;
    var tmp0 = this.he6_1;
    var tmp_0 = KMutableProperty0;
    var tmp_1 = SyncPauseable$_get_paused_$ref_1oeebp(tmp0);
    tmp.ie6_1 = getPropertyCallableRef('paused', 0, tmp_0, tmp_1, SyncPauseable$_set_paused_$ref_ddu6tj(tmp0));
    this.je6_1 = new Lock();
    this.ke6_1 = true;
    this.le6_1 = Monotonic_instance.ck();
    var tmp_2 = this;
    tmp_2.me6_1 = SyncEventLoop$nowProvider$lambda(this);
    this.ne6_1 = ArrayDeque.ul();
    var tmp_3 = this;
    var tmp_4 = Companion_instance_0;
    tmp_3.oe6_1 = tmp_4.da9(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_5 = this;
    tmp_5.pe6_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.qe6_1 = null;
  }
  re6(task) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0 = this.je6_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0.n9w();
      try {
        this.ne6_1.yl(task);
        this.je6_1.r9w();
        break $l$block;
      }finally {
        tmp0.p9w();
      }
    }
  }
  se6(time, task) {
    return _queueAfter(this, time, false, task);
  }
  f7() {
    var oldImmediateRun = this.ge6_1;
    try {
      this.ge6_1 = true;
      this.te6();
      this.ke6_1 = false;
    }finally {
      this.ge6_1 = oldImmediateRun;
    }
  }
  ue6(task) {
    if (this.ge6_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.oe6_1.ja9().de6()) >= 0;
  }
  ve6(runTimers) {
    var count = 0;
    while (this.we6(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  te6(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.ve6(runTimers) : $super.ve6.call(this, runTimers);
  }
  we6(runTimers) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0 = this.je6_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0.n9w();
      try {
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.oe6_1.n1()) {
            tmp_1 = this.ue6(this.oe6_1.ja9());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.oe6_1.ka9();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      }finally {
        tmp0.p9w();
      }
    }
    var timedTask = tmp$ret$1;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        timedTask.be6_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.pe6_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.ae6_1 && !this.ge6_1) {
        timedTask.ce6(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.de6(), timedTask.ze5_1)), new Duration(_get_now__e6dlkr(this))).ik_1);
        this.oe6_1.pa4(timedTask);
      }
    }
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0_0 = this.je6_1;
    var tmp$ret$9;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0_0.n9w();
      try {
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.ne6_1.n1()) {
          tmp_2 = this.ne6_1.zl();
        } else {
          tmp_2 = null;
        }
        tmp$ret$9 = tmp_2;
        break $l$block_0;
      }finally {
        tmp0_0.p9w();
      }
    }
    var task = tmp$ret$9;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      if (task == null)
        null;
      else
        task();
    } catch ($p_0) {
      if ($p_0 instanceof Error) {
        var e_0 = $p_0;
        this.pe6_1(e_0);
      } else {
        throw $p_0;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.ye6_1 = func;
    this.ze6_1 = node;
    this.ae7_1 = base;
  }
  f7() {
    if (this.ze6_1.ce7_1.z4(this)) {
      __updateChildListenerCount(this.ae7_1, this.ze6_1.be7_1, -1);
    }
  }
  ee7() {
    this.ze6_1.ce7_1.d2(this);
    __updateChildListenerCount(this.ae7_1, this.ze6_1.be7_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.be7_1 = type;
    this.ce7_1 = FastArrayList.f9v();
    this.de7_1 = FastArrayList.f9v();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.o(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.uay(this.le7(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.ne7(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.ue7(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.ne7(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.ne7(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.ve7(event.d8o(), event);
}
class BaseEventListener {
  static je7($box) {
    var $this = createThis(this, $box);
    $this.fe7_1 = null;
    $this.ge7_1 = null;
    $this.he7_1 = null;
    $this.ie7_1 = null;
    return $this;
  }
  o9u(_set____db54di) {
    this.fe7_1 = _set____db54di;
  }
  p9u() {
    return this.fe7_1;
  }
  ke7(other) {
    var tmp0_safe_receiver = this.ge7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.ge7_1 = other;
    var tmp1_safe_receiver = this.ge7_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  }
  le7(type, handler) {
    if (this.he7_1 == null)
      this.he7_1 = FastIdentityMap();
    var tmp0 = ensureNotNull(this.he7_1);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var res = get_0(tmp0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var out = new ListenerNode(type);
      set(tmp0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_0 = new Listener(handler, lists, this);
    this_0.ee7();
    return this_0;
  }
  me7(type) {
    var tmp0_safe_receiver = this.he7_1;
    var tmp = tmp0_safe_receiver == null ? null : get_0(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  ne7(type, event, result, up, down) {
    var eventListenerCount = this.oe7(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.pe7(type, event, result);
    }
    var listeners = this.me7(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.ce7_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.de7_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.d9v_1;
        var n = 0;
        while (n < array.length) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].ye6_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            result.re7_1 = result.re7_1 + 1 | 0;
          }
        }
      }finally {
        temp.a5();
      }
    }
    if (up) {
      this.se7(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      result.qe7_1 = result.qe7_1 + 1 | 0;
    }
    return event.te7();
  }
  ue7(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  we7(event) {
    return dispatch_0.call(this, event);
  }
  se7(type, event, result) {
  }
  pe7(type, event, result) {
  }
  oe7(type) {
    var tmp0_safe_receiver = this.ie7_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.qe7_1 = iterationCount;
    this.re7_1 = resultCount;
  }
  ra8() {
    this.qe7_1 = 0;
    this.re7_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.qe7_1 + ', resultCount=' + this.re7_1 + ')';
  }
  hashCode() {
    var result = this.qe7_1;
    result = imul(result, 31) + this.re7_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.qe7_1 === tmp0_other_with_cast.qe7_1))
      return false;
    if (!(this.re7_1 === tmp0_other_with_cast.re7_1))
      return false;
    return true;
  }
}
class Event {
  constructor() {
    this.de8_1 = null;
    this.ee8_1 = false;
  }
  fe8(_set____db54di) {
    this.de8_1 = _set____db54di;
  }
  je8(reason) {
    throw StopPropagatingException.ne8(reason);
  }
  ge8(_set____db54di) {
    this.ee8_1 = _set____db54di;
  }
  te7() {
    return this.ee8_1;
  }
  he8(reason) {
    this.ee8_1 = true;
  }
  ie8(reason, $super) {
    reason = reason === VOID ? null : reason;
    var tmp;
    if ($super === VOID) {
      this.he8(reason);
      tmp = Unit_instance;
    } else {
      tmp = $super.he8.call(this, reason);
    }
    return tmp;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.ce8_1 = type;
  }
  d8o() {
    return this.ce8_1;
  }
}
class Companion {
  constructor() {
    Companion_instance_8 = this;
    this.oe8_1 = values();
  }
}
class Type extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.re8_1 = type;
    this.se8_1 = id;
    this.te8_1 = amountX;
    this.ue8_1 = amountY;
  }
  d8o() {
    return this.re8_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.re8_1) + ', id=' + this.se8_1 + ', amountX=' + this.te8_1 + ', amountY=' + this.ue8_1 + ')';
  }
  hashCode() {
    var result = this.re8_1.hashCode();
    result = imul(result, 31) + this.se8_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.te8_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ue8_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.re8_1.equals(tmp0_other_with_cast.re8_1))
      return false;
    if (!(this.se8_1 === tmp0_other_with_cast.se8_1))
      return false;
    if (!equals(this.te8_1, tmp0_other_with_cast.te8_1))
      return false;
    if (!equals(this.ue8_1, tmp0_other_with_cast.ue8_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_9 = this;
    this.ve8_1 = values_0();
  }
}
class Type_0 extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.ye8_1 = type;
    this.ze8_1 = id;
    this.ae9_1 = key;
    this.be9_1 = keyCode;
    this.ce9_1 = character;
    this.de9_1 = shift;
    this.ee9_1 = ctrl;
    this.fe9_1 = alt;
    this.ge9_1 = meta;
    this.he9_1 = str;
    this.ie9_1 = Companion_getInstance().jk_1;
  }
  d8o() {
    return this.ye8_1;
  }
  je9() {
    var tmp0_elvis_lhs = this.he9_1;
    return tmp0_elvis_lhs == null ? toString_0(this.ce9_1) : tmp0_elvis_lhs;
  }
  ke9() {
    return Companion_getInstance_2().zb0().wb0() ? this.ge9_1 : this.ee9_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.ye8_1) + ', id=' + this.ze8_1 + ', key=' + this.ae9_1.toString() + ', keyCode=' + this.be9_1 + ', character=' + toString_0(this.ce9_1) + ', shift=' + this.de9_1 + ', ctrl=' + this.ee9_1 + ', alt=' + this.fe9_1 + ', meta=' + this.ge9_1 + ', str=' + this.he9_1 + ')';
  }
  hashCode() {
    var result = this.ye8_1.hashCode();
    result = imul(result, 31) + this.ze8_1 | 0;
    result = imul(result, 31) + this.ae9_1.hashCode() | 0;
    result = imul(result, 31) + this.be9_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.ce9_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.de9_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ee9_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fe9_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ge9_1) | 0;
    result = imul(result, 31) + (this.he9_1 == null ? 0 : getStringHashCode(this.he9_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.ye8_1.equals(tmp0_other_with_cast.ye8_1))
      return false;
    if (!(this.ze8_1 === tmp0_other_with_cast.ze8_1))
      return false;
    if (!this.ae9_1.equals(tmp0_other_with_cast.ae9_1))
      return false;
    if (!(this.be9_1 === tmp0_other_with_cast.be9_1))
      return false;
    if (!(this.ce9_1 === tmp0_other_with_cast.ce9_1))
      return false;
    if (!(this.de9_1 === tmp0_other_with_cast.de9_1))
      return false;
    if (!(this.ee9_1 === tmp0_other_with_cast.ee9_1))
      return false;
    if (!(this.fe9_1 === tmp0_other_with_cast.fe9_1))
      return false;
    if (!(this.ge9_1 === tmp0_other_with_cast.ge9_1))
      return false;
    if (!(this.he9_1 == tmp0_other_with_cast.he9_1))
      return false;
    return true;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_10 = this;
    this.le9_1 = values_1();
  }
}
class Type_1 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.oe9_1 = scale;
  }
  pe9(value, target) {
    return value * (this.oe9_1 / target.oe9_1);
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.se9_1 = type;
    this.te9_1 = id;
    this.ue9_1 = x;
    this.ve9_1 = y;
    this.we9_1 = button;
    this.xe9_1 = buttons;
    this.ye9_1 = scrollDeltaX;
    this.ze9_1 = scrollDeltaY;
    this.aea_1 = scrollDeltaZ;
    this.bea_1 = isShiftDown;
    this.cea_1 = isCtrlDown;
    this.dea_1 = isAltDown;
    this.eea_1 = isMetaDown;
    this.fea_1 = scaleCoords;
    this.gea_1 = emulated;
    this.hea_1 = scrollDeltaMode;
    this.iea_1 = null;
    var tmp = this;
    tmp.jea_1 = MouseEvent$requestLock$lambda;
  }
  d8o() {
    return this.se9_1;
  }
  kea(other) {
    this.se9_1 = other.se9_1;
    this.te9_1 = other.te9_1;
    this.ue9_1 = other.ue9_1;
    this.ve9_1 = other.ve9_1;
    this.we9_1 = other.we9_1;
    this.xe9_1 = other.xe9_1;
    this.ye9_1 = other.ye9_1;
    this.ze9_1 = other.ze9_1;
    this.aea_1 = other.aea_1;
    this.bea_1 = other.bea_1;
    this.cea_1 = other.cea_1;
    this.dea_1 = other.dea_1;
    this.eea_1 = other.eea_1;
    this.fea_1 = other.fea_1;
    this.gea_1 = other.gea_1;
    this.hea_1 = other.hea_1;
  }
  lea(mode) {
    return this.hea_1.pe9(this.ze9_1, mode);
  }
  mea(mode, x, y, z) {
    this.hea_1 = mode;
    this.ye9_1 = x;
    this.ze9_1 = y;
    this.aea_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.se9_1) + ', id=' + this.te9_1 + ', x=' + this.ue9_1 + ', y=' + this.ve9_1 + ', button=' + this.we9_1.toString() + ', buttons=' + this.xe9_1 + ', scrollDeltaX=' + this.ye9_1 + ', scrollDeltaY=' + this.ze9_1 + ', scrollDeltaZ=' + this.aea_1 + ', isShiftDown=' + this.bea_1 + ', isCtrlDown=' + this.cea_1 + ', isAltDown=' + this.dea_1 + ', isMetaDown=' + this.eea_1 + ', scaleCoords=' + this.fea_1 + ', emulated=' + this.gea_1 + ', scrollDeltaMode=' + this.hea_1.toString() + ')';
  }
  hashCode() {
    var result = this.se9_1.hashCode();
    result = imul(result, 31) + this.te9_1 | 0;
    result = imul(result, 31) + this.ue9_1 | 0;
    result = imul(result, 31) + this.ve9_1 | 0;
    result = imul(result, 31) + this.we9_1.hashCode() | 0;
    result = imul(result, 31) + this.xe9_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.ye9_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ze9_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.aea_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bea_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.cea_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dea_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.eea_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fea_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gea_1) | 0;
    result = imul(result, 31) + this.hea_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.se9_1.equals(tmp0_other_with_cast.se9_1))
      return false;
    if (!(this.te9_1 === tmp0_other_with_cast.te9_1))
      return false;
    if (!(this.ue9_1 === tmp0_other_with_cast.ue9_1))
      return false;
    if (!(this.ve9_1 === tmp0_other_with_cast.ve9_1))
      return false;
    if (!this.we9_1.equals(tmp0_other_with_cast.we9_1))
      return false;
    if (!(this.xe9_1 === tmp0_other_with_cast.xe9_1))
      return false;
    if (!equals(this.ye9_1, tmp0_other_with_cast.ye9_1))
      return false;
    if (!equals(this.ze9_1, tmp0_other_with_cast.ze9_1))
      return false;
    if (!equals(this.aea_1, tmp0_other_with_cast.aea_1))
      return false;
    if (!(this.bea_1 === tmp0_other_with_cast.bea_1))
      return false;
    if (!(this.cea_1 === tmp0_other_with_cast.cea_1))
      return false;
    if (!(this.dea_1 === tmp0_other_with_cast.dea_1))
      return false;
    if (!(this.eea_1 === tmp0_other_with_cast.eea_1))
      return false;
    if (!(this.fea_1 === tmp0_other_with_cast.fea_1))
      return false;
    if (!(this.gea_1 === tmp0_other_with_cast.gea_1))
      return false;
    if (!this.hea_1.equals(tmp0_other_with_cast.hea_1))
      return false;
    return true;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_2 {
  constructor() {
    Companion_instance_11 = this;
    this.nea_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_18();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_4().g9h_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.oea_1 = new Mixin();
    this.pea_1 = index;
    this.qea_1 = id;
    this.rea_1 = p;
    this.sea_1 = force;
    this.tea_1 = status;
    this.uea_1 = kind;
    this.vea_1 = button;
  }
  wea() {
    return this.rea_1.r9g_1;
  }
  xea() {
    return this.rea_1.s9g_1;
  }
  e1m() {
    return !this.tea_1.equals(Status_REMOVE_getInstance());
  }
  yea(other) {
    this.qea_1 = other.qea_1;
    this.rea_1 = other.rea_1;
    this.sea_1 = other.sea_1;
    this.tea_1 = other.tea_1;
    this.uea_1 = other.uea_1;
    this.vea_1 = other.vea_1;
  }
  hashCode() {
    return this.pea_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.pea_1 === other.pea_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.pea_1 + ', id=' + this.qea_1 + ', p=' + this.rea_1.toString() + ', force=' + this.sea_1 + ', status=' + this.tea_1.toString() + ', kind=' + this.uea_1.toString() + ', button=' + this.vea_1.toString() + ')';
  }
  o9u(value) {
    this.oea_1.o9u(value);
  }
  p9u() {
    return this.oea_1.p9u();
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_12 = this;
    this.zea_1 = values_2();
  }
}
class Type_2 extends Enum {}
class Companion_4 {
  constructor() {
    this.aeb_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_8().t9v_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.deb_1 = type;
    this.eeb_1 = screen;
    this.feb_1 = currentTime;
    this.geb_1 = scaleCoords;
    this.heb_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_13.aeb_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.ieb_1 = tmp_2;
    this.jeb_1 = FastArrayList.f9v();
    this.keb_1 = FastArrayList.f9v();
    this.leb_1 = FastIntMap();
  }
  d8o() {
    return this.deb_1;
  }
  meb() {
    return this.jeb_1;
  }
  neb() {
    return this.meb().s2();
  }
  oeb(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.leb_1.get(id);
  }
  toString() {
    var tmp = toString(this.deb_1);
    var tmp_0 = this.neb();
    var tmp_1 = this.meb();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  peb(type) {
    this.deb_1 = type;
    this.feb_1 = Companion_getInstance_8().x9v();
    this.jeb_1.a5();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.leb_1.clear();
  }
  qeb() {
    this.keb_1.a5();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.meb();
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.u2(_unary__edvuaz);
      if (it.e1m()) {
        this.keb_1.d2(it);
      }
    }
  }
  reb(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.leb_1.get(id);
    return tmp0_elvis_lhs == null ? this.seb(id) : tmp0_elvis_lhs;
  }
  seb(id) {
    var touch = this.ieb_1[this.jeb_1.s2()];
    touch.qea_1 = id;
    this.jeb_1.d2(touch);
    var tmp0 = this.leb_1;
    // Inline function 'korlibs.datastructure.set' call
    var key = touch.qea_1;
    // Inline function 'kotlin.js.asDynamic' call
    tmp0.set(key, touch);
    return touch;
  }
  teb(id, p, status, force, kind, button) {
    var touch = this.reb(id);
    touch.rea_1 = p;
    touch.tea_1 = status;
    touch.sea_1 = force;
    touch.uea_1 = kind;
    touch.vea_1 = button;
  }
  ueb(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.teb(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.teb.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  veb(touch) {
    this.teb(touch.qea_1, touch.rea_1, touch.tea_1, touch.sea_1, touch.uea_1, touch.vea_1);
  }
  web(other) {
    this.deb_1 = other.deb_1;
    this.eeb_1 = other.eeb_1;
    this.feb_1 = other.feb_1;
    this.geb_1 = other.geb_1;
    this.heb_1 = other.heb_1;
    var inductionVariable = 0;
    var last = Companion_instance_13.aeb_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ieb_1[n].yea(other.ieb_1[n]);
      }
       while (inductionVariable < last);
    this.jeb_1.a5();
    this.keb_1.a5();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.leb_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.meb();
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.u2(_unary__edvuaz);
      var touch = this.ieb_1[otherTouch.pea_1];
      this.jeb_1.d2(touch);
      if (touch.e1m()) {
        this.keb_1.d2(touch);
      }
      var tmp0 = this.leb_1;
      // Inline function 'korlibs.datastructure.set' call
      var key = touch.qea_1;
      // Inline function 'kotlin.js.asDynamic' call
      tmp0.set(key, touch);
    }
  }
  xeb() {
    return this.deb_1.equals(Type_START_getInstance());
  }
  yeb() {
    return this.deb_1.equals(Type_END_getInstance());
  }
  hashCode() {
    var result = this.deb_1.hashCode();
    result = imul(result, 31) + this.eeb_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.feb_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.geb_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.heb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.deb_1.equals(tmp0_other_with_cast.deb_1))
      return false;
    if (!(this.eeb_1 === tmp0_other_with_cast.eeb_1))
      return false;
    if (!equals(this.feb_1, tmp0_other_with_cast.feb_1))
      return false;
    if (!(this.geb_1 === tmp0_other_with_cast.geb_1))
      return false;
    if (!(this.heb_1 === tmp0_other_with_cast.heb_1))
      return false;
    return true;
  }
}
class Companion_5 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height, setPos) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    setPos = setPos === VOID ? true : setPos;
    super(Companion_instance_14);
    this.cec_1 = x;
    this.dec_1 = y;
    this.eec_1 = width;
    this.fec_1 = height;
    this.gec_1 = setPos;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.cec_1 + ', y=' + this.dec_1 + ', width=' + this.eec_1 + ', height=' + this.fec_1 + ', setPos=' + this.gec_1 + ')';
  }
  hashCode() {
    var result = this.cec_1;
    result = imul(result, 31) + this.dec_1 | 0;
    result = imul(result, 31) + this.eec_1 | 0;
    result = imul(result, 31) + this.fec_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gec_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.cec_1 === tmp0_other_with_cast.cec_1))
      return false;
    if (!(this.dec_1 === tmp0_other_with_cast.dec_1))
      return false;
    if (!(this.eec_1 === tmp0_other_with_cast.eec_1))
      return false;
    if (!(this.fec_1 === tmp0_other_with_cast.fec_1))
      return false;
    if (!(this.gec_1 === tmp0_other_with_cast.gec_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  constructor(reason) {
    return new.target.ne8(reason);
  }
  static ne8(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.te();
    captureStack($this, $this.me8_1);
    $this.le8_1 = reason;
    return $this;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_15 = this;
    this.hec_1 = values_3();
  }
}
class Type_3 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    files = files === VOID ? null : files;
    super();
    this.kec_1 = type;
    this.lec_1 = files;
  }
  d8o() {
    return this.kec_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.kec_1) + ', files=' + toString_1(this.lec_1) + ')';
  }
  hashCode() {
    var result = this.kec_1.hashCode();
    result = imul(result, 31) + (this.lec_1 == null ? 0 : hashCode(this.lec_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.kec_1.equals(tmp0_other_with_cast.kec_1))
      return false;
    if (!equals(this.lec_1, tmp0_other_with_cast.lec_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_16);
  }
}
class Companion_8 {}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_17);
  }
}
class Companion_9 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_18);
  }
}
class Companion_10 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_19);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_27();
    super(Companion_getInstance_27());
    this.pec_1 = true;
    this.qec_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.pec_1 + ', render=' + this.qec_1 + ')';
  }
}
class Companion_11 extends RenderEvent {
  constructor() {
    Companion_instance_20 = null;
    super();
    Companion_instance_20 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_28();
    super(Companion_getInstance_28());
  }
}
class Companion_12 extends InitEvent {
  constructor() {
    Companion_instance_21 = null;
    super();
    Companion_instance_21 = this;
  }
}
class Companion_13 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_22);
  }
}
class Companion_14 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_23);
    this.uec_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.uec_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.uec_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.uec_1 === tmp0_other_with_cast.uec_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.vec_1 = new TouchEvent();
    this.wec_1 = new TouchEvent();
    this.xec_1 = Mode_JS_getInstance();
  }
  yec(type, scaleCoords) {
    this.wec_1.geb_1 = scaleCoords;
    this.wec_1.peb(type);
    if (this.xec_1.w1_1 === 2) {
      this.wec_1.web(this.vec_1);
      this.wec_1.deb_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.wec_1.jeb_1;
      var n = 0;
      var m = 0;
      while (n < this_0.s2()) {
        if (m >= 0 && !(m === n)) {
          this_0.e5(m, this_0.u2(n));
        }
        var it = this_0.u2(n);
        var tmp;
        if (it.e1m()) {
          it.tea_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          var tmp0 = this.wec_1.leb_1;
          // Inline function 'korlibs.datastructure.remove' call
          var key = it.qea_1;
          // Inline function 'kotlin.js.asDynamic' call
          tmp0.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.s2() > m) {
        this_0.g5(this_0.s2() - 1 | 0);
      }
    }
  }
  zec() {
    switch (this.xec_1.w1_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.vec_1.meb();
        var n = 0;
        while (n < this_0.s2()) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.u2(_unary__edvuaz);
          if (this.wec_1.oeb(oldTouch.qea_1) == null) {
            if (oldTouch.e1m()) {
              oldTouch.tea_1 = Status_REMOVE_getInstance();
              this.wec_1.veb(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.wec_1.qeb();
    this.vec_1.web(this.wec_1);
    return this.wec_1;
  }
  aed(id, p, force, kind, button) {
    var touch = this.wec_1.reb(id);
    touch.rea_1 = p;
    touch.sea_1 = force;
    touch.uea_1 = kind;
    touch.vea_1 = button;
    if (this.xec_1.w1_1 === 2) {
      var tmp = touch;
      switch (this.wec_1.deb_1.w1_1) {
        case 0:
          tmp.tea_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.tea_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.tea_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.vec_1.oeb(id);
      touch.tea_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  bed(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.aed(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.aed.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class Companion_15 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(4);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.eed_1 = gamepadsLength;
    this.fed_1 = gamepads;
  }
  d8o() {
    return Companion_instance_24;
  }
  toString() {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.fed_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.hed_1) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s = destination.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$5 = item.ned();
      destination_0.d2(tmp$ret$5);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.eed_1;
    result = imul(result, 31) + hashCode(this.fed_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.eed_1 === tmp0_other_with_cast.eed_1))
      return false;
    if (!equals(this.fed_1, tmp0_other_with_cast.fed_1))
      return false;
    return true;
  }
}
class BatteryStatus extends Enum {}
class Companion_16 {
  constructor() {
    this.oed_1 = 'Wireless Controller';
    this.ped_1 = 4;
    this.qed_1 = 0.075;
  }
  red(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  sed(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.red(value, margin, apply) : $super.red.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_25.oed_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.ged_1 = index;
    this.hed_1 = connected;
    this.ied_1 = name;
    this.jed_1 = rawButtons;
    this.ked_1 = batteryLevel;
    this.led_1 = name2;
    this.med_1 = batteryStatus;
  }
  ted() {
    var tmp0_elvis_lhs = this.ied_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.led_1;
  }
  ued(that) {
    this.ged_1 = that.ged_1;
    this.ied_1 = that.ied_1;
    this.led_1 = that.led_1;
    this.hed_1 = that.hed_1;
    this.ked_1 = that.ked_1;
    this.med_1 = that.med_1;
    var tmp = that.jed_1;
    var tmp_0 = this.jed_1;
    var tmp0 = this.jed_1.length;
    // Inline function 'kotlin.math.min' call
    var b = that.jed_1.length;
    var tmp$ret$0 = Math.min(tmp0, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  ved(button) {
    return this.jed_1[button.yed()];
  }
  zed(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('Gamepad[' + this.ged_1 + '][' + this.ted() + ']');
    if (includeButtons) {
      this_0.m1('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.ved(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.m1(',');
          }
          this_0.m1(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.m1(']');
    }
    return this_0.toString();
  }
  ned(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.zed(includeButtons) : $super.zed.call(this, includeButtons);
  }
  toString() {
    return this.zed(false);
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.aee_1 = values_4();
  }
  bee(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.eee_1 = type;
    this.fee_1 = gamepad;
  }
  d8o() {
    return this.eee_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.eee_1) + ', gamepad=' + this.fee_1 + ')';
  }
  hashCode() {
    var result = this.eee_1.hashCode();
    result = imul(result, 31) + this.fee_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.eee_1.equals(tmp0_other_with_cast.eee_1))
      return false;
    if (!(this.fee_1 === tmp0_other_with_cast.fee_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.gee_1 = values_5();
    this.hee_1 = 32;
  }
}
class GameButton extends Enum {
  yed() {
    return this.w1_1;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.iee_1 = dispatcher;
    this.jee_1 = booleanArray(4);
    this.kee_1 = new GamePadUpdateEvent();
    this.lee_1 = new GamePadConnectionEvent();
    this.mee_1 = IntArrayList.za1();
  }
  nee() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.kee_1.fed_1;
    var n = 0;
    while (n < this_0.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].hed_1 = false;
    }
    this.kee_1.eed_1 = 0;
  }
  oee(info) {
    var _receiver__tnumb7 = this.kee_1;
    var _unary__edvuaz = _receiver__tnumb7.eed_1;
    _receiver__tnumb7.eed_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.kee_1.fed_1[index];
    pad.ued(info);
    pad.hed_1 = true;
    pad.ged_1 = index;
  }
  pee(out) {
    out.a5();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.kee_1.fed_1;
    var n = 0;
    while (n < this_0.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.jee_1[it.ged_1] === it.hed_1)) {
        this.jee_1[it.ged_1] = it.hed_1;
        out.ga2(it.ged_1);
        if (!it.hed_1) {
          it.ied_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.lee_1;
        this_1.eee_1 = Companion_getInstance_33().bee(it.hed_1);
        this_1.fee_1 = it.ged_1;
        this.iee_1.we7(this_1);
      }
    }
    this.iee_1.we7(this.kee_1);
    return out;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.qee_1 = Key_UNKNOWN_getInstance().w1_1 + 1 | 0;
    this.ree_1 = Key_ENTER_getInstance();
    this.see_1 = Key_N0_getInstance();
    this.tee_1 = Key_N1_getInstance();
    this.uee_1 = Key_N2_getInstance();
    this.vee_1 = Key_N3_getInstance();
    this.wee_1 = Key_N4_getInstance();
    this.xee_1 = Key_N5_getInstance();
    this.yee_1 = Key_N6_getInstance();
    this.zee_1 = Key_N7_getInstance();
    this.aef_1 = Key_N8_getInstance();
    this.bef_1 = Key_N9_getInstance();
  }
  cef() {
    return Key_CONTROL_getInstance();
  }
  def() {
    return Key_CONTROL_getInstance();
  }
  eef() {
    return Key_SHIFT_getInstance();
  }
  fef() {
    return Key_SHIFT_getInstance();
  }
  gef() {
    return Key_ALT_getInstance();
  }
  hef() {
    return Key_ALT_getInstance();
  }
  ief() {
    return Key_SUPER_getInstance();
  }
  jef() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  mef() {
    switch (this.w1_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.nef_1 = MouseButton_NONE_getInstance().w1_1 + 1 | 0;
    this.oef_1 = values_6();
  }
  u2(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.oef_1;
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.ref_1 = id;
    this.sef_1 = bits;
  }
}
class ISoftKeyboardConfig {}
class SoftKeyboardType extends Enum {}
class SoftKeyboardReturnKeyType extends Enum {}
class SoftKeyboardConfig {
  constructor(softKeyboardType, softKeyboardSmartDashes, softKeyboardSmartQuotes, softKeyboardSpellChecking, softKeyboardTextContentType, softKeyboardSmartInsertDelete, softKeyboardPassword, softKeyboardReturnKeyType, softKeyboardAutocapitalization, softKeyboardAutocorrection, softKeyboardEnablesReturnKeyAutomatically) {
    softKeyboardType = softKeyboardType === VOID ? SoftKeyboardType_DEFAULT_getInstance() : softKeyboardType;
    softKeyboardSmartDashes = softKeyboardSmartDashes === VOID ? null : softKeyboardSmartDashes;
    softKeyboardSmartQuotes = softKeyboardSmartQuotes === VOID ? null : softKeyboardSmartQuotes;
    softKeyboardSpellChecking = softKeyboardSpellChecking === VOID ? null : softKeyboardSpellChecking;
    softKeyboardTextContentType = softKeyboardTextContentType === VOID ? null : softKeyboardTextContentType;
    softKeyboardSmartInsertDelete = softKeyboardSmartInsertDelete === VOID ? null : softKeyboardSmartInsertDelete;
    softKeyboardPassword = softKeyboardPassword === VOID ? false : softKeyboardPassword;
    softKeyboardReturnKeyType = softKeyboardReturnKeyType === VOID ? SoftKeyboardReturnKeyType_DEFAULT_getInstance() : softKeyboardReturnKeyType;
    softKeyboardAutocapitalization = softKeyboardAutocapitalization === VOID ? null : softKeyboardAutocapitalization;
    softKeyboardAutocorrection = softKeyboardAutocorrection === VOID ? null : softKeyboardAutocorrection;
    softKeyboardEnablesReturnKeyAutomatically = softKeyboardEnablesReturnKeyAutomatically === VOID ? false : softKeyboardEnablesReturnKeyAutomatically;
    this.tef_1 = softKeyboardType;
    this.uef_1 = softKeyboardSmartDashes;
    this.vef_1 = softKeyboardSmartQuotes;
    this.wef_1 = softKeyboardSpellChecking;
    this.xef_1 = softKeyboardTextContentType;
    this.yef_1 = softKeyboardSmartInsertDelete;
    this.zef_1 = softKeyboardPassword;
    this.aeg_1 = softKeyboardReturnKeyType;
    this.beg_1 = softKeyboardAutocapitalization;
    this.ceg_1 = softKeyboardAutocorrection;
    this.deg_1 = softKeyboardEnablesReturnKeyAutomatically;
  }
  toString() {
    return 'SoftKeyboardConfig(softKeyboardType=' + this.tef_1.toString() + ', softKeyboardSmartDashes=' + this.uef_1 + ', softKeyboardSmartQuotes=' + this.vef_1 + ', softKeyboardSpellChecking=' + this.wef_1 + ', softKeyboardTextContentType=' + this.xef_1 + ', softKeyboardSmartInsertDelete=' + this.yef_1 + ', softKeyboardPassword=' + this.zef_1 + ', softKeyboardReturnKeyType=' + this.aeg_1.toString() + ', softKeyboardAutocapitalization=' + this.beg_1 + ', softKeyboardAutocorrection=' + this.ceg_1 + ', softKeyboardEnablesReturnKeyAutomatically=' + this.deg_1 + ')';
  }
  hashCode() {
    var result = this.tef_1.hashCode();
    result = imul(result, 31) + (this.uef_1 == null ? 0 : getBooleanHashCode(this.uef_1)) | 0;
    result = imul(result, 31) + (this.vef_1 == null ? 0 : getBooleanHashCode(this.vef_1)) | 0;
    result = imul(result, 31) + (this.wef_1 == null ? 0 : getBooleanHashCode(this.wef_1)) | 0;
    result = imul(result, 31) + (this.xef_1 == null ? 0 : getStringHashCode(this.xef_1)) | 0;
    result = imul(result, 31) + (this.yef_1 == null ? 0 : getBooleanHashCode(this.yef_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zef_1) | 0;
    result = imul(result, 31) + this.aeg_1.hashCode() | 0;
    result = imul(result, 31) + (this.beg_1 == null ? 0 : getBooleanHashCode(this.beg_1)) | 0;
    result = imul(result, 31) + (this.ceg_1 == null ? 0 : getBooleanHashCode(this.ceg_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.deg_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoftKeyboardConfig))
      return false;
    var tmp0_other_with_cast = other instanceof SoftKeyboardConfig ? other : THROW_CCE();
    if (!this.tef_1.equals(tmp0_other_with_cast.tef_1))
      return false;
    if (!(this.uef_1 == tmp0_other_with_cast.uef_1))
      return false;
    if (!(this.vef_1 == tmp0_other_with_cast.vef_1))
      return false;
    if (!(this.wef_1 == tmp0_other_with_cast.wef_1))
      return false;
    if (!(this.xef_1 == tmp0_other_with_cast.xef_1))
      return false;
    if (!(this.yef_1 == tmp0_other_with_cast.yef_1))
      return false;
    if (!(this.zef_1 === tmp0_other_with_cast.zef_1))
      return false;
    if (!this.aeg_1.equals(tmp0_other_with_cast.aeg_1))
      return false;
    if (!(this.beg_1 == tmp0_other_with_cast.beg_1))
      return false;
    if (!(this.ceg_1 == tmp0_other_with_cast.ceg_1))
      return false;
    if (!(this.deg_1 === tmp0_other_with_cast.deg_1))
      return false;
    return true;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.eeg_1 = Companion_getInstance_1().pb5('AG');
    this.feg_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_isUniformBuffersSupported() {
  var tmp0_safe_receiver = this.geh();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.heh();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp0_safe_receiver = this.geh();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ieh();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
class AG {
  constructor() {
    return new.target.keg();
  }
  static keg() {
    Companion_getInstance_37();
    var $this = createThis(this);
    $this.geg_1 = new Mixin();
    $this.heg_1 = AGFrameBuffer.yeg(true);
    $this.ieg_1 = 0;
    $this.jeg_1 = new AGStats();
    return $this;
  }
  zeg() {
    return this.heg_1;
  }
  aeh() {
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0 = Companion_getInstance_37().eeg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_INFO_getInstance();
    if (tmp0.obj(level)) {
      tmp0.pbj(level, this);
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0_0 = Companion_getInstance_37().eeg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level_0 = Level_INFO_getInstance();
    if (tmp0_0.obj(level_0)) {
      var tmp$ret$5 = 'AG.contextLost()';
      tmp0_0.pbj(level_0, tmp$ret$5);
    }
    this.ieg_1 = this.ieg_1 + 1 | 0;
  }
  v7e() {
    return this.beh(AGFinish_instance);
  }
  ceh() {
    return Unit_instance;
  }
  qeb() {
    return Unit_instance;
  }
  beh(command) {
    return Unit_instance;
  }
  deh(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.beh(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  eeh(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.beh(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
  feh(frameBuffer, frameBufferInfo, x, y, width, height, data, kind) {
    return Unit_instance;
  }
  o9u(value) {
    this.geg_1.o9u(value);
  }
  p9u() {
    return this.geg_1.p9u();
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.dei_1 = parentFeatures;
    this.eei_1 = graphicExtensions;
    this.fei_1 = isInstancedSupported;
    this.gei_1 = isUniformBuffersSupported;
    this.hei_1 = isVertexArraysSupported;
    this.iei_1 = isStorageMultisampleSupported;
    this.jei_1 = isFloatTextureSupported;
  }
  geh() {
    return this.dei_1;
  }
  heh() {
    return this.gei_1;
  }
  ieh() {
    return this.hei_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.dei_1) + ', graphicExtensions=' + toString(this.eei_1) + ', isInstancedSupported=' + this.fei_1 + ', isUniformBuffersSupported=' + this.gei_1 + ', isVertexArraysSupported=' + this.hei_1 + ', isStorageMultisampleSupported=' + this.iei_1 + ', isFloatTextureSupported=' + this.jei_1 + ')';
  }
  hashCode() {
    var result = this.dei_1 == null ? 0 : hashCode(this.dei_1);
    result = imul(result, 31) + hashCode(this.eei_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fei_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gei_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.hei_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.iei_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jei_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.dei_1, tmp0_other_with_cast.dei_1))
      return false;
    if (!equals(this.eei_1, tmp0_other_with_cast.eei_1))
      return false;
    if (!(this.fei_1 === tmp0_other_with_cast.fei_1))
      return false;
    if (!(this.gei_1 === tmp0_other_with_cast.gei_1))
      return false;
    if (!(this.hei_1 === tmp0_other_with_cast.hei_1))
      return false;
    if (!(this.iei_1 === tmp0_other_with_cast.iei_1))
      return false;
    if (!(this.jei_1 === tmp0_other_with_cast.jei_1))
      return false;
    return true;
  }
}
class Companion_22 {
  constructor() {
    this.xej_1 = 128;
    this.yej_1 = 128;
  }
}
class AGFrameBuffer {
  constructor(base, id) {
    return new.target.zej(base, id);
  }
  static zej(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.leg_1 = base;
    $this.meg_1 = id;
    $this.neg_1 = 1;
    $this.oeg_1 = true;
    $this.peg_1 = true;
    $this.qeg_1 = 0;
    $this.reg_1 = 0;
    $this.seg_1 = 128;
    $this.teg_1 = 128;
    $this.ueg_1 = 128;
    $this.veg_1 = 128;
    $this.weg_1 = RectangleInt.f9r();
    $this.xeg_1 = null;
    return $this;
  }
  static yeg(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.zej(new AGFrameBufferBase(isMain), id);
  }
  aek() {
    return this.leg_1.aek();
  }
  iek() {
    return this.leg_1.fek_1;
  }
  jek() {
    return this.leg_1.gek_1;
  }
  sej() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.qeg_1, this.reg_1, this.seg_1, this.teg_1), this.neg_1), this.peg_1), this.oeg_1);
  }
  kek(width, height) {
    return this.lek(0, 0, width, height);
  }
  mek(x, y, width, height, fullWidth, fullHeight) {
    if (this.qeg_1 === x && this.reg_1 === y && this.seg_1 === width && this.teg_1 === height && this.ueg_1 === fullWidth && this.veg_1 === fullHeight)
      return true;
    this.jek().bel(NullBitmap.ucg(width, height));
    this.leg_1.hek_1 = Companion_getInstance_9().tb3(imul(imul(fullWidth, fullHeight), 8));
    this.qeg_1 = x;
    this.reg_1 = y;
    this.seg_1 = width;
    this.teg_1 = height;
    this.ueg_1 = fullWidth;
    this.veg_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  lek(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.mek(x, y, width, height, fullWidth, fullHeight) : $super.mek.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  f7() {
    this.leg_1.f7();
  }
  cel(samples) {
    if (this.neg_1 === samples)
      return Unit_instance;
    this.neg_1 = samples;
    markAsDirty(this);
  }
  del(hasDepth, hasStencil) {
    if (this.peg_1 === hasDepth && this.oeg_1 === hasStencil)
      return Unit_instance;
    this.peg_1 = hasDepth;
    this.oeg_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.iek() ? 'main' : '' + this.meg_1) + ', ' + this.seg_1 + ', ' + this.teg_1 + ')';
  }
}
class AGObject {
  constructor() {
    this.aem_1 = null;
    this.bem_1 = -1;
    this.cem_1 = -2;
    this.dem_1 = -1;
  }
  gem() {
    this.eem();
    this.cem_1 = this.dem_1 - 1 | 0;
  }
  eem() {
    this.dem_1 = this.dem_1 + 1 | 0;
  }
  f7() {
    var tmp0_safe_receiver = this.aem_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pen();
    }
    this.aem_1 = null;
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_54().eel_1 : targetKind;
    super();
    this.rek_1 = targetKind;
    this.sek_1 = Companion_getInstance_1().pb5('AGTexture');
    this.tek_1 = false;
    this.uek_1 = false;
    this.vek_1 = null;
    this.wek_1 = null;
    this.xek_1 = null;
    this.yek_1 = false;
    this.zek_1 = null;
    this.ael_1 = Companion_getInstance_9().ub3(new Long(0, 0));
  }
  iel() {
    var tmp0_safe_receiver = this.zek_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rcf();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = fromGl(Companion_getInstance_54(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.rek_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  w9z() {
    var tmp0_safe_receiver = this.xek_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sc1_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  x9z() {
    var tmp0_safe_receiver = this.xek_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tc1_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  kel() {
    var tmp = this.xek_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.yel_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s2();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  }
  zel(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.zek_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.xek_1 = bmp;
    this.ael_1 = Companion_getInstance_9().tb3(imul(imul(imul(this.w9z(), this.x9z()), this.kel()), 4));
    this.eem();
    this.uek_1 = mipmaps;
    this.vek_1 = baseMipmapLevel;
    this.wek_1 = maxMipmapLevel;
    return this;
  }
  bel(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.zel(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.zel.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  fem(bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.sc1_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.tc1_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.w9z() + ',' + this.x9z() + ')';
  }
}
class Companion_23 {
  constructor() {
    this.vei_1 = 8;
  }
  wei() {
    return AGTextureUnits.jem();
  }
}
class AGTextureUnits {
  constructor(textures, infos) {
    return new.target.kem(textures, infos);
  }
  static kem(textures, infos) {
    var $this = createThis(this);
    $this.hem_1 = textures;
    $this.iem_1 = infos;
    return $this;
  }
  static jem(size) {
    size = size === VOID ? Companion_instance_32.vei_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = Array(size);
    return this.kem(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  s2() {
    return this.hem_1.length;
  }
  lem(other, index) {
    return this.mem(index, other.hem_1[index], AGTextureUnitInfoArray__get_impl_xhvpef(other.iem_1, index));
  }
  mem(index, texture, info) {
    this.hem_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.iem_1, index, info);
  }
  nem(index, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_40().pem_1 : info;
    var tmp;
    if ($super === VOID) {
      this.mem(index, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.mem.call(this, index, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  qem(sampler, texture, info) {
    this.mem(sampler.cen_1, texture, info);
  }
  een(sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_40().pem_1 : info;
    var tmp;
    if ($super === VOID) {
      this.qem(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.qem.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  a5() {
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.mem(n, null, Companion_getInstance_40().pem_1);
      }
       while (inductionVariable < last);
  }
  g9m() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.hem_1.slice();
    return AGTextureUnits.kem(tmp$ret$0, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.iem_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.hem_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.iem_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.hem_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.iem_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.hem_1, tmp0_other_with_cast.hem_1))
      return false;
    if (!equals(this.iem_1, tmp0_other_with_cast.iem_1))
      return false;
    return true;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.jen_1 = null;
  }
  ken(data, offset, length) {
    return upload(this, _Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)), false);
  }
  len(data, offset, length) {
    return upload(this, _Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(data, offset, length)), false);
  }
  men(data, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? data.length - offset | 0 : length;
    return $super === VOID ? this.len(data, offset, length) : $super.len.call(this, data, offset, length);
  }
  nen(data, offset, length) {
    return upload(this, sliceWithSize(data, offset, length), true);
  }
  oen(data) {
    return upload(this, data, true);
  }
  toString() {
    var tmp0_safe_receiver = this.jen_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jb2();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.fek_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    this_0.tek_1 = true;
    tmp.gek_1 = this_0;
    this.hek_1 = Companion_getInstance_9().tb3(0);
  }
  aek() {
    return !this.fek_1;
  }
  f7() {
    this.gek_1.f7();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.fek_1 + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    this.oem_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.pem_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_55().ren_1), Companion_getInstance_54().eel_1);
  }
  qen(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  uen(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  ven(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_55().ren_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.uen(wrap, linear, trilinear) : $super.uen.call(this, new AGWrapMode(wrap), linear, trilinear).wen_1;
  }
}
class AGTextureUnitInfo {
  constructor(data) {
    Companion_getInstance_40();
    this.wen_1 = data;
  }
  toString() {
    return AGTextureUnitInfo__toString_impl_7im6je(this.wen_1);
  }
  hashCode() {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.wen_1);
  }
  equals(other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.wen_1, other);
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.xen_1 = FastIdentityMap();
  }
  ra8() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.xen_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      var it = v.value;
      ensureNotNull(get_0(this_0, it)).ra8();
    }
  }
  geo() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.xen_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      var it = v.value;
      ensureNotNull(get_0(this_0, it)).heo();
    }
  }
  ieo(block) {
    var tmp0 = this.xen_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var res = get_0(tmp0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var out = new UniformBlockBuffer(block);
      set(tmp0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.jeo_1 = program;
    this.keo_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.jeo_1.weo_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.qep_1;
      destination.d2(tmp$ret$2);
    }
    tmp.leo_1 = distinct(destination);
    var tmp_0 = this;
    var tmp0 = this.leo_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = tmp0.p1();
      if (!iterator.q1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      var maxValue = iterator.r1().sep_1 + 1 | 0;
      while (iterator.q1()) {
        var v = iterator.r1().sep_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.meo_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.meo_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = Array(tmp_3);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.also' call
    var _iterator__ex2g4s_0 = this.leo_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var layout = _iterator__ex2g4s_0.r1();
      tmp_4[layout.sep_1] = layout;
    }
    tmp_1.neo_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.neo_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = Array(tmp_7);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.neo_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_10 = this.keo_1.ieo(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.oeo_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.neo_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = Array(tmp_13);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.oeo_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.yen_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.peo_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.neo_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = Array(tmp_19);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.oeo_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.zen_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.qeo_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.neo_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.reo_1 = tmp_25;
  }
  wep() {
    var inductionVariable = 0;
    var last = this.reo_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.oeo_1[n];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z6x();
        this.reo_1[n] = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.reo_1.slice();
    return new UniformBlocksBuffersRef(this.peo_1, this.qeo_1, tmp$ret$0);
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.jej_1 = AGScissor.beq(0, 0, 0, 0);
    this.kej_1 = Companion_getInstance_41().v9p(-2147483648, -2147483648, 2147483647, 2147483647);
    this.lej_1 = Companion_getInstance_41().v9p(-32766, -32766, 2147483647, 2147483647);
    this.mej_1 = Companion_getInstance_41().v9p(-32767, -32767, 2147483647, 2147483647);
  }
  v9p(left, top, right, bottom) {
    return AGScissor.beq(left, top, right - left | 0, bottom - top | 0);
  }
  ceq(left, top, right, bottom) {
    return AGScissor.deq(left, top, right - left, bottom - top);
  }
  eeq(rect) {
    if (rect == null)
      return this.mej_1;
    if (rect.t9h())
      return this.mej_1;
    return AGScissor.feq(rect.o9h_1, rect.p9h_1, rect.q9h_1, rect.r9h_1);
  }
  geq(prev, next) {
    if (prev.equals(this.mej_1))
      return next;
    if (next.equals(this.mej_1))
      return prev;
    var intersectsX = prev.v9h() <= next.w9h() && prev.w9h() >= next.v9h();
    var intersectsY = prev.x9h() <= next.y9h() && prev.y9h() >= next.x9h();
    if (!intersectsX || !intersectsY)
      return this.jej_1;
    var tmp0 = prev.v9h();
    // Inline function 'kotlin.math.max' call
    var b = next.v9h();
    var left = Math.max(tmp0, b);
    var tmp0_0 = prev.x9h();
    // Inline function 'kotlin.math.max' call
    var b_0 = next.x9h();
    var top = Math.max(tmp0_0, b_0);
    var tmp0_1 = prev.w9h();
    // Inline function 'kotlin.math.min' call
    var b_1 = next.w9h();
    var right = Math.min(tmp0_1, b_1);
    var tmp0_2 = prev.y9h();
    // Inline function 'kotlin.math.min' call
    var b_2 = next.y9h();
    var bottom = Math.min(tmp0_2, b_2);
    return this.v9p(left, top, right, bottom);
  }
}
class AGScissor {
  constructor(_left, _top, _right, _bottom) {
    return new.target.heq(_left, _top, _right, _bottom);
  }
  static heq(_left, _top, _right, _bottom) {
    Companion_getInstance_41();
    var $this = createThis(this);
    $this.xep_1 = _left;
    $this.yep_1 = _top;
    $this.zep_1 = _right;
    $this.aeq_1 = _bottom;
    return $this;
  }
  t9h() {
    return this.equals(Companion_getInstance_41().mej_1);
  }
  static beq(x, y, width, height) {
    Companion_getInstance_41();
    return this.heq(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static deq(x, y, width, height) {
    Companion_getInstance_41();
    return this.beq(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static feq(x, y, width, height) {
    Companion_getInstance_41();
    return this.beq(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  v9h() {
    return this.xep_1;
  }
  x9h() {
    return this.yep_1;
  }
  w9h() {
    return this.zep_1;
  }
  y9h() {
    return this.aeq_1;
  }
  wea() {
    return this.v9h();
  }
  xea() {
    return this.x9h();
  }
  w9z() {
    return this.w9h() - this.v9h() | 0;
  }
  x9z() {
    return this.y9h() - this.x9h() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_41().mej_1))
      return 'null';
    return 'Scissor(x=' + this.wea() + ', y=' + this.xea() + ', width=' + this.w9z() + ', height=' + this.x9z() + ')';
  }
  ieq() {
    return this.t9h() ? Companion_getInstance_5().d9i() : Companion_getInstance_5().r9p(this.wea(), this.xea(), this.w9z(), this.x9z());
  }
  jeq() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.ieq();
    var tmp;
    if (this_0.u9h()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.xep_1;
    result = imul(result, 31) + this.yep_1 | 0;
    result = imul(result, 31) + this.zep_1 | 0;
    result = imul(result, 31) + this.aeq_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.xep_1 === tmp0_other_with_cast.xep_1))
      return false;
    if (!(this.yep_1 === tmp0_other_with_cast.yep_1))
      return false;
    if (!(this.zep_1 === tmp0_other_with_cast.zep_1))
      return false;
    if (!(this.aeq_1 === tmp0_other_with_cast.aeq_1))
      return false;
    return true;
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.zei_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.aej_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_46().keq_1), Companion_getInstance_47().xeq_1, Companion_getInstance_47().xeq_1, Companion_getInstance_47().xeq_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_42();
    this.aer_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.aer_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.aer_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.aer_1, other);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.xei_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.yei_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_43();
    this.eer_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.eer_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.eer_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.eer_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.ier_1 = _AGDrawType___init__impl__emm6mb(0);
    this.jer_1 = _AGDrawType___init__impl__emm6mb(1);
    this.ker_1 = _AGDrawType___init__impl__emm6mb(2);
    this.ler_1 = _AGDrawType___init__impl__emm6mb(3);
    this.mer_1 = _AGDrawType___init__impl__emm6mb(4);
    this.ner_1 = _AGDrawType___init__impl__emm6mb(5);
    this.oer_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class AGDrawType {
  constructor(ordinal) {
    Companion_getInstance_44();
    this.per_1 = ordinal;
  }
  toString() {
    return AGDrawType__toString_impl_eonaeb(this.per_1);
  }
  hashCode() {
    return AGDrawType__hashCode_impl_ylaury(this.per_1);
  }
  equals(other) {
    return AGDrawType__equals_impl_rtafo6(this.per_1, other);
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.bej_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.cej_1 = _AGColorMask___init__impl__j38ai8_1();
    this.dej_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.eej_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.fej_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.gej_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class AGColorMask {
  constructor(data) {
    Companion_getInstance_45();
    this.qer_1 = data;
  }
  toString() {
    return AGColorMask__toString_impl_5i5oqg(this.qer_1);
  }
  hashCode() {
    return AGColorMask__hashCode_impl_g9082f(this.qer_1);
  }
  equals(other) {
    return AGColorMask__equals_impl_mrih8l(this.qer_1, other);
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.keq_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.leq_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.meq_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.neq_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.oeq_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.peq_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.qeq_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.req_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_46();
    this.rer_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.rer_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.rer_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.rer_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.seq_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.teq_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.ueq_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.veq_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.weq_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.xeq_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.yeq_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.zeq_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_47();
    this.ser_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.ser_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.ser_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.ser_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.nej_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.oej_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.pej_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.qej_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.rej_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGCullFace {
  constructor(ordinal) {
    Companion_getInstance_48();
    this.ter_1 = ordinal;
  }
  toString() {
    return AGCullFace__toString_impl_7d891w(this.ter_1);
  }
  hashCode() {
    return AGCullFace__hashCode_impl_t4e5ur(this.ter_1);
  }
  equals(other) {
    return AGCullFace__equals_impl_wgngjr(this.ter_1, other);
  }
}
class AGVertexArrayObject {
  constructor(list, isDynamic) {
    return new.target.xer(list, isDynamic);
  }
  static xer(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.uer_1 = new Mixin();
    $this.ver_1 = list;
    $this.wer_1 = isDynamic;
    return $this;
  }
  static yer(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.xer(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.ver_1.toString() + ', isDynamic=' + this.wer_1 + ')';
  }
  hashCode() {
    var result = this.ver_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.wer_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.ver_1.equals(tmp0_other_with_cast.ver_1))
      return false;
    if (!(this.wer_1 === tmp0_other_with_cast.wer_1))
      return false;
    return true;
  }
  o9u(value) {
    this.uer_1.o9u(value);
  }
  p9u() {
    return this.uer_1.p9u();
  }
}
class AGVertexData {
  constructor(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.hes([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.ies_1 = layout;
    this.jes_1 = buffer;
    this.kes_1 = baseOffset;
  }
  toString() {
    return 'AGVertexData(layout=' + this.ies_1.toString() + ', buffer=' + this.jes_1.toString() + ', baseOffset=' + this.kes_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.ies_1);
    result = imul(result, 31) + hashCode(this.jes_1) | 0;
    result = imul(result, 31) + this.kes_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.ies_1, tmp0_other_with_cast.ies_1))
      return false;
    if (!equals(this.jes_1, tmp0_other_with_cast.jes_1))
      return false;
    if (!(this.kes_1 === tmp0_other_with_cast.kes_1))
      return false;
    return true;
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.yer([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_51().mei_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().eet_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_61().uei_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_32.wei() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_50().qei_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_42().aej_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_43().yei_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_45().dej_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_52().iej_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_41().mej_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_48().oej_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_44().mer_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.jeh_1 = frameBuffer;
    this.keh_1 = frameBufferInfo;
    this.leh_1 = vertexData;
    this.meh_1 = indices;
    this.neh_1 = indexType;
    this.oeh_1 = program;
    this.peh_1 = uniformBlocks;
    this.qeh_1 = textureUnits;
    this.reh_1 = blending;
    this.seh_1 = stencilOpFunc;
    this.teh_1 = stencilRef;
    this.ueh_1 = colorMask;
    this.veh_1 = depthAndFrontFace;
    this.weh_1 = scissor;
    this.xeh_1 = cullFace;
    this.yeh_1 = drawType;
    this.zeh_1 = drawOffset;
    this.aei_1 = vertexCount;
    this.bei_1 = instances;
  }
  cei(ag) {
    ag.eeh(this.jeh_1, this.keh_1, this.leh_1, this.oeh_1, this.yeh_1, this.aei_1, this.meh_1, this.neh_1, this.zeh_1, this.reh_1, this.peh_1, this.qeh_1, this.teh_1, this.seh_1, this.ueh_1, this.veh_1, this.weh_1, this.xeh_1, this.bei_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.jeh_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.keh_1) + ', vertexData=' + this.leh_1.toString() + ', indices=' + toString_1(this.meh_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.neh_1) + ', program=' + this.oeh_1.toString() + ', uniformBlocks=' + toString(this.peh_1) + ', textureUnits=' + this.qeh_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.reh_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.seh_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.teh_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.ueh_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.veh_1) + ', scissor=' + this.weh_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.xeh_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.yeh_1) + ', drawOffset=' + this.zeh_1 + ', vertexCount=' + this.aei_1 + ', instances=' + this.bei_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.jeh_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.keh_1) | 0;
    result = imul(result, 31) + this.leh_1.hashCode() | 0;
    result = imul(result, 31) + (this.meh_1 == null ? 0 : hashCode(this.meh_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.neh_1) | 0;
    result = imul(result, 31) + this.oeh_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.peh_1) | 0;
    result = imul(result, 31) + this.qeh_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.reh_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.seh_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.teh_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.ueh_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.veh_1) | 0;
    result = imul(result, 31) + this.weh_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.xeh_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.yeh_1) | 0;
    result = imul(result, 31) + this.zeh_1 | 0;
    result = imul(result, 31) + this.aei_1 | 0;
    result = imul(result, 31) + this.bei_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.jeh_1, tmp0_other_with_cast.jeh_1))
      return false;
    if (!equals(this.keh_1, tmp0_other_with_cast.keh_1))
      return false;
    if (!this.leh_1.equals(tmp0_other_with_cast.leh_1))
      return false;
    if (!equals(this.meh_1, tmp0_other_with_cast.meh_1))
      return false;
    if (!(this.neh_1 === tmp0_other_with_cast.neh_1))
      return false;
    if (!this.oeh_1.equals(tmp0_other_with_cast.oeh_1))
      return false;
    if (!equals(this.peh_1, tmp0_other_with_cast.peh_1))
      return false;
    if (!this.qeh_1.equals(tmp0_other_with_cast.qeh_1))
      return false;
    if (!(this.reh_1 === tmp0_other_with_cast.reh_1))
      return false;
    if (!(this.seh_1 === tmp0_other_with_cast.seh_1))
      return false;
    if (!equals(this.teh_1, tmp0_other_with_cast.teh_1))
      return false;
    if (!(this.ueh_1 === tmp0_other_with_cast.ueh_1))
      return false;
    if (!(this.veh_1 === tmp0_other_with_cast.veh_1))
      return false;
    if (!this.weh_1.equals(tmp0_other_with_cast.weh_1))
      return false;
    if (!(this.xeh_1 === tmp0_other_with_cast.xeh_1))
      return false;
    if (!(this.yeh_1 === tmp0_other_with_cast.yeh_1))
      return false;
    if (!(this.zeh_1 === tmp0_other_with_cast.zeh_1))
      return false;
    if (!(this.aei_1 === tmp0_other_with_cast.aei_1))
      return false;
    if (!(this.bei_1 === tmp0_other_with_cast.bei_1))
      return false;
    return true;
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.het_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.iet_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.oei_1 = _AGBlending___init__impl__upt3bq(-1);
    this.pei_1 = Companion_getInstance_50().xet(Companion_getInstance_57().pet_1, Companion_getInstance_57().wet_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().wet_1);
    this.qei_1 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().set_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().set_1);
    this.rei_1 = Companion_getInstance_50().yet(Companion_getInstance_57().pet_1, Companion_getInstance_57().set_1);
    this.sei_1 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().net_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
    this.tei_1 = Companion_getInstance_50().xet(Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
  }
  zet(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  xet(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_58().aeu_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.zet(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.zet.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).jet_1;
  }
  deu(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  yet(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_58().aeu_1 : eq;
    return $super === VOID ? this.deu(src, dst, eq) : $super.deu.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).jet_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_50();
    this.jet_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.jet_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.jet_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.jet_1, other);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.eeu_1 = frameBuffer;
    this.feu_1 = frameBufferInfo;
    this.geu_1 = color;
    this.heu_1 = depth;
    this.ieu_1 = stencil;
    this.jeu_1 = clearColor;
    this.keu_1 = clearDepth;
    this.leu_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.eeu_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.feu_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.geu_1) + ', depth=' + this.heu_1 + ', stencil=' + this.ieu_1 + ', clearColor=' + this.jeu_1 + ', clearDepth=' + this.keu_1 + ', clearStencil=' + this.leu_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.eeu_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.feu_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.geu_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.heu_1) | 0;
    result = imul(result, 31) + this.ieu_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jeu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.keu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.leu_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.eeu_1, tmp0_other_with_cast.eeu_1))
      return false;
    if (!equals(this.feu_1, tmp0_other_with_cast.feu_1))
      return false;
    if (!(this.geu_1 === tmp0_other_with_cast.geu_1))
      return false;
    if (!equals(this.heu_1, tmp0_other_with_cast.heu_1))
      return false;
    if (!(this.ieu_1 === tmp0_other_with_cast.ieu_1))
      return false;
    if (!(this.jeu_1 === tmp0_other_with_cast.jeu_1))
      return false;
    if (!(this.keu_1 === tmp0_other_with_cast.keu_1))
      return false;
    if (!(this.leu_1 === tmp0_other_with_cast.leu_1))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.kei_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.lei_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.mei_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.nei_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.hej_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.iej_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_46().keq_1), Companion_getInstance_59().meu_1);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.uej_1 = _AGReadKind___init__impl__sw15xt(0);
    this.vej_1 = _AGReadKind___init__impl__sw15xt(1);
    this.wej_1 = _AGReadKind___init__impl__sw15xt(2);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.eel_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.fel_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.gel_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.hel_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_54();
    this.jel_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.jel_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.jel_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.jel_1, other);
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_48 = this;
    this.ren_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.sen_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.ten_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_55();
    this.peu_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.peu_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.peu_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.peu_1, other);
  }
}
class Companion_40 {
  qeu() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  get(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.net_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.oet_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.pet_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.qet_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.ret_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.set_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.tet_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.uet_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.vet_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.wet_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_57();
    this.reu_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.reu_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.reu_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.reu_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.aeu_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.beu_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.ceu_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_58();
    this.seu_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.seu_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.seu_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.seu_1, other);
  }
}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    this.meu_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.neu_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.oeu_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.tej_1 = list;
  }
  cei(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.tej_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.u2(_unary__edvuaz).cei(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.tej_1) + ')';
  }
  hashCode() {
    return hashCode(this.tej_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.tej_1, tmp0_other_with_cast.tej_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.teu_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.teu_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.teu_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.teu_1 === tmp0_other_with_cast.teu_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_9().tb3(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_9().tb3(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_9().tb3(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.ueu_1 = texturesCount;
    this.veu_1 = texturesMemory;
    this.weu_1 = buffersCount;
    this.xeu_1 = buffersMemory;
    this.yeu_1 = frameBuffersCount;
    this.zeu_1 = frameBuffersMemory;
    this.aev_1 = texturesCreated;
    this.bev_1 = texturesDeleted;
    this.cev_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.ueu_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.veu_1) + ', buffers[' + this.weu_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.xeu_1) + ', frameBuffers[' + this.yeu_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.zeu_1) + ', programs[' + this.cev_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.sep_1 = fixedLocation;
    this.tep_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.uep_1 = ArrayList.p2();
    this.vep_1 = 0;
  }
  h1() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  wev() {
    return this.uep_1;
  }
  xev() {
    return this.tep_1.s2();
  }
  yev() {
    return nextMultipleOf(this.xev(), 256);
  }
  zev() {
    return this.wev().s2();
  }
  aew(name) {
    return this.hew(name, VarType_Float1_getInstance(), 4, 4);
  }
  bew(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.aew(name) : $super.aew.call(this, name);
  }
  cew(name) {
    return this.hew(name, VarType_Float2_getInstance(), 8, 8);
  }
  dew(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.cew(name) : $super.cew.call(this, name);
  }
  eew(name) {
    return this.hew(name, VarType_Float4_getInstance(), 16, 16);
  }
  few(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.eew(name) : $super.eew.call(this, name);
  }
  gew(name) {
    return this.hew(name, VarType_Mat4_getInstance(), 64, 16);
  }
  lev(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.gew(name) : $super.gew.call(this, name);
  }
  hew(name, type, size, align) {
    var tmp = this.tep_1.cfe(size, align);
    var _unary__edvuaz = this.vep_1;
    this.vep_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.wev(), ', ') + ', fixedLocation=' + this.sep_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    var tmp = this;
    var tmp_0 = this.lev();
    var tmp_1 = KProperty1;
    tmp.hev_1 = tmp_0.vev(this, getPropertyCallableRef('u_ProjMat', 1, tmp_1, DefaultShaders$ProjViewUB$_get_u_ProjMat_$ref_f2hall(), null));
    var tmp_2 = this;
    var tmp_3 = this.lev();
    var tmp_4 = KProperty1;
    tmp_2.iev_1 = tmp_3.vev(this, getPropertyCallableRef('u_ViewMat', 1, tmp_4, DefaultShaders$ProjViewUB$_get_u_ViewMat_$ref_a9z0a9(), null));
  }
  jev() {
    var tmp = KProperty1;
    return this.hev_1.yq(this, getPropertyCallableRef('u_ProjMat', 1, tmp, DefaultShaders$ProjViewUB$_get_u_ProjMat_$ref_f2hall(), null));
  }
  kev() {
    var tmp = KProperty1;
    return this.iev_1.yq(this, getPropertyCallableRef('u_ViewMat', 1, tmp, DefaultShaders$ProjViewUB$_get_u_ViewMat_$ref_a9z0a9(), null));
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    var tmp = this;
    var tmp_0 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance());
    var tmp_1 = KProperty1;
    tmp.les_1 = tmp_0.mew(this, getPropertyCallableRef('u_Tex', 1, tmp_1, DefaultShaders$_get_u_Tex_$ref_n7dx9w(), null));
    var tmp_2 = this;
    var tmp_3 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance());
    var tmp_4 = KProperty1;
    tmp_2.mes_1 = tmp_3.mew(this, getPropertyCallableRef('u_TexEx', 1, tmp_4, DefaultShaders$_get_u_TexEx_$ref_359me1(), null));
    this.nes_1 = Attribute.dex('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.oes_1 = Attribute.dex('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.pes_1 = Attribute.dex('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.qes_1 = Varying.pex('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.res_1 = Varying.pex('v_Col', VarType_Float4_getInstance());
    this.ses_1 = Temp.bey(0, VarType_Float4_getInstance());
    this.tes_1 = Temp.bey(1, VarType_Float4_getInstance());
    this.ues_1 = Temp.bey(2, VarType_Mat2_getInstance());
    this.ves_1 = ProgramLayout.hes([this.nes_1, this.oes_1, this.pes_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.eey();
    builder.jey(builder.fey(), builder.gey());
    builder.jey(builder.key(), builder.ley());
    builder.jey(builder.mey(), builder.ney(builder.ney(builder.jev(), builder.kev()), builder.qey([builder.oey(), builder.pey(0.0), builder.pey(1.0)])));
    tmp_5.wes_1 = VertexShader(builder.rey());
    var tmp_6 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.eey();
    var coords = this_0.sey(this_0.fey(), 'xy');
    this_0.jey(this_0.mey(), this_0.ney(this_0.tey(this_0.iew(), coords), this_0.uey(this_0.tey(DefaultShaders_getInstance().jew(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.rey());
    tmp_6.xes_1 = new Program(this.wes_1, tmp$ret$2);
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.eey();
    builder_0.jey(builder_0.mey(), builder_0.qey([builder_0.pey(1.0), builder_0.pey(1.0), builder_0.pey(0.0), builder_0.pey(1.0)]));
    tmp_7.yes_1 = FragmentShader(builder_0.rey());
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.eey();
    builder_1.jey(builder_1.mey(), builder_1.key());
    tmp_8.zes_1 = FragmentShader(builder_1.rey());
    var tmp_9 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.eey();
    builder_2.jey(builder_2.mey(), builder_2.ney(builder_2.sey(builder_2.tey(builder_2.iew(), builder_2.sey(builder_2.fey(), 'xy')), 'rgba'), builder_2.key()));
    var tmp$ret$9 = FragmentShader(builder_2.rey());
    tmp_9.aet_1 = new Program(this.wes_1, tmp$ret$9, 'PROGRAM_TINTED_TEXTURE');
    var tmp_10 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.eey();
    builder_3.jey(builder_3.vey(), builder_3.tey(builder_3.iew(), builder_3.sey(builder_3.fey(), 'xy')));
    builder_3.jey(builder_3.sey(builder_3.vey(), 'rgb'), builder_3.wey(builder_3.sey(builder_3.vey(), 'rgb'), builder_3.sey(builder_3.vey(), 'a')));
    builder_3.jey(builder_3.mey(), builder_3.ney(builder_3.sey(builder_3.vey(), 'rgba'), builder_3.key()));
    var tmp$ret$11 = FragmentShader(builder_3.rey());
    tmp_10.bet_1 = new Program(this.wes_1, tmp$ret$11, 'PROGRAM_TINTED_TEXTURE');
    this.cet_1 = new Program(this.wes_1, this.zes_1, 'PROGRAM_SOLID_COLOR');
    this.det_1 = ProgramLayout.hes([this.nes_1]);
    var tmp_11 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.eey();
    builder_4.jey(builder_4.mey(), builder_4.qey([builder_4.oey(), builder_4.pey(0.0), builder_4.pey(1.0)]));
    var tmp_12 = VertexShader(builder_4.rey());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.eey();
    builder_5.jey(builder_5.mey(), builder_5.qey([builder_5.pey(1.0), builder_5.pey(0.0), builder_5.pey(0.0), builder_5.pey(1.0)]));
    var tmp$ret$15 = FragmentShader(builder_5.rey());
    tmp_11.eet_1 = new Program(tmp_12, tmp$ret$15, 'PROGRAM_DEBUG');
    var tmp_13 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.eey();
    builder_6.jey(builder_6.mey(), builder_6.ney(builder_6.ney(builder_6.jev(), builder_6.kev()), builder_6.qey([builder_6.oey(), builder_6.pey(0.0), builder_6.pey(1.0)])));
    var tmp_14 = VertexShader(builder_6.rey());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.eey();
    builder_7.jey(builder_7.mey(), builder_7.qey([builder_7.pey(1.0), builder_7.pey(0.0), builder_7.pey(0.0), builder_7.pey(1.0)]));
    var tmp$ret$19 = FragmentShader(builder_7.rey());
    tmp_13.fet_1 = new Program(tmp_14, tmp$ret$19, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  iew() {
    var tmp = KProperty1;
    return this.les_1.yq(this, getPropertyCallableRef('u_Tex', 1, tmp, DefaultShaders$_get_u_Tex_$ref_n7dx9w(), null));
  }
  jew() {
    var tmp = KProperty1;
    return this.mes_1.yq(this, getPropertyCallableRef('u_TexEx', 1, tmp, DefaultShaders$_get_u_TexEx_$ref_359me1(), null));
  }
  jev() {
    return ProjViewUB_getInstance().jev().rep_1;
  }
  kev() {
    return ProjViewUB_getInstance().kev().rep_1;
  }
}
class VarTypeAccessor {}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function atan(y, x) {
  return Func.nfl('atan', [y, x], y.d8o());
}
function texture2D(sampler, coord) {
  return Func.nfl('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.zfk(cond, otrue, ofalse);
}
function pow(b, e) {
  return Func.nfl('pow', [b, e], b.d8o());
}
function exp(v) {
  return Func.nfl('exp', [v], v.d8o());
}
function sqrt(v) {
  return Func.nfl('sqrt', [v], v.d8o());
}
function abs(v) {
  return Func.nfl('abs', [v], v.d8o());
}
function fract(v) {
  return Func.nfl('fract', [v], v.d8o());
}
function clamp(v, min, max) {
  return Func.nfl('clamp', [v, min, max], v.d8o());
}
function min_0(a, b) {
  return Func.nfl('min', [a, b], a.d8o());
}
function max_1(a, b) {
  return Func.nfl('max', [a, b], a.d8o());
}
function fwidth(a) {
  return Func.nfl('fwidth', [a], a.d8o());
}
function mix(a, b, step) {
  return Func.nfl('mix', [a, b, step], a.d8o());
}
function smoothstep(a, b, c) {
  return Func.nfl('smoothstep', [a, b, c], a.d8o());
}
function length(a) {
  return Func.nfl('length', [a], VarType_Float1_getInstance());
}
function dot(a, b) {
  return Func.nfl('dot', [a, b], VarType_Float1_getInstance());
}
function get_lit(_this__u8e3s4) {
  return FloatLiteral.dfl(_this__u8e3s4);
}
function vec2(ops) {
  return Vector.efl(VarType_Float2_getInstance(), ops);
}
function vec3(ops) {
  return Vector.efl(VarType_Float3_getInstance(), ops);
}
function vec4(ops) {
  return Vector.efl(VarType_Float4_getInstance(), ops);
}
function vec2_0(ops) {
  var tmp = VarType_Float2_getInstance();
  var tmp_0 = 0;
  var tmp_1 = ops.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = Array(tmp_1);
  while (tmp_0 < tmp_1) {
    var tmp_3 = tmp_0;
    tmp_2[tmp_3] = this.pey(ops[tmp_3]);
    tmp_0 = tmp_0 + 1 | 0;
  }
  return Vector.efl(tmp, tmp_2);
}
function vec3_0(ops) {
  var tmp = VarType_Float3_getInstance();
  var tmp_0 = 0;
  var tmp_1 = ops.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = Array(tmp_1);
  while (tmp_0 < tmp_1) {
    var tmp_3 = tmp_0;
    tmp_2[tmp_3] = this.pey(ops[tmp_3]);
    tmp_0 = tmp_0 + 1 | 0;
  }
  return Vector.efl(tmp, tmp_2);
}
function get_1(_this__u8e3s4, swizzle) {
  return Swizzle.ffl(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.sey(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.sey(_this__u8e3s4, 'y');
}
function get_z(_this__u8e3s4) {
  return this.sey(_this__u8e3s4, 'z');
}
function get_w(_this__u8e3s4) {
  return this.sey(_this__u8e3s4, 'w');
}
function get_a(_this__u8e3s4) {
  return this.sey(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.bfl('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '==', that);
}
function lt(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '<', that);
}
function le(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.cfl(_this__u8e3s4, '>', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.uf0(this.pey(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.xf0(this.pey(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.ney(this.pey(_this__u8e3s4), that);
}
function minus_2(_this__u8e3s4, that) {
  return this.uf0(_this__u8e3s4, this.pey(that));
}
function plus_4(_this__u8e3s4, that) {
  return this.xf0(_this__u8e3s4, this.pey(that));
}
function times_1(_this__u8e3s4, that) {
  return this.ney(_this__u8e3s4, this.pey(that));
}
function div_0(_this__u8e3s4, that) {
  return this.wey(_this__u8e3s4, this.pey(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.gf1(_this__u8e3s4, this.pey(that));
}
class Builder {
  constructor(context) {
    return new.target.xey(context);
  }
  static xey(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.hey_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.iey_1 = ArrayList.p2();
    return $this;
  }
  static ffk(parent) {
    return this.xey(parent.hey_1);
  }
  yey() {
    return Builder.ffk(this);
  }
  zey() {
    return FuncBuilder.efk(this);
  }
  aez() {
    return new Stms(toList(this.iey_1));
  }
  bez() {
    var funcs = LinkedHashMap.m7();
    (new Program$Builder$_funcs$1(funcs)).yfk(this.iey_1);
    var _iterator__ex2g4s = this.hey_1.qfl_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var func = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.set' call
      var key = func.afg_1;
      funcs.b5(key, func);
    }
    return toList(funcs.y4());
  }
  rey() {
    return to(this.aez(), this.bez());
  }
  cez(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.zey();
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.cfk_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$3 = to(item.if4_1, item.d8o());
      destination.d2(tmp$ret$3);
    }
    // Inline function 'kotlin.also' call
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.aez());
    // Inline function 'kotlin.collections.plusAssign' call
    this.hey_1.qfl_1.d2(this_2);
    return this_2;
  }
  dez(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  eez(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.dez(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.dez;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  fez(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  gez(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.fez(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.fez;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  hez(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  iez(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.hez(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.hez;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  jez(type) {
    var _receiver__tnumb7 = this.hey_1;
    var _unary__edvuaz = _receiver__tnumb7.rfl_1;
    _receiver__tnumb7.rfl_1 = _unary__edvuaz + 1 | 0;
    return Temp.bey(_unary__edvuaz, type);
  }
  kez(initialValue) {
    var temp = this.jez(initialValue.d8o());
    this.jey(temp, initialValue);
    return temp;
  }
  lez(_this__u8e3s4, p0) {
    return CustomFunc.ofl(_this__u8e3s4, listOf(p0));
  }
  mez(_this__u8e3s4, p0, p1) {
    return CustomFunc.ofl(_this__u8e3s4, listOf_0([p0, p1]));
  }
  nez(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.ofl(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  oez(_this__u8e3s4, callback) {
    var body = this.yey();
    callback(body);
    _this__u8e3s4.cfj_1 = body.aez();
  }
  pez(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.df1(ref, this.pey(min));
      var body = this.yey();
      block(body, min);
      var stmIf = new If(cond, body.aez());
      // Inline function 'kotlin.collections.plusAssign' call
      this.iey_1.d2(stmIf);
      var tmp = stmIf;
      this.oez(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.ff1(ref, this.pey(middle));
      var body_0 = this.yey();
      body_0.pez(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.aez());
      // Inline function 'kotlin.collections.plusAssign' call
      this.iey_1.d2(stmIf_0);
      var tmp_0 = stmIf_0;
      this.oez(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  qez(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.df1(ref, this.pey(min));
      var body = this.yey();
      block(body, min);
      var stmIf = new If(cond, body.aez());
      // Inline function 'kotlin.collections.plusAssign' call
      this.iey_1.d2(stmIf);
      var tmp = stmIf;
      this.oez(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  }
  rez(shader) {
    this.sez(shader);
    return this;
  }
  sez(shader) {
    var tmp = shader.ofe_1;
    if (tmp instanceof Stms) {
      this.iey_1.t2(shader.ofe_1.gfi_1);
    } else {
      this.iey_1.d2(shader.ofe_1);
    }
    this.hey_1.qfl_1.t2(shader.pfe_1);
  }
  jey(target, expr) {
    var tmp0 = this.iey_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new Set(target, expr);
    tmp0.d2(element);
  }
  tez() {
    var tmp0 = this.iey_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = Discard_getInstance();
    tmp0.d2(element);
  }
  uez(operand) {
    var tmp0 = this.iey_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new Return(operand);
    tmp0.d2(element);
  }
  vez(operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.uez(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.uez.call(this, operand);
    }
    return tmp;
  }
  wez(type) {
    var _receiver__tnumb7 = this.hey_1;
    var _unary__edvuaz = _receiver__tnumb7.rfl_1;
    _receiver__tnumb7.rfl_1 = _unary__edvuaz + 1 | 0;
    return Temp.sfl(_unary__edvuaz, type, 1);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().iew();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().jev();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().kev();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().nes_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().oes_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().pes_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().qes_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().res_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().ses_1;
}
function get_t_Temp1() {
  return DefaultShaders_getInstance().tes_1;
}
class ProgramBuilderDefault extends Builder {
  constructor() {
    return new.target.eey();
  }
  static eey() {
    return this.xey();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.if1_1 = vao;
    this.jf1_1 = glId;
    this.kf1_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  constructor(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    return new.target.vf1(str, error, errorInt, gl, debugName, type, shaderReturnInt);
  }
  static vf1(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.xb('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.uf1_1);
    $this.nf1_1 = str;
    $this.of1_1 = error;
    $this.pf1_1 = errorInt;
    $this.qf1_1 = gl;
    $this.rf1_1 = debugName;
    $this.sf1_1 = type;
    $this.tf1_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.wf4_1 = index;
    this.xf4_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.yf4_1 = -1;
    this.zf4_1 = -1;
    this.af5_1 = -1;
    this.bf5_1 = -1;
  }
  ra8() {
    this.xf4_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.yf4_1 = -1;
    this.zf4_1 = -1;
    this.af5_1 = -1;
    this.bf5_1 = -1;
  }
}
class AGOpengl extends AG {
  constructor(gl, context) {
    return new.target.kf7(gl, context);
  }
  static kf7(gl, context) {
    context = context === VOID ? null : context;
    var $this = this.keg();
    $this.af2_1 = gl;
    $this.bf2_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.cf2_1 = LinkedHashSet.v2();
    $this.df2_1 = new GLGlobalState($this.af2_1, $this);
    $this.ef2_1 = HashMap.s9();
    $this.ff2_1 = null;
    var tmp_0 = $this;
    tmp_0.gf2_1 = lazy(AGOpengl$glslConfig$delegate$lambda($this));
    $this.hf2_1 = null;
    $this.if2_1 = Companion_getInstance_50().oei_1;
    $this.jf2_1 = Companion_getInstance_48().nej_1;
    $this.kf2_1 = Companion_getInstance_42().zei_1;
    $this.lf2_1 = Companion_getInstance_43().xei_1;
    $this.mf2_1 = Companion_getInstance_45().bej_1;
    $this.nf2_1 = Companion_getInstance_52().hej_1;
    $this.of2_1 = null;
    $this.pf2_1 = AGTextureUnits.jem();
    $this.qf2_1 = new Int32Array($this.pf2_1.s2());
    $this.rf2_1 = 0;
    $this.sf2_1 = Companion_getInstance_41().lej_1;
    $this.tf2_1 = -1;
    $this.uf2_1 = -1;
    $this.vf2_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    $this.wf2_1 = Ref();
    $this.xf2_1 = Buffer.eb2(36);
    var tmp_1 = $this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = Array(32);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.yf2_1 = tmp_3;
    $this.zf2_1 = allocDirect(Companion_instance_4, 0);
    $this.af3_1 = 7;
    $this.bf3_1 = 0;
    $this.cf3_1 = Companion_instance_49.qeu();
    $this.df3_1 = -1;
    $this.ef3_1 = new Long(-1, -1);
    $this.ff3_1 = null;
    return $this;
  }
  static lf7(context) {
    return this.kf7(context.nf7_1, context);
  }
  geh() {
    return this.af2_1;
  }
  aeh() {
    var gl = this.af2_1;
    super.aeh();
    gl.pf7();
    gl.qf7();
    this.ef2_1.a5();
    resetObjects(this);
    this.tf2_1 = -1;
    this.uf2_1 = -1;
    this.vf2_1 = true;
  }
  deh(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.af2_1;
    this.rf7(frameBuffer, frameBufferInfo);
    this.sf7(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.tf7(Companion_getInstance_45().eej_1);
      gl.uf7(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.vf7(true);
      gl.wf7(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.kf2_1 = Companion_getInstance_42().zei_1;
      gl.xf7(-1);
      gl.yf7(stencil);
      mask = mask | 1024;
    }
    gl.zf7(mask);
  }
  eeh(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.af2_1;
    this.rf7(frameBuffer, frameBufferInfo);
    this.sf7(scissor, frameBuffer, frameBufferInfo);
    var tmp1_safe_receiver = this.hf2_1;
    if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ver_1, vertexData.ver_1)) {
      var tmp0_safe_receiver = this.hf2_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this.af8(tmp0_safe_receiver);
      }
      this.hf2_1 = vertexData;
      this.bf8(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.ver_1.d9v_1;
      var n = 0;
      while (n < array.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer(this, entry.jes_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.cf8(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.if2_1 === blending)) {
      this.if2_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.ff8(3042, enable)) {
        gl.df8(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.ef8(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.gf8(depthAndFrontFace);
    this.tf7(colorMask);
    if (!(this.jf2_1 === cullFace)) {
      this.jf2_1 = cullFace;
      this.hf8(cullFace);
    }
    if (!(this.kf2_1 === stencilOpFunc) || !equals(this.lf2_1, stencilRef)) {
      this.kf2_1 = stencilOpFunc;
      this.lf2_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.jf8(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.lf8(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.kf8(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.kf8(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.nf8(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.mf8(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.mf8(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.xf7(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.of8(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.of8(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.if8(2960);
        gl.xf7(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      bindBuffer(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_51().kei_1;
    if (!(indexType_0 === Companion_getInstance_51().kei_1))
      if (!(instances === 1)) {
        gl.sf8(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.rf8(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.qf8(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.pf8(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  lf3() {
    var tmp0 = this.gf2_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('glslConfig', 1, tmp, AGOpengl$_get_glslConfig_$ref_sx7q53(), null);
    return tmp0.k3();
  }
  ceh() {
    var gl = this.af2_1;
    var tmp0_safe_receiver = this.bf2_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.tf8();
    }
    gl.uf8(this.ieg_1);
    resetObjects(this);
    this.rf2_1 = getIntegerv(gl, 36006);
    gl.vf6(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.wf6())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.uf6(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.uf6(3553, 33085, 0);
    }
  }
  qeb() {
    var tmp0_safe_receiver = this.hf2_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.af8(tmp0_safe_receiver);
    }
    this.hf2_1 = null;
    this.rf7(this.zeg().leg_1, this.zeg().sej());
    var tmp1_safe_receiver = this.bf2_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.vf8();
    }
  }
  v7e() {
    var tmp0_safe_receiver = this.hf2_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.af8(tmp0_safe_receiver);
    }
    this.hf2_1 = null;
    this.af2_1.nd();
    deletePendingObjects(this);
  }
  hf8(face) {
    if (this.af2_1.ff8(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_48().oej_1))) {
      this.af2_1.wf8(toGl_5(face));
    }
  }
  vf5(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.cem_1 === _this__u8e3s4.dem_1)) {
      _this__u8e3s4.cem_1 = _this__u8e3s4.dem_1;
      block(_this__u8e3s4);
    }
  }
  af8(vao) {
    if (this.vf2_1 && this.af2_1.ieh()) {
      this.af2_1.zf8(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.ver_1.d9v_1;
      var n = 0;
      while (n < array.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = array[_unary__edvuaz].ies_1.zer_1;
        var n_0 = 0;
        while (n_0 < this_0.s2()) {
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.u2(_unary__edvuaz_0);
          if (att.aex_1) {
            var loc = att.cex_1;
            if (loc >= 0) {
              if (!(att.bex_1 === 0)) {
                this.af2_1.xf8(loc, 0);
              }
              this.af2_1.yf8(loc);
            }
          }
        }
      }
    }
  }
  bf8(vao) {
    var gl = this.af2_1;
    if (this.vf2_1 && gl.ieh()) {
      var vaoGl = get_gl(vao);
      if (vao.wer_1) {
        if (!(this.uf2_1 === this.ieg_1)) {
          this.tf2_1 = genVertexArray(gl);
          this.uf2_1 = this.ieg_1;
          if (this.tf2_1 <= 0)
            this.vf2_1 = false;
        }
        gl.zf8(this.tf2_1);
        this.af9(vao);
      } else {
        if (!(vaoGl.kf1_1 === this.ieg_1)) {
          vaoGl.kf1_1 = this.ieg_1;
          vaoGl.jf1_1 = genVertexArray(gl);
          if (vaoGl.jf1_1 <= 0)
            this.vf2_1 = false;
          gl.zf8(vaoGl.jf1_1);
          this.af9(vao);
        }
        gl.zf8(vaoGl.jf1_1);
        this.bf9(vao, this.vf2_1);
      }
    } else {
      this.af9(vao);
    }
  }
  bf9(vao, updateBuffersOnly) {
    var gl = this.af2_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.ver_1.d9v_1;
      var n = 0;
      while (n < array.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer(this, entry.jes_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.wf2_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.ver_1.d9v_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.jes_1;
      var vertexLayout = entry_0.ies_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.zer_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.ees_1;
      bindBuffer(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.wf2_1);
      var totalSize = vertexLayout.ges_1;
      var inductionVariable = 0;
      var last = vattrspos.s2() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.u2(n_1);
          if (!att.aex_1)
            continue $l$loop;
          var off = vattrspos.u2(n_1);
          var loc = att.cex_1;
          var glElementType = toGl_7(att.d8o());
          var elementCount = att.d8o().gf6_1;
          if (loc >= 0) {
            gl.cf9(loc);
            gl.df9(loc, elementCount, glElementType, att.zew_1, totalSize, add(numberToLong(entry_0.kes_1), fromInt(off)));
            if (!(att.bex_1 === 0)) {
              gl.xf8(loc, att.bex_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  af9(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.bf9(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.bf9.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  cf8(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.of2_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2 = textureUnits.hem_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.iem_1, n);
        var tex = tmp2;
        if (equals(frameBuffer.gek_1, tex)) {
          tex = null;
        }
        var tmp0_safe_receiver = tex;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dem_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if (!(this.pf2_1.hem_1[n] === tex) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.pf2_1.iem_1, n) === info) || !(this.qf2_1[n] === texVersion)) {
          this.pf2_1.mem(n, tex, info);
          this.qf2_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.ef9(tex, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex.iel(), wrap, this.ff9(tex, linear, trilinear), this.gf9(tex, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex.iel()));
          } else {
            this.ef9(null, Companion_getInstance_54().eel_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.qf3_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.s2();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_0 = uniformBlocks.hf9_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var block = tmp_0;
        var tmp4 = uniformBlocks.if9_1[n_0];
        var tmp6 = uniformBlocks.jf9_1[n_0];
        $l$block: {
          if (glProgram.qf3_1.wf3_1.vf4()) {
            var buffer = bindBuffer(this, tmp4, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_0 = buffer == null ? null : buffer.sf5_1;
            this.af2_1.kf9(35345, block.yen_1.sep_1, tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0, imul(tmp6, block.beo_1), block.beo_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.zf3_1[block.yen_1.sep_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.error' call
            var message = "Can't find uniform at " + block.yen_1.sep_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.o(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(tmp4).jen_1);
          var currentMem = ref.mf9_1;
          var ublock = ref.lf9_1;
          if (tmp6 >= 0) {
            if (!arrayequal(bufferMem, tmp6, currentMem, 0, ublock.yev())) {
              arraycopy_0(bufferMem, imul(ublock.yev(), tmp6), currentMem, 0, ublock.yev());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.wev();
              var n_1 = 0;
              while (n_1 < this_0.s2()) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.u2(_unary__edvuaz);
                writeUniform(this, uniform.rep_1, glProgramInfo, sliceBuffer(currentMem, uniform.oep_1, uniform.oep_1 + uniform.cf6_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.yen_1.toString() + ' has an invalid valueIndex=' + tmp6);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  ff9(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.yek_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  gf9(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  pf9(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_41().mej_1) || scissor.equals(Companion_getInstance_41().kej_1) ? scissor : frameBuffer.fek_1 ? Companion_getInstance_41().v9p(scissor.v9h(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.y9h() | 0, scissor.w9h(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.x9h() | 0) : scissor;
  }
  feh(frameBuffer, frameBufferInfo, x, y, width, height, data, kind) {
    var gl = this.af2_1;
    this.rf7(frameBuffer, frameBufferInfo);
    var region = this.pf9(AGScissor.beq(x, y, width, height), frameBuffer, frameBufferInfo);
    var tmp;
    if (isIntArray(data)) {
      tmp = 4;
    } else {
      if (isFloatArray(data)) {
        tmp = 4;
      } else {
        if (isByteArray(data)) {
          tmp = 1;
        } else {
          tmp = kind === Companion_getInstance_53().uej_1 ? 4 : kind === Companion_getInstance_53().vej_1 ? 4 : kind === Companion_getInstance_53().wej_1 ? 1 : 1;
        }
      }
    }
    var bytesPerPixel = tmp;
    var flipY = frameBuffer.fek_1;
    var area = imul(width, height);
    var stride = imul(width, bytesPerPixel);
    var nbytes = imul(height, stride);
    if (this.zf2_1.jb2() < nbytes) {
      this.zf2_1 = allocDirect(Companion_instance_4, nbytes);
    }
    var buffer = this.zf2_1;
    if (kind === Companion_getInstance_53().uej_1) {
      gl.qf9(region.wea(), region.xea(), region.w9z(), region.x9z(), 6408, 5121, buffer);
    } else if (kind === Companion_getInstance_53().vej_1) {
      gl.qf9(region.wea(), region.xea(), region.w9z(), region.x9z(), 6402, 5126, buffer);
    } else if (kind === Companion_getInstance_53().wej_1) {
      gl.qf9(region.wea(), region.xea(), region.w9z(), region.x9z(), 6401, 5121, buffer);
    }
    if (isIntArray(data))
      getS32Array(buffer, 0, data, VOID, area);
    else {
      if (isFloatArray(data))
        getF32Array(buffer, 0, data, VOID, area);
      else {
        if (isByteArray(data))
          getS8Array(buffer, 0, data, VOID, area);
        else {
          if (data instanceof Buffer) {
            if (flipY) {
              var inductionVariable = 0;
              if (inductionVariable < height)
                do {
                  var n = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  arraycopy_0(buffer, imul((height - 1 | 0) - n | 0, stride), data, imul(n, stride), stride);
                }
                 while (inductionVariable < height);
            } else {
              arraycopy_0(buffer, 0, data, 0, nbytes);
            }
          } else {
            // Inline function 'kotlin.TODO' call
            throw NotImplementedError.le();
          }
        }
      }
    }
    if (flipY) {
      var tmp_0;
      if (isIntArray(data)) {
        tmp_0 = Bitmap32.fcb(width, height, _RgbaArray___init__impl__oib4y4(data));
      } else {
        if (isFloatArray(data)) {
          tmp_0 = FloatBitmap32.lce(width, height, data);
        } else {
          if (isByteArray(data)) {
            tmp_0 = Bitmap8.rcc(width, height, data);
          } else {
            tmp_0 = null;
          }
        }
      }
      var tmp5_safe_receiver = tmp_0;
      if (tmp5_safe_receiver == null)
        null;
      else
        tmp5_safe_receiver.gc9();
    }
  }
  ef9(tex, target) {
    var gl = this.af2_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(this, tex);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.gf7_1;
    gl.rf9(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.xek_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.hf7_1 === texBitmap.bc2_1) || !(glTex.if7_1 === this.ieg_1)) {
        glTex.hf7_1 = texBitmap.bc2_1;
        glTex.if7_1 = this.ieg_1;
        tex.gem();
      }
      this.vf5(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  rf7(frameBuffer, info) {
    var gl = this.af2_1;
    if (!(this.cf3_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.sf9(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.fek_1) {
      if (!(this.df3_1 === this.rf2_1)) {
        this.df3_1 = this.rf2_1;
        gl.tf9(36160, this.rf2_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(this, frameBuffer);
    var tex = fb.wf9_1.gek_1;
    var doMsaa = false;
    if (!equals(fb.zf9_1, info)) {
      fb.zf9_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.xek_1 = NullBitmap.ucg(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.af3_1;
      var old = selectTextureUnit(this, index);
      try {
        this.ef9(tex, Companion_getInstance_54().eel_1);
        textureUnitParameters(this, Companion_getInstance_54().eel_1, Companion_getInstance_55().ren_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.ef9(null, Companion_getInstance_54().eel_1);
        }
        selectTextureUnit(this, old);
      }
      gl.afa(36161, fb.xf9_1);
      if (!(internalFormat === 0)) {
        gl.bfa(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.afa(36161, 0);
      gl.tf9(36160, fb.yf9_1);
      gl.cfa(36160, 36064, 3553, _get_gl__ndc1ty_1(this, fb.wf9_1.gek_1).gf7_1, 0);
      if (!(internalFormat === 0)) {
        gl.dfa(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.xf9_1);
      } else {
        gl.dfa(36160, 36128, 36161, 0);
        gl.dfa(36160, 36096, 36161, 0);
      }
    }
    if (!(this.df3_1 === fb.yf9_1)) {
      this.df3_1 = fb.yf9_1;
      gl.tf9(36160, fb.yf9_1);
    }
  }
  gf8(renderState) {
    var gl = this.af2_1;
    if (!(this.nf2_1 === renderState)) {
      this.nf2_1 = renderState;
      gl.efa(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.vf7(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.ffa(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_46().keq_1);
      if (gl.ff8(2929, enable)) {
        gl.gfa(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  tf7(colorMask) {
    var gl = this.af2_1;
    if (!(this.mf2_1 === colorMask)) {
      this.mf2_1 = colorMask;
      gl.hfa(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  sf7(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.af2_1;
    var scissor_0 = this.pf9(scissor, frameBuffer, frameBufferInfo);
    if (!this.sf2_1.equals(scissor_0)) {
      this.sf2_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_41().mej_1);
      if (gl.ff8(3089, enable)) {
        gl.ifa(scissor_0.wea(), scissor_0.xea(), scissor_0.w9z(), scissor_0.x9z());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.cf5_1 = gl;
    this.df5_1 = ag;
    this.ef5_1 = atomic$int$1(0);
    this.ff5_1 = atomic$int$1(0);
    this.gf5_1 = atomic$ref$1(0.0);
    this.hf5_1 = atomic$int$1(0);
    this.if5_1 = atomic$int$1(0);
    this.jf5_1 = atomic$ref$1(0.0);
    this.kf5_1 = new Lock();
    this.lf5_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.mf5_1 = globalState;
    this.nf5_1 = this.mf5_1.cf5_1;
  }
  of5() {
  }
  pen() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0 = this.mf5_1.kf5_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0.n9w();
      try {
        // Inline function 'kotlin.collections.plusAssign' call
        this.mf5_1.lf5_1.d2(this);
        break $l$block;
      }finally {
        tmp0.p9w();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.qf3_1 = programInfo;
  }
  of5() {
    this.qf3_1.jfa(this.nf5_1);
  }
  rf3() {
    this.qf3_1.kfa(this.nf5_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.sf5_1 = genBuffer(this.nf5_1);
    this.tf5_1 = -1;
    this.uf5_1 = 0.0;
    this.mf5_1.hf5_1.atomicfu$incrementAndGet();
  }
  xf6(value) {
    var tmp0 = this.mf5_1.jf5_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var upd = cur + value - this.uf5_1;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.uf5_1 = value;
  }
  of5() {
    this.mf5_1.if5_1.atomicfu$incrementAndGet();
    deleteBuffer(this.nf5_1, this.sf5_1);
    this.sf5_1 = -1;
    this.tf5_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.sf5_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.gf7_1 = genTexture(this.nf5_1);
    this.hf7_1 = -2;
    this.if7_1 = -2;
    this.jf7_1 = 0.0;
    this.mf5_1.ef5_1.atomicfu$incrementAndGet();
  }
  xf6(value) {
    var tmp0 = this.mf5_1.gf5_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var upd = cur + value - this.jf7_1;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.jf7_1 = value;
  }
  of5() {
    this.mf5_1.ff5_1.atomicfu$incrementAndGet();
    deleteTexture(this.nf5_1, this.gf7_1);
    this.gf7_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.wf9_1 = ag;
    this.xf9_1 = genRenderbuffer(this.nf5_1);
    this.yf9_1 = genFramebuffer(this.nf5_1);
    this.zf9_1 = Companion_getInstance_49().iet_1;
  }
  of5() {
    deleteRenderbuffer(this.nf5_1, this.xf9_1);
    deleteFramebuffer(this.nf5_1, this.yf9_1);
    this.xf9_1 = -1;
    this.yf9_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.sf3_1 = programId;
    this.tf3_1 = vertexId;
    this.uf3_1 = fragmentId;
    this.vf3_1 = blocks;
    this.wf3_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.vf3_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$2 = element.sep_1;
      destination.b5(tmp$ret$2, element);
    }
    tmp.xf3_1 = destination;
    var tmp_0 = this;
    var tmp0 = this.vf3_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = tmp0.p1();
      if (!iterator.q1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      var maxValue = iterator.r1().sep_1;
      while (iterator.q1()) {
        var v = iterator.r1().sep_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.yf3_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.yf3_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = Array(tmp_3);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.xf3_1.w4(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_6 = UniformsRef.lfa(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.zf3_1 = tmp_4;
    this.af4_1 = FastStringMap();
    this.bf4_1 = FastStringMap();
  }
  nf4(gl, name) {
    var tmp0 = this.bf4_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp0.get(name);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var out = gl.mfa(this.sf3_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp0.set(name, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  kfa(gl) {
    gl.nfa(this.sf3_1);
  }
  jfa(gl) {
    if (!(this.tf3_1 === 0)) {
      gl.ofa(this.tf3_1);
    }
    if (!(this.uf3_1 === 0)) {
      gl.ofa(this.uf3_1);
    }
    if (!(this.sf3_1 === 0)) {
      gl.pfa(this.sf3_1);
    }
    this.tf3_1 = 0;
    this.uf3_1 = 0;
    this.sf3_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.sf3_1 + ', vertexId=' + this.tf3_1 + ', fragmentId=' + this.uf3_1 + ', blocks=' + toString(this.vf3_1) + ', config=' + this.wf3_1.toString() + ')';
  }
  hashCode() {
    var result = this.sf3_1;
    result = imul(result, 31) + this.tf3_1 | 0;
    result = imul(result, 31) + this.uf3_1 | 0;
    result = imul(result, 31) + hashCode(this.vf3_1) | 0;
    result = imul(result, 31) + this.wf3_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.sf3_1 === tmp0_other_with_cast.sf3_1))
      return false;
    if (!(this.tf3_1 === tmp0_other_with_cast.tf3_1))
      return false;
    if (!(this.uf3_1 === tmp0_other_with_cast.uf3_1))
      return false;
    if (!equals(this.vf3_1, tmp0_other_with_cast.vf3_1))
      return false;
    if (!this.wf3_1.equals(tmp0_other_with_cast.wf3_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.mf3_1 = Companion_getInstance_1().pb5('GLShaderCompiler');
  }
  nf3(gl, config, program, debugName) {
    var id = gl.ufa();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_63().wfa();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_63().xfa()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var tmp0 = this.mf3_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level = Level_TRACE_getInstance();
      if (tmp0.obj(level)) {
        var tmp$ret$2 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_63().wfa() + '. used=' + usedGlSlVersion;
        tmp0.pbj(level, tmp$ret$2);
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$5 = config.yfa(VOID, VOID, usedGlSlVersion, item);
      destination.d2(tmp$ret$5);
    }
    var _destruct__k2r9zo = this.zfa(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.jm();
    var vertexShaderId = _destruct__k2r9zo.km();
    var finalConfig = _destruct__k2r9zo.fx();
    var _iterator__ex2g4s_0 = program.aep_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var attr = _iterator__ex2g4s_0.r1();
      var location = attr.cex_1;
      gl.afb(id, location, attr.if4_1);
    }
    gl.bfb(id, fragmentShaderId);
    gl.bfb(id, vertexShaderId);
    gl.cfb(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.xeo_1, finalConfig);
  }
  zfa(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.p2();
    var _iterator__ex2g4s = configs.p1();
    $l$loop: while (_iterator__ex2g4s.q1()) {
      var config = _iterator__ex2g4s.r1();
      try {
        var fragmentString = toNewGlslString(program.teo_1, config);
        var vertexString = toNewGlslString(program.seo_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var tmp0 = this.mf3_1;
        // Inline function 'korlibs.logger.Logger.log' call
        var level = Level_DEBUG_getInstance();
        if (tmp0.obj(level)) {
          var tmp$ret$3 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          tmp0.pbj(level, tmp$ret$3);
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var tmp0_0 = this.mf3_1;
          // Inline function 'korlibs.logger.Logger.log' call
          var level_0 = Level_DEBUG_getInstance();
          if (tmp0_0.obj(level_0)) {
            var tmp$ret$6 = stackTraceToString(e);
            tmp0_0.pbj(level_0, tmp$ret$6);
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.d2(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(errors, 10));
    var _iterator__ex2g4s_0 = errors.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$10 = item.message;
      destination.d2(tmp$ret$10);
    }
    throw Exception.ue('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  constructor(size) {
    return new.target.hfb(size);
  }
  static hfb(size) {
    size = size === VOID ? Size2D.l9i(640, 480) : size;
    var $this = this.keg();
    $this.zeg().kek(numberToInt(size.j9i_1), numberToInt(size.k9i_1));
    return $this;
  }
}
class AGBaseLog extends AGDummy {
  static bfc(size) {
    size = size === VOID ? Size2D.l9i(640, 480) : size;
    var $this = this.hfb(size);
    $this.wfb_1 = 0;
    $this.xfb_1 = 0;
    $this.yfb_1 = 0;
    $this.zfb_1 = 0;
    $this.afc_1 = linkedHashMapOf([]);
    return $this;
  }
  cfc(str, kind) {
  }
  beh(command) {
    this.cfc(toString(command), Kind_COMMAND_getInstance());
  }
  v7e() {
    return this.cfc('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  constructor(size) {
    return new.target.rfb(size);
  }
  static rfb(size) {
    size = size === VOID ? Size2D.l9i(640, 480) : size;
    return this.bfc(size);
  }
  cfc(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_44 {}
class UniformBlockBuffer {
  constructor(block) {
    this.yen_1 = block;
    this.zen_1 = new AGBuffer();
    this.aeo_1 = this.yen_1.xev();
    this.beo_1 = this.yen_1.yev();
    this.ceo_1 = this.yen_1.wev().s2();
    this.deo_1 = Buffer.eb2(imul(this.beo_1, 1));
    this.eeo_1 = UniformsRef.dfc(this.yen_1, this.deo_1, -1);
    this.feo_1 = Buffer.eb2(this.yen_1.yev());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.yen_1) + ')';
  }
  efc(value) {
    this.eeo_1.nf9_1 = value;
  }
  z6x() {
    return this.eeo_1.nf9_1;
  }
  ffc(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      var tmp0 = index + 1 | 0;
      // Inline function 'kotlin.math.max' call
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(tmp0, b);
      this.deo_1 = copyOf(this.deo_1, imul(this.beo_1, newCapacity));
      this.eeo_1.mf9_1 = this.deo_1;
    }
  }
  ra8() {
    this.efc(-1);
  }
  heo() {
    var tmp = this.deo_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.z6x() + 1 | 0, this.yen_1.yev());
    var tmp$ret$0 = Math.max(0, b);
    this.zen_1.nen(tmp, 0, tmp$ret$0);
    return this;
  }
  gfc() {
    var _unary__edvuaz = this.z6x();
    this.efc(_unary__edvuaz - 1 | 0);
  }
}
class UniformsRef {
  constructor(block, buffer, index) {
    return new.target.dfc(block, buffer, index);
  }
  static dfc(block, buffer, index) {
    var $this = createThis(this);
    $this.lf9_1 = block;
    $this.mf9_1 = buffer;
    $this.nf9_1 = index;
    $this.of9_1 = $this.lf9_1.yev();
    return $this;
  }
  static lfa(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.dfc(block, Buffer.eb2(imul(block.yev(), size)), index);
  }
  hfc(uniform) {
    return imul(this.nf9_1, this.of9_1) + uniform.oep_1 | 0;
  }
  ifc(ref) {
    arraycopy_0(ref.deo_1, 0, this.mf9_1, imul(this.nf9_1, this.of9_1), this.of9_1);
  }
  jfc(uniform, value) {
    return this.kfc(uniform, value);
  }
  lfc(uniform, value) {
    return this.mfc(uniform, value.r9g_1, value.s9g_1);
  }
  nfc(uniform, value) {
    return this.ofc(uniform, _RGBA___get_rf__impl__kvz75k(value), _RGBA___get_gf__impl__5gcu1f(value), _RGBA___get_bf__impl__1xz5yg(value), _RGBA___get_af__impl__vu36qv(value));
  }
  pfc(uniform, value) {
    return this.ofc(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  }
  qfc(uniform, value) {
    return this.ofc(uniform, value.q9t_1, value.r9t_1, value.s9t_1, value.t9t_1);
  }
  rfc(uniform, value) {
    switch (uniform.d8o().w1_1) {
      case 3:
        this.sfc(uniform, value, Companion_getInstance_6().x9n_1);
        break;
      case 2:
        this.tfc(uniform, value, Companion_getInstance_6().x9n_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
    }
  }
  tfc(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.hfc(uniform);
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0 = this.mf9_1;
        var tmp2 = this_0 + imul(n, 4) | 0;
        var it = indices[n];
        // Inline function 'korlibs.memory.setF32' call
        var value_0 = value.b9p(it);
        var tmp;
        if (true) {
          tmp0.ib2(tmp2, value_0);
          tmp = Unit_instance;
        } else {
          tmp0.hb2(tmp2, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  sfc(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.tfc(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.tfc.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
  kfc(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.hfc(uniform);
    var tmp0 = this.mf9_1;
    // Inline function 'korlibs.memory.setF32' call
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      tmp0.ib2(byteOffset, value);
      tmp = Unit_instance;
    } else {
      tmp0.hb2(byteOffset, value);
      tmp = Unit_instance;
    }
  }
  mfc(uniform, x, y) {
    // Inline function 'kotlin.also' call
    var this_0 = this.hfc(uniform);
    this.ufc(this_0, x, y);
  }
  ofc(uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.hfc(uniform);
    this.vfc(this_0, x, y, z, w);
  }
  ufc(index, x, y) {
    var tmp0 = this.mf9_1;
    // Inline function 'korlibs.memory.setF32' call
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      tmp0.ib2(byteOffset, x);
      tmp = Unit_instance;
    } else {
      tmp0.hb2(byteOffset, x);
      tmp = Unit_instance;
    }
    var tmp0_0 = this.mf9_1;
    // Inline function 'korlibs.memory.setF32' call
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      tmp0_0.ib2(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      tmp0_0.hb2(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
  }
  vfc(index, x, y, z, w) {
    var tmp0 = this.mf9_1;
    // Inline function 'korlibs.memory.setF32' call
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      tmp0.ib2(byteOffset, x);
      tmp = Unit_instance;
    } else {
      tmp0.hb2(byteOffset, x);
      tmp = Unit_instance;
    }
    var tmp0_0 = this.mf9_1;
    // Inline function 'korlibs.memory.setF32' call
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      tmp0_0.ib2(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      tmp0_0.hb2(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    var tmp0_1 = this.mf9_1;
    // Inline function 'korlibs.memory.setF32' call
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      tmp0_1.ib2(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      tmp0_1.hb2(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    var tmp0_2 = this.mf9_1;
    // Inline function 'korlibs.memory.setF32' call
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      tmp0_2.ib2(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      tmp0_2.hb2(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  }
}
class Operand {
  static afl(type) {
    var $this = createThis(this);
    $this.wf5_1 = type;
    return $this;
  }
  d8o() {
    return this.wf5_1;
  }
}
class OperandWithArray extends Operand {
  static dfn(type, arrayCount) {
    var $this = this.afl(type);
    $this.yf5_1 = arrayCount;
    $this.zf5_1 = type.ff6_1;
    $this.af6_1 = type.gf6_1;
    $this.bf6_1 = imul($this.af6_1, $this.yf5_1);
    $this.cf6_1 = imul(type.if6_1, $this.yf5_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static cfm(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.dfn(type, arrayCount);
    $this.if4_1 = name;
    $this.jf4_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(arrayCount);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.if4_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.kf4_1 = tmp_1;
    $this.lf4_1 = 0;
    $this.mf4_1 = null;
    return $this;
  }
  static bfm(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.cfm(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d8o().equals(other.d8o());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.if4_1 === other.if4_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static jfd(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.cfm(name, type, arrayCount, precision);
    $this.ifd_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  constructor(name, voffset, vindex, block, type, arrayCount) {
    return new.target.wfc(name, voffset, vindex, block, type, arrayCount);
  }
  static wfc(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.jfd(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.oep_1 = voffset;
    $this.pep_1 = vindex;
    $this.qep_1 = block;
    $this.rep_1 = Uniform.xfd(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  yq(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.if4_1 + "', offset=" + this.oep_1 + ', type=' + this.d8o().toString() + ')';
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.mev_1 = block;
    this.nev_1 = name;
    this.oev_1 = voffset;
    this.pev_1 = vindex;
    this.qev_1 = type;
    this.rev_1 = arrayCount;
    this.sev_1 = size;
    this.tev_1 = align;
    var tmp = this;
    tmp.uev_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  yfd() {
    var tmp0 = this.uev_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('uniform', 1, tmp, UniformBlock$Gen$_get_uniform_$ref_tylxot(), null);
    return tmp0.k3();
  }
  vev(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.nev_1;
    tmp.nev_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.yfd();
  }
  toString() {
    return 'Gen(block=' + this.mev_1.toString() + ', name=' + this.nev_1 + ', voffset=' + this.oev_1 + ', vindex=' + this.pev_1 + ', type=' + this.qev_1.toString() + ', arrayCount=' + this.rev_1 + ', size=' + this.sev_1 + ', align=' + this.tev_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.mev_1);
    result = imul(result, 31) + (this.nev_1 == null ? 0 : getStringHashCode(this.nev_1)) | 0;
    result = imul(result, 31) + this.oev_1 | 0;
    result = imul(result, 31) + this.pev_1 | 0;
    result = imul(result, 31) + this.qev_1.hashCode() | 0;
    result = imul(result, 31) + this.rev_1 | 0;
    result = imul(result, 31) + this.sev_1 | 0;
    result = imul(result, 31) + this.tev_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.mev_1, tmp0_other_with_cast.mev_1))
      return false;
    if (!(this.nev_1 == tmp0_other_with_cast.nev_1))
      return false;
    if (!(this.oev_1 === tmp0_other_with_cast.oev_1))
      return false;
    if (!(this.pev_1 === tmp0_other_with_cast.pev_1))
      return false;
    if (!this.qev_1.equals(tmp0_other_with_cast.qev_1))
      return false;
    if (!(this.rev_1 === tmp0_other_with_cast.rev_1))
      return false;
    if (!(this.sev_1 === tmp0_other_with_cast.sev_1))
      return false;
    if (!(this.tev_1 === tmp0_other_with_cast.tev_1))
      return false;
    return true;
  }
}
class Companion_45 {
  constructor() {
    Companion_instance_54 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.uei_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_61();
    this.hf9_1 = blocks;
    this.if9_1 = buffers;
    this.jf9_1 = valueIndices;
  }
  s2() {
    return this.hf9_1.length;
  }
}
class UBLayoutBuilder {
  constructor() {
    this.zfd_1 = 0;
    this.afe_1 = 4;
    var tmp = this;
    tmp.bfe_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  s2() {
    var tmp0 = this.bfe_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('size', 1, tmp, UBLayoutBuilder$_get_size_$ref_u8lr3t(), null);
    return tmp0.k3();
  }
  cfe(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).zfd_1;
    this.zfd_1 = this.zfd_1 + size | 0;
    return this_0;
  }
}
class Companion_46 {
  dfe(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.w1_1, 16));
  }
  efe(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.dfe(isES, isWebGL, isCore, version, os) : $super.dfe.call(this, isES, isWebGL, isCore, version, os).ffe_1;
  }
  gfe() {
    return Companion_instance_55.efe(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  hfe(version) {
    return Companion_instance_55.efe(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.ffe_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.ffe_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.ffe_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.ffe_1, other);
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.vfa_1 = Companion_getInstance_1().pb5('GlslGenerator');
  }
  wfa() {
    return Companion_getInstance_64().wfa();
  }
  xfa() {
    return Companion_getInstance_64().xfa();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.ife_1 = generator;
    this.jfe_1 = result;
    this.kfe_1 = attributes;
    this.lfe_1 = uniforms;
    this.mfe_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.ife_1) + ', result=' + this.jfe_1 + ', attributes=' + toString(this.kfe_1) + ', uniforms=' + toString(this.lfe_1) + ', varyings=' + toString(this.mfe_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.ife_1);
    result = imul(result, 31) + getStringHashCode(this.jfe_1) | 0;
    result = imul(result, 31) + hashCode(this.kfe_1) | 0;
    result = imul(result, 31) + hashCode(this.lfe_1) | 0;
    result = imul(result, 31) + hashCode(this.mfe_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.ife_1, tmp0_other_with_cast.ife_1))
      return false;
    if (!(this.jfe_1 === tmp0_other_with_cast.jfe_1))
      return false;
    if (!equals(this.kfe_1, tmp0_other_with_cast.kfe_1))
      return false;
    if (!equals(this.lfe_1, tmp0_other_with_cast.lfe_1))
      return false;
    if (!equals(this.mfe_1, tmp0_other_with_cast.mfe_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.hff_1 = function_0;
  }
  pj(a, b) {
    return this.hff_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.hff_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.w84().rf4_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.w1_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.w1_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.ff6_1.w1_1) {
        case 0:
          var tmp_1;
          switch (type.gf6_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.gf6_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.gf6_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.yf5_1 === 1) ? '[' + _this__u8e3s4.yf5_1 + ']' : '';
}
function get_IN() {
  return this.w84().rff();
}
function get_OUT() {
  return this.w84().wff();
}
function get_UNIFORM() {
  return this.w84().vff();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_63();
    this.zfe_1 = kind;
    this.aff_1 = config;
  }
  w84() {
    return this.aff_1;
  }
  bff(shader) {
    return this.kfg(shader.ofe_1, shader.pfe_1);
  }
  kfg(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.zfe_1.equals(ShaderType_FRAGMENT_getInstance()) && this.aff_1.qff()) {
      types.kff_1.d2(Varying.pex(this.aff_1.xff(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.zff(mainFunc);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = funcs.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (types.pff_1.w2(element.efg_1.h1())) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.distinctBy' call
    var this_0 = reversed(destination);
    var set = HashSet.mb();
    var list = ArrayList.p2();
    var _iterator__ex2g4s_0 = this_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var e = _iterator__ex2g4s_0.r1();
      var key = e.efg_1.h1();
      if (set.d2(key)) {
        list.d2(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s_1 = funcs.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var func = _iterator__ex2g4s_1.r1();
      types.zff(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    var tmp_0 = Companion_getInstance_12();
    // Inline function 'kotlin.also' call
    var this_1 = tmp_0.cbx(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    if (Companion_getInstance_64().xfa()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var tmp0 = Companion_getInstance_63().vfa_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level = Level_INFO_getInstance();
      if (tmp0.obj(level)) {
        var tmp$ret$10 = 'GlSlGenerator.version: ' + this.aff_1.tf4_1;
        tmp0.pbj(level, tmp$ret$10);
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var tmp0_0 = Companion_getInstance_63().vfa_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level_0 = Level_DEBUG_getInstance();
      if (tmp0_0.obj(level_0)) {
        var tmp$ret$13 = 'GlSlGenerator:\n' + this_1;
        tmp0_0.pbj(level_0, tmp$ret$13);
      }
    }
    var result = this_1;
    var tmp_1;
    if (root instanceof Raw) {
      tmp_1 = root.nfg(Companion_getInstance_64().dff_1);
    } else {
      tmp_1 = result;
    }
    return new Result(this, tmp_1, toList(types.jff_1), toList(types.lff_1), toList(types.kff_1));
  }
}
class Companion_48 {
  constructor() {
    Companion_instance_57 = this;
    this.cff_1 = new GlslConfig(Companion_instance_55.gfe(), new Immutable(VOID, VOID, VOID, true));
    this.dff_1 = 'GLSL';
    this.eff_1 = 100;
    this.fff_1 = 'fragColor';
    this.gff_1 = 'gl_FragColor';
  }
  wfa() {
    var tmp0_safe_receiver = Companion_instance_1.wi('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  }
  xfa() {
    return Companion_instance_1.wi('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_64();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.rf4_1 = variant;
    this.sf4_1 = features;
    this.tf4_1 = glslVersion;
    this.uf4_1 = compatibility;
  }
  ofg(name) {
    if (this.uf4_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  qff() {
    if (_GLVariant___get_isES__impl__yezzg8(this.rf4_1))
      return this.tf4_1 >= 300;
    return !this.uf4_1;
  }
  vf4() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.qff() && this.sf4_1.heh();
  }
  rff() {
    return this.qff() ? 'in' : 'attribute';
  }
  wff() {
    return this.qff() ? 'out' : 'varying';
  }
  vff() {
    return 'uniform';
  }
  xff() {
    return this.qff() ? Companion_getInstance_64().fff_1 : Companion_getInstance_64().gff_1;
  }
  pfg(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  yfa(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.rf4_1 : variant;
    features = features === VOID ? this.sf4_1 : features;
    glslVersion = glslVersion === VOID ? this.tf4_1 : glslVersion;
    compatibility = compatibility === VOID ? this.uf4_1 : compatibility;
    return $super === VOID ? this.pfg(variant, features, glslVersion, compatibility) : $super.pfg.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.rf4_1) + ', features=' + toString(this.sf4_1) + ', glslVersion=' + this.tf4_1 + ', compatibility=' + this.uf4_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.rf4_1);
    result = imul(result, 31) + hashCode(this.sf4_1) | 0;
    result = imul(result, 31) + this.tf4_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.uf4_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.rf4_1 === tmp0_other_with_cast.rf4_1))
      return false;
    if (!equals(this.sf4_1, tmp0_other_with_cast.sf4_1))
      return false;
    if (!(this.tf4_1 === tmp0_other_with_cast.tf4_1))
      return false;
    if (!(this.uf4_1 === tmp0_other_with_cast.uf4_1))
      return false;
    return true;
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.yff_1 = default_0;
  }
  zff(func) {
    this.gfh(func.dfg_1);
  }
  yfk(stms) {
    var _iterator__ex2g4s = stms.p1();
    while (_iterator__ex2g4s.q1()) {
      var stm = _iterator__ex2g4s.r1();
      this.gfh(stm);
    }
  }
  gfh(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.hfh(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.kfh(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.ifh(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.jfh(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.lfh(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.nfh(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.mfh(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.ofh(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.pfh(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  hfh(stms) {
    var _iterator__ex2g4s = stms.gfi_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var stm = _iterator__ex2g4s.r1();
      this.gfh(stm);
    }
  }
  ifh(stm) {
    this.qfh(stm.afj_1);
    this.gfh(stm.bfj_1);
    this.gfh(stm.cfj_1);
  }
  jfh(stm) {
    this.tfh(stm.dfj_1);
    this.qfh(stm.efj_1);
    this.gfh(stm.gfj_1);
  }
  kfh(stm) {
    this.qfh(stm.ifi_1);
    this.qfh(stm.hfi_1);
  }
  lfh(stm) {
  }
  mfh(stm) {
  }
  nfh(stm) {
  }
  ofh(stm) {
    this.gfh(stm.mfg_1);
  }
  pfh(stm) {
    var tmp0_safe_receiver = stm.jfi_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.qfh(tmp0_safe_receiver);
    }
  }
  qfh(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.tfh(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.xfh(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.yfh(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.zfh(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.ffi(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.dfi(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.efi(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.cfi(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.afi(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.bfi(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.rfh(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  rfh(func) {
    var _iterator__ex2g4s = func.vfi().p1();
    while (_iterator__ex2g4s.q1()) {
      var op = _iterator__ex2g4s.r1();
      this.qfh(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.sfh(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.ffh(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  sfh(func) {
    return this.yff_1;
  }
  ffh(func) {
    return this.yff_1;
  }
  tfh(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.rfg(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.tfg(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.zfg(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.vfg(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.xfg(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.wfh(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.ufh(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.vfh(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  ufh(temp) {
    return this.yff_1;
  }
  vfh(arg) {
    return this.yff_1;
  }
  rfg(attribute) {
    return this.yff_1;
  }
  tfg(varying) {
    return this.yff_1;
  }
  vfg(uniform) {
    return this.yff_1;
  }
  zfg(sampler) {
    return this.yff_1;
  }
  xfg(typedUniform) {
    return this.vfg(typedUniform.rep_1);
  }
  wfh(output) {
    return this.yff_1;
  }
  xfh(operand) {
    this.qfh(operand.pfi_1);
    return this.yff_1;
  }
  yfh(operand) {
    this.qfh(operand.rfi_1);
    this.qfh(operand.tfi_1);
    return this.yff_1;
  }
  zfh(operand) {
    this.qfh(operand.xfi_1);
    this.qfh(operand.yfi_1);
    this.qfh(operand.zfi_1);
    return this.yff_1;
  }
  afi(operand) {
    this.qfh(operand.ofj_1);
    return this.yff_1;
  }
  bfi(operand) {
    this.qfh(operand.rfj_1);
    this.qfh(operand.sfj_1);
    return this.yff_1;
  }
  cfi(operand) {
    var indexedObject = operand.mfi_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.qfh(op);
    }
    return this.yff_1;
  }
  dfi(operand) {
    return this.yff_1;
  }
  efi(operand) {
    return this.yff_1;
  }
  ffi(operand) {
    return this.yff_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.jff_1 = LinkedHashSet.v2();
    this.kff_1 = LinkedHashSet.v2();
    this.lff_1 = LinkedHashSet.v2();
    this.mff_1 = LinkedHashSet.v2();
    this.nff_1 = LinkedHashSet.v2();
    this.off_1 = LinkedHashSet.v2();
    this.pff_1 = LinkedHashSet.v2();
  }
  qfg(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.jff_1.d2(attribute);
  }
  rfg(attribute) {
    this.qfg(attribute);
    return Unit_instance;
  }
  sfg(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.kff_1.d2(varying);
  }
  tfg(varying) {
    this.sfg(varying);
    return Unit_instance;
  }
  ufg(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.lff_1.d2(uniform);
    var tmp0_safe_receiver = uniform.wfd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.plusAssign' call
      this.mff_1.d2(tmp0_safe_receiver);
    }
    var tmp0 = this.nff_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = uniform.wfd_1.qep_1;
    tmp0.d2(element);
  }
  vfg(uniform) {
    this.ufg(uniform);
    return Unit_instance;
  }
  wfg(typedUniform) {
    var tmp0 = this.lff_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = typedUniform.rep_1;
    tmp0.d2(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.mff_1.d2(typedUniform);
    var tmp0_0 = this.nff_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element_0 = typedUniform.qep_1;
    tmp0_0.d2(element_0);
  }
  xfg(typedUniform) {
    this.wfg(typedUniform);
    return Unit_instance;
  }
  yfg(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.off_1.d2(sampler);
  }
  zfg(sampler) {
    this.yfg(sampler);
    return Unit_instance;
  }
  afh(func) {
    var tmp0 = this.pff_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = func.efh().h1();
    tmp0.d2(element);
  }
  ffh(func) {
    this.afh(func);
    return Unit_instance;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.gfg_1 = kind;
    this.hfg_1 = config;
    this.ifg_1 = LinkedHashSet.v2();
    this.jfg_1 = new Indenter();
  }
  w84() {
    return this.hfg_1;
  }
  hfh(stms) {
    var _iterator__ex2g4s = stms.gfi_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var stm = _iterator__ex2g4s.r1();
      this.gfh(stm);
    }
  }
  kfh(stm) {
    this.jfg_1.vbx(this.qfh(stm.hfi_1) + ' = ' + this.qfh(stm.ifi_1) + ';');
  }
  lfh(stm) {
    this.jfg_1.vbx('discard;');
  }
  mfh(stm) {
    this.jfg_1.vbx('break;');
  }
  nfh(stm) {
    this.jfg_1.vbx('continue;');
  }
  pfh(stm) {
    var result = stm.jfi_1;
    if (!(result == null)) {
      this.jfg_1.vbx('return ' + this.qfh(result) + ';');
    } else {
      this.jfg_1.vbx('return;');
    }
  }
  cfi(operand) {
    var tmp = this.tff(operand.lfi_1) + '(';
    return tmp + joinToString_0(operand.mfi_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  xfh(operand) {
    return '(' + operand.ofi_1 + '(' + this.qfh(operand.pfi_1) + ')' + ')';
  }
  yfh(operand) {
    return '(' + this.qfh(operand.rfi_1) + ' ' + operand.sfi_1 + ' ' + this.qfh(operand.tfi_1) + ')';
  }
  rfh(func) {
    var tmp = this.hfg_1.ofg(func.h1()) + '(';
    var tmp_0 = func.vfi();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  zfh(ternary) {
    return '((' + this.qfh(ternary.xfi_1) + ') ? (' + this.qfh(ternary.yfi_1) + ') : (' + this.qfh(ternary.zfi_1) + '))';
  }
  ifh(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.jfg_1;
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.qfh(stm.afj_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.vbx(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.f2h();
    try {
      this.gfh(stm.bfj_1);
    }finally {
      this_0.wbx();
    }
    this_0.vbx('}');
    if (!(stm.cfj_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.vbx(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.f2h();
      try {
        this.gfh(ensureNotNull(stm.cfj_1));
      }finally {
        this_0.wbx();
      }
      this_0.vbx('}');
    }
  }
  jfh(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.jfg_1;
    var varType = this.tff(stm.dfj_1.d8o());
    var loopVar = this.tfh(stm.dfj_1);
    var min = this.qfh(stm.efj_1);
    var maxExclusive = this.qfh(stm.ffj_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.vbx(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.f2h();
    try {
      this.gfh(stm.gfj_1);
    }finally {
      this_0.wbx();
    }
    this_0.vbx('}');
  }
  ofh(stm) {
    // Inline function 'kotlin.apply' call
    this.jfg_1.vbx(stm.nfg(Companion_getInstance_64().dff_1));
  }
  tfh(operand) {
    super.tfh(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.gfg_1.w1_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.hfg_1.xff();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.if4_1;
    }
    return tmp;
  }
  ufh(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.ifg_1.d2(temp);
    return super.ufh(temp);
  }
  wfh(output) {
    return super.wfh(output);
  }
  dfi(operand) {
    return '' + operand.ifj_1;
  }
  efi(operand) {
    var str = '' + operand.kfj_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  ffi(operand) {
    return '' + operand.mfj_1;
  }
  afi(operand) {
    return this.qfh(operand.ofj_1) + '.' + operand.pfj_1;
  }
  bfi(operand) {
    return this.qfh(operand.rfj_1) + '[' + this.qfh(operand.sfj_1) + ']';
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.gfi_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.gfi_1) + ')';
  }
  hashCode() {
    return hashCode(this.gfi_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.gfi_1, tmp0_other_with_cast.gfi_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.hfi_1 = to;
    this.ifi_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.hfi_1) + ', from=' + toString(this.ifi_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.hfi_1);
    result = imul(result, 31) + hashCode(this.ifi_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.hfi_1, tmp0_other_with_cast.hfi_1))
      return false;
    if (!equals(this.ifi_1, tmp0_other_with_cast.ifi_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.jfi_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.jfi_1) + ')';
  }
  hashCode() {
    return this.jfi_1 == null ? 0 : hashCode(this.jfi_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.jfi_1, tmp0_other_with_cast.jfi_1))
      return false;
    return true;
  }
}
class Break extends Stm {}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.afj_1 = cond;
    this.bfj_1 = tbody;
    this.cfj_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.afj_1) + ', tbody=' + toString(this.bfj_1) + ', fbody=' + toString_1(this.cfj_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.afj_1);
    result = imul(result, 31) + hashCode(this.bfj_1) | 0;
    result = imul(result, 31) + (this.cfj_1 == null ? 0 : hashCode(this.cfj_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.afj_1, tmp0_other_with_cast.afj_1))
      return false;
    if (!equals(this.bfj_1, tmp0_other_with_cast.bfj_1))
      return false;
    if (!equals(this.cfj_1, tmp0_other_with_cast.cfj_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {}
class Raw extends Stm {
  tfj(name) {
    return this.lfg_1.w4(name);
  }
  ufj(name, default_0) {
    var tmp0_elvis_lhs = this.tfj(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  nfg(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.ufj(name, default_0) : $super.ufj.call(this, name, default_0);
  }
}
class Program$ExpressionBuilder$Companion$INSTANCE$1 {}
class Companion_49 {
  constructor() {
    Companion_instance_58 = this;
    var tmp = this;
    tmp.vfj_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
}
class FuncBuilder extends Builder {
  constructor(parent) {
    return new.target.efk(parent);
  }
  static efk(parent) {
    var $this = this.ffk(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.cfk_1 = ArrayList.p2();
    return $this;
  }
  dfk(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.rfk(name, type);
    // Inline function 'kotlin.collections.plusAssign' call
    this.cfk_1.d2(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.vfk_1 = decl;
  }
  yq(thisRef, property) {
    var tmp = this.vfk_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.wfj_1 = rettype;
    this.xfj_1 = varTypes;
    this.yfj_1 = builder;
    this.zfj_1 = block;
  }
  mew(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.yfj_1.cez(tmp, this.wfj_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.xfk_1 = $funcs;
    super(Unit_instance, $box);
  }
  afh(func) {
    var tmp0 = this.xfk_1;
    var tmp2 = func.h1();
    var tmp = func.efh();
    // Inline function 'kotlin.collections.set' call
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    tmp0.b5(tmp2, value);
  }
  ffh(func) {
    this.afh(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  constructor(cond, otrue, ofalse) {
    return new.target.zfk(cond, otrue, ofalse);
  }
  static zfk(cond, otrue, ofalse) {
    var $this = this.afl(otrue.d8o());
    $this.xfi_1 = cond;
    $this.yfi_1 = otrue;
    $this.zfi_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.xfi_1) + ', otrue=' + toString(this.yfi_1) + ', ofalse=' + toString(this.zfi_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.xfi_1);
    result = imul(result, 31) + hashCode(this.yfi_1) | 0;
    result = imul(result, 31) + hashCode(this.zfi_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.xfi_1, tmp0_other_with_cast.xfi_1))
      return false;
    if (!equals(this.yfi_1, tmp0_other_with_cast.yfi_1))
      return false;
    if (!equals(this.zfi_1, tmp0_other_with_cast.zfi_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  constructor(op, right) {
    return new.target.bfl(op, right);
  }
  static bfl(op, right) {
    var $this = this.afl(right.d8o());
    $this.ofi_1 = op;
    $this.pfi_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.ofi_1 + ', right=' + toString(this.pfi_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.ofi_1);
    result = imul(result, 31) + hashCode(this.pfi_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.ofi_1 === tmp0_other_with_cast.ofi_1))
      return false;
    if (!equals(this.pfi_1, tmp0_other_with_cast.pfi_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  constructor(left, op, right) {
    return new.target.cfl(left, op, right);
  }
  static cfl(left, op, right) {
    var $this = this.afl(left.d8o());
    $this.rfi_1 = left;
    $this.sfi_1 = op;
    $this.tfi_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.rfi_1) + ', op=' + this.sfi_1 + ', right=' + toString(this.tfi_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.rfi_1);
    result = imul(result, 31) + getStringHashCode(this.sfi_1) | 0;
    result = imul(result, 31) + hashCode(this.tfi_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.rfi_1, tmp0_other_with_cast.rfi_1))
      return false;
    if (!(this.sfi_1 === tmp0_other_with_cast.sfi_1))
      return false;
    if (!equals(this.tfi_1, tmp0_other_with_cast.tfi_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {}
class FloatLiteral extends Operand {
  constructor(value) {
    return new.target.dfl(value);
  }
  static dfl(value) {
    var $this = this.afl(VarType_Float1_getInstance());
    $this.kfj_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.kfj_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.kfj_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.kfj_1, tmp0_other_with_cast.kfj_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  constructor(type, ops) {
    return new.target.efl(type, ops);
  }
  static efl(type, ops) {
    var $this = this.afl(type);
    $this.lfi_1 = type;
    $this.mfi_1 = ops;
    return $this;
  }
  d8o() {
    return this.lfi_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.lfi_1.equals(other.lfi_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.mfi_1, other.mfi_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.lfi_1.hashCode(), 7) + contentHashCode(this.mfi_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.lfi_1.toString() + ', ops=' + toString(this.mfi_1) + ')';
  }
}
class Swizzle extends Operand {
  constructor(left, swizzle) {
    return new.target.ffl(left, swizzle);
  }
  static ffl(left, swizzle) {
    var $this = this.afl(left.d8o().gfl(swizzle.length));
    $this.ofj_1 = left;
    $this.pfj_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.ofj_1) + ', swizzle=' + this.pfj_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.ofj_1);
    result = imul(result, 31) + getStringHashCode(this.pfj_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.ofj_1, tmp0_other_with_cast.ofj_1))
      return false;
    if (!(this.pfj_1 === tmp0_other_with_cast.pfj_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {}
class BaseFunc extends Operand {
  static hfl(type) {
    return this.afl(type);
  }
}
class Func extends BaseFunc {
  constructor(name, ops, type) {
    return new.target.mfl(name, ops, type);
  }
  static mfl(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.hfl(type);
    $this.jfl_1 = name;
    $this.kfl_1 = ops;
    $this.lfl_1 = type;
    return $this;
  }
  h1() {
    return this.jfl_1;
  }
  vfi() {
    return this.kfl_1;
  }
  d8o() {
    return this.lfl_1;
  }
  static nfl(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.mfl(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.jfl_1 + ', ops=' + toString(this.kfl_1) + ', type=' + this.lfl_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.jfl_1);
    result = imul(result, 31) + hashCode(this.kfl_1) | 0;
    result = imul(result, 31) + this.lfl_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.jfl_1 === tmp0_other_with_cast.jfl_1))
      return false;
    if (!equals(this.kfl_1, tmp0_other_with_cast.kfl_1))
      return false;
    if (!this.lfl_1.equals(tmp0_other_with_cast.lfl_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  constructor(ref, ops) {
    return new.target.ofl(ref, ops);
  }
  static ofl(ref, ops) {
    var $this = this.hfl(ref.pfl());
    $this.cfh_1 = ref;
    $this.dfh_1 = ops;
    return $this;
  }
  efh() {
    return this.cfh_1;
  }
  vfi() {
    return this.dfh_1;
  }
  h1() {
    return this.efh().h1();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.qfl_1 = ArrayList.p2();
    this.rfl_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.qfe_1 + '-' + fragment.qfe_1 : name;
    this.seo_1 = vertex;
    this.teo_1 = fragment;
    this.ueo_1 = name;
    this.veo_1 = plus_0(this.seo_1.vfe_1, this.teo_1.vfe_1);
    this.weo_1 = plus_0(this.seo_1.wfe_1, this.teo_1.wfe_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.weo_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.qep_1;
      destination.d2(tmp$ret$2);
    }
    tmp.xeo_1 = distinct(destination);
    this.yeo_1 = plus_0(this.seo_1.yfe_1, this.teo_1.yfe_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.veo_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.cd(capacity);
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.im_1, new UniformInProgram(element.im_1, element.hm_1));
      destination_0.b5(pair.pm_1, pair.qm_1);
    }
    tmp_0.zeo_1 = destination_0;
    this.aep_1 = plus_0(this.seo_1.xfe_1, this.teo_1.xfe_1);
    this.bep_1 = (imul(this.seo_1.hashCode(), 11) + imul(this.teo_1.hashCode(), 7) | 0) + getStringHashCode(this.ueo_1) | 0;
  }
  hashCode() {
    return this.bep_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.seo_1.equals(other.seo_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.teo_1.equals(other.teo_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.ueo_1 === other.ueo_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  f7() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.aep_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = item.if4_1;
      destination.d2(tmp$ret$2);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.veo_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var tmp$ret$5 = item_0.if4_1;
      destination_0.d2(tmp$ret$5);
    }
    return 'Program(name=' + this.ueo_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  vfl(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  wfl(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.seo_1 : vertex;
    fragment = fragment === VOID ? this.teo_1 : fragment;
    name = name === VOID ? this.ueo_1 : name;
    return $super === VOID ? this.vfl(vertex, fragment, name) : $super.vfl.call(this, vertex, fragment, name);
  }
}
class Provider {
  constructor(index, stype) {
    this.kew_1 = index;
    this.lew_1 = stype;
  }
  mew(thisRef, property) {
    return Sampler.xfl(property.callableName, this.kew_1, this.lew_1);
  }
}
class Sampler extends Variable {
  constructor(name, index, stype) {
    return new.target.xfl(name, index, stype);
  }
  static xfl(name, index, stype) {
    var $this = this.bfm(name, stype.afm_1);
    $this.cen_1 = index;
    $this.den_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.if4_1 + ', ' + this.cen_1 + ', ' + this.den_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d8o().equals(other.d8o());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.if4_1 === other.if4_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
  }
  yq(thisRef, property) {
    return this;
  }
}
class Temp extends Variable {
  constructor(id, type, arrayCount, precision) {
    return new.target.sfl(id, type, arrayCount, precision);
  }
  static sfl(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.cfm('temp' + id, type, arrayCount, precision);
  }
  static bey(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.sfl(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.if4_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d8o().equals(other.d8o());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.if4_1 === other.if4_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
  }
}
class Varying extends Variable {
  constructor(name, type, arrayCount, precision) {
    return new.target.dfm(name, type, arrayCount, precision);
  }
  static dfm(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.cfm(name, type, arrayCount, precision);
  }
  static pex(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.dfm(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.if4_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d8o().equals(other.d8o());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.if4_1 === other.if4_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
  }
}
class Output extends Varying {
  constructor() {
    return new.target.pfm();
  }
  static pfm() {
    Output_instance = null;
    var $this = this.pex('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d8o().equals(other.d8o());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.if4_1 === other.if4_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
  }
}
class Companion_50 {
  qfm(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  rfm(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  sfm(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  tfm(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  ufm(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  vfm(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.ff6_1 = kind;
    this.gf6_1 = elementCount;
    this.hf6_1 = isMatrix;
    this.if6_1 = imul(this.ff6_1.yfm_1, this.gf6_1);
  }
  gfl(length) {
    var tmp;
    switch (this.ff6_1.w1_1) {
      case 1:
        tmp = Companion_instance_59.qfm(length);
        break;
      case 2:
        tmp = Companion_instance_59.rfm(length);
        break;
      case 3:
        tmp = Companion_instance_59.sfm(length);
        break;
      case 4:
        tmp = Companion_instance_59.tfm(length);
        break;
      case 5:
        tmp = Companion_instance_59.ufm(length);
        break;
      case 6:
        tmp = Companion_instance_59.vfm(length);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.le();
    }
    return tmp;
  }
  zfm() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Arg extends Variable {
  constructor(name, type, arrayCount, precision) {
    return new.target.rfk(name, type, arrayCount, precision);
  }
  static rfk(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.cfm(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.if4_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d8o().equals(other.d8o());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.if4_1 === other.if4_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.nfe_1 = type;
    this.ofe_1 = stm;
    this.pfe_1 = functions;
    this.qfe_1 = name;
    this.rfe_1 = hashCode(this.ofe_1);
    this.sfe_1 = hashCode(this.pfe_1);
    this.tfe_1 = (imul(this.nfe_1.hashCode(), 17) + this.rfe_1 | 0) + imul(this.sfe_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    this_0.gfh(this.ofe_1);
    tmp.ufe_1 = this_0;
    this.vfe_1 = this.ufe_1.lff_1;
    this.wfe_1 = this.ufe_1.mff_1;
    this.xfe_1 = this.ufe_1.jff_1;
    this.yfe_1 = this.ufe_1.off_1;
  }
  afn() {
    var tmp = this.ofe_1;
    return tmp instanceof Raw;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.nfe_1.equals(other.nfe_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.tfe_1 === other.tfe_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.ofe_1, other.ofe_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.pfe_1, other.pfe_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.tfe_1;
  }
  toString() {
    return 'Shader(type=' + this.nfe_1.toString() + ', stm=' + toString(this.ofe_1) + ', functions=' + toString(this.pfe_1) + ', name=' + this.qfe_1 + ')';
  }
}
class ProgramLayout {
  constructor(items, layoutSize, fixedLocation) {
    return new.target.bfn(items, layoutSize, fixedLocation);
  }
  static bfn(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.zer_1 = items;
    $this.aes_1 = layoutSize;
    $this.bes_1 = fixedLocation;
    $this.ces_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.zer_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.za1();
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var v = _iterator__ex2g4s.r1();
      var a = v.d8o().ff6_1.yfm_1;
      var tmp$ret$3 = a <= 1 ? 1 : a;
      this_1.ga2(tmp$ret$3);
    }
    tmp.des_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.zer_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.za1();
    var _iterator__ex2g4s_0 = this_2.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var v_0 = _iterator__ex2g4s_0.r1();
      $this.ces_1 = !(v_0.ifd_1 == null) ? v_0.ifd_1 : nextAlignedTo($this.ces_1, v_0.d8o().ff6_1.yfm_1);
      var out = $this.ces_1;
      $this.ces_1 = $this.ces_1 + v_0.d8o().if6_1 | 0;
      this_3.ga2(out);
    }
    tmp_0.ees_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.des_1);
    tmp_1.fes_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.aes_1;
    tmp_2.ges_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.ces_1, $this.fes_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  static hes(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.bfn(toFastList_0(variables), layoutSize);
  }
  z7b() {
    return joinToString(this.zer_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.z7b() + ', fixedLocation=' + this.bes_1 + ']';
  }
  p1() {
    return this.zer_1.p1();
  }
}
class Attribute extends VariableWithOffset {
  constructor(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    return new.target.cfn(name, type, normalized, offset, active, precision, divisor, fixedLocation);
  }
  static cfn(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.jfd(name, type, 1, precision, offset);
    $this.zew_1 = normalized;
    $this.aex_1 = active;
    $this.bex_1 = divisor;
    $this.cex_1 = fixedLocation;
    return $this;
  }
  static dex(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.cfn(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  toString() {
    return 'Attribute(' + this.if4_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.d8o().equals(other.d8o());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.if4_1 === other.if4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.zew_1 === (other instanceof Attribute ? other : THROW_CCE()).zew_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.ifd_1 == other.ifd_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.aex_1 === other.aex_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.zew_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.ifd_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.aex_1) | 0;
    return out;
  }
}
class Uniform extends VariableWithOffset {
  constructor(name, type, arrayCount, precision, offset, typedUniform) {
    return new.target.xfd(name, type, arrayCount, precision, offset, typedUniform);
  }
  static xfd(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.jfd(name, type, arrayCount, precision, offset);
    $this.wfd_1 = typedUniform;
    if (type.zfm()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.o(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.if4_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.lf4_1 === other.lf4_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.d8o().equals(other.d8o());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.yf5_1 === other.yf5_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.if4_1 === other.if4_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.lf4_1 + imul(this.d8o().hashCode(), 7) | 0) + imul(getStringHashCode(this.if4_1), 11) | 0;
  }
}
class Precision extends Enum {}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.yfm_1 = bytesSize;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.afm_1 = vtype;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.afg_1 = name;
    this.bfg_1 = rettype;
    this.cfg_1 = args;
    this.dfg_1 = stm;
    this.efg_1 = this;
  }
  h1() {
    return this.afg_1;
  }
  pfl() {
    return this.bfg_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.afg_1 + ', rettype=' + this.bfg_1.toString() + ', args=' + toString(this.cfg_1) + ', stm=' + toString(this.dfg_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.afg_1);
    result = imul(result, 31) + this.bfg_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.cfg_1) | 0;
    result = imul(result, 31) + hashCode(this.dfg_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.afg_1 === tmp0_other_with_cast.afg_1))
      return false;
    if (!this.bfg_1.equals(tmp0_other_with_cast.bfg_1))
      return false;
    if (!equals(this.cfg_1, tmp0_other_with_cast.cfg_1))
      return false;
    if (!equals(this.dfg_1, tmp0_other_with_cast.dfg_1))
      return false;
    return true;
  }
}
class ShaderType extends Enum {}
class UniformInProgram {
  constructor(uniform, index) {
    this.efn_1 = uniform;
    this.ffn_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.efn_1.toString() + ', index=' + this.ffn_1 + ')';
  }
  hashCode() {
    var result = this.efn_1.hashCode();
    result = imul(result, 31) + this.ffn_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.efn_1.equals(tmp0_other_with_cast.efn_1))
      return false;
    if (!(this.ffn_1 === tmp0_other_with_cast.ffn_1))
      return false;
    return true;
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.gfn_1 = function_0;
  }
  u1o() {
    return this.gfn_1();
  }
  p5() {
    return this.gfn_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.hfn_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.hfn_1());
  }
}
class Companion_51 {
  constructor() {
    this.ifn_1 = 33309;
    this.jfn_1 = 33084;
    this.kfn_1 = 33085;
    this.lfn_1 = 256;
    this.mfn_1 = 1024;
    this.nfn_1 = 16384;
    this.ofn_1 = 0;
    this.pfn_1 = 1;
    this.qfn_1 = 0;
    this.rfn_1 = 1;
    this.sfn_1 = 2;
    this.tfn_1 = 3;
    this.ufn_1 = 4;
    this.vfn_1 = 5;
    this.wfn_1 = 6;
    this.xfn_1 = 0;
    this.yfn_1 = 1;
    this.zfn_1 = 768;
    this.afo_1 = 769;
    this.bfo_1 = 770;
    this.cfo_1 = 771;
    this.dfo_1 = 772;
    this.efo_1 = 773;
    this.ffo_1 = 774;
    this.gfo_1 = 775;
    this.hfo_1 = 776;
    this.ifo_1 = 32774;
    this.jfo_1 = 32777;
    this.kfo_1 = 32777;
    this.lfo_1 = 34877;
    this.mfo_1 = 32778;
    this.nfo_1 = 32779;
    this.ofo_1 = 32968;
    this.pfo_1 = 32969;
    this.qfo_1 = 32970;
    this.rfo_1 = 32971;
    this.sfo_1 = 32769;
    this.tfo_1 = 32770;
    this.ufo_1 = 32771;
    this.vfo_1 = 32772;
    this.wfo_1 = 32773;
    this.xfo_1 = 34962;
    this.yfo_1 = 34963;
    this.zfo_1 = 34964;
    this.afp_1 = 34965;
    this.bfp_1 = 35040;
    this.cfp_1 = 35044;
    this.dfp_1 = 35048;
    this.efp_1 = 34660;
    this.ffp_1 = 34661;
    this.gfp_1 = 34342;
    this.hfp_1 = 1028;
    this.ifp_1 = 1029;
    this.jfp_1 = 1032;
    this.kfp_1 = 3553;
    this.lfp_1 = 32879;
    this.mfp_1 = 2884;
    this.nfp_1 = 3042;
    this.ofp_1 = 3024;
    this.pfp_1 = 2960;
    this.qfp_1 = 2929;
    this.rfp_1 = 3089;
    this.sfp_1 = 32823;
    this.tfp_1 = 32926;
    this.ufp_1 = 32928;
    this.vfp_1 = 0;
    this.wfp_1 = 1280;
    this.xfp_1 = 1281;
    this.yfp_1 = 1282;
    this.zfp_1 = 1285;
    this.afq_1 = 2304;
    this.bfq_1 = 2305;
    this.cfq_1 = 2849;
    this.dfq_1 = 33901;
    this.efq_1 = 33902;
    this.ffq_1 = 2885;
    this.gfq_1 = 2886;
    this.hfq_1 = 2928;
    this.ifq_1 = 2930;
    this.jfq_1 = 2931;
    this.kfq_1 = 2932;
    this.lfq_1 = 2961;
    this.mfq_1 = 2962;
    this.nfq_1 = 2964;
    this.ofq_1 = 2965;
    this.pfq_1 = 2966;
    this.qfq_1 = 2967;
    this.rfq_1 = 2963;
    this.sfq_1 = 2968;
    this.tfq_1 = 34816;
    this.ufq_1 = 34817;
    this.vfq_1 = 34818;
    this.wfq_1 = 34819;
    this.xfq_1 = 36003;
    this.yfq_1 = 36004;
    this.zfq_1 = 36005;
    this.afr_1 = 2978;
    this.bfr_1 = 3088;
    this.cfr_1 = 3106;
    this.dfr_1 = 3107;
    this.efr_1 = 3317;
    this.ffr_1 = 3333;
    this.gfr_1 = 3379;
    this.hfr_1 = 3386;
    this.ifr_1 = 3408;
    this.jfr_1 = 3410;
    this.kfr_1 = 3411;
    this.lfr_1 = 3412;
    this.mfr_1 = 3413;
    this.nfr_1 = 3414;
    this.ofr_1 = 3415;
    this.pfr_1 = 10752;
    this.qfr_1 = 32824;
    this.rfr_1 = 32873;
    this.sfr_1 = 32936;
    this.tfr_1 = 32937;
    this.ufr_1 = 32938;
    this.vfr_1 = 32939;
    this.wfr_1 = 34466;
    this.xfr_1 = 34467;
    this.yfr_1 = 4352;
    this.zfr_1 = 4353;
    this.afs_1 = 4354;
    this.bfs_1 = 33170;
    this.cfs_1 = 5120;
    this.dfs_1 = 5121;
    this.efs_1 = 5122;
    this.ffs_1 = 5123;
    this.gfs_1 = 5124;
    this.hfs_1 = 5125;
    this.ifs_1 = 5126;
    this.jfs_1 = 5132;
    this.kfs_1 = 6402;
    this.lfs_1 = 6406;
    this.mfs_1 = 6407;
    this.nfs_1 = 6408;
    this.ofs_1 = 6409;
    this.pfs_1 = 6410;
    this.qfs_1 = 32819;
    this.rfs_1 = 32820;
    this.sfs_1 = 33635;
    this.tfs_1 = 35632;
    this.ufs_1 = 35633;
    this.vfs_1 = 34921;
    this.wfs_1 = 36347;
    this.xfs_1 = 36348;
    this.yfs_1 = 35661;
    this.zfs_1 = 35660;
    this.aft_1 = 34930;
    this.bft_1 = 36349;
    this.cft_1 = 35663;
    this.dft_1 = 35712;
    this.eft_1 = 35714;
    this.fft_1 = 35715;
    this.gft_1 = 35717;
    this.hft_1 = 35718;
    this.ift_1 = 35719;
    this.jft_1 = 35721;
    this.kft_1 = 35722;
    this.lft_1 = 35724;
    this.mft_1 = 35725;
    this.nft_1 = 512;
    this.oft_1 = 513;
    this.pft_1 = 514;
    this.qft_1 = 515;
    this.rft_1 = 516;
    this.sft_1 = 517;
    this.tft_1 = 518;
    this.uft_1 = 519;
    this.vft_1 = 7680;
    this.wft_1 = 7681;
    this.xft_1 = 7682;
    this.yft_1 = 7683;
    this.zft_1 = 5386;
    this.afu_1 = 34055;
    this.bfu_1 = 34056;
    this.cfu_1 = 7936;
    this.dfu_1 = 7937;
    this.efu_1 = 7938;
    this.ffu_1 = 7939;
    this.gfu_1 = 9728;
    this.hfu_1 = 9729;
    this.ifu_1 = 9984;
    this.jfu_1 = 9985;
    this.kfu_1 = 9986;
    this.lfu_1 = 9987;
    this.mfu_1 = 10240;
    this.nfu_1 = 10241;
    this.ofu_1 = 10242;
    this.pfu_1 = 10243;
    this.qfu_1 = 32882;
    this.rfu_1 = 5890;
    this.sfu_1 = 34067;
    this.tfu_1 = 34068;
    this.ufu_1 = 34069;
    this.vfu_1 = 34070;
    this.wfu_1 = 34071;
    this.xfu_1 = 34072;
    this.yfu_1 = 34073;
    this.zfu_1 = 34074;
    this.afv_1 = 34076;
    this.bfv_1 = 33984;
    this.cfv_1 = 33985;
    this.dfv_1 = 33986;
    this.efv_1 = 33987;
    this.ffv_1 = 33988;
    this.gfv_1 = 33989;
    this.hfv_1 = 33990;
    this.ifv_1 = 33991;
    this.jfv_1 = 33992;
    this.kfv_1 = 33993;
    this.lfv_1 = 33994;
    this.mfv_1 = 33995;
    this.nfv_1 = 33996;
    this.ofv_1 = 33997;
    this.pfv_1 = 33998;
    this.qfv_1 = 33999;
    this.rfv_1 = 34000;
    this.sfv_1 = 34001;
    this.tfv_1 = 34002;
    this.ufv_1 = 34003;
    this.vfv_1 = 34004;
    this.wfv_1 = 34005;
    this.xfv_1 = 34006;
    this.yfv_1 = 34007;
    this.zfv_1 = 34008;
    this.afw_1 = 34009;
    this.bfw_1 = 34010;
    this.cfw_1 = 34011;
    this.dfw_1 = 34012;
    this.efw_1 = 34013;
    this.ffw_1 = 34014;
    this.gfw_1 = 34015;
    this.hfw_1 = 34016;
    this.ifw_1 = 10497;
    this.jfw_1 = 33071;
    this.kfw_1 = 33648;
    this.lfw_1 = 35664;
    this.mfw_1 = 35665;
    this.nfw_1 = 35666;
    this.ofw_1 = 35667;
    this.pfw_1 = 35668;
    this.qfw_1 = 35669;
    this.rfw_1 = 35670;
    this.sfw_1 = 35671;
    this.tfw_1 = 35672;
    this.ufw_1 = 35673;
    this.vfw_1 = 35674;
    this.wfw_1 = 35675;
    this.xfw_1 = 35676;
    this.yfw_1 = 35678;
    this.zfw_1 = 35680;
    this.afx_1 = 34338;
    this.bfx_1 = 34339;
    this.cfx_1 = 34340;
    this.dfx_1 = 34341;
    this.efx_1 = 34922;
    this.ffx_1 = 34373;
    this.gfx_1 = 34975;
    this.hfx_1 = 35738;
    this.ifx_1 = 35739;
    this.jfx_1 = 35713;
    this.kfx_1 = 35716;
    this.lfx_1 = 35720;
    this.mfx_1 = 36346;
    this.nfx_1 = 36344;
    this.ofx_1 = 36345;
    this.pfx_1 = 36336;
    this.qfx_1 = 36337;
    this.rfx_1 = 36338;
    this.sfx_1 = 36339;
    this.tfx_1 = 36340;
    this.ufx_1 = 36341;
    this.vfx_1 = 36160;
    this.wfx_1 = 36161;
    this.xfx_1 = 32854;
    this.yfx_1 = 32855;
    this.zfx_1 = 36194;
    this.afy_1 = 33189;
    this.bfy_1 = 6401;
    this.cfy_1 = 36168;
    this.dfy_1 = 36162;
    this.efy_1 = 36163;
    this.ffy_1 = 36164;
    this.gfy_1 = 36176;
    this.hfy_1 = 36177;
    this.ify_1 = 36178;
    this.jfy_1 = 36179;
    this.kfy_1 = 36180;
    this.lfy_1 = 36181;
    this.mfy_1 = 36048;
    this.nfy_1 = 36049;
    this.ofy_1 = 36050;
    this.pfy_1 = 36051;
    this.qfy_1 = 36064;
    this.rfy_1 = 36096;
    this.sfy_1 = 33306;
    this.tfy_1 = 34041;
    this.ufy_1 = 36128;
    this.vfy_1 = 0;
    this.wfy_1 = 36053;
    this.xfy_1 = 36054;
    this.yfy_1 = 36055;
    this.zfy_1 = 36057;
    this.afz_1 = 36061;
    this.bfz_1 = 36006;
    this.cfz_1 = 36007;
    this.dfz_1 = 34024;
    this.efz_1 = 1286;
    this.ffz_1 = 37120;
    this.gfz_1 = 34836;
    this.hfz_1 = 3313;
    this.ifz_1 = 3314;
    this.jfz_1 = 3316;
    this.kfz_1 = 3315;
    this.lfz_1 = 3312;
    this.mfz_1 = 37441;
    this.nfz_1 = 36197;
    this.ofz_1 = 35345;
    this.pfz_1 = 35368;
    this.qfz_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.gf3_1 = new Mixin();
    this.hf3_1 = new ContextInfo();
    this.if3_1 = null;
    var tmp = this;
    tmp.jf3_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  vf6(texture) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  bfb(program, shader) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  afb(program, index, name) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  pf5(target, buffer) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  tf9(target, framebuffer) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  afa(target, renderbuffer) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  rf9(target, texture) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  df8(modeRGB, modeAlpha) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ef8(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  zf6(target, size, data, usage) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  yf6(target, offset, size, data) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  zf7(mask) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  uf7(red, green, blue, alpha) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  wf7(d) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  yf7(s) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  hfa(red, green, blue, alpha) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  sfa(shader) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ufa() {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  qfa(type) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  wf8(mode) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  rfz(n, items) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  sfz(n, items) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  pfa(program) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  tfz(n, items) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ofa(shader) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ufz(n, items) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  gfa(func) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  vf7(flag) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ffa(n, f) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  if8(cap) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  yf8(index) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  pf8(mode, first, count) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  rf8(mode, count, type, indices) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  jf8(cap) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  cf9(index) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  nd() {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  dfa(target, attachment, renderbuffertarget, renderbuffer) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  cfa(target, attachment, textarget, texture, level) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  efa(mode) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  vfz(n, buffers) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  df7(target) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  wfz(n, framebuffers) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  xfz(n, renderbuffers) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  yfz(n, textures) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  mfa(program, name) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  tfa() {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  zfz(pname, data) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ag0(program, pname, params) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  bg0(shader, pname, params) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  cg0(shader, bufSize, length, infoLog) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  kf3(name) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  cfb(program) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  af7(pname, param) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  qf9(x, y, width, height, format, type, pixels) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  bfa(target, internalformat, width, height) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ifa(x, y, width, height) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  rfa(shader, string) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  lf8(func, ref, mask) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  kf8(face, func, ref, mask) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  xf7(mask) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  of8(face, mask) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  nf8(fail, zfail, zpass) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  mf8(face, sfail, dpfail, dppass) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  bf7(target, level, internalformat, width, height, border, format, type, pixels) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  cf7(target, level, internalformat, format, type, data) {
    var buffer = Buffer.eb2(imul(imul(data.sc1_1, data.tc1_1), 4), true);
    setArrayLE(buffer, 0, data.pc9().ic1_1);
    this.bf7(target, level, internalformat, data.sc1_1, data.tc1_1, 0, format, type, buffer);
  }
  uf6(target, pname, param) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  qf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  of4(location, v0) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  jf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  rf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  kf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  sf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  lf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  tf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  mf6(location, count, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  nf6(location, count, transpose, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  of6(location, count, transpose, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  pf6(location, count, transpose, value) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  nfa(program) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  df9(index, size, type, normalized, stride, pointer) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  sf9(x, y, width, height) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ff8(cap, enable) {
    if (enable) {
      this.jf8(cap);
    } else {
      this.if8(cap);
    }
    return enable;
  }
  qf8(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  sf8(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  xf8(index, divisor) {
    unsupported();
  }
  kf9(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  pf4(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  qf4(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  dg0(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  zf8(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  wf6() {
    return Companion_instance_55.gfe();
  }
  pf7() {
    return Unit_instance;
  }
  uf8(contextVersion) {
    return Unit_instance;
  }
  eg0(name, index) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  g81() {
    if (this.if3_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.le();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = until(0, numExtensions);
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList.p2();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = tmp0.n3_1;
        var last = tmp0.o3_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = element;
            // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
            var tmp0_safe_receiver = this.eg0(7939, it);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.d2(tmp0_safe_receiver);
            }
          }
           while (!(element === last));
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.kf3(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.if3_1 = tmp_0;
    }
    return ensureNotNull(this.if3_1);
  }
  qf7() {
    return this.g81();
  }
  o9u(value) {
    this.gf3_1.o9u(value);
  }
  p9u() {
    return this.gf3_1.p9u();
  }
}
class KmlGlContext {
  constructor(window_0, gl, parent, $box) {
    parent = parent === VOID ? null : parent;
    boxApply(this, $box);
    this.mf7_1 = window_0;
    this.nf7_1 = gl;
    this.of7_1 = parent;
  }
  tf8() {
  }
  vf8() {
  }
  f7() {
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.fg0_1 = null;
    this.gg0_1 = Companion_getInstance_1().pb5('KorgeReload');
  }
  hg0(eventDispatcher) {
    if (!Companion_getInstance_2().ab1().lb1() || !(Companion_instance_1.wi('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.fg0_1 = eventDispatcher;
  }
  ig0() {
    if (!Companion_getInstance_2().ab1().lb1())
      return Unit_instance;
    if (!(this.fg0_1 == null))
      this.fg0_1 = null;
  }
}
class Companion_52 {}
class KorgeReloadInternalImpl {
  jg0(clazz, context) {
    return clazz;
  }
  kg0(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.lg0_1 = injector;
    this.mg0_1 = refreshedClasses;
    this.ng0_1 = rootFolders;
  }
}
class Companion_53 {
  constructor() {
    Companion_instance_62 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_50().rei_1;
    tmp.og0_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.pg0_1 = this.og0_1.bg4(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_50().yet(Companion_getInstance_57().pet_1, Companion_getInstance_57().wet_1);
    tmp_0.qg0_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_50().tei_1;
    tmp_1.rg0_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_50().yet(Companion_getInstance_57().oet_1, Companion_getInstance_57().set_1);
    tmp_2.sg0_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_50().yet(Companion_getInstance_57().pet_1, Companion_getInstance_57().tet_1);
    tmp_3.tg0_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_50().yet(Companion_getInstance_57().wet_1, Companion_getInstance_57().set_1);
    tmp_4.ug0_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_50().yet(Companion_getInstance_57().wet_1, Companion_getInstance_57().uet_1);
    tmp_5.vg0_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_50().yet(Companion_getInstance_57().qet_1, Companion_getInstance_57().net_1);
    tmp_6.wg0_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().net_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1, Companion_getInstance_58().ceu_1);
    tmp_7.xg0_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_50().xet(Companion_getInstance_57().ret_1, Companion_getInstance_57().wet_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
    tmp_8.yg0_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().net_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
    tmp_9.zg0_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().net_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
    tmp_10.ag1_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().net_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
    tmp_11.bg1_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().net_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
    tmp_12.cg1_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_50().xet(Companion_getInstance_57().uet_1, Companion_getInstance_57().net_1, Companion_getInstance_57().pet_1, Companion_getInstance_57().pet_1);
    tmp_13.dg1_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.eg1_1 = [this.pg0_1, this.qg0_1, this.og0_1, this.rg0_1, this.sg0_1, this.tg0_1, this.ug0_1, this.vg0_1, this.wg0_1, this.xg0_1, this.yg0_1, this.zg0_1, this.ag1_1, this.bg1_1, this.cg1_1, this.dg1_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.eg1_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cd(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$5 = ensureNotNull(element.zg3_1);
      destination.b5(tmp$ret$5, element);
    }
    tmp_15.fg1_1 = destination;
    this.gg1_1 = toList_0(this.eg1_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.eg1_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.cd(capacity_0);
    var inductionVariable_0 = this_1.n3_1;
    var last_0 = this_1.o3_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var it = element_0;
        var tmp$ret$8 = Companion_getInstance_69().eg1_1[it];
        destination_0.b5(tmp$ret$8, element_0);
      }
       while (!(element_0 === last_0));
    tmp_16.hg1_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_69();
    name = name === VOID ? null : name;
    this.yg3_1 = factors;
    this.zg3_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.yg3_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.zg3_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.ag4_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.ag4_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.yg3_1 === other.yg3_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.zg3_1 == other.zg3_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.zg3_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  cg4(factors, name) {
    return new BlendMode(factors, name);
  }
  bg4(factors, name, $super) {
    factors = factors === VOID ? this.yg3_1 : factors;
    name = name === VOID ? this.zg3_1 : name;
    return $super === VOID ? this.cg4(factors, name) : $super.cg4.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.dg4_1 = booleanArray(Companion_getInstance_35().qee_1);
    this.eg4_1 = booleanArray(Companion_getInstance_35().qee_1);
    this.fg4_1 = false;
    this.gg4_1 = false;
    this.hg4_1 = false;
    this.ig4_1 = false;
  }
  jg4(key) {
    return this.kg4(key);
  }
  kg4(key) {
    return this.dg4_1[key.w1_1];
  }
  lg4(key) {
    return this.dg4_1[key.w1_1] && !this.eg4_1[key.w1_1];
  }
  mg4(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.dg4_1[key.w1_1] = false;
        break;
      case false:
        this.dg4_1[key.w1_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.fg4_1 = shift || this.jg4(Companion_getInstance_35().eef()) || this.jg4(Companion_getInstance_35().fef());
    this.gg4_1 = ctrl || this.jg4(Companion_getInstance_35().cef()) || this.jg4(Companion_getInstance_35().def());
    this.hg4_1 = alt || this.jg4(Companion_getInstance_35().gef()) || this.jg4(Companion_getInstance_35().hef());
    this.ig4_1 = meta || this.jg4(Key_META_getInstance());
  }
  ng4(e) {
    switch (e.ye8_1.w1_1) {
      case 0:
      case 1:
        this.mg4(e.ae9_1, e.ye8_1.equals(Type_UP_getInstance()), this.fg4_1, this.gg4_1, this.hg4_1, this.ig4_1);
        break;
      default:
        break;
    }
  }
  og4(delta) {
  }
  pg4(delta) {
    arraycopy_4(this.dg4_1, 0, this.eg4_1, 0, this.dg4_1.length);
  }
}
class Companion_54 {
  constructor() {
    this.qg4_1 = 256;
  }
}
class Input {
  constructor() {
    this.rg4_1 = new Mixin();
    this.sg4_1 = Companion_getInstance_18().nea_1;
    this.tg4_1 = new TouchEvent();
    var tmp = this;
    tmp.ug4_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.vg4_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.wg4_1 = 20.0;
    this.xg4_1 = Vector2D.t9g(-1000.0, -1000.0);
    this.yg4_1 = Vector2D.t9g(-1000.0, -1000.0);
    this.zg4_1 = 0;
    this.ag5_1 = false;
    this.bg5_1 = true;
    this.cg5_1 = false;
    this.dg5_1 = new InputKeys();
    this.eg5_1 = booleanArray(256);
    this.fg5_1 = booleanArray(256);
    this.gg5_1 = new Float64Array(256);
    this.hg5_1 = new Float64Array(256);
    this.ig5_1 = booleanArray(256);
    this.jg5_1 = booleanArray(256);
    this.kg5_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$4 = new GamepadInfo(it);
        destination.d2(tmp$ret$4);
      }
       while (!(item === last));
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_1.lg5_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.mg5_1 = ArrayList.p2();
  }
  og5(touchEvent) {
    this.tg4_1.web(touchEvent);
  }
  pg5() {
    return this.xg4_1;
  }
  qg5(p, down) {
    if (down)
      this.yg4_1 = p;
    else
      this.xg4_1 = p;
  }
  rg5(button, down) {
    this.zg4_1 = setBits(this.zg4_1, button.sef_1, down);
  }
  sg5() {
    this.mg5_1.a5();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.lg5_1;
    var n = 0;
    while (n < this_0.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.hed_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.mg5_1.d2(gamepad);
      }
    }
  }
  tg5(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.eg5_1.length - 1 | 0) : false) {
      this.eg5_1[pKeyCode] = b;
    }
  }
  ug5(delta) {
    var tmp0_safe_receiver = this.p9u();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a5();
    }
    this.dg5_1.og4(delta);
  }
  vg5(delta) {
    this.cg5_1 = false;
    this.dg5_1.pg4(delta);
    endFrameOldKeys(this, delta);
  }
  wg5(e) {
    switch (e.ye8_1.w1_1) {
      case 1:
        this.tg5(e.be9_1, true);
        break;
      case 0:
        this.tg5(e.be9_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  o9u(value) {
    this.rg4_1.o9u(value);
  }
  p9u() {
    return this.rg4_1.p9u();
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.xg5_1 = 1280;
    this.yg5_1 = 720;
    this.zg5_1 = Size2D.l9i(1280, 720);
  }
}
class Companion_55 {
  ag6(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    this_0.cg6(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.m7() : props;
    this.bg6_1 = props;
  }
  dg6(str) {
    var _iterator__ex2g4s = split(str, ['\n']).p1();
    $l$loop_0: while (_iterator__ex2g4s.q1()) {
      var line = _iterator__ex2g4s.r1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.u2(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.collections.getOrElse' call
      var tmp;
      if (0 <= 1 ? 1 < parts.s2() : false) {
        tmp = parts.u2(1);
      } else {
        tmp = ' ';
      }
      // Inline function 'kotlin.text.trim' call
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.bg6_1.b5(key, value);
    }
  }
  cg6(str) {
    this.a5();
    this.dg6(str);
  }
  a5() {
    this.bg6_1.a5();
  }
  eg6(key, value) {
    return this.bg6_1.b5(key, value);
  }
  b5(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.eg6(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  fg6(from) {
    this.bg6_1.d5(from);
  }
  d5(from) {
    return this.fg6(from);
  }
  t7a(key) {
    return this.bg6_1.c5(key);
  }
  c5(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.t7a((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  i3() {
    return this.bg6_1.i3();
  }
  x4() {
    return this.bg6_1.x4();
  }
  y4() {
    return this.bg6_1.y4();
  }
  u2f(key) {
    return this.bg6_1.u4(key);
  }
  u4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.u2f((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  wi(key) {
    return this.bg6_1.w4(key);
  }
  w4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.wi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  n1() {
    return this.bg6_1.n1();
  }
  s2() {
    return this.bg6_1.s2();
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.gg6_1 = closeable;
  }
  hg6() {
    var tmp0_safe_receiver = this.gg6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f7();
    }
    this.gg6_1 = null;
  }
  ra8() {
    this.gg6_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.ig6_1 = Pool.ga8(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.jg6_1 = FastIdentityMap();
    this.kg6_1 = fastArrayListOf([]);
    this.lg6_1 = 0;
    this.mg6_1 = 60;
  }
  ng6(closeable) {
    var tmp0 = this.jg6_1;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var res = get_0(tmp0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'kotlin.also' call
      var this_0 = this.ig6_1.ja8();
      this_0.gg6_1 = closeable;
      var out = this_0;
      set(tmp0, closeable, out);
    }
  }
  og6() {
    this.lg6_1 = this.lg6_1 + 1 | 0;
    if (this.lg6_1 >= this.mg6_1) {
      this.lg6_1 = 0;
      this.pg6();
    }
  }
  pg6() {
    var _iterator__ex2g4s = this.kg6_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var entry = _iterator__ex2g4s.r1();
      if (!contains_1(this.jg6_1, entry.gg6_1)) {
        var tmp0_safe_receiver = entry.gg6_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.f7();
        }
        this.ig6_1.ka8(entry);
      }
    }
    this.kg6_1.a5();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.jg6_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      var it = v.value;
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.kg6_1.d2(it_0);
    }
    clear(this.jg6_1);
  }
  f7() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.kg6_1.d9v_1;
    var n = 0;
    while (n < array.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].hg6();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.jg6_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      var it = v.value;
      ensureNotNull(get_0(this_0, it)).hg6();
    }
    this.kg6_1.a5();
    this.ig6_1.a5();
    clear(this.jg6_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.qg6_1 = 0;
    this.rg6_1 = TextureBase.wg6(null, 0, 0);
    this.sg6_1 = FastIdentityMap();
  }
  ra8() {
    this.qg6_1 = 0;
    this.rg6_1.tg6_1 = null;
    this.rg6_1.vg6_1 = -1;
    this.rg6_1.xg6(0);
    this.rg6_1.yg6(0);
    clear(this.sg6_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.rg6_1.toString() + ', usedMemory=' + this.qg6_1 + ', slices=' + get_size(this.sg6_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.zg6_1 = ag;
    this.ag7_1 = new Long(0, 0);
    this.bg7_1 = FastSmallSet.na5();
    this.cg7_1 = FastSmallSet.na5();
    this.dg7_1 = FastArrayList.f9v();
    this.eg7_1 = 60;
    this.fg7_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.gg7_1 = Pool.ga8(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.hg7_1 = FastIdentityMap();
    this.ig7_1 = null;
    this.jg7_1 = null;
    this.kg7_1 = null;
    this.lg7_1 = null;
    this.mg7_1 = null;
    this.ng7_1 = null;
    this.og7_1 = null;
    this.pg7_1 = null;
    this.qg7_1 = 0;
  }
  sg7() {
    return this.bg7_1.s2();
  }
  tg7() {
    return this.cg7_1.s2();
  }
  ug7() {
    return this.dg7_1.s2();
  }
  toString() {
    return this.vg7();
  }
  vg7() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.sg7() + ', numReferencedBitmapsSinceGC=' + this.tg7() + ', numReferencedBitmaps=' + this.ug7() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().ub3(this.ag7_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().ub3(this.fg7_1)) + ')';
  }
  wg7(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).rg6_1);
  }
  xg7(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  yg7(slice) {
    return _getTexture(this, slice);
  }
  zg7() {
    clearFastCacheAccess(this);
    this.qg7_1 = this.qg7_1 + 1 | 0;
    if (this.qg7_1 >= this.eg7_1) {
      this.qg7_1 = 0;
      this.pg6();
    }
  }
  pg6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.dg7_1.d9v_1;
    var n = 0;
    while (n < array.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.cg7_1.pa5(bmp))
        if (compare(this.ag7_1, this.fg7_1) < 0 || compare(this.fg7_1, new Long(0, 0)) < 0) {
          this.ag8(bmp, 'GC');
        } else
          this.bg7_1.oa5(bmp);
    }
    this.dg7_1.a5();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.cg7_1.ja5_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      this.dg7_1.d2(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = this.bg7_1.ja5_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      this.dg7_1.d2(element_0);
    }
    this.cg7_1.a5();
  }
  ag8(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.hg7_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    var tmp0 = this.fg7_1;
    // Inline function 'kotlin.Long.minus' call
    var other = info.qg6_1;
    tmp_0.fg7_1 = subtract(tmp0, fromInt(other));
    this.cg7_1.qa5(bmp);
    if (this.jg7_1 === info || this.lg7_1 === info) {
      clearFastCacheAccess(this);
    }
    info.rg6_1.f7();
    this.gg7_1.ka8(info);
    this.bg7_1.qa5(bmp);
  }
  f7() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.hg7_1)).p1();
    while (_iterator__ex2g4s.q1()) {
      var bmp = _iterator__ex2g4s.r1();
      this.ag8(bmp, 'close');
    }
    clear(this.hg7_1);
    this.dg7_1.a5();
    this.cg7_1.a5();
    this.bg7_1.a5();
    this.gg7_1.a5();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.bg8_1 = ag;
    this.cg8_1 = FastIdentityMap();
    this.dg8_1 = FastSmallSet.na5();
    var tmp = this;
    tmp.eg8_1 = Pool.ha8(VOID, AgBufferManager$bufferPool$lambda);
    this.fg8_1 = 0;
    this.gg8_1 = 60;
    this.hg8_1 = Buffer.eb2(0);
  }
  ig8(cached) {
    this.dg8_1.oa5(cached);
    var tmp0 = this.cg8_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var res = get_0(tmp0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'kotlin.also' call
      var this_0 = this.eg8_1.ja8();
      this_0.oen(cached.jg8_1);
      var out = this_0;
      set(tmp0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  og6() {
    removeCache(this);
    this.fg8_1 = this.fg8_1 + 1 | 0;
    if (this.fg8_1 >= this.gg8_1) {
      this.fg8_1 = 0;
      this.pg6();
    }
  }
  pg6() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.dg8_1.ja5_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      this.kg8(element);
    }
    this.dg8_1.a5();
  }
  lg8(buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = buffer.u2(_unary__edvuaz);
      this.kg8(it);
    }
  }
  kg8(buffer) {
    var buf = getAndRemove(this.cg8_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      buf.oen(this.hg8_1);
      this.eg8_1.ka8(buf);
    }
  }
}
class AgCachedBuffer {
  constructor(data) {
    this.jg8_1 = data;
  }
}
class BatchBuffers {
  constructor() {
    this.wg8_1 = new AGBuffer();
    this.xg8_1 = new AGBuffer();
    this.yg8_1 = new AGBuffer();
    this.zg8_1 = AGVertexArrayObject.yer([new AGVertexData(Companion_getInstance_72().tg8_1, this.wg8_1), new AGVertexData(Companion_getInstance_72().ug8_1, this.xg8_1)], false);
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.xfl('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.mg8_1 = tmp_2;
    this.ng8_1 = 16383;
    this.og8_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$4 = 'BatchBuilder2D.Companion[0]';
      tmp0.pbj(level, tmp$ret$4);
    }
    this.pg8_1 = Attribute.dex('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_0 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_0 = Level_TRACE_getInstance();
    if (tmp0_0.obj(level_0)) {
      var tmp$ret$7 = 'BatchBuilder2D.Companion[1]';
      tmp0_0.pbj(level_0, tmp$ret$7);
    }
    this.qg8_1 = Varying.pex('v_Col2', VarType_Float4_getInstance());
    this.rg8_1 = Attribute.dex('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.sg8_1 = Varying.pex('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_1 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_1 = Level_TRACE_getInstance();
    if (tmp0_1.obj(level_1)) {
      var tmp$ret$10 = 'BatchBuilder2D.Companion[2]';
      tmp0_1.pbj(level_1, tmp$ret$10);
    }
    this.tg8_1 = ProgramLayout.hes([DefaultShaders_getInstance().nes_1, DefaultShaders_getInstance().oes_1, this.ag9(), this.pg8_1]);
    this.ug8_1 = ProgramLayout.hes([this.rg8_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_2 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_2 = Level_TRACE_getInstance();
    if (tmp0_2.obj(level_2)) {
      var tmp$ret$13 = 'BatchBuilder2D.Companion[3]';
      tmp0_2.pbj(level_2, tmp$ret$13);
    }
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.eey();
    this_0.jey(this_0.fey(), this_0.gey());
    this_0.jey(Companion_getInstance_72().sg8_1, Companion_getInstance_72().rg8_1);
    this_0.jey(Companion_getInstance_72().bg9(), this_0.qey([this_0.ney(this_0.sey(Companion_getInstance_72().ag9(), 'rgb'), this_0.sey(Companion_getInstance_72().ag9(), 'a')), this_0.sey(Companion_getInstance_72().ag9(), 'a')]));
    this_0.jey(Companion_getInstance_72().qg8_1, Companion_getInstance_72().pg8_1);
    this_0.jey(this_0.mey(), this_0.ney(this_0.ney(this_0.jev(), this_0.kev()), this_0.qey([this_0.oey(), this_0.pey(0.0), this_0.pey(1.0)])));
    var tmp_5 = VertexShader(this_0.rey());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.eey();
    Companion_getInstance_72().cg9(this_1);
    this_1.jey(this_1.mey(), this_1.ney(this_1.mey(), Companion_getInstance_72().bg9()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.ff1(this_1.sey(this_1.mey(), 'a'), this_1.pey(0.0));
    var body = this_1.yey();
    body.tez();
    var stmIf = new If(cond, body.aez());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.iey_1.d2(stmIf);
    var tmp$ret$17 = FragmentShader(this_1.rey());
    tmp_4.vg8_1 = new Program(tmp_5, tmp$ret$17, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_3 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_3 = Level_TRACE_getInstance();
    if (tmp0_3.obj(level_3)) {
      var tmp$ret$25 = 'BatchBuilder2D.Companion[4]';
      tmp0_3.pbj(level_3, tmp$ret$25);
    }
  }
  ag9() {
    return DefaultShaders_getInstance().pes_1;
  }
  bg9() {
    return DefaultShaders_getInstance().res_1;
  }
  cg9(builder) {
    // Inline function 'kotlin.apply' call
    var tmp = Companion_getInstance_72().sg8_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.pez(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_72();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_72().og8_1 : reqMaxQuads;
    this.qg2_1 = ctx;
    this.rg2_1 = reqMaxQuads;
    this.sg2_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    var tmp0 = this.rg2_1;
    // Inline function 'kotlin.math.min' call
    var b = Companion_getInstance_72().ng8_1;
    tmp.tg2_1 = Math.min(tmp0, b);
    this.ug2_1 = this.qg2_1.cg2_1;
    this.vg2_1 = this.qg2_1.jg1_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_0 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0_0.obj(level)) {
      var tmp$ret$3 = 'BatchBuilder2D[0]';
      tmp0_0.pbj(level, tmp$ret$3);
    }
    this.qg2_1.eg2_1.v9y(BatchBuilder2D$lambda(this));
    this.wg2_1 = imul(this.tg2_1, 4);
    this.xg2_1 = imul(this.tg2_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_1 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_0 = Level_TRACE_getInstance();
    if (tmp0_1.obj(level_0)) {
      var tmp$ret$6 = 'BatchBuilder2D[1]';
      tmp0_1.pbj(level_0, tmp$ret$6);
    }
    this.yg2_1 = Buffer.eb2(imul(24, this.wg2_1));
    this.zg2_1 = new Int8Array(this.wg2_1);
    this.ag3_1 = Buffer.eb2(imul(2, this.xg2_1));
    this.bg3_1 = get_u16(this.ag3_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_2 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_1 = Level_TRACE_getInstance();
    if (tmp0_2.obj(level_1)) {
      var tmp$ret$9 = 'BatchBuilder2D[2]';
      tmp0_2.pbj(level_1, tmp$ret$9);
    }
    this.cg3_1 = 0;
    this.dg3_1 = 0;
    this.eg3_1 = 0;
    this.fg3_1 = 0;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this.sg2_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = Array(tmp_2);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.gg3_1 = tmp_3;
    this.hg3_1 = false;
    this.ig3_1 = Companion_getInstance_69().og0_1;
    this.jg3_1 = Companion_getInstance_72().vg8_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_3 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_2 = Level_TRACE_getInstance();
    if (tmp0_3.obj(level_2)) {
      var tmp$ret$14 = 'BatchBuilder2D[3]';
      tmp0_3.pbj(level_2, tmp$ret$14);
    }
    var tmp_4 = this;
    tmp_4.kg3_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_4 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_3 = Level_TRACE_getInstance();
    if (tmp0_4.obj(level_3)) {
      var tmp$ret$17 = 'BatchBuilder2D[4]';
      tmp0_4.pbj(level_3, tmp$ret$17);
    }
    this.lg3_1 = Companion_getInstance_43().yei_1;
    this.mg3_1 = Companion_getInstance_42().aej_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_5 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_4 = Level_TRACE_getInstance();
    if (tmp0_5.obj(level_4)) {
      var tmp$ret$20 = 'BatchBuilder2D[5]';
      tmp0_5.pbj(level_4, tmp$ret$20);
    }
    this.ng3_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_6 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_5 = Level_TRACE_getInstance();
    if (tmp0_6.obj(level_5)) {
      var tmp$ret$23 = 'BatchBuilder2D[6]';
      tmp0_6.pbj(level_5, tmp$ret$23);
    }
    this.og3_1 = Companion_getInstance_41().mej_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_7 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_6 = Level_TRACE_getInstance();
    if (tmp0_7.obj(level_6)) {
      var tmp$ret$26 = 'BatchBuilder2D[7]';
      tmp0_7.pbj(level_6, tmp$ret$26);
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_8 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_7 = Level_TRACE_getInstance();
    if (tmp0_8.obj(level_7)) {
      var tmp$ret$29 = 'BatchBuilder2D[11]';
      tmp0_8.pbj(level_7, tmp$ret$29);
    }
    this.pg3_1 = new Signal();
    this.qg3_1 = new Signal();
    this.rg3_1 = fastArrayListOf([]);
    this.sg3_1 = 0;
    this.tg3_1 = 0;
    this.ug3_1 = 0;
  }
  fg9() {
    return this.qg2_1.xg1_1;
  }
  gg9(value) {
    this.cg3_1 = value;
  }
  hg9() {
    return this.cg3_1;
  }
  ig9() {
    var inductionVariable = 0;
    var last = this.sg2_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.gg3_1[n] = null;
      }
       while (inductionVariable < last);
    this.fg3_1 = 0;
  }
  og6() {
    this.kg3_1.ra8();
  }
  jg9() {
    return this.og3_1;
  }
  kg9(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.zg2_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  lg9(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.mg9(6, 4);
    this.ng9();
    var vp = this.dg3_1;
    var vd = this.yg2_1;
    vp = vp + this.kg9(vd, vp, x0, y0, tex.bal(), tex.cal(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.kg9(vd, vp, x1, y1, tex.dal(), tex.eal(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.kg9(vd, vp, x2, y2, tex.fal(), tex.gal(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.kg9(vd, vp, x3, y3, tex.hal(), tex.ial(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.dg3_1 = vp;
    this.gg9(this.hg9() + 4 | 0);
  }
  og9(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.fg3_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.lg9(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.lg9.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  pg9(vc) {
    this.eg3_1 = this.eg3_1 + _addIndices(this, this.bg3_1, this.eg3_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  ng9(vc, $super) {
    vc = vc === VOID ? this.hg9() : vc;
    var tmp;
    if ($super === VOID) {
      this.pg9(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.pg9.call(this, vc);
    }
    return tmp;
  }
  qg9(array, matrix, vcount, icount, texIndex) {
    this.mg9(icount, vcount);
    var i16 = this.bg3_1;
    var ip = this.eg3_1;
    var vc = this.hg9();
    var arrayIndices = array.rg9_1;
    // Inline function 'kotlin.math.min' call
    var b = array.ug9_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.dg3_1;
    var src = get_i32(array.vg9_1);
    var dst = get_i32(this.yg2_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.dg3_1 / 6 | 0;
    arrayfill(this.zg2_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.u9h()) {
      applyMatrix(this, matrix, this.dg3_1, vcount);
    }
    this.cg3_1 = this.cg3_1 + vcount | 0;
    this.dg3_1 = this.dg3_1 + imul(vcount, 6) | 0;
    this.eg3_1 = this.eg3_1 + icount_0 | 0;
  }
  yg9(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.tg9_1 : vcount;
    icount = icount === VOID ? array.ug9_1 : icount;
    texIndex = texIndex === VOID ? this.fg3_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.qg9(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.qg9.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  mg9(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.zg9();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.o(toString(message));
    }
    return doFlush;
  }
  aga(tex, smoothing, blendMode, program, icount, vcount) {
    var tmp2 = tex.tg6_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      this.mg9(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_72().vg8_1 : program;
      if (this.bga(tmp2, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.dg9();
      if (!contains_0(this.gg3_1, tmp2)) {
        this.fg3_1 = 0;
        this.gg3_1[0] = tmp2;
      }
      this.hg3_1 = smoothing;
      this.ig3_1 = blendMode;
      this.jg3_1 = pprogram;
    }
  }
  cga(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.gg3_1;
    var n = 0;
    while (n < this_0.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  bga(tex, smoothing, blendMode, program) {
    var hasTex = this.cga(tex);
    if (!(this.gg3_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.gg3_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.gg3_1[n] === null) {
            this.gg3_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.gg3_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.gg3_1[n_0]) {
          this.fg3_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.hg3_1 === smoothing && this.ig3_1 === blendMode && this.jg3_1 === program;
  }
  dga(tex, smoothing, blendMode, program, icount, vcount) {
    this.aga(this.ug2_1.wg7(tex), smoothing, blendMode, program, icount, vcount);
  }
  ega(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.fga(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  xg3(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.w9z() : width;
    height = height === VOID ? tex.x9z() : height;
    m = m === VOID ? Companion_getInstance_7().v9k_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().zc2_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_69().og0_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.ega(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.ega.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  fga(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.aga(tex.qak(), filtering, blendMode, program, 6, 4);
    this.gga(x, y, width, height, m, tex, colorMul);
  }
  gga(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.og9(m.n9l(x0, y0), m.o9l(x0, y0), m.n9l(x1, y0), m.o9l(x1, y0), m.n9l(x1, y1), m.o9l(x1, y1), m.n9l(x0, y1), m.o9l(x0, y1), tex, colorMul);
  }
  hga() {
    this.kg3_1.qa8_1.yg8_1.nen(this.ag3_1, 0, imul(this.eg3_1, 2));
  }
  iga() {
    this.qg2_1.iga();
    var inductionVariable = 0;
    var last = this.sg2_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_40().ven(VOID, this.hg3_1);
        this.qg2_1.sg1_1.qem(Companion_getInstance_72().mg8_1[n], this.gg3_1[n], info);
      }
       while (inductionVariable < last);
  }
  dg9() {
    if (this.sg3_1 === this.eg3_1)
      return Unit_instance;
    this.iga();
    this.tg3_1 = this.tg3_1 + 1 | 0;
    var tmp0 = this.rg3_1;
    var tmp0_frameBuffer = this.qg2_1.mg2_1.leg_1;
    var tmp1_frameBufferInfo = this.qg2_1.mg2_1.sej();
    var tmp2_vertexData = this.kg3_1.qa8_1.zg8_1;
    var tmp3_indices = this.kg3_1.qa8_1.yg8_1;
    var tmp4_program = this.jg3_1;
    var tmp5_drawType = Companion_getInstance_44().mer_1;
    var tmp6_blending = this.ig3_1.yg3_1;
    var tmp7_uniformBlocks = this.qg2_1.jga(this.jg3_1, false);
    var tmp8_textureUnits = this.qg2_1.sg1_1.g9m();
    var tmp9_stencilOpFunc = this.mg3_1;
    var tmp10_stencilRef = this.lg3_1;
    var tmp11_colorMask = this.ng3_1;
    var tmp12_scissor = this.og3_1;
    var tmp13_drawOffset = imul(this.sg3_1, 2);
    var tmp14_vertexCount = this.eg3_1 - this.sg3_1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new AGBatch(tmp0_frameBuffer, tmp1_frameBufferInfo, tmp2_vertexData, tmp3_indices, VOID, tmp4_program, tmp7_uniformBlocks, tmp8_textureUnits, tmp6_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp12_scissor, VOID, tmp5_drawType, tmp13_drawOffset, tmp14_vertexCount);
    tmp0.d2(element);
    this.sg3_1 = this.eg3_1;
  }
  kga(uploadVertices, uploadIndices) {
    this.lga(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.sg2_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.gg3_1[n] = null;
      }
       while (inductionVariable < last);
    this.fg3_1 = 0;
  }
  eg9(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.kga(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.kga.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  lga(uploadVertices, uploadIndices) {
    this.dg9();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.rg3_1.n1()) {
      if (uploadVertices) {
        this.kg3_1.qa8_1.wg8_1.nen(this.yg2_1, 0, imul(this.dg3_1, 4));
        this.kg3_1.qa8_1.xg8_1.ken(this.zg2_1, 0, this.dg3_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.hga();
      }
      this.qg2_1.mga();
      draw_1(this.vg2_1, new AGMultiBatch(toList(this.rg3_1)));
      this.rg3_1.a5();
      this.pg3_1.x9y(this);
      this.ug3_1 = this.ug3_1 + 1 | 0;
      this.qg2_1.nga();
      this.kg3_1.r1();
    }
    this.gg9(0);
    this.dg3_1 = 0;
    this.sg3_1 = 0;
    this.eg3_1 = 0;
  }
  zg9(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.lga(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.lga.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  oga(vertexCount) {
    var oldVertexCount = this.hg9();
    this.gg9(vertexCount);
    try {
      this.pg3_1.x9y(this);
    }finally {
      this.gg9(oldVertexCount);
    }
  }
}
class BoundsProvider {}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.xga()).a9n();
}
function get_globalToWindowScaleAvg() {
  return this.bgb().a9n();
}
function windowToGlobalCoords(pos) {
  var tmp0 = this.vga();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (tmp0.t9h()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.t9g(tmp0.m9l(pos.r9g_1, pos.s9g_1), tmp0.p9l(pos.r9g_1, pos.s9g_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.pga_1 = Companion_getInstance_7().y9k();
    this.qga_1 = MatrixTransform.y9m();
    this.rga_1 = Companion_getInstance_7().y9k();
    this.sga_1 = MatrixTransform.y9m();
    this.tga_1 = Companion_getInstance_5().r9p(0, 0, 1280, 720);
  }
  uga(_set____db54di) {
    this.pga_1 = _set____db54di;
  }
  vga() {
    return this.pga_1;
  }
  wga(_set____db54di) {
    this.qga_1 = _set____db54di;
  }
  xga() {
    return this.qga_1;
  }
  yga(_set____db54di) {
    this.rga_1 = _set____db54di;
  }
  zga() {
    return this.rga_1;
  }
  agb(_set____db54di) {
    this.sga_1 = _set____db54di;
  }
  bgb() {
    return this.sga_1;
  }
  cgb(_set____db54di) {
    this.tga_1 = _set____db54di;
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.ggb_1 = ProgramLayout.hes([DefaultShaders_getInstance().nes_1, DefaultShaders_getInstance().pes_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.eey();
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    builder.jey(builder.mey(), builder.ney(builder.ney(this_0.jev(), this_0.kev()), builder.qey([this_0.nes_1, builder.pey(0.0), builder.pey(1.0)])));
    builder.jey(this_0.res_1, this_0.pes_1);
    tmp.hgb_1 = VertexShader(builder.rey());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.eey();
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    builder_0.jey(builder_0.mey(), this_1.res_1);
    tmp_0.igb_1 = FragmentShader(builder_0.rey());
    this.jgb_1 = new Program(this.hgb_1, this.igb_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_73();
    this.kgb_1 = ctx;
    this.lgb_1 = new Signal();
    this.kgb_1.eg2_1.v9y(LineRenderBatcher$lambda(this));
    this.mgb_1 = this.kgb_1.jg1_1;
    this.ngb_1 = Colors_getInstance().pc8_1;
    this.ogb_1 = new AGBuffer();
    this.pgb_1 = AGVertexArrayObject.yer([new AGVertexData(Companion_getInstance_73().ggb_1, this.ogb_1)], false);
    this.qgb_1 = 1024;
    this.rgb_1 = allocDirect(Companion_instance_4, imul(24, this.qgb_1));
    this.sgb_1 = Matrix4.d9o();
    this.tgb_1 = 0;
    this.ugb_1 = 0;
    this.vgb_1 = Companion_getInstance_69().og0_1;
    this.wgb_1 = Companion_getInstance_7().y9k();
  }
  ygb(p0, p1, color0, color1, m) {
    return this.zgb(p0.r9g_1, p0.s9g_1, p1.r9g_1, p1.s9g_1, this.ngb_1, color1, m);
  }
  xgb(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.ngb_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.wgb_1 : m;
    var tmp;
    if ($super === VOID) {
      this.ygb(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.ygb.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  agc(x0, y0, x1, y1, color0, color1, m) {
    if (this.tgb_1 >= (this.qgb_1 - 2 | 0)) {
      this.nd();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  bgc(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.ngb_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.wgb_1 : m;
    var tmp;
    if ($super === VOID) {
      this.agc(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.agc.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  zgb(x0, y0, x1, y1, color0, color1, m) {
    return this.agc(x0, y0, x1, y1, color0, color1, m);
  }
  cgc(path, m) {
    var lastPos = {_v: Vector2D.y9j()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.y9j();
    var l = Vector2D.y9j();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.nah_1;
    var n_0 = 0;
    while (n_0 < this_0.s2()) {
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.j9u(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.oah_1.u2(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.t9g(tmp, path.oah_1.u2(_unary__edvuaz_1));
          i = it;
          if (!true) {
            this.xgb(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.oah_1.u2(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.t9g(tmp_0, path.oah_1.u2(_unary__edvuaz_3));
          if (!false) {
            this.xgb(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.oah_1.u2(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var tmp0 = Vector2D.t9g(tmp_1, path.oah_1.u2(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.oah_1.u2(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.t9g(tmp_2, path.oah_1.u2(_unary__edvuaz_7));
          var sum = Companion_getInstance_4().z9s(l, tmp0) + Companion_getInstance_4().z9s(tmp0, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.y9j()};
          var prevPos = {_v: Vector2D.y9j()};
          var emittedCount = {_v: 0};
          var tmp0_0 = Companion_getInstance_10().w9f_1;
          LineRenderBatcher$drawVector$lambda(lastPos_0)(Companion_getInstance_13().nae(l, tmp0, a, tmp0_0));
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(n_1 * dt);
              LineRenderBatcher$drawVector$lambda_0(this, lastPos, m, emittedCount, lastPos_0, prevPos)(Companion_getInstance_13().nae(l, tmp0, a, ratio));
            }
             while (!(n_1 === nEnd));
          l = a;
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.oah_1.u2(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var tmp0_1 = Vector2D.t9g(tmp_3, path.oah_1.u2(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.oah_1.u2(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var tmp2 = Vector2D.t9g(tmp_4, path.oah_1.u2(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.oah_1.u2(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.t9g(tmp_5, path.oah_1.u2(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_4().z9s(l, tmp0_1) + Companion_getInstance_4().z9s(tmp0_1, tmp2) + Companion_getInstance_4().z9s(tmp2, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.y9j()};
          var prevPos_0 = {_v: Vector2D.y9j()};
          var emittedCount_0 = {_v: 0};
          var tmp0_2 = Companion_getInstance_10().w9f_1;
          LineRenderBatcher$drawVector$lambda_1(lastPos_1)(Companion_getInstance_13().mae(l, tmp0_1, tmp2, a_1, tmp0_2));
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              LineRenderBatcher$drawVector$lambda_2(this, lastPos, m, emittedCount_0, lastPos_1, prevPos_0)(Companion_getInstance_13().mae(l, tmp0_1, tmp2, a_1, ratio_0));
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          break;
        case 4:
          var p = i;
          if (!false) {
            this.xgb(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          break;
      }
    }
  }
  nd() {
    if (this.tgb_1 > 0) {
      this.lgb_1.x9y(this);
      this.ogb_1.nen(this.rgb_1, 0, imul(this.ugb_1, 4));
      this.kgb_1.iga();
      var tmp0_$receiver = this.mgb_1;
      var tmp1_frameBuffer = this.kgb_1.mg2_1;
      var tmp2_vertexData = this.pgb_1;
      var tmp3_program = Companion_getInstance_73().jgb_1;
      var tmp4_drawType = Companion_getInstance_44().ler_1;
      var tmp5_vertexCount = this.tgb_1;
      var tmp6_uniformBlocks = this.kgb_1.dgc(Companion_getInstance_73().jgb_1);
      var tmp7_blending = this.vgb_1.yg3_1;
      draw_0(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.tgb_1 = 0;
    this.ugb_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.wgc();
}
function get_pixelsPerLogicalInchRatio() {
  return this.xgc() / 96.0;
}
function get_computedPixelRatio() {
  return this.wgc() * this.ygc();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_72().og8_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.ig1_1 = new Mixin();
    this.jg1_1 = ag;
    this.kg1_1 = bp;
    this.lg1_1 = deviceDimensionsProvider;
    this.mg1_1 = stats;
    this.ng1_1 = coroutineContext;
    this.og1_1 = batchMaxQuads;
    this.pg1_1 = windowConfig;
    this.qg1_1 = new BufferCache();
    this.rg1_1 = FastIdentityMap();
    this.sg1_1 = AGTextureUnits.jem();
    this.tg1_1 = Companion_getInstance_7().y9k();
    this.ug1_1 = Companion_getInstance_7().y9k();
    this.vg1_1 = Matrix4.d9o();
    this.wg1_1 = Matrix4.d9o();
    this.xg1_1 = Companion_getInstance_7().y9k();
    this.yg1_1 = true;
    var tmp_0 = this;
    tmp_0.zg1_1 = Pool.ha8(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.ag2_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.bg2_1 = new AgAutoFreeManager();
    this.cg2_1 = new AgBitmapTextureManager(this.jg1_1);
    this.dg2_1 = new AgBufferManager(this.jg1_1);
    this.eg2_1 = new Signal();
    this.fg2_1 = 1.0;
    this.gg2_1 = Colors_getInstance().zc2_1;
    this.hg2_1 = new BatchBuilder2D(this, this.og1_1);
    var tmp_2 = this;
    tmp_2.ig2_1 = Pool.ha8(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.jg2_1 = new RenderContext2D(this.hg2_1, this.cg2_1);
    this.kg2_1 = true;
    this.lg2_1 = null;
    this.mg2_1 = this.jg1_1.zeg();
    this.ng2_1 = LinkedHashSet.v2();
    var tmp_3 = this;
    tmp_3.og2_1 = Pool.ha8(VOID, RenderContext$frameBuffers$lambda);
    this.pg2_1 = FastArrayList.f9v();
  }
  fgc() {
    return this.pg1_1.fgc();
  }
  nga() {
  }
  egc() {
    var tmp0 = this.ag2_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('projViewMatUB', 1, tmp, RenderContext$_get_projViewMatUB_$ref_e0jwh6(), null);
    return tmp0.k3();
  }
  iga() {
    if (this.yg1_1 && this.mg2_1.aek()) {
      this.vg1_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().v9p(0, this.mg2_1.teg_1, this.mg2_1.seg_1, 0), -1.0, 1.0);
    } else {
      this.vg1_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().v9p(0, 0, this.mg2_1.seg_1, this.mg2_1.teg_1), -1.0, 1.0);
      this.vg1_1 = this.vg1_1.a9p(toMatrix4(this.tg1_1));
    }
    var tmp0 = this.egc();
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = tmp0.z6x();
      tmp0.efc(_unary__edvuaz + 1 | 0);
      tmp0.ffc(tmp0.z6x() + 1 | 0);
      var blockSize = tmp0.beo_1;
      var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
      var index1 = imul(tmp0.z6x(), blockSize);
      var texBlockSize = tmp0.yen_1.wev().s2();
      var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp0.z6x(), texBlockSize);
      if (tmp0.z6x() > 0) {
        arraycopy_0(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
      } else {
        arrayfill_0(tmp0.deo_1, 0, 0, blockSize);
      }
      var tmp0_0 = tmp0.yen_1;
      var it = tmp0.eeo_1;
      it.rfc(tmp0_0.jev(), this.vg1_1);
      it.rfc(tmp0_0.kev(), this.wg1_1);
      if (true && tmp0.z6x() >= 1) {
        var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = tmp0.z6x();
          tmp0.efc(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  ggc() {
    return coerceAtLeast_0(round(this.hgc() * this.fg2_1), 1.0);
  }
  igc(kind) {
    this.eg2_1.x9y(kind);
  }
  vg3(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.igc(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.igc.call(this, kind);
    }
    return tmp;
  }
  jgc() {
    var tmp0_elvis_lhs = this.mg2_1;
    return tmp0_elvis_lhs == null ? this.zeg() : tmp0_elvis_lhs;
  }
  kgc() {
    return this.jgc() === this.zeg();
  }
  zeg() {
    return this.jg1_1.zeg();
  }
  lgc(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.jg1_1.deh(this.mg2_1.leg_1, this.mg2_1.sej(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  mgc(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().ec3_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_41().mej_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.lgc(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.lgc.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  v7e() {
    this.jg1_1.v7e();
    this.og2_1.la8(this.ng2_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.ng2_1.n1()) {
      this.ng2_1.a5();
    }
  }
  wg3(bmp) {
    return this.cg2_1.xg7(bmp);
  }
  ngc(bmp) {
    return this.cg2_1.yg7(bmp);
  }
  ig8(buffer) {
    return this.dg2_1.ig8(buffer);
  }
  ogc(closeable) {
    return this.bg2_1.ng6(closeable);
  }
  pgc() {
    this.hg2_1.ig9();
  }
  zg7() {
    this.vg3();
    this.v7e();
    this.hg2_1.og6();
    this.bg2_1.og6();
    this.cg2_1.zg7();
    this.dg2_1.og6();
  }
  f7() {
    this.cg2_1.f7();
    this.bg2_1.f7();
  }
  qgc(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.og2_1.ja8();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.ng2_1.d2(rb);
    }
    rb.mek(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.del(hasDepth, hasStencil);
    rb.cel(msamples);
    return rb;
  }
  rgc(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.qgc(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.qgc.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  sgc(rb) {
    this.ng2_1.z4(rb);
    this.og2_1.ka8(rb);
  }
  tgc(frameBuffer) {
    this.pg2_1.d2(this.mg2_1);
    this.mg2_1 = frameBuffer;
  }
  ugc() {
    this.mg2_1 = this.pg2_1.g5(this.pg2_1.s2() - 1 | 0);
  }
  ieo(uniformBlock) {
    return this.qg1_1.ieo(uniformBlock);
  }
  vgc(program) {
    var tmp0 = this.rg1_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var res = get_0(tmp0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var out = new AGProgramWithUniforms(program, this.qg1_1);
      set(tmp0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  jga(program, autoUpload) {
    if (autoUpload) {
      this.mga();
    }
    return this.vgc(program).wep();
  }
  dgc(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.jga(program, autoUpload) : $super.jga.call(this, program, autoUpload);
  }
  mga() {
    this.qg1_1.geo();
  }
  o9u(value) {
    this.ig1_1.o9u(value);
  }
  p9u() {
    return this.ig1_1.p9u();
  }
  uga(_set____db54di) {
    this.kg1_1.uga(_set____db54di);
  }
  vga() {
    return this.kg1_1.vga();
  }
  wga(_set____db54di) {
    this.kg1_1.wga(_set____db54di);
  }
  xga() {
    return this.kg1_1.xga();
  }
  yga(_set____db54di) {
    this.kg1_1.yga(_set____db54di);
  }
  zga() {
    return this.kg1_1.zga();
  }
  agb(_set____db54di) {
    this.kg1_1.agb(_set____db54di);
  }
  bgb() {
    return this.kg1_1.bgb();
  }
  cgb(_set____db54di) {
    this.kg1_1.cgb(_set____db54di);
  }
  dgb() {
    return this.kg1_1.dgb();
  }
  egb() {
    return this.kg1_1.egb();
  }
  fgb(pos) {
    return this.kg1_1.fgb(pos);
  }
  geh() {
    return this.jg1_1.geh();
  }
  heh() {
    return this.jg1_1.heh();
  }
  ieh() {
    return this.jg1_1.ieh();
  }
  wgc() {
    return this.lg1_1.wgc();
  }
  xgc() {
    return this.lg1_1.xgc();
  }
  ygc() {
    return this.lg1_1.ygc();
  }
  hgc() {
    return this.lg1_1.hgc();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.zgc_1 = new Mixin();
    this.agd_1 = batch;
    this.bgd_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = get_logger_0();
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'RenderContext2D[0]';
      tmp0.pbj(level, tmp$ret$2);
    }
    this.cgd_1 = Size2D.l9i(0, 0);
    var tmp = this;
    tmp.dgd_1 = Pool.ha8(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_0 = get_logger_0();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_0 = Level_TRACE_getInstance();
    if (tmp0_0.obj(level_0)) {
      var tmp$ret$5 = 'RenderContext2D[1]';
      tmp0_0.pbj(level_0, tmp$ret$5);
    }
    this.egd_1 = Companion_getInstance_7().v9k_1;
    this.fgd_1 = Companion_getInstance_69().og0_1;
    this.ggd_1 = Colors_getInstance().zc2_1;
    this.hgd_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0_1 = get_logger_0();
    // Inline function 'korlibs.logger.Logger.log' call
    var level_1 = Level_TRACE_getInstance();
    if (tmp0_1.obj(level_1)) {
      var tmp$ret$8 = 'RenderContext2D[2]';
      tmp0_1.pbj(level_1, tmp$ret$8);
    }
  }
  igd(matrix) {
    this.egd_1 = matrix;
  }
  jgd(rect, color, filtering, bmp, program) {
    var tmp0_$this = this.agd_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.getTexture' call
    var tmp1_tex = this.bgd_1.xg7(bmp);
    var tmp2_x = rect.o9h_1;
    var tmp3_y = rect.p9h_1;
    var tmp4_width = rect.q9h_1;
    var tmp5_height = rect.r9h_1;
    var tmp6_m = this.egd_1;
    var tmp7_blendMode = this.fgd_1;
    tmp0_$this.ega(tmp1_tex, tmp2_x, tmp3_y, tmp4_width, tmp5_height, tmp6_m, filtering, color, tmp7_blendMode, program);
  }
  kgd(rect, color, filtering, bmp, program, $super) {
    color = color === VOID ? this.ggd_1 : color;
    filtering = filtering === VOID ? this.hgd_1 : filtering;
    var tmp;
    if (bmp === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      tmp = get_Bitmaps_white();
    } else {
      tmp = bmp;
    }
    bmp = tmp;
    program = program === VOID ? null : program;
    var tmp_0;
    if ($super === VOID) {
      this.jgd(rect, color, filtering, bmp, program);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.jgd.call(this, rect, new RGBA(color), filtering, bmp, program);
    }
    return tmp_0;
  }
  lgd(scissor) {
    var tmp0 = this.egd_1;
    var tmp2 = Vector2D.a9k(scissor.v9h(), scissor.x9h());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (tmp0.t9h()) {
        tmp$ret$0 = tmp2;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.t9g(tmp0.m9l(tmp2.r9g_1, tmp2.s9g_1), tmp0.p9l(tmp2.r9g_1, tmp2.s9g_1));
    }
    var tl = tmp$ret$0;
    var tmp0_0 = this.egd_1;
    var tmp2_0 = Vector2D.a9k(scissor.w9h(), scissor.y9h());
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (tmp0_0.t9h()) {
        tmp$ret$1 = tmp2_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.t9g(tmp0_0.m9l(tmp2_0.r9g_1, tmp2_0.s9g_1), tmp0_0.p9l(tmp2_0.r9g_1, tmp2_0.s9g_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_41().ceq(tl.r9g_1, tl.s9g_1, br.r9g_1, br.s9g_1);
  }
  o9u(value) {
    this.zgc_1.o9u(value);
  }
  p9u() {
    return this.zgc_1.p9u();
  }
}
class SDFShaders extends Builder {
  constructor() {
    return new.target.uge();
  }
  static uge() {
    SDFShaders_instance = null;
    var $this = this.xey();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.xez();
    var tmp_1 = $this.xez();
    var tmp_2 = $this.xez();
    var tmp_3 = $this.xez();
    var tmp_4 = $this.iez(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda);
    var tmp_5 = KProperty1;
    tmp.ogd_1 = tmp_4.mew($this, getPropertyCallableRef('opInterpolate', 1, tmp_5, SDFShaders$_get_opInterpolate_$ref_4qhkt1(), null));
    var tmp_6 = $this;
    var tmp_7 = $this.xez();
    var tmp_8 = $this.xez();
    var tmp_9 = $this.xez();
    var tmp_10 = $this.gez(tmp_7, tmp_8, VOID, tmp_9, SDFShaders$opUnion$delegate$lambda);
    var tmp_11 = KProperty1;
    tmp_6.pgd_1 = tmp_10.mew($this, getPropertyCallableRef('opUnion', 1, tmp_11, SDFShaders$_get_opUnion_$ref_cdui7t(), null));
    var tmp_12 = $this;
    var tmp_13 = $this.xez();
    var tmp_14 = $this.xez();
    var tmp_15 = $this.xez();
    var tmp_16 = $this.gez(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opIntersect$delegate$lambda);
    var tmp_17 = KProperty1;
    tmp_12.qgd_1 = tmp_16.mew($this, getPropertyCallableRef('opIntersect', 1, tmp_17, SDFShaders$_get_opIntersect_$ref_u559qh(), null));
    var tmp_18 = $this;
    var tmp_19 = $this.xez();
    var tmp_20 = $this.xez();
    var tmp_21 = $this.xez();
    var tmp_22 = $this.gez(tmp_19, tmp_20, VOID, tmp_21, SDFShaders$opSubtract$delegate$lambda);
    var tmp_23 = KProperty1;
    tmp_18.rgd_1 = tmp_22.mew($this, getPropertyCallableRef('opSubtract', 1, tmp_23, SDFShaders$_get_opSubtract_$ref_p8l300(), null));
    var tmp_24 = $this;
    var tmp_25 = $this.xez();
    var tmp_26 = $this.xez();
    var tmp_27 = $this.xez();
    var tmp_28 = $this.gez(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opRound$delegate$lambda);
    var tmp_29 = KProperty1;
    tmp_24.sgd_1 = tmp_28.mew($this, getPropertyCallableRef('opRound', 1, tmp_29, SDFShaders$_get_opRound_$ref_9t8c14(), null));
    var tmp_30 = $this;
    var tmp_31 = $this.xez();
    var tmp_32 = $this.xez();
    var tmp_33 = $this.xez();
    var tmp_34 = $this.gez(tmp_31, tmp_32, VOID, tmp_33, SDFShaders$opBorder$delegate$lambda);
    var tmp_35 = KProperty1;
    tmp_30.tgd_1 = tmp_34.mew($this, getPropertyCallableRef('opBorder', 1, tmp_35, SDFShaders$_get_opBorder_$ref_iiclig(), null));
    var tmp_36 = $this;
    var tmp_37 = $this.xez();
    var tmp_38 = $this.xez();
    var tmp_39 = $this.xez();
    var tmp_40 = $this.gez(tmp_37, tmp_38, VOID, tmp_39, SDFShaders$opBorderInner$delegate$lambda);
    var tmp_41 = KProperty1;
    tmp_36.ugd_1 = tmp_40.mew($this, getPropertyCallableRef('opBorderInner', 1, tmp_41, SDFShaders$_get_opBorderInner_$ref_ygse5o(), null));
    var tmp_42 = $this;
    var tmp_43 = $this.xez();
    var tmp_44 = $this.xez();
    var tmp_45 = $this.eez(tmp_43, VOID, tmp_44, SDFShaders$opAA$delegate$lambda);
    var tmp_46 = KProperty1;
    tmp_42.vgd_1 = tmp_45.mew($this, getPropertyCallableRef('opAA', 1, tmp_46, SDFShaders$_get_opAA_$ref_mqoapw(), null));
    var tmp_47 = $this;
    var tmp_48 = $this.xez();
    var tmp_49 = $this.xez();
    var tmp_50 = $this.eez(tmp_48, VOID, tmp_49, SDFShaders$opAARev$delegate$lambda);
    var tmp_51 = KProperty1;
    tmp_47.wgd_1 = tmp_50.mew($this, getPropertyCallableRef('opAARev', 1, tmp_51, SDFShaders$_get_opAARev_$ref_nlalub(), null));
    var tmp_52 = $this;
    var tmp_53 = $this.xez();
    var tmp_54 = $this.xez();
    var tmp_55 = $this.xez();
    var tmp_56 = $this.xez();
    var tmp_57 = $this.iez(tmp_53, tmp_54, tmp_55, VOID, tmp_56, SDFShaders$opSmoothUnion$delegate$lambda);
    var tmp_58 = KProperty1;
    tmp_52.xgd_1 = tmp_57.mew($this, getPropertyCallableRef('opSmoothUnion', 1, tmp_58, SDFShaders$_get_opSmoothUnion_$ref_wprp3p(), null));
    var tmp_59 = $this;
    var tmp_60 = $this.xez();
    var tmp_61 = $this.xez();
    var tmp_62 = $this.xez();
    var tmp_63 = $this.xez();
    var tmp_64 = $this.iez(tmp_60, tmp_61, tmp_62, VOID, tmp_63, SDFShaders$opSmoothSubtraction$delegate$lambda);
    var tmp_65 = KProperty1;
    tmp_59.ygd_1 = tmp_64.mew($this, getPropertyCallableRef('opSmoothSubtraction', 1, tmp_65, SDFShaders$_get_opSmoothSubtraction_$ref_tx1hqo(), null));
    var tmp_66 = $this;
    var tmp_67 = $this.xez();
    var tmp_68 = $this.xez();
    var tmp_69 = $this.xez();
    var tmp_70 = $this.xez();
    var tmp_71 = $this.iez(tmp_67, tmp_68, tmp_69, VOID, tmp_70, SDFShaders$opSmoothIntersection$delegate$lambda);
    var tmp_72 = KProperty1;
    tmp_66.zgd_1 = tmp_71.mew($this, getPropertyCallableRef('opSmoothIntersection', 1, tmp_72, SDFShaders$_get_opSmoothIntersection_$ref_g7mgmr(), null));
    var tmp_73 = $this;
    var tmp_74 = $this.tfl();
    var tmp_75 = $this.xez();
    var tmp_76 = $this.xez();
    var tmp_77 = $this.gez(tmp_74, tmp_75, VOID, tmp_76, SDFShaders$circle$delegate$lambda);
    var tmp_78 = KProperty1;
    tmp_73.age_1 = tmp_77.mew($this, getPropertyCallableRef('circle', 1, tmp_78, SDFShaders$_get_circle_$ref_82iglx(), null));
    var tmp_79 = $this;
    var tmp_80 = $this.tfl();
    var tmp_81 = $this.tfl();
    var tmp_82 = $this.ufl();
    var tmp_83 = $this.xez();
    var tmp_84 = $this.iez(tmp_80, tmp_81, tmp_82, VOID, tmp_83, SDFShaders$roundedBox$delegate$lambda);
    var tmp_85 = KProperty1;
    tmp_79.bge_1 = tmp_84.mew($this, getPropertyCallableRef('roundedBox', 1, tmp_85, SDFShaders$_get_roundedBox_$ref_o204ah(), null));
    var tmp_86 = $this;
    var tmp_87 = $this.tfl();
    var tmp_88 = $this.tfl();
    var tmp_89 = $this.xez();
    var tmp_90 = $this.gez(tmp_87, tmp_88, VOID, tmp_89, SDFShaders$box$delegate$lambda);
    var tmp_91 = KProperty1;
    tmp_86.cge_1 = tmp_90.mew($this, getPropertyCallableRef('box', 1, tmp_91, SDFShaders$_get_box_$ref_yzz852(), null));
    var tmp_92 = $this;
    var tmp_93 = $this.ufl();
    var tmp_94 = $this.ufl();
    var tmp_95 = $this.ufl();
    var tmp_96 = $this.gez(tmp_93, tmp_94, VOID, tmp_95, SDFShaders$opCombinePremultipliedColors$delegate$lambda);
    var tmp_97 = KProperty1;
    tmp_92.dge_1 = tmp_96.mew($this, getPropertyCallableRef('opCombinePremultipliedColors', 1, tmp_97, SDFShaders$_get_opCombinePremultipliedColors_$ref_995q2r(), null));
    return $this;
  }
  ege() {
    var tmp = KProperty1;
    return this.ogd_1.yq(this, getPropertyCallableRef('opInterpolate', 1, tmp, SDFShaders$_get_opInterpolate_$ref_4qhkt1(), null));
  }
  fge() {
    var tmp = KProperty1;
    return this.pgd_1.yq(this, getPropertyCallableRef('opUnion', 1, tmp, SDFShaders$_get_opUnion_$ref_cdui7t(), null));
  }
  gge() {
    var tmp = KProperty1;
    return this.qgd_1.yq(this, getPropertyCallableRef('opIntersect', 1, tmp, SDFShaders$_get_opIntersect_$ref_u559qh(), null));
  }
  hge() {
    var tmp = KProperty1;
    return this.rgd_1.yq(this, getPropertyCallableRef('opSubtract', 1, tmp, SDFShaders$_get_opSubtract_$ref_p8l300(), null));
  }
  ige() {
    var tmp = KProperty1;
    return this.sgd_1.yq(this, getPropertyCallableRef('opRound', 1, tmp, SDFShaders$_get_opRound_$ref_9t8c14(), null));
  }
  jge() {
    var tmp = KProperty1;
    return this.tgd_1.yq(this, getPropertyCallableRef('opBorder', 1, tmp, SDFShaders$_get_opBorder_$ref_iiclig(), null));
  }
  kge() {
    var tmp = KProperty1;
    return this.ugd_1.yq(this, getPropertyCallableRef('opBorderInner', 1, tmp, SDFShaders$_get_opBorderInner_$ref_ygse5o(), null));
  }
  lge() {
    var tmp = KProperty1;
    return this.vgd_1.yq(this, getPropertyCallableRef('opAA', 1, tmp, SDFShaders$_get_opAA_$ref_mqoapw(), null));
  }
  mge() {
    var tmp = KProperty1;
    return this.wgd_1.yq(this, getPropertyCallableRef('opAARev', 1, tmp, SDFShaders$_get_opAARev_$ref_nlalub(), null));
  }
  nge() {
    var tmp = KProperty1;
    return this.xgd_1.yq(this, getPropertyCallableRef('opSmoothUnion', 1, tmp, SDFShaders$_get_opSmoothUnion_$ref_wprp3p(), null));
  }
  oge() {
    var tmp = KProperty1;
    return this.ygd_1.yq(this, getPropertyCallableRef('opSmoothSubtraction', 1, tmp, SDFShaders$_get_opSmoothSubtraction_$ref_tx1hqo(), null));
  }
  pge() {
    var tmp = KProperty1;
    return this.zgd_1.yq(this, getPropertyCallableRef('opSmoothIntersection', 1, tmp, SDFShaders$_get_opSmoothIntersection_$ref_g7mgmr(), null));
  }
  qge() {
    var tmp = KProperty1;
    return this.age_1.yq(this, getPropertyCallableRef('circle', 1, tmp, SDFShaders$_get_circle_$ref_82iglx(), null));
  }
  rge() {
    var tmp = KProperty1;
    return this.bge_1.yq(this, getPropertyCallableRef('roundedBox', 1, tmp, SDFShaders$_get_roundedBox_$ref_o204ah(), null));
  }
  sge() {
    var tmp = KProperty1;
    return this.cge_1.yq(this, getPropertyCallableRef('box', 1, tmp, SDFShaders$_get_box_$ref_yzz852(), null));
  }
  tge() {
    var tmp = KProperty1;
    return this.dge_1.yq(this, getPropertyCallableRef('opCombinePremultipliedColors', 1, tmp, SDFShaders$_get_opCombinePremultipliedColors_$ref_995q2r(), null));
  }
}
class TextureBase {
  constructor(base, size) {
    return new.target.vge(base, size);
  }
  static vge(base, size) {
    var $this = createThis(this);
    $this.tg6_1 = base;
    $this.ug6_1 = size;
    $this.vg6_1 = -1;
    return $this;
  }
  s2() {
    return this.ug6_1;
  }
  static wg6(base, width, height) {
    return this.vge(base, SizeInt.q9s(width, height));
  }
  xg6(width) {
    this.ug6_1 = SizeInt.q9s(width, this.x9z());
  }
  w9z() {
    return this.ug6_1.o9s_1;
  }
  yg6(height) {
    this.ug6_1 = SizeInt.q9s(this.w9z(), height);
  }
  x9z() {
    return this.ug6_1.p9s_1;
  }
  f7() {
    var tmp0_safe_receiver = this.tg6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f7();
    }
    this.tg6_1 = null;
  }
  rg7(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.tg6_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.zel(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.tg6_1) + ')';
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.wge_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_74();
    icount = icount === VOID ? indices.length : icount;
    this.rg9_1 = indices;
    this.sg9_1 = vcount;
    this.tg9_1 = vcount;
    this.ug9_1 = icount;
    this.vg9_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.sg9_1), 4));
    this.wg9_1 = this.vg9_1;
    this.xg9_1 = 0;
  }
  xge(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  yge(index, x, y, width, height, matrix, bmp, colMul) {
    this.zge(index, x, y, width, height, matrix, bmp.bal(), bmp.cal(), bmp.dal(), bmp.eal(), bmp.hal(), bmp.ial(), bmp.fal(), bmp.gal(), colMul);
  }
  zge(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.a9l_1;
    var cf = matrix.c9l_1;
    var txf = matrix.e9l_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.d9l_1;
    var bf = matrix.b9l_1;
    var tyf = matrix.f9l_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.wg9_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.xge(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.xge(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.xge(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.xge(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ResourcesRoot {
  cgf(path, file) {
    _get_mountable__707cy(this).zbr(path, file);
  }
  be5(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    this.bgf_1 = this_0;
    tmp.agf_1 = this_0.wbg();
    this.cgf('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class RCollection {
  constructor() {
    this.dgf_1 = ArrayList.p2();
    this.egf_1 = LinkedHashMap.m7();
  }
}
class Stats {
  constructor() {
    this.fgf_1 = new RCollection();
    this.ggf_1 = new RCollection();
  }
  ceh() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.fgf_1.dgf_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.u2(_unary__edvuaz).ceh();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.ggf_1.dgf_1;
    var n_0 = 0;
    while (n_0 < this_1.s2()) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.u2(_unary__edvuaz_0).ceh();
    }
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.c9w() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.d9w() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.ogf_1 = key;
    this.pgf_1 = initial;
    this.qgf_1 = end;
    this.rgf_1 = interpolator;
    this.sgf_1 = includeStart;
    this.tgf_1 = fastStartTime;
    this.ugf_1 = fastDuration;
    this.vgf_1 = initialization;
    this.wgf_1 = FastDuration__plus_impl_q1enab(this.tgf_1, equals(this.ugf_1, Companion_instance_3.d9w()) ? get_fastNanoseconds_0(0) : this.ugf_1);
  }
  xgf() {
    return toDuration_1(this.tgf_1);
  }
  ygf() {
    return toDuration_1(this.ugf_1);
  }
  tby() {
    if (!this.sgf_1) {
      this.pgf_1 = this.ogf_1.get();
    }
    var tmp0_safe_receiver = this.vgf_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  zgf(ratio) {
    this.ogf_1.set(this.rgf_1(new Ratio(ratio), this.pgf_1, this.qgf_1));
  }
  toString() {
    return 'V2(key=' + this.ogf_1.callableName + ', range=[' + toString_1(this.pgf_1) + '-' + toString_1(this.qgf_1) + '], startTime=' + Duration__toString_impl_8d916b(this.xgf()) + ', duration=' + Duration__toString_impl_8d916b(this.ygf()) + ')';
  }
  hashCode() {
    var result = hashCode(this.ogf_1);
    result = imul(result, 31) + (this.pgf_1 == null ? 0 : hashCode(this.pgf_1)) | 0;
    result = imul(result, 31) + (this.qgf_1 == null ? 0 : hashCode(this.qgf_1)) | 0;
    result = imul(result, 31) + hashCode(this.rgf_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sgf_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.tgf_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.ugf_1) | 0;
    result = imul(result, 31) + (this.vgf_1 == null ? 0 : hashCode(this.vgf_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.ogf_1, tmp0_other_with_cast.ogf_1))
      return false;
    if (!equals(this.pgf_1, tmp0_other_with_cast.pgf_1))
      return false;
    if (!equals(this.qgf_1, tmp0_other_with_cast.qgf_1))
      return false;
    if (!equals(this.rgf_1, tmp0_other_with_cast.rgf_1))
      return false;
    if (!(this.sgf_1 === tmp0_other_with_cast.sgf_1))
      return false;
    if (!equals(this.tgf_1, tmp0_other_with_cast.tgf_1))
      return false;
    if (!equals(this.ugf_1, tmp0_other_with_cast.ugf_1))
      return false;
    if (!equals(this.vgf_1, tmp0_other_with_cast.vgf_1))
      return false;
    return true;
  }
}
class V2CallbackSupport {
  constructor() {
    V2CallbackSupport_instance = this;
    this.agg_1 = Unit_instance;
  }
}
class DEFAULT {}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.bgg_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.cgg_1 = text;
    this.dgg_1 = enabled;
    this.egg_1 = children;
    this.fgg_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.cgg_1 + ', enabled=' + this.dgg_1 + ', children=' + toString_1(this.egg_1) + ', action=' + toString(this.fgg_1) + ')';
  }
  hashCode() {
    var result = this.cgg_1 == null ? 0 : getStringHashCode(this.cgg_1);
    result = imul(result, 31) + getBooleanHashCode(this.dgg_1) | 0;
    result = imul(result, 31) + (this.egg_1 == null ? 0 : hashCode(this.egg_1)) | 0;
    result = imul(result, 31) + hashCode(this.fgg_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.cgg_1 == tmp0_other_with_cast.cgg_1))
      return false;
    if (!(this.dgg_1 === tmp0_other_with_cast.dgg_1))
      return false;
    if (!equals(this.egg_1, tmp0_other_with_cast.egg_1))
      return false;
    if (!equals(this.fgg_1, tmp0_other_with_cast.fgg_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.ggg_1 = 60;
    this.hgg_1 = Companion_getInstance_1().pb5('GameWindow');
    this.igg_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.wgi_1 = level;
    this.xgi_1 = 4000000;
  }
  w7g() {
    return this.wgi_1;
  }
  ygi(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.w1_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp0 = listOf_0([devicePixelRatio, 2.0, 1.0]);
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$0 = element;
              break $l$block;
            }
          }
          tmp$ret$0 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$0;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  zgi(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.xgi_1 : targetPixels;
    return $super === VOID ? this.ygi(width, height, devicePixelRatio, targetPixels) : $super.ygi.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$continuousRenderMode$$inlined$observable$1 extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.cgj_1 = this$0;
    super($initialValue, $box);
  }
  dgj(property, oldValue, newValue) {
    var tmp0_safe_receiver = this.cgj_1.agi_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  }
  er(property, oldValue, newValue) {
    return this.dgj(property, oldValue, newValue);
  }
}
class GameWindow extends BaseEventListener {
  constructor() {
    return new.target.ggj();
  }
  static ggj() {
    CoroutineKey_getInstance();
    var $this = this.je7();
    $this.ngg_1 = new Mixin();
    $this.ogg_1 = Cursor_DEFAULT_getInstance();
    $this.pgg_1 = false;
    $this.qgg_1 = AGDummy.hfb();
    $this.rgg_1 = SyncEventLoopCoroutineDispatcher.jgj();
    $this.sgg_1 = GameWindowCoroutineDispatcher.ugj();
    $this.tgg_1 = new PauseEvent();
    $this.ugg_1 = new ResumeEvent();
    $this.vgg_1 = new StopEvent();
    $this.wgg_1 = new DestroyEvent();
    $this.xgg_1 = new UpdateEvent();
    $this.ygg_1 = new RenderEvent();
    $this.zgg_1 = new InitEvent();
    $this.agh_1 = new DisposeEvent();
    $this.bgh_1 = new FullScreenEvent();
    $this.cgh_1 = new ReshapeEvent();
    $this.dgh_1 = new KeyEvent();
    $this.egh_1 = new MouseEvent();
    $this.fgh_1 = new GestureEvent();
    $this.ggh_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.hgh_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.igh_1 = 60;
    $this.jgh_1 = 0;
    $this.kgh_1 = 0;
    $this.lgh_1 = true;
    $this.mgh_1 = null;
    $this.ngh_1 = false;
    $this.ogh_1 = false;
    $this.pgh_1 = Colors_getInstance().ac3_1;
    $this.qgh_1 = new Signal();
    $this.rgh_1 = new Signal();
    $this.sgh_1 = null;
    $this.tgh_1 = false;
    $this.ugh_1 = true;
    $this.vgh_1 = 0;
    $this.wgh_1 = true;
    $this.xgh_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.ygh_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.zgh_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.agi_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.bgi_1 = new GameWindow$continuousRenderMode$$inlined$observable$1(true, $this);
    $this.cgi_1 = false;
    $this.dgi_1 = -1;
    $this.egi_1 = -1;
    $this.fgi_1 = -1;
    $this.ggi_1 = -1;
    $this.hgi_1 = false;
    $this.igi_1 = false;
    $this.jgi_1 = false;
    $this.kgi_1 = 0;
    $this.lgi_1 = Companion_instance_3.c9w();
    $this.mgi_1 = new Lock();
    $this.ngi_1 = booleanArray(Companion_getInstance_35().qee_1);
    $this.ogi_1 = 0;
    $this.pgi_1 = 0.0;
    $this.qgi_1 = 0.0;
    $this.rgi_1 = 0.0;
    $this.sgi_1 = false;
    $this.tgi_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  vgj(windowRect) {
  }
  wgj(force, config) {
  }
  xgj(force, config, $super) {
    force = force === VOID ? true : force;
    config = config === VOID ? null : config;
    var tmp;
    if ($super === VOID) {
      this.wgj(force, config);
      tmp = Unit_instance;
    } else {
      tmp = $super.wgj.call(this, force, config);
    }
    return tmp;
  }
  ygj() {
  }
  zgj(_set____db54di) {
    this.ogg_1 = _set____db54di;
  }
  agk() {
    return this.ogg_1;
  }
  j3() {
    return CoroutineKey_getInstance();
  }
  bgk() {
    return this.qgg_1;
  }
  cgk() {
    return this.sgg_1;
  }
  dgk(coroutineContext) {
    return coroutineContext.ep(this.cgk());
  }
  *egk($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.od();
    return this.dgk(tmp$ret$0);
  }
  fgk(block) {
    return this.le7(Companion_getInstance_27(), block);
  }
  ggk() {
    return get_fastMicroseconds(1000000.0 / this.hgk());
  }
  igk() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.hgk();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  agj() {
    return 60;
  }
  jgk(name, time) {
  }
  hgk() {
    return _get_fpsCached__581dty(this);
  }
  kgk(value) {
    return Unit_instance;
  }
  w9z() {
    return this.jgh_1;
  }
  x9z() {
    return this.kgh_1;
  }
  lgk(_set____db54di) {
    this.mgh_1 = _set____db54di;
  }
  mgk(_set____db54di) {
    this.ngh_1 = _set____db54di;
  }
  ngk(_set____db54di) {
    this.ogh_1 = _set____db54di;
  }
  ogk(_set____db54di) {
    this.pgh_1 = _set____db54di;
  }
  pgk() {
    return this.pgh_1;
  }
  qgk(value) {
    return Unit_instance;
  }
  fgc() {
    return Quality_AUTOMATIC_getInstance();
  }
  rgk(value) {
    this.tgh_1 = value;
    this.rgh_1.x9y(value);
    if (value) {
      invoke(this.qgh_1);
    }
  }
  sgk() {
    return this.tgh_1;
  }
  tgk(width, height) {
    return Unit_instance;
  }
  ugk(exitCode) {
    return this.y1v(exitCode);
  }
  vgk(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.ugk(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.ugk.call(this, exitCode);
    }
    return tmp;
  }
  y1v(exitCode) {
    if (this.xgh_1)
      return Unit_instance;
    this.xgh_1 = true;
    this.wgh_1 = false;
    this.vgh_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0 = CoroutineKey_getInstance().hgg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_INFO_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'GameWindow.close';
      tmp0.pbj(level, tmp$ret$2);
    }
    this.cgk().f7();
    cancelChildren(this.cgk());
  }
  wgk(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.y1v(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.y1v.call(this, exitCode);
    }
    return tmp;
  }
  *xgk($completion) {
    while (this.wgh_1) {
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
      yield* delay_0(tmp$ret$0, $completion);
    }
    return Unit_instance;
  }
  *ygk(entry, $completion) {
    var tmp = (yield* this.egk($completion)).ep(CoroutineName.b1u('GameWindow.loop'));
    launchImmediately(tmp, GameWindow$loop$slambda(entry, this));
    while (this.wgh_1) {
      var elapsed;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.time.measureTime' call
      var mark = Monotonic_instance.ck();
      elapsed = this.zgk();
      var realElapsed = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
      var available = FastDuration__minus_impl_evs237(this.ggk(), elapsed);
      if (FastDuration__compareTo_impl_4fhnj7(available, Companion_instance_3.c9w()) > 0) {
        yield* this.agl(available, $completion);
      }
    }
    return Unit_instance;
  }
  *agl(time, $completion) {
    yield* delay(time, $completion);
    return Unit_instance;
  }
  fgj(_set____db54di) {
    var tmp = KMutableProperty1;
    var tmp_0 = GameWindow$_get_continuousRenderMode_$ref_vajq30();
    return this.bgi_1.br(this, getPropertyCallableRef('continuousRenderMode', 1, tmp, tmp_0, GameWindow$_set_continuousRenderMode_$ref_z8748w()), _set____db54di);
  }
  egj() {
    var tmp = KMutableProperty1;
    var tmp_0 = GameWindow$_get_continuousRenderMode_$ref_vajq30();
    return this.bgi_1.zq(this, getPropertyCallableRef('continuousRenderMode', 1, tmp, tmp_0, GameWindow$_set_continuousRenderMode_$ref_z8748w()));
  }
  bgl(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().le5();
    if (doRender) {
      var tmp = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.time.measureTime' call
      var mark = Monotonic_instance.ck();
      this.cgl(doUpdate, true);
      tmp.ygh_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.time.measureTime' call
      var mark_0 = Monotonic_instance.ck();
      if (!doRender) {
        this.cgl(true, false);
      }
      this.dgl(frameStartTime);
      tmp_0.zgh_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().me5();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  zgk(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().me5() : frameStartTime;
    return $super === VOID ? this.bgl(doUpdate, doRender, frameStartTime) : $super.bgl.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).f9w_1;
  }
  cgl(doUpdate, doRender) {
    if (doRender) {
      if (this.jgi_1) {
        this.jgi_1 = false;
        this.bgk().aeh();
      }
      if (this.cgi_1) {
        this.cgi_1 = false;
        this.bgk().zeg().lek(this.dgi_1, this.egi_1, this.fgi_1, this.ggi_1);
        this.egl(this.dgi_1, this.egi_1, this.fgi_1, this.ggi_1);
      }
    }
    if (this.hgi_1) {
      this.hgi_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.w9z() + ', ' + this.x9z() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.zgg_1;
      this_0.ee8_1 = false;
      this.we7(this_0);
    }
    try {
      this.fgl(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  ceh() {
    this.kgi_1 = 0;
  }
  ggl() {
    this.kgi_1 = this.kgi_1 + 1 | 0;
  }
  dgl(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    this.hgl();
    tmp.lgi_1 = stopwatch.re5();
    try {
      var now = PerformanceCounter_getInstance().le5();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.cgk().sgj_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.igk(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.cgk().igl(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  hgl() {
  }
  fgl(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0 = this.mgi_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0.n9w();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_0 = this.ygg_1;
        this_0.ee8_1 = false;
        this_0.pec_1 = update;
        this_0.qec_1 = render;
        this.we7(this_0);
        break $l$block;
      }finally {
        tmp0.p9w();
      }
    }
  }
  jgl(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.ggh_1;
    this_0.ee8_1 = false;
    this_0.kec_1 = type;
    this_0.lec_1 = files;
    return this.we7(this_0);
  }
  egl(x, y, width, height) {
    this.kgl(x, y, width, height, width, height);
  }
  kgl(x, y, width, height, fullWidth, fullHeight) {
    this.bgk().zeg().mek(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.cgh_1;
    this_0.ee8_1 = false;
    this_0.cec_1 = x;
    this_0.dec_1 = y;
    this_0.eec_1 = width;
    this_0.fec_1 = height;
    this.we7(this_0);
  }
  nee() {
    this.tgi_1.nee();
  }
  oee(info) {
    this.tgi_1.oee(info);
  }
  pee(out) {
    return this.tgi_1.pee(out);
  }
  lgl(out, $super) {
    out = out === VOID ? IntArrayList.za1() : out;
    return $super === VOID ? this.pee(out) : $super.pee.call(this, out);
  }
  *mgl(data, $completion) {
    return Unit_instance;
  }
  *ngl($completion) {
    return null;
  }
  o9u(_set____db54di) {
    this.ngg_1.o9u(_set____db54di);
  }
  p9u() {
    return this.ngg_1.p9u();
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_69 = this;
    this.ogl_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    Companion_getInstance_76();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    title = title === VOID ? '' : title;
    this.pgl_1 = multithreaded;
    this.qgl_1 = hdr;
    this.rgl_1 = msaa;
    this.sgl_1 = checkGl;
    this.tgl_1 = logGl;
    this.ugl_1 = cacheGl;
    this.vgl_1 = fullscreen;
    this.wgl_1 = decorated;
    this.xgl_1 = transparent;
    this.ygl_1 = resizable;
    this.zgl_1 = title;
  }
  agm(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    return new GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  bgm(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title, $super) {
    multithreaded = multithreaded === VOID ? this.pgl_1 : multithreaded;
    hdr = hdr === VOID ? this.qgl_1 : hdr;
    msaa = msaa === VOID ? this.rgl_1 : msaa;
    checkGl = checkGl === VOID ? this.sgl_1 : checkGl;
    logGl = logGl === VOID ? this.tgl_1 : logGl;
    cacheGl = cacheGl === VOID ? this.ugl_1 : cacheGl;
    fullscreen = fullscreen === VOID ? this.vgl_1 : fullscreen;
    decorated = decorated === VOID ? this.wgl_1 : decorated;
    transparent = transparent === VOID ? this.xgl_1 : transparent;
    resizable = resizable === VOID ? this.ygl_1 : resizable;
    title = title === VOID ? this.zgl_1 : title;
    return $super === VOID ? this.agm(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) : $super.agm.call(this, multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.pgl_1 + ', hdr=' + this.qgl_1 + ', msaa=' + this.rgl_1 + ', checkGl=' + this.sgl_1 + ', logGl=' + this.tgl_1 + ', cacheGl=' + this.ugl_1 + ', fullscreen=' + this.vgl_1 + ', decorated=' + this.wgl_1 + ', transparent=' + this.xgl_1 + ', resizable=' + this.ygl_1 + ', title=' + this.zgl_1 + ')';
  }
  hashCode() {
    var result = this.pgl_1 == null ? 0 : getBooleanHashCode(this.pgl_1);
    result = imul(result, 31) + (this.qgl_1 == null ? 0 : getBooleanHashCode(this.qgl_1)) | 0;
    result = imul(result, 31) + (this.rgl_1 == null ? 0 : this.rgl_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sgl_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.tgl_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ugl_1) | 0;
    result = imul(result, 31) + (this.vgl_1 == null ? 0 : getBooleanHashCode(this.vgl_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wgl_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xgl_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ygl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zgl_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.pgl_1 == tmp0_other_with_cast.pgl_1))
      return false;
    if (!(this.qgl_1 == tmp0_other_with_cast.qgl_1))
      return false;
    if (!(this.rgl_1 == tmp0_other_with_cast.rgl_1))
      return false;
    if (!(this.sgl_1 === tmp0_other_with_cast.sgl_1))
      return false;
    if (!(this.tgl_1 === tmp0_other_with_cast.tgl_1))
      return false;
    if (!(this.ugl_1 === tmp0_other_with_cast.ugl_1))
      return false;
    if (!(this.vgl_1 == tmp0_other_with_cast.vgl_1))
      return false;
    if (!(this.wgl_1 === tmp0_other_with_cast.wgl_1))
      return false;
    if (!(this.xgl_1 === tmp0_other_with_cast.xgl_1))
      return false;
    if (!(this.ygl_1 === tmp0_other_with_cast.ygl_1))
      return false;
    if (!(this.zgl_1 === tmp0_other_with_cast.zgl_1))
      return false;
    return true;
  }
}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.cgm_1 = quality;
  }
  fgc() {
    return this.cgm_1;
  }
}
class TextClipboardData {
  constructor(text, contentType) {
    contentType = contentType === VOID ? null : contentType;
    this.dgm_1 = text;
    this.egm_1 = contentType;
  }
  toString() {
    return 'TextClipboardData(text=' + this.dgm_1 + ', contentType=' + this.egm_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.dgm_1);
    result = imul(result, 31) + (this.egm_1 == null ? 0 : getStringHashCode(this.egm_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextClipboardData))
      return false;
    var tmp0_other_with_cast = other instanceof TextClipboardData ? other : THROW_CCE();
    if (!(this.dgm_1 === tmp0_other_with_cast.dgm_1))
      return false;
    if (!(this.egm_1 == tmp0_other_with_cast.egm_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.fgm_1 = time;
    this.ggm_1 = continuation;
    this.hgm_1 = callback;
    this.igm_1 = null;
  }
}
class Companion_61 {
  constructor() {
    Companion_instance_70 = this;
    this.jgm_1 = Companion_getInstance_1().pb5('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.kgm_1 = function_0;
  }
  u1o() {
    return this.kgm_1();
  }
  p5() {
    return this.kgm_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  constructor(nowProvider, fast) {
    return new.target.ugj(nowProvider, fast);
  }
  static ugj(nowProvider, fast) {
    Companion_getInstance_77();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.q1t();
    $this.lgj_1 = nowProvider;
    $this.mgj_1 = fast;
    $this.ngj_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.ogj_1 = tmp_1.da9(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.pgj_1 = new NonRecursiveLock();
    $this.qgj_1 = get_fastMilliseconds_0(0);
    $this.rgj_1 = get_fastMilliseconds_0(0);
    $this.sgj_1 = null;
    $this.tgj_1 = Companion_getInstance_1().pb5('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  t1t(context, block) {
    return this.s1t(context, block);
  }
  lgm(block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.pgj_1.i9w_1;
    this.ngj_1.na9(block);
  }
  s1t(context, block) {
    return this.lgm(block);
  }
  mgm() {
    return this.lgj_1().f9w_1;
  }
  i1u(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = toNumber(timeMillis);
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.ngm(tmp$ret$0, continuation);
  }
  ngm(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.mgm(), time), continuation, null);
    continuation.y1q(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.pgj_1.i9w_1;
    this.ogj_1.pa4(task);
  }
  j1u(timeMillis, block, context) {
    var tmp = this.mgm();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = toNumber(timeMillis);
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.pgj_1.i9w_1;
    this.ogj_1.pa4(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  igl(availableTime) {
    this.ogm(get_fast(availableTime));
  }
  ogm(availableTime) {
    try {
      var startTime = this.mgm();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.pgj_1.i9w_1;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.ogj_1.n1()) {
          tmp_1 = this.mgj_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.ogj_1.ja9().fgm_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.ogj_1.ka9();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.igm_1 == null)) {
            var tmp1_safe_receiver = item.ggm_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.igm_1);
              var tmp$ret$8 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.qd(tmp$ret$8);
            }
            if (!(item.hgm_1 == null)) {
              var tmp2_safe_receiver = item.igm_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.ggm_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.qd(tmp$ret$10);
            }
            var tmp4_safe_receiver = item.hgm_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.c1t();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.mgm(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.pgm(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.qgj_1 = stopwatch.re5();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.pgj_1.i9w_1;
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.ngj_1.n1()) {
          tmp_4 = this.ngj_1.oa9();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        try {
          task.c1t();
        } catch ($p_0) {
          if ($p_0 instanceof Error) {
            var e_0 = $p_0;
            printStackTrace(e_0);
          } else {
            throw $p_0;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.re5();
        var elapsed = FastDuration__minus_impl_evs237(this.mgm(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.pgm(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.rgj_1 = stopwatch_0.re5();
    } catch ($p_1) {
      if ($p_1 instanceof Error) {
        var e_1 = $p_1;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p_1;
      }
    }
  }
  pgm(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var tmp0 = this.tgj_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_WARN_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.ogj_1.ga9_1 + ', tasks=' + this.ngj_1.s2() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      tmp0.pbj(level, tmp$ret$2);
    }
  }
  f7() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$0 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.igl(tmp$ret$0);
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0 = Companion_getInstance_77().jgm_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_INFO_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$4 = 'GameWindowCoroutineDispatcher.close';
      tmp0.pbj(level, tmp$ret$4);
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.ogj_1.n1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.ogj_1.ka9().ggm_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.qd(tmp$ret$7);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.ngj_1.n1()) {
        break $l$loop_0;
      }
      this.ngj_1.oa9().c1t();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.mgj_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  constructor(eventLoop) {
    return new.target.qgm(eventLoop);
  }
  static qgm(eventLoop) {
    var $this = this.q1t();
    $this.igj_1 = eventLoop;
    return $this;
  }
  static jgj(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.qgm(new SyncEventLoop(immediateRun));
  }
  f7() {
    this.igj_1.f7();
  }
  s1t(context, block) {
    this.igj_1.re6(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  i1u(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.y1q(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.igj_1.se6(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  j1u(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.igj_1.se6(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_62 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.c9w() : fastDeltaTime;
    super();
    this.tgm_1 = fastDeltaTime;
  }
  ugm() {
    return toDuration_1(this.tgm_1);
  }
  d8o() {
    return Companion_instance_71;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.tgm_1) + ')';
  }
}
class Companion_63 {
  constructor() {
    this.vgm_1 = 536805376;
    this.wgm_1 = 805240832;
    this.xgm_1 = 2;
    this.ygm_1 = 32;
    this.zgm_1 = 256;
    this.agn_1 = 512;
    this.bgn_1 = 768;
    this.cgn_1 = 769;
    this.dgn_1 = 1024;
    this.egn_1 = 1025;
    this.fgn_1 = 1026;
    this.ggn_1 = 1027;
  }
}
class SDL extends FFILib {
  constructor() {
    return new.target.mgo();
  }
  static mgo() {
    var $this = this.mbm([get_SDLPath()]);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_14().sbm_1;
    var tmp_0 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config, true);
    var tmp_1 = KProperty1;
    tmp.mgn_1 = tmp_0.fbm($this, getPropertyCallableRef('SDL_Init', 1, tmp_1, SDL$_get_SDL_Init_$ref_fdpb0v(), null));
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_14().sbm_1;
    var tmp_3 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_0, true);
    var tmp_4 = KProperty1;
    tmp_2.ngn_1 = tmp_3.fbm($this, getPropertyCallableRef('SDL_CreateWindow', 1, tmp_4, SDL$_get_SDL_CreateWindow_$ref_e58syb(), null));
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_14().sbm_1;
    var tmp_6 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true);
    var tmp_7 = KProperty1;
    tmp_5.ogn_1 = tmp_6.fbm($this, getPropertyCallableRef('SDL_SetWindowTitle', 1, tmp_7, SDL$_get_SDL_SetWindowTitle_$ref_icmwbr(), null));
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_14().sbm_1;
    var tmp_9 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true);
    var tmp_10 = KProperty1;
    tmp_8.pgn_1 = tmp_9.fbm($this, getPropertyCallableRef('SDL_SetWindowSize', 1, tmp_10, SDL$_get_SDL_SetWindowSize_$ref_ckt22g(), null));
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_14().sbm_1;
    var tmp_12 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true);
    var tmp_13 = KProperty1;
    tmp_11.qgn_1 = tmp_12.fbm($this, getPropertyCallableRef('SDL_SetWindowPosition', 1, tmp_13, SDL$_get_SDL_SetWindowPosition_$ref_2c0hsw(), null));
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_14().sbm_1;
    var tmp_15 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true);
    var tmp_16 = KProperty1;
    tmp_14.rgn_1 = tmp_15.fbm($this, getPropertyCallableRef('SDL_ShowWindow', 1, tmp_16, SDL$_get_SDL_ShowWindow_$ref_83ud82(), null));
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_14().sbm_1;
    var tmp_18 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true);
    var tmp_19 = KProperty1;
    tmp_17.sgn_1 = tmp_18.fbm($this, getPropertyCallableRef('SDL_RaiseWindow', 1, tmp_19, SDL$_get_SDL_RaiseWindow_$ref_ttmwsf(), null));
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_14().sbm_1;
    var tmp_21 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_6, true);
    var tmp_22 = KProperty1;
    tmp_20.tgn_1 = tmp_21.fbm($this, getPropertyCallableRef('SDL_PollEvent', 1, tmp_22, SDL$_get_SDL_PollEvent_$ref_uu6x8g(), null));
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_14().sbm_1;
    var tmp_24 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true);
    var tmp_25 = KProperty1;
    tmp_23.ugn_1 = tmp_24.fbm($this, getPropertyCallableRef('SDL_Quit', 1, tmp_25, SDL$_get_SDL_Quit_$ref_lztjv4(), null));
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_14().sbm_1;
    var tmp_27 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_8, true);
    var tmp_28 = KProperty1;
    tmp_26.vgn_1 = tmp_27.fbm($this, getPropertyCallableRef('SDL_GL_CreateContext', 1, tmp_28, SDL$_get_SDL_GL_CreateContext_$ref_c6mh1i(), null));
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_14().sbm_1;
    var tmp_30 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true);
    var tmp_31 = KProperty1;
    tmp_29.wgn_1 = tmp_30.fbm($this, getPropertyCallableRef('SDL_GL_DeleteContext', 1, tmp_31, SDL$_get_SDL_GL_DeleteContext_$ref_thj01h(), null));
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_14().sbm_1;
    var tmp_33 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_10, true);
    var tmp_34 = KProperty1;
    tmp_32.xgn_1 = tmp_33.fbm($this, getPropertyCallableRef('SDL_GL_MakeCurrent', 1, tmp_34, SDL$_get_SDL_GL_MakeCurrent_$ref_ivrniq(), null));
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_14().sbm_1;
    var tmp_36 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true);
    var tmp_37 = KProperty1;
    tmp_35.ygn_1 = tmp_36.fbm($this, getPropertyCallableRef('SDL_GL_SwapWindow', 1, tmp_37, SDL$_get_SDL_GL_SwapWindow_$ref_v4dmea(), null));
    return $this;
  }
  zgn() {
    var tmp = KProperty1;
    return this.mgn_1.zq(this, getPropertyCallableRef('SDL_Init', 1, tmp, SDL$_get_SDL_Init_$ref_fdpb0v(), null));
  }
  ago() {
    var tmp = KProperty1;
    return this.ngn_1.zq(this, getPropertyCallableRef('SDL_CreateWindow', 1, tmp, SDL$_get_SDL_CreateWindow_$ref_e58syb(), null));
  }
  bgo() {
    var tmp = KProperty1;
    return this.ogn_1.zq(this, getPropertyCallableRef('SDL_SetWindowTitle', 1, tmp, SDL$_get_SDL_SetWindowTitle_$ref_icmwbr(), null));
  }
  cgo() {
    var tmp = KProperty1;
    return this.pgn_1.zq(this, getPropertyCallableRef('SDL_SetWindowSize', 1, tmp, SDL$_get_SDL_SetWindowSize_$ref_ckt22g(), null));
  }
  dgo() {
    var tmp = KProperty1;
    return this.qgn_1.zq(this, getPropertyCallableRef('SDL_SetWindowPosition', 1, tmp, SDL$_get_SDL_SetWindowPosition_$ref_2c0hsw(), null));
  }
  ego() {
    var tmp = KProperty1;
    return this.rgn_1.zq(this, getPropertyCallableRef('SDL_ShowWindow', 1, tmp, SDL$_get_SDL_ShowWindow_$ref_83ud82(), null));
  }
  fgo() {
    var tmp = KProperty1;
    return this.sgn_1.zq(this, getPropertyCallableRef('SDL_RaiseWindow', 1, tmp, SDL$_get_SDL_RaiseWindow_$ref_ttmwsf(), null));
  }
  ggo() {
    var tmp = KProperty1;
    return this.tgn_1.zq(this, getPropertyCallableRef('SDL_PollEvent', 1, tmp, SDL$_get_SDL_PollEvent_$ref_uu6x8g(), null));
  }
  hgo() {
    var tmp = KProperty1;
    return this.ugn_1.zq(this, getPropertyCallableRef('SDL_Quit', 1, tmp, SDL$_get_SDL_Quit_$ref_lztjv4(), null));
  }
  igo() {
    var tmp = KProperty1;
    return this.vgn_1.zq(this, getPropertyCallableRef('SDL_GL_CreateContext', 1, tmp, SDL$_get_SDL_GL_CreateContext_$ref_c6mh1i(), null));
  }
  jgo() {
    var tmp = KProperty1;
    return this.wgn_1.zq(this, getPropertyCallableRef('SDL_GL_DeleteContext', 1, tmp, SDL$_get_SDL_GL_DeleteContext_$ref_thj01h(), null));
  }
  kgo() {
    var tmp = KProperty1;
    return this.xgn_1.zq(this, getPropertyCallableRef('SDL_GL_MakeCurrent', 1, tmp, SDL$_get_SDL_GL_MakeCurrent_$ref_ivrniq(), null));
  }
  lgo() {
    var tmp = KProperty1;
    return this.ygn_1.zq(this, getPropertyCallableRef('SDL_GL_SwapWindow', 1, tmp, SDL$_get_SDL_GL_SwapWindow_$ref_v4dmea(), null));
  }
}
class KmlGlOpenGL extends KmlGl {
  constructor(gl) {
    gl = gl === VOID ? OpenGL.qgu() : gl;
    super();
    this.vgu_1 = gl;
  }
  wgu(_this__u8e3s4) {
    return CreateFFIPointer(fromInt(_this__u8e3s4));
  }
  xgu(_this__u8e3s4) {
    return CreateFFIPointer(_this__u8e3s4);
  }
  vf6(texture) {
    return this.vgu_1.ygu()(texture);
  }
  bfb(program, shader) {
    return this.vgu_1.zgu()(program, shader);
  }
  afb(program, index, name) {
    return this.vgu_1.agv()(program, index, name);
  }
  pf5(target, buffer) {
    return this.vgu_1.bgv()(target, buffer);
  }
  tf9(target, framebuffer) {
    return this.vgu_1.cgv()(target, framebuffer);
  }
  afa(target, renderbuffer) {
    return this.vgu_1.dgv()(target, renderbuffer);
  }
  rf9(target, texture) {
    return this.vgu_1.egv()(target, texture);
  }
  df8(modeRGB, modeAlpha) {
    return this.vgu_1.fgv()(modeRGB, modeAlpha);
  }
  ef8(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.vgu_1.ggv()(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  zf6(target, size, data, usage) {
    return this.vgu_1.hgv()(target, this.wgu(size), get_pointer_0(data), usage);
  }
  yf6(target, offset, size, data) {
    return this.vgu_1.igv()(target, this.wgu(offset), this.wgu(size), get_pointer_0(data));
  }
  zf7(mask) {
    return this.vgu_1.jgv()(mask);
  }
  uf7(red, green, blue, alpha) {
    return this.vgu_1.kgv()(red, green, blue, alpha);
  }
  wf7(d) {
    return this.vgu_1.lgv()(d);
  }
  yf7(s) {
    return this.vgu_1.mgv()(s);
  }
  hfa(red, green, blue, alpha) {
    var tmp = this.vgu_1.ngv();
    // Inline function 'korlibs.math.toInt' call
    var tmp_0 = red ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_1 = green ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_2 = blue ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    return tmp(tmp_0, tmp_1, tmp_2, alpha ? 1 : 0);
  }
  sfa(shader) {
    return this.vgu_1.ogv()(shader);
  }
  ufa() {
    return this.vgu_1.pgv()();
  }
  qfa(type) {
    return this.vgu_1.qgv()(type);
  }
  wf8(mode) {
    return this.vgu_1.rgv()(mode);
  }
  rfz(n, items) {
    return this.vgu_1.sgv()(n, get_pointer_0(items));
  }
  sfz(n, items) {
    return this.vgu_1.tgv()(n, get_pointer_0(items));
  }
  pfa(program) {
    return this.vgu_1.ugv()(program);
  }
  tfz(n, items) {
    return this.vgu_1.vgv()(n, get_pointer_0(items));
  }
  ofa(shader) {
    return this.vgu_1.wgv()(shader);
  }
  ufz(n, items) {
    return this.vgu_1.xgv()(n, get_pointer_0(items));
  }
  gfa(func) {
    return this.vgu_1.ygv()(func);
  }
  vf7(flag) {
    var tmp = this.vgu_1.zgv();
    // Inline function 'korlibs.math.toInt' call
    return tmp(flag ? 1 : 0);
  }
  ffa(n, f) {
    return this.vgu_1.agw()(n, f);
  }
  if8(cap) {
    return this.vgu_1.bgw()(cap);
  }
  yf8(index) {
    return this.vgu_1.cgw()(index);
  }
  pf8(mode, first, count) {
    return this.vgu_1.dgw()(mode, first, count);
  }
  rf8(mode, count, type, indices) {
    return this.vgu_1.egw()(mode, count, type, this.wgu(indices));
  }
  jf8(cap) {
    return this.vgu_1.fgw()(cap);
  }
  cf9(index) {
    return this.vgu_1.ggw()(index);
  }
  nd() {
    return this.vgu_1.hgw()();
  }
  dfa(target, attachment, renderbuffertarget, renderbuffer) {
    return this.vgu_1.igw()(target, attachment, renderbuffertarget, renderbuffer);
  }
  cfa(target, attachment, textarget, texture, level) {
    return this.vgu_1.jgw()(target, attachment, textarget, texture, level);
  }
  efa(mode) {
    return this.vgu_1.kgw()(mode);
  }
  vfz(n, buffers) {
    return this.vgu_1.lgw()(n, get_pointer_0(buffers));
  }
  df7(target) {
    return this.vgu_1.mgw()(target);
  }
  wfz(n, framebuffers) {
    return this.vgu_1.ngw()(n, get_pointer_0(framebuffers));
  }
  xfz(n, renderbuffers) {
    return this.vgu_1.ogw()(n, get_pointer_0(renderbuffers));
  }
  yfz(n, textures) {
    return this.vgu_1.pgw()(n, get_pointer_0(textures));
  }
  mfa(program, name) {
    return this.vgu_1.qgw()(program, name);
  }
  tfa() {
    return this.vgu_1.rgw()();
  }
  zfz(pname, data) {
    return this.vgu_1.sgw()(pname, get_pointer_0(data));
  }
  ag0(program, pname, params) {
    return this.vgu_1.tgw()(program, pname, get_pointer_0(params));
  }
  bg0(shader, pname, params) {
    return this.vgu_1.ugw()(shader, pname, get_pointer_0(params));
  }
  cg0(shader, bufSize, length, infoLog) {
    this.vgu_1.vgw()(shader, bufSize, get_pointer_0(length), get_pointer_0(infoLog));
  }
  kf3(name) {
    var tmp0_elvis_lhs = this.vgu_1.wgw()(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  cfb(program) {
    return this.vgu_1.xgw()(program);
  }
  af7(pname, param) {
    return this.vgu_1.ygw()(pname, param);
  }
  qf9(x, y, width, height, format, type, pixels) {
    return this.vgu_1.zgw()(x, y, width, height, format, type, get_pointer_0(pixels));
  }
  bfa(target, internalformat, width, height) {
    return this.vgu_1.agx()(target, internalformat, width, height);
  }
  ifa(x, y, width, height) {
    return this.vgu_1.bgx()(x, y, width, height);
  }
  rfa(shader, string) {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = CreateFFIMemory(8);
    var lengthsPtr = get_pointer(Deno.UnsafePointer.of(this_0));
    var bytes = encodeToByteArray(string + '\x00');
    set32(lengthsPtr, bytes.length - 1 | 0);
    // Inline function 'korlibs.ffi.usePointer' call
    var this_1 = CreateFFIMemory_0(bytes);
    var strPtr = get_pointer(Deno.UnsafePointer.of(this_1));
    // Inline function 'korlibs.ffi.usePointer' call
    var this_2 = CreateFFIMemory(8);
    var strPtrPtr = get_pointer(Deno.UnsafePointer.of(this_2));
    setFFIPointer(strPtrPtr, strPtr);
    this.vgu_1.cgx()(shader, 1, strPtrPtr, lengthsPtr);
  }
  lf8(func, ref, mask) {
    return this.vgu_1.dgx()(func, ref, mask);
  }
  kf8(face, func, ref, mask) {
    return this.vgu_1.egx()(face, func, ref, mask);
  }
  xf7(mask) {
    return this.vgu_1.fgx()(mask);
  }
  of8(face, mask) {
    return this.vgu_1.ggx()(face, mask);
  }
  nf8(fail, zfail, zpass) {
    return this.vgu_1.hgx()(fail, zfail, zpass);
  }
  mf8(face, sfail, dpfail, dppass) {
    return this.vgu_1.igx()(face, sfail, dpfail, dppass);
  }
  bf7(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp = this.vgu_1.jgx();
    tmp(target, level, internalformat, width, height, border, format, type, pixels == null ? null : get_pointer_0(pixels));
  }
  uf6(target, pname, param) {
    return this.vgu_1.kgx()(target, pname, param);
  }
  qf6(location, count, value) {
    return this.vgu_1.lgx()(location, count, get_pointer_0(value));
  }
  of4(location, v0) {
    return this.vgu_1.mgx()(location, v0);
  }
  jf6(location, count, value) {
    return this.vgu_1.ngx()(location, count, get_pointer_0(value));
  }
  rf6(location, count, value) {
    return this.vgu_1.ogx()(location, count, get_pointer_0(value));
  }
  kf6(location, count, value) {
    return this.vgu_1.pgx()(location, count, get_pointer_0(value));
  }
  sf6(location, count, value) {
    return this.vgu_1.qgx()(location, count, get_pointer_0(value));
  }
  lf6(location, count, value) {
    return this.vgu_1.rgx()(location, count, get_pointer_0(value));
  }
  tf6(location, count, value) {
    return this.vgu_1.sgx()(location, count, get_pointer_0(value));
  }
  mf6(location, count, value) {
    return this.vgu_1.tgx()(location, count, get_pointer_0(value));
  }
  nf6(location, count, transpose, value) {
    var tmp = this.vgu_1.ugx();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  of6(location, count, transpose, value) {
    var tmp = this.vgu_1.vgx();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  pf6(location, count, transpose, value) {
    var tmp = this.vgu_1.wgx();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  nfa(program) {
    return this.vgu_1.xgx()(program);
  }
  df9(index, size, type, normalized, stride, pointer) {
    var tmp = this.vgu_1.ygx();
    // Inline function 'korlibs.math.toInt' call
    return tmp(index, size, type, normalized ? 1 : 0, stride, this.xgu(pointer));
  }
  sf9(x, y, width, height) {
    return this.vgu_1.zgx()(x, y, width, height);
  }
  qf8(mode, first, count, instancecount) {
    return this.vgu_1.agy()(mode, first, count, instancecount);
  }
  sf8(mode, count, type, indices, instancecount) {
    return this.vgu_1.bgy()(mode, count, type, this.wgu(indices), instancecount);
  }
  xf8(index, divisor) {
    return this.vgu_1.cgy()(index, divisor);
  }
  heh() {
    return true;
  }
  kf9(target, index, buffer, offset, size) {
    return this.vgu_1.dgy()(target, index, buffer, this.wgu(offset), this.wgu(size));
  }
  pf4(program, name) {
    return this.vgu_1.egy()(program, name);
  }
  qf4(program, uniformBlockIndex, uniformBlockBinding) {
    return this.vgu_1.fgy()(program, uniformBlockIndex, uniformBlockBinding);
  }
  ieh() {
    return true;
  }
  dg0(n, arrays) {
    return this.vgu_1.ggy()(n, get_pointer_0(arrays));
  }
  zf8(array) {
    return this.vgu_1.hgy()(array);
  }
}
class Companion_64 {
  constructor() {
    this.igy_1 = 16384;
  }
}
class OpenGL extends FFILib {
  constructor() {
    return new.target.qgu();
  }
  static qgu() {
    var $this = this.mbm(['/System/Library/Frameworks/OpenGL.framework/OpenGL']);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_14().sbm_1;
    var tmp_0 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config, true);
    var tmp_1 = KProperty1;
    tmp.sgo_1 = tmp_0.fbm($this, getPropertyCallableRef('glDrawArraysInstanced', 1, tmp_1, OpenGL$_get_glDrawArraysInstanced_$ref_u1p2u7(), null));
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_14().sbm_1;
    var tmp_3 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_0, true);
    var tmp_4 = KProperty1;
    tmp_2.tgo_1 = tmp_3.fbm($this, getPropertyCallableRef('glDrawElementsInstanced', 1, tmp_4, OpenGL$_get_glDrawElementsInstanced_$ref_ngtsf8(), null));
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_14().sbm_1;
    var tmp_6 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true);
    var tmp_7 = KProperty1;
    tmp_5.ugo_1 = tmp_6.fbm($this, getPropertyCallableRef('glVertexAttribDivisor', 1, tmp_7, OpenGL$_get_glVertexAttribDivisor_$ref_e0aam8(), null));
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_14().sbm_1;
    var tmp_9 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true);
    var tmp_10 = KProperty1;
    tmp_8.vgo_1 = tmp_9.fbm($this, getPropertyCallableRef('glTexSubImage2D', 1, tmp_10, OpenGL$_get_glTexSubImage2D_$ref_ot6p7g(), null));
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_14().sbm_1;
    var tmp_12 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true);
    var tmp_13 = KProperty1;
    tmp_11.wgo_1 = tmp_12.fbm($this, getPropertyCallableRef('glTexImage2D', 1, tmp_13, OpenGL$_get_glTexImage2D_$ref_hd9bwc(), null));
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_14().sbm_1;
    var tmp_15 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true);
    var tmp_16 = KProperty1;
    tmp_14.xgo_1 = tmp_15.fbm($this, getPropertyCallableRef('glTexParameteri', 1, tmp_16, OpenGL$_get_glTexParameteri_$ref_6ujtm1(), null));
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_14().sbm_1;
    var tmp_18 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true);
    var tmp_19 = KProperty1;
    tmp_17.ygo_1 = tmp_18.fbm($this, getPropertyCallableRef('glTexParameterf', 1, tmp_19, OpenGL$_get_glTexParameterf_$ref_5feyfg(), null));
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_14().sbm_1;
    var tmp_21 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_6, true);
    var tmp_22 = KProperty1;
    tmp_20.zgo_1 = tmp_21.fbm($this, getPropertyCallableRef('glTexParameterfv', 1, tmp_22, OpenGL$_get_glTexParameterfv_$ref_hy0keg(), null));
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_14().sbm_1;
    var tmp_24 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true);
    var tmp_25 = KProperty1;
    tmp_23.agp_1 = tmp_24.fbm($this, getPropertyCallableRef('glTexParameteriv', 1, tmp_25, OpenGL$_get_glTexParameteriv_$ref_q36a9n(), null));
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_14().sbm_1;
    var tmp_27 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_8, true);
    var tmp_28 = KProperty1;
    tmp_26.bgp_1 = tmp_27.fbm($this, getPropertyCallableRef('glStencilOp', 1, tmp_28, OpenGL$_get_glStencilOp_$ref_xgguj7(), null));
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_14().sbm_1;
    var tmp_30 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true);
    var tmp_31 = KProperty1;
    tmp_29.cgp_1 = tmp_30.fbm($this, getPropertyCallableRef('glStencilMask', 1, tmp_31, OpenGL$_get_glStencilMask_$ref_cflgew(), null));
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_14().sbm_1;
    var tmp_33 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_10, true);
    var tmp_34 = KProperty1;
    tmp_32.dgp_1 = tmp_33.fbm($this, getPropertyCallableRef('glReadPixels', 1, tmp_34, OpenGL$_get_glReadPixels_$ref_oohu9z(), null));
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_14().sbm_1;
    var tmp_36 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true);
    var tmp_37 = KProperty1;
    tmp_35.egp_1 = tmp_36.fbm($this, getPropertyCallableRef('glStencilFunc', 1, tmp_37, OpenGL$_get_glStencilFunc_$ref_e7srow(), null));
    var tmp_38 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_12 = Companion_getInstance_14().sbm_1;
    var tmp_39 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_12, true);
    var tmp_40 = KProperty1;
    tmp_38.fgp_1 = tmp_39.fbm($this, getPropertyCallableRef('glScissor', 1, tmp_40, OpenGL$_get_glScissor_$ref_e6ft78(), null));
    var tmp_41 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_13 = Companion_getInstance_14().sbm_1;
    var tmp_42 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_13, true);
    var tmp_43 = KProperty1;
    tmp_41.ggp_1 = tmp_42.fbm($this, getPropertyCallableRef('glPolygonOffset', 1, tmp_43, OpenGL$_get_glPolygonOffset_$ref_oqmkwz(), null));
    var tmp_44 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_14 = Companion_getInstance_14().sbm_1;
    var tmp_45 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_14, true);
    var tmp_46 = KProperty1;
    tmp_44.hgp_1 = tmp_45.fbm($this, getPropertyCallableRef('glPixelStorei', 1, tmp_46, OpenGL$_get_glPixelStorei_$ref_ywwdb6(), null));
    var tmp_47 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_15 = Companion_getInstance_14().sbm_1;
    var tmp_48 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_15, true);
    var tmp_49 = KProperty1;
    tmp_47.igp_1 = tmp_48.fbm($this, getPropertyCallableRef('glLineWidth', 1, tmp_49, OpenGL$_get_glLineWidth_$ref_1ljuf6(), null));
    var tmp_50 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_16 = Companion_getInstance_14().sbm_1;
    var tmp_51 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_16, true);
    var tmp_52 = KProperty1;
    tmp_50.jgp_1 = tmp_51.fbm($this, getPropertyCallableRef('glGetTexParameterfv', 1, tmp_52, OpenGL$_get_glGetTexParameterfv_$ref_gfvs8(), null));
    var tmp_53 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_17 = Companion_getInstance_14().sbm_1;
    var tmp_54 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_17, true);
    var tmp_55 = KProperty1;
    tmp_53.kgp_1 = tmp_54.fbm($this, getPropertyCallableRef('glGetTexParameteriv', 1, tmp_55, OpenGL$_get_glGetTexParameteriv_$ref_qjhbit(), null));
    var tmp_56 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_18 = Companion_getInstance_14().sbm_1;
    var tmp_57 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_18, true);
    var tmp_58 = KProperty1;
    tmp_56.lgp_1 = tmp_57.fbm($this, getPropertyCallableRef('glGetError', 1, tmp_58, OpenGL$_get_glGetError_$ref_48ki14(), null));
    var tmp_59 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_19 = Companion_getInstance_14().sbm_1;
    var tmp_60 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_19, true);
    var tmp_61 = KProperty1;
    tmp_59.mgp_1 = tmp_60.fbm($this, getPropertyCallableRef('glGetFloatv', 1, tmp_61, OpenGL$_get_glGetFloatv_$ref_qyzna8(), null));
    var tmp_62 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_20 = Companion_getInstance_14().sbm_1;
    var tmp_63 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_20, true);
    var tmp_64 = KProperty1;
    tmp_62.ngp_1 = tmp_63.fbm($this, getPropertyCallableRef('glGetIntegerv', 1, tmp_64, OpenGL$_get_glGetIntegerv_$ref_oigptu(), null));
    var tmp_65 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_21 = Companion_getInstance_14().sbm_1;
    var tmp_66 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_21, true);
    var tmp_67 = KProperty1;
    tmp_65.ogp_1 = tmp_66.fbm($this, getPropertyCallableRef('glGetBooleanv', 1, tmp_67, OpenGL$_get_glGetBooleanv_$ref_17fmss(), null));
    var tmp_68 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_22 = Companion_getInstance_14().sbm_1;
    var tmp_69 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_22, true);
    var tmp_70 = KProperty1;
    tmp_68.pgp_1 = tmp_69.fbm($this, getPropertyCallableRef('glGenTextures', 1, tmp_70, OpenGL$_get_glGenTextures_$ref_omr6fc(), null));
    var tmp_71 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_23 = Companion_getInstance_14().sbm_1;
    var tmp_72 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_23, true);
    var tmp_73 = KProperty1;
    tmp_71.qgp_1 = tmp_72.fbm($this, getPropertyCallableRef('glDepthRange', 1, tmp_73, OpenGL$_get_glDepthRange_$ref_7h8k9c(), null));
    var tmp_74 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_24 = Companion_getInstance_14().sbm_1;
    var tmp_75 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_24, true);
    var tmp_76 = KProperty1;
    tmp_74.rgp_1 = tmp_75.fbm($this, getPropertyCallableRef('glDepthRangef', 1, tmp_76, OpenGL$_get_glDepthRangef_$ref_wzcry4(), null));
    var tmp_77 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_25 = Companion_getInstance_14().sbm_1;
    var tmp_78 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_25, true);
    var tmp_79 = KProperty1;
    tmp_77.sgp_1 = tmp_78.fbm($this, getPropertyCallableRef('glClearDepth', 1, tmp_79, OpenGL$_get_glClearDepth_$ref_sjvems(), null));
    var tmp_80 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_26 = Companion_getInstance_14().sbm_1;
    var tmp_81 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_26, true);
    var tmp_82 = KProperty1;
    tmp_80.tgp_1 = tmp_81.fbm($this, getPropertyCallableRef('glClearDepthf', 1, tmp_82, OpenGL$_get_glClearDepthf_$ref_izp45c(), null));
    var tmp_83 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_27 = Companion_getInstance_14().sbm_1;
    var tmp_84 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_27, true);
    var tmp_85 = KProperty1;
    tmp_83.ugp_1 = tmp_84.fbm($this, getPropertyCallableRef('glDrawArrays', 1, tmp_85, OpenGL$_get_glDrawArrays_$ref_58aslw(), null));
    var tmp_86 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_28 = Companion_getInstance_14().sbm_1;
    var tmp_87 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_28, true);
    var tmp_88 = KProperty1;
    tmp_86.vgp_1 = tmp_87.fbm($this, getPropertyCallableRef('glDrawElements', 1, tmp_88, OpenGL$_get_glDrawElements_$ref_j22jw1(), null));
    var tmp_89 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_29 = Companion_getInstance_14().sbm_1;
    var tmp_90 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_29, true);
    var tmp_91 = KProperty1;
    tmp_89.wgp_1 = tmp_90.fbm($this, getPropertyCallableRef('glFrontFace', 1, tmp_91, OpenGL$_get_glFrontFace_$ref_10zhh2(), null));
    var tmp_92 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_30 = Companion_getInstance_14().sbm_1;
    var tmp_93 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_30, true);
    var tmp_94 = KProperty1;
    tmp_92.xgp_1 = tmp_93.fbm($this, getPropertyCallableRef('glFinish', 1, tmp_94, OpenGL$_get_glFinish_$ref_a9jkgn(), null));
    var tmp_95 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_31 = Companion_getInstance_14().sbm_1;
    var tmp_96 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_31, true);
    var tmp_97 = KProperty1;
    tmp_95.ygp_1 = tmp_96.fbm($this, getPropertyCallableRef('glFlush', 1, tmp_97, OpenGL$_get_glFlush_$ref_hbpd7w(), null));
    var tmp_98 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_32 = Companion_getInstance_14().sbm_1;
    var tmp_99 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_32, true);
    var tmp_100 = KProperty1;
    tmp_98.zgp_1 = tmp_99.fbm($this, getPropertyCallableRef('glEnable', 1, tmp_100, OpenGL$_get_glEnable_$ref_zdgp5z(), null));
    var tmp_101 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_33 = Companion_getInstance_14().sbm_1;
    var tmp_102 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_33, true);
    var tmp_103 = KProperty1;
    tmp_101.agq_1 = tmp_102.fbm($this, getPropertyCallableRef('glIsEnabled', 1, tmp_103, OpenGL$_get_glIsEnabled_$ref_ibwkwp(), null));
    var tmp_104 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_34 = Companion_getInstance_14().sbm_1;
    var tmp_105 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_34, true);
    var tmp_106 = KProperty1;
    tmp_104.bgq_1 = tmp_105.fbm($this, getPropertyCallableRef('glDisable', 1, tmp_106, OpenGL$_get_glDisable_$ref_hoj2m0(), null));
    var tmp_107 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_35 = Companion_getInstance_14().sbm_1;
    var tmp_108 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_35, true);
    var tmp_109 = KProperty1;
    tmp_107.cgq_1 = tmp_108.fbm($this, getPropertyCallableRef('glDepthMask', 1, tmp_109, OpenGL$_get_glDepthMask_$ref_tykd6n(), null));
    var tmp_110 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_36 = Companion_getInstance_14().sbm_1;
    var tmp_111 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_36, true);
    var tmp_112 = KProperty1;
    tmp_110.dgq_1 = tmp_111.fbm($this, getPropertyCallableRef('glDepthFunc', 1, tmp_112, OpenGL$_get_glDepthFunc_$ref_vqrogn(), null));
    var tmp_113 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_37 = Companion_getInstance_14().sbm_1;
    var tmp_114 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_37, true);
    var tmp_115 = KProperty1;
    tmp_113.egq_1 = tmp_114.fbm($this, getPropertyCallableRef('glDeleteTextures', 1, tmp_115, OpenGL$_get_glDeleteTextures_$ref_vpf7h5(), null));
    var tmp_116 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_38 = Companion_getInstance_14().sbm_1;
    var tmp_117 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_38, true);
    var tmp_118 = KProperty1;
    tmp_116.fgq_1 = tmp_117.fbm($this, getPropertyCallableRef('glCullFace', 1, tmp_118, OpenGL$_get_glCullFace_$ref_lyfha3(), null));
    var tmp_119 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_39 = Companion_getInstance_14().sbm_1;
    var tmp_120 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_39, true);
    var tmp_121 = KProperty1;
    tmp_119.ggq_1 = tmp_120.fbm($this, getPropertyCallableRef('glCopyTexImage2D', 1, tmp_121, OpenGL$_get_glCopyTexImage2D_$ref_12iy8f(), null));
    var tmp_122 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_40 = Companion_getInstance_14().sbm_1;
    var tmp_123 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_40, true);
    var tmp_124 = KProperty1;
    tmp_122.hgq_1 = tmp_123.fbm($this, getPropertyCallableRef('glCopyTexSubImage2D', 1, tmp_124, OpenGL$_get_glCopyTexSubImage2D_$ref_r7972n(), null));
    var tmp_125 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_41 = Companion_getInstance_14().sbm_1;
    var tmp_126 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_41, true);
    var tmp_127 = KProperty1;
    tmp_125.igq_1 = tmp_126.fbm($this, getPropertyCallableRef('glColorMask', 1, tmp_127, OpenGL$_get_glColorMask_$ref_xlmwdb(), null));
    var tmp_128 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_42 = Companion_getInstance_14().sbm_1;
    var tmp_129 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_42, true);
    var tmp_130 = KProperty1;
    tmp_128.jgq_1 = tmp_129.fbm($this, getPropertyCallableRef('glClearStencil', 1, tmp_130, OpenGL$_get_glClearStencil_$ref_cyn4zp(), null));
    var tmp_131 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_43 = Companion_getInstance_14().sbm_1;
    var tmp_132 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_43, true);
    var tmp_133 = KProperty1;
    tmp_131.kgq_1 = tmp_132.fbm($this, getPropertyCallableRef('glClearColor', 1, tmp_133, OpenGL$_get_glClearColor_$ref_ovlm18(), null));
    var tmp_134 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_44 = Companion_getInstance_14().sbm_1;
    var tmp_135 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_44, true);
    var tmp_136 = KProperty1;
    tmp_134.lgq_1 = tmp_135.fbm($this, getPropertyCallableRef('glClear', 1, tmp_136, OpenGL$_get_glClear_$ref_gr5car(), null));
    var tmp_137 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_45 = Companion_getInstance_14().sbm_1;
    var tmp_138 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_45, true);
    var tmp_139 = KProperty1;
    tmp_137.mgq_1 = tmp_138.fbm($this, getPropertyCallableRef('glBindTexture', 1, tmp_139, OpenGL$_get_glBindTexture_$ref_ikazn2(), null));
    var tmp_140 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_46 = Companion_getInstance_14().sbm_1;
    var tmp_141 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_46, true);
    var tmp_142 = KProperty1;
    tmp_140.ngq_1 = tmp_141.fbm($this, getPropertyCallableRef('glHint', 1, tmp_142, OpenGL$_get_glHint_$ref_o1skrn(), null));
    var tmp_143 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_47 = Companion_getInstance_14().sbm_1;
    var tmp_144 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_47, true);
    var tmp_145 = KProperty1;
    tmp_143.ogq_1 = tmp_144.fbm($this, getPropertyCallableRef('glViewport', 1, tmp_145, OpenGL$_get_glViewport_$ref_jzsdt0(), null));
    var tmp_146 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_48 = Companion_getInstance_14().sbm_1;
    var tmp_147 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true))]), false), null, config_48, true);
    var tmp_148 = KProperty1;
    tmp_146.pgq_1 = tmp_147.fbm($this, getPropertyCallableRef('glGetString', 1, tmp_148, OpenGL$_get_glGetString_$ref_fj04nd(), null));
    var tmp_149 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_49 = Companion_getInstance_14().sbm_1;
    var tmp_150 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true))]), false), null, config_49, true);
    var tmp_151 = KProperty1;
    tmp_149.qgq_1 = tmp_150.fbm($this, getPropertyCallableRef('glGetStringi', 1, tmp_151, OpenGL$_get_glGetStringi_$ref_4v6he0(), null));
    var tmp_152 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_50 = Companion_getInstance_14().sbm_1;
    var tmp_153 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_50, true);
    var tmp_154 = KProperty1;
    tmp_152.rgq_1 = tmp_153.fbm($this, getPropertyCallableRef('glVertexAttribPointer', 1, tmp_154, OpenGL$_get_glVertexAttribPointer_$ref_8ozh8f(), null));
    var tmp_155 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_51 = Companion_getInstance_14().sbm_1;
    var tmp_156 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_51, true);
    var tmp_157 = KProperty1;
    tmp_155.sgq_1 = tmp_156.fbm($this, getPropertyCallableRef('glVertexAttrib4fv', 1, tmp_157, OpenGL$_get_glVertexAttrib4fv_$ref_i22oze(), null));
    var tmp_158 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_52 = Companion_getInstance_14().sbm_1;
    var tmp_159 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_52, true);
    var tmp_160 = KProperty1;
    tmp_158.tgq_1 = tmp_159.fbm($this, getPropertyCallableRef('glActiveTexture', 1, tmp_160, OpenGL$_get_glActiveTexture_$ref_6v6wm3(), null));
    var tmp_161 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_53 = Companion_getInstance_14().sbm_1;
    var tmp_162 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_53, true);
    var tmp_163 = KProperty1;
    tmp_161.ugq_1 = tmp_162.fbm($this, getPropertyCallableRef('glAttachShader', 1, tmp_163, OpenGL$_get_glAttachShader_$ref_5wudxc(), null));
    var tmp_164 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_54 = Companion_getInstance_14().sbm_1;
    var tmp_165 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_54, true);
    var tmp_166 = KProperty1;
    tmp_164.vgq_1 = tmp_165.fbm($this, getPropertyCallableRef('glBindAttribLocation', 1, tmp_166, OpenGL$_get_glBindAttribLocation_$ref_dl103y(), null));
    var tmp_167 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_55 = Companion_getInstance_14().sbm_1;
    var tmp_168 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_55, true);
    var tmp_169 = KProperty1;
    tmp_167.wgq_1 = tmp_168.fbm($this, getPropertyCallableRef('glBindBuffer', 1, tmp_169, OpenGL$_get_glBindBuffer_$ref_esyx8t(), null));
    var tmp_170 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_56 = Companion_getInstance_14().sbm_1;
    var tmp_171 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_56, true);
    var tmp_172 = KProperty1;
    tmp_170.xgq_1 = tmp_171.fbm($this, getPropertyCallableRef('glBindFramebuffer', 1, tmp_172, OpenGL$_get_glBindFramebuffer_$ref_ravdz4(), null));
    var tmp_173 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_57 = Companion_getInstance_14().sbm_1;
    var tmp_174 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_57, true);
    var tmp_175 = KProperty1;
    tmp_173.ygq_1 = tmp_174.fbm($this, getPropertyCallableRef('glBindRenderbuffer', 1, tmp_175, OpenGL$_get_glBindRenderbuffer_$ref_aricg9(), null));
    var tmp_176 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_58 = Companion_getInstance_14().sbm_1;
    var tmp_177 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_58, true);
    var tmp_178 = KProperty1;
    tmp_176.zgq_1 = tmp_177.fbm($this, getPropertyCallableRef('glBlendColor', 1, tmp_178, OpenGL$_get_glBlendColor_$ref_w6qdhk(), null));
    var tmp_179 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_59 = Companion_getInstance_14().sbm_1;
    var tmp_180 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_59, true);
    var tmp_181 = KProperty1;
    tmp_179.agr_1 = tmp_180.fbm($this, getPropertyCallableRef('glBlendEquation', 1, tmp_181, OpenGL$_get_glBlendEquation_$ref_oeso43(), null));
    var tmp_182 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_60 = Companion_getInstance_14().sbm_1;
    var tmp_183 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_60, true);
    var tmp_184 = KProperty1;
    tmp_182.bgr_1 = tmp_183.fbm($this, getPropertyCallableRef('glBlendEquationSeparate', 1, tmp_184, OpenGL$_get_glBlendEquationSeparate_$ref_r5jrrk(), null));
    var tmp_185 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_61 = Companion_getInstance_14().sbm_1;
    var tmp_186 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_61, true);
    var tmp_187 = KProperty1;
    tmp_185.cgr_1 = tmp_186.fbm($this, getPropertyCallableRef('glBlendFunc', 1, tmp_187, OpenGL$_get_glBlendFunc_$ref_n80uw5(), null));
    var tmp_188 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_62 = Companion_getInstance_14().sbm_1;
    var tmp_189 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_62, true);
    var tmp_190 = KProperty1;
    tmp_188.dgr_1 = tmp_189.fbm($this, getPropertyCallableRef('glBlendFuncSeparate', 1, tmp_190, OpenGL$_get_glBlendFuncSeparate_$ref_bapj9k(), null));
    var tmp_191 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_63 = Companion_getInstance_14().sbm_1;
    var tmp_192 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_63, true);
    var tmp_193 = KProperty1;
    tmp_191.egr_1 = tmp_192.fbm($this, getPropertyCallableRef('glBufferData', 1, tmp_193, OpenGL$_get_glBufferData_$ref_bi09ts(), null));
    var tmp_194 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_64 = Companion_getInstance_14().sbm_1;
    var tmp_195 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_64, true);
    var tmp_196 = KProperty1;
    tmp_194.fgr_1 = tmp_195.fbm($this, getPropertyCallableRef('glBufferSubData', 1, tmp_196, OpenGL$_get_glBufferSubData_$ref_ypz5y(), null));
    var tmp_197 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_65 = Companion_getInstance_14().sbm_1;
    var tmp_198 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_65, true);
    var tmp_199 = KProperty1;
    tmp_197.ggr_1 = tmp_198.fbm($this, getPropertyCallableRef('glCheckFramebufferStatus', 1, tmp_199, OpenGL$_get_glCheckFramebufferStatus_$ref_n8hay5(), null));
    var tmp_200 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_66 = Companion_getInstance_14().sbm_1;
    var tmp_201 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_66, true);
    var tmp_202 = KProperty1;
    tmp_200.hgr_1 = tmp_201.fbm($this, getPropertyCallableRef('glCompileShader', 1, tmp_202, OpenGL$_get_glCompileShader_$ref_1vlby0(), null));
    var tmp_203 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_67 = Companion_getInstance_14().sbm_1;
    var tmp_204 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_67, true);
    var tmp_205 = KProperty1;
    tmp_203.igr_1 = tmp_204.fbm($this, getPropertyCallableRef('glCompressedTexImage2D', 1, tmp_205, OpenGL$_get_glCompressedTexImage2D_$ref_6a7ukj(), null));
    var tmp_206 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_68 = Companion_getInstance_14().sbm_1;
    var tmp_207 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_68, true);
    var tmp_208 = KProperty1;
    tmp_206.jgr_1 = tmp_207.fbm($this, getPropertyCallableRef('glCompressedTexSubImage2D', 1, tmp_208, OpenGL$_get_glCompressedTexSubImage2D_$ref_j9i56l(), null));
    var tmp_209 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_69 = Companion_getInstance_14().sbm_1;
    var tmp_210 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_69, true);
    var tmp_211 = KProperty1;
    tmp_209.kgr_1 = tmp_210.fbm($this, getPropertyCallableRef('glCreateProgram', 1, tmp_211, OpenGL$_get_glCreateProgram_$ref_fbgki0(), null));
    var tmp_212 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_70 = Companion_getInstance_14().sbm_1;
    var tmp_213 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_70, true);
    var tmp_214 = KProperty1;
    tmp_212.lgr_1 = tmp_213.fbm($this, getPropertyCallableRef('glCreateShader', 1, tmp_214, OpenGL$_get_glCreateShader_$ref_j1n6qx(), null));
    var tmp_215 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_71 = Companion_getInstance_14().sbm_1;
    var tmp_216 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_71, true);
    var tmp_217 = KProperty1;
    tmp_215.mgr_1 = tmp_216.fbm($this, getPropertyCallableRef('glDeleteBuffers', 1, tmp_217, OpenGL$_get_glDeleteBuffers_$ref_7jx1zs(), null));
    var tmp_218 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_72 = Companion_getInstance_14().sbm_1;
    var tmp_219 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_72, true);
    var tmp_220 = KProperty1;
    tmp_218.ngr_1 = tmp_219.fbm($this, getPropertyCallableRef('glDeleteFramebuffers', 1, tmp_220, OpenGL$_get_glDeleteFramebuffers_$ref_s5tsqh(), null));
    var tmp_221 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_73 = Companion_getInstance_14().sbm_1;
    var tmp_222 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_73, true);
    var tmp_223 = KProperty1;
    tmp_221.ogr_1 = tmp_222.fbm($this, getPropertyCallableRef('glDeleteProgram', 1, tmp_223, OpenGL$_get_glDeleteProgram_$ref_wmd3hz(), null));
    var tmp_224 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_74 = Companion_getInstance_14().sbm_1;
    var tmp_225 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_74, true);
    var tmp_226 = KProperty1;
    tmp_224.pgr_1 = tmp_225.fbm($this, getPropertyCallableRef('glDeleteRenderbuffers', 1, tmp_226, OpenGL$_get_glDeleteRenderbuffers_$ref_fnagu6(), null));
    var tmp_227 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_75 = Companion_getInstance_14().sbm_1;
    var tmp_228 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_75, true);
    var tmp_229 = KProperty1;
    tmp_227.qgr_1 = tmp_228.fbm($this, getPropertyCallableRef('glDeleteShader', 1, tmp_229, OpenGL$_get_glDeleteShader_$ref_85at3u(), null));
    var tmp_230 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_76 = Companion_getInstance_14().sbm_1;
    var tmp_231 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_76, true);
    var tmp_232 = KProperty1;
    tmp_230.rgr_1 = tmp_231.fbm($this, getPropertyCallableRef('glDetachShader', 1, tmp_232, OpenGL$_get_glDetachShader_$ref_p7me4u(), null));
    var tmp_233 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_77 = Companion_getInstance_14().sbm_1;
    var tmp_234 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_77, true);
    var tmp_235 = KProperty1;
    tmp_233.sgr_1 = tmp_234.fbm($this, getPropertyCallableRef('glDisableVertexAttribArray', 1, tmp_235, OpenGL$_get_glDisableVertexAttribArray_$ref_canr21(), null));
    var tmp_236 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_78 = Companion_getInstance_14().sbm_1;
    var tmp_237 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_78, true);
    var tmp_238 = KProperty1;
    tmp_236.tgr_1 = tmp_237.fbm($this, getPropertyCallableRef('glEnableVertexAttribArray', 1, tmp_238, OpenGL$_get_glEnableVertexAttribArray_$ref_mrvgzs(), null));
    var tmp_239 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_79 = Companion_getInstance_14().sbm_1;
    var tmp_240 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_79, true);
    var tmp_241 = KProperty1;
    tmp_239.ugr_1 = tmp_240.fbm($this, getPropertyCallableRef('glFramebufferRenderbuffer', 1, tmp_241, OpenGL$_get_glFramebufferRenderbuffer_$ref_hhwykz(), null));
    var tmp_242 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_80 = Companion_getInstance_14().sbm_1;
    var tmp_243 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_80, true);
    var tmp_244 = KProperty1;
    tmp_242.vgr_1 = tmp_243.fbm($this, getPropertyCallableRef('glFramebufferTexture2D', 1, tmp_244, OpenGL$_get_glFramebufferTexture2D_$ref_g6yiuu(), null));
    var tmp_245 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_81 = Companion_getInstance_14().sbm_1;
    var tmp_246 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_81, true);
    var tmp_247 = KProperty1;
    tmp_245.wgr_1 = tmp_246.fbm($this, getPropertyCallableRef('glGenBuffers', 1, tmp_247, OpenGL$_get_glGenBuffers_$ref_3fgg4n(), null));
    var tmp_248 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_82 = Companion_getInstance_14().sbm_1;
    var tmp_249 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_82, true);
    var tmp_250 = KProperty1;
    tmp_248.xgr_1 = tmp_249.fbm($this, getPropertyCallableRef('glGenerateMipmap', 1, tmp_250, OpenGL$_get_glGenerateMipmap_$ref_75ep0z(), null));
    var tmp_251 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_83 = Companion_getInstance_14().sbm_1;
    var tmp_252 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_83, true);
    var tmp_253 = KProperty1;
    tmp_251.ygr_1 = tmp_252.fbm($this, getPropertyCallableRef('glGenFramebuffers', 1, tmp_253, OpenGL$_get_glGenFramebuffers_$ref_og1dlm(), null));
    var tmp_254 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_84 = Companion_getInstance_14().sbm_1;
    var tmp_255 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_84, true);
    var tmp_256 = KProperty1;
    tmp_254.zgr_1 = tmp_255.fbm($this, getPropertyCallableRef('glGenRenderbuffers', 1, tmp_256, OpenGL$_get_glGenRenderbuffers_$ref_sj2idf(), null));
    var tmp_257 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_85 = Companion_getInstance_14().sbm_1;
    var tmp_258 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_85, true);
    var tmp_259 = KProperty1;
    tmp_257.ags_1 = tmp_258.fbm($this, getPropertyCallableRef('glGetActiveAttrib', 1, tmp_259, OpenGL$_get_glGetActiveAttrib_$ref_hic01i(), null));
    var tmp_260 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_86 = Companion_getInstance_14().sbm_1;
    var tmp_261 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_86, true);
    var tmp_262 = KProperty1;
    tmp_260.bgs_1 = tmp_261.fbm($this, getPropertyCallableRef('glGetActiveUniform', 1, tmp_262, OpenGL$_get_glGetActiveUniform_$ref_5ujg6q(), null));
    var tmp_263 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_87 = Companion_getInstance_14().sbm_1;
    var tmp_264 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_87, true);
    var tmp_265 = KProperty1;
    tmp_263.cgs_1 = tmp_264.fbm($this, getPropertyCallableRef('glGetAttachedShaders', 1, tmp_265, OpenGL$_get_glGetAttachedShaders_$ref_tulvfa(), null));
    var tmp_266 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_88 = Companion_getInstance_14().sbm_1;
    var tmp_267 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_88, true);
    var tmp_268 = KProperty1;
    tmp_266.dgs_1 = tmp_267.fbm($this, getPropertyCallableRef('glGetAttribLocation', 1, tmp_268, OpenGL$_get_glGetAttribLocation_$ref_lv3vph(), null));
    var tmp_269 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_89 = Companion_getInstance_14().sbm_1;
    var tmp_270 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_89, true);
    var tmp_271 = KProperty1;
    tmp_269.egs_1 = tmp_270.fbm($this, getPropertyCallableRef('glGetUniformLocation', 1, tmp_271, OpenGL$_get_glGetUniformLocation_$ref_fup42x(), null));
    var tmp_272 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_90 = Companion_getInstance_14().sbm_1;
    var tmp_273 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_90, true);
    var tmp_274 = KProperty1;
    tmp_272.fgs_1 = tmp_273.fbm($this, getPropertyCallableRef('glGetBufferParameteriv', 1, tmp_274, OpenGL$_get_glGetBufferParameteriv_$ref_xxl2a2(), null));
    var tmp_275 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_91 = Companion_getInstance_14().sbm_1;
    var tmp_276 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_91, true);
    var tmp_277 = KProperty1;
    tmp_275.ggs_1 = tmp_276.fbm($this, getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, tmp_277, OpenGL$_get_glGetFramebufferAttachmentParameteriv_$ref_sjmcxg(), null));
    var tmp_278 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_92 = Companion_getInstance_14().sbm_1;
    var tmp_279 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_92, true);
    var tmp_280 = KProperty1;
    tmp_278.hgs_1 = tmp_279.fbm($this, getPropertyCallableRef('glGetProgramInfoLog', 1, tmp_280, OpenGL$_get_glGetProgramInfoLog_$ref_js6e94(), null));
    var tmp_281 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_93 = Companion_getInstance_14().sbm_1;
    var tmp_282 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_93, true);
    var tmp_283 = KProperty1;
    tmp_281.igs_1 = tmp_282.fbm($this, getPropertyCallableRef('glGetRenderbufferParameteriv', 1, tmp_283, OpenGL$_get_glGetRenderbufferParameteriv_$ref_r8jfj4(), null));
    var tmp_284 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_94 = Companion_getInstance_14().sbm_1;
    var tmp_285 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_94, true);
    var tmp_286 = KProperty1;
    tmp_284.jgs_1 = tmp_285.fbm($this, getPropertyCallableRef('glGetProgramiv', 1, tmp_286, OpenGL$_get_glGetProgramiv_$ref_wgrcbz(), null));
    var tmp_287 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_95 = Companion_getInstance_14().sbm_1;
    var tmp_288 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_95, true);
    var tmp_289 = KProperty1;
    tmp_287.kgs_1 = tmp_288.fbm($this, getPropertyCallableRef('glGetShaderiv', 1, tmp_289, OpenGL$_get_glGetShaderiv_$ref_iwrqoo(), null));
    var tmp_290 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_96 = Companion_getInstance_14().sbm_1;
    var tmp_291 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_96, true);
    var tmp_292 = KProperty1;
    tmp_290.lgs_1 = tmp_291.fbm($this, getPropertyCallableRef('glGetShaderInfoLog', 1, tmp_292, OpenGL$_get_glGetShaderInfoLog_$ref_fszgwf(), null));
    var tmp_293 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_97 = Companion_getInstance_14().sbm_1;
    var tmp_294 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_97, true);
    var tmp_295 = KProperty1;
    tmp_293.mgs_1 = tmp_294.fbm($this, getPropertyCallableRef('glGetShaderPrecisionFormat', 1, tmp_295, OpenGL$_get_glGetShaderPrecisionFormat_$ref_jq4d3k(), null));
    var tmp_296 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_98 = Companion_getInstance_14().sbm_1;
    var tmp_297 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_98, true);
    var tmp_298 = KProperty1;
    tmp_296.ngs_1 = tmp_297.fbm($this, getPropertyCallableRef('glGetShaderSource', 1, tmp_298, OpenGL$_get_glGetShaderSource_$ref_pj8uze(), null));
    var tmp_299 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_99 = Companion_getInstance_14().sbm_1;
    var tmp_300 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_99, true);
    var tmp_301 = KProperty1;
    tmp_299.ogs_1 = tmp_300.fbm($this, getPropertyCallableRef('glGetUniformfv', 1, tmp_301, OpenGL$_get_glGetUniformfv_$ref_i91n0k(), null));
    var tmp_302 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_100 = Companion_getInstance_14().sbm_1;
    var tmp_303 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_100, true);
    var tmp_304 = KProperty1;
    tmp_302.pgs_1 = tmp_303.fbm($this, getPropertyCallableRef('glGetUniformiv', 1, tmp_304, OpenGL$_get_glGetUniformiv_$ref_ps57nj(), null));
    var tmp_305 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_101 = Companion_getInstance_14().sbm_1;
    var tmp_306 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_101, true);
    var tmp_307 = KProperty1;
    tmp_305.qgs_1 = tmp_306.fbm($this, getPropertyCallableRef('glGetVertexAttribfv', 1, tmp_307, OpenGL$_get_glGetVertexAttribfv_$ref_cluoyk(), null));
    var tmp_308 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_102 = Companion_getInstance_14().sbm_1;
    var tmp_309 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_102, true);
    var tmp_310 = KProperty1;
    tmp_308.rgs_1 = tmp_309.fbm($this, getPropertyCallableRef('glGetVertexAttribiv', 1, tmp_310, OpenGL$_get_glGetVertexAttribiv_$ref_ee2ich(), null));
    var tmp_311 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_103 = Companion_getInstance_14().sbm_1;
    var tmp_312 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_103, true);
    var tmp_313 = KProperty1;
    tmp_311.sgs_1 = tmp_312.fbm($this, getPropertyCallableRef('glGetVertexAttribPointerv', 1, tmp_313, OpenGL$_get_glGetVertexAttribPointerv_$ref_dobxt9(), null));
    var tmp_314 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_104 = Companion_getInstance_14().sbm_1;
    var tmp_315 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_104, true);
    var tmp_316 = KProperty1;
    tmp_314.tgs_1 = tmp_315.fbm($this, getPropertyCallableRef('glIsBuffer', 1, tmp_316, OpenGL$_get_glIsBuffer_$ref_4dxhq8(), null));
    var tmp_317 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_105 = Companion_getInstance_14().sbm_1;
    var tmp_318 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_105, true);
    var tmp_319 = KProperty1;
    tmp_317.ugs_1 = tmp_318.fbm($this, getPropertyCallableRef('glIsFramebuffer', 1, tmp_319, OpenGL$_get_glIsFramebuffer_$ref_44fxeb(), null));
    var tmp_320 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_106 = Companion_getInstance_14().sbm_1;
    var tmp_321 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_106, true);
    var tmp_322 = KProperty1;
    tmp_320.vgs_1 = tmp_321.fbm($this, getPropertyCallableRef('glIsProgram', 1, tmp_322, OpenGL$_get_glIsProgram_$ref_bgwnt6(), null));
    var tmp_323 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_107 = Companion_getInstance_14().sbm_1;
    var tmp_324 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_107, true);
    var tmp_325 = KProperty1;
    tmp_323.wgs_1 = tmp_324.fbm($this, getPropertyCallableRef('glIsRenderbuffer', 1, tmp_325, OpenGL$_get_glIsRenderbuffer_$ref_2jbmae(), null));
    var tmp_326 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_108 = Companion_getInstance_14().sbm_1;
    var tmp_327 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_108, true);
    var tmp_328 = KProperty1;
    tmp_326.xgs_1 = tmp_327.fbm($this, getPropertyCallableRef('glIsTexture', 1, tmp_328, OpenGL$_get_glIsTexture_$ref_dn0x8f(), null));
    var tmp_329 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_109 = Companion_getInstance_14().sbm_1;
    var tmp_330 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_109, true);
    var tmp_331 = KProperty1;
    tmp_329.ygs_1 = tmp_330.fbm($this, getPropertyCallableRef('glIsShader', 1, tmp_331, OpenGL$_get_glIsShader_$ref_blsvid(), null));
    var tmp_332 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_110 = Companion_getInstance_14().sbm_1;
    var tmp_333 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_110, true);
    var tmp_334 = KProperty1;
    tmp_332.zgs_1 = tmp_333.fbm($this, getPropertyCallableRef('glLinkProgram', 1, tmp_334, OpenGL$_get_glLinkProgram_$ref_k0e64a(), null));
    var tmp_335 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_111 = Companion_getInstance_14().sbm_1;
    var tmp_336 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_111, true);
    var tmp_337 = KProperty1;
    tmp_335.agt_1 = tmp_336.fbm($this, getPropertyCallableRef('glReleaseShaderCompiler', 1, tmp_337, OpenGL$_get_glReleaseShaderCompiler_$ref_8da41x(), null));
    var tmp_338 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_112 = Companion_getInstance_14().sbm_1;
    var tmp_339 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_112, true);
    var tmp_340 = KProperty1;
    tmp_338.bgt_1 = tmp_339.fbm($this, getPropertyCallableRef('glRenderbufferStorage', 1, tmp_340, OpenGL$_get_glRenderbufferStorage_$ref_qen0i3(), null));
    var tmp_341 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_113 = Companion_getInstance_14().sbm_1;
    var tmp_342 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_113, true);
    var tmp_343 = KProperty1;
    tmp_341.cgt_1 = tmp_342.fbm($this, getPropertyCallableRef('glSampleCoverage', 1, tmp_343, OpenGL$_get_glSampleCoverage_$ref_sixmzc(), null));
    var tmp_344 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_114 = Companion_getInstance_14().sbm_1;
    var tmp_345 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_114, true);
    var tmp_346 = KProperty1;
    tmp_344.dgt_1 = tmp_345.fbm($this, getPropertyCallableRef('glShaderBinary', 1, tmp_346, OpenGL$_get_glShaderBinary_$ref_j1pcqs(), null));
    var tmp_347 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_115 = Companion_getInstance_14().sbm_1;
    var tmp_348 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_115, true);
    var tmp_349 = KProperty1;
    tmp_347.egt_1 = tmp_348.fbm($this, getPropertyCallableRef('glShaderSource', 1, tmp_349, OpenGL$_get_glShaderSource_$ref_sd8a3a(), null));
    var tmp_350 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_116 = Companion_getInstance_14().sbm_1;
    var tmp_351 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_116, true);
    var tmp_352 = KProperty1;
    tmp_350.fgt_1 = tmp_351.fbm($this, getPropertyCallableRef('glStencilFuncSeparate', 1, tmp_352, OpenGL$_get_glStencilFuncSeparate_$ref_f9hv8t(), null));
    var tmp_353 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_117 = Companion_getInstance_14().sbm_1;
    var tmp_354 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_117, true);
    var tmp_355 = KProperty1;
    tmp_353.ggt_1 = tmp_354.fbm($this, getPropertyCallableRef('glStencilMaskSeparate', 1, tmp_355, OpenGL$_get_glStencilMaskSeparate_$ref_rm3vsr(), null));
    var tmp_356 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_118 = Companion_getInstance_14().sbm_1;
    var tmp_357 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_118, true);
    var tmp_358 = KProperty1;
    tmp_356.hgt_1 = tmp_357.fbm($this, getPropertyCallableRef('glStencilOpSeparate', 1, tmp_358, OpenGL$_get_glStencilOpSeparate_$ref_65dhkg(), null));
    var tmp_359 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_119 = Companion_getInstance_14().sbm_1;
    var tmp_360 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_119, true);
    var tmp_361 = KProperty1;
    tmp_359.igt_1 = tmp_360.fbm($this, getPropertyCallableRef('glUniform1f', 1, tmp_361, OpenGL$_get_glUniform1f_$ref_5y6rsp(), null));
    var tmp_362 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_120 = Companion_getInstance_14().sbm_1;
    var tmp_363 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_120, true);
    var tmp_364 = KProperty1;
    tmp_362.jgt_1 = tmp_363.fbm($this, getPropertyCallableRef('glUniform2f', 1, tmp_364, OpenGL$_get_glUniform2f_$ref_8q7ifc(), null));
    var tmp_365 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_121 = Companion_getInstance_14().sbm_1;
    var tmp_366 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_121, true);
    var tmp_367 = KProperty1;
    tmp_365.kgt_1 = tmp_366.fbm($this, getPropertyCallableRef('glUniform3f', 1, tmp_367, OpenGL$_get_glUniform3f_$ref_nelsnd(), null));
    var tmp_368 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_122 = Companion_getInstance_14().sbm_1;
    var tmp_369 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_122, true);
    var tmp_370 = KProperty1;
    tmp_368.lgt_1 = tmp_369.fbm($this, getPropertyCallableRef('glUniform4f', 1, tmp_370, OpenGL$_get_glUniform4f_$ref_wy3z3q(), null));
    var tmp_371 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_123 = Companion_getInstance_14().sbm_1;
    var tmp_372 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_123, true);
    var tmp_373 = KProperty1;
    tmp_371.mgt_1 = tmp_372.fbm($this, getPropertyCallableRef('glUniform1i', 1, tmp_373, OpenGL$_get_glUniform1i_$ref_4j1wm4(), null));
    var tmp_374 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_124 = Companion_getInstance_14().sbm_1;
    var tmp_375 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_124, true);
    var tmp_376 = KProperty1;
    tmp_374.ngt_1 = tmp_375.fbm($this, getPropertyCallableRef('glUniform2i', 1, tmp_376, OpenGL$_get_glUniform2i_$ref_a5cdlx(), null));
    var tmp_377 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_125 = Companion_getInstance_14().sbm_1;
    var tmp_378 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_125, true);
    var tmp_379 = KProperty1;
    tmp_377.ogt_1 = tmp_378.fbm($this, getPropertyCallableRef('glUniform3i', 1, tmp_379, OpenGL$_get_glUniform3i_$ref_otqnty(), null));
    var tmp_380 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_126 = Companion_getInstance_14().sbm_1;
    var tmp_381 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_126, true);
    var tmp_382 = KProperty1;
    tmp_380.pgt_1 = tmp_381.fbm($this, getPropertyCallableRef('glUniform4i', 1, tmp_382, OpenGL$_get_glUniform4i_$ref_viz3x5(), null));
    var tmp_383 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_127 = Companion_getInstance_14().sbm_1;
    var tmp_384 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_127, true);
    var tmp_385 = KProperty1;
    tmp_383.qgt_1 = tmp_384.fbm($this, getPropertyCallableRef('glUniform1fv', 1, tmp_385, OpenGL$_get_glUniform1fv_$ref_fi5vj7(), null));
    var tmp_386 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_128 = Companion_getInstance_14().sbm_1;
    var tmp_387 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_128, true);
    var tmp_388 = KProperty1;
    tmp_386.rgt_1 = tmp_387.fbm($this, getPropertyCallableRef('glUniform2fv', 1, tmp_388, OpenGL$_get_glUniform2fv_$ref_dbglj0(), null));
    var tmp_389 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_129 = Companion_getInstance_14().sbm_1;
    var tmp_390 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_129, true);
    var tmp_391 = KProperty1;
    tmp_389.sgt_1 = tmp_390.fbm($this, getPropertyCallableRef('glUniform3fv', 1, tmp_391, OpenGL$_get_glUniform3fv_$ref_sw0zdx(), null));
    var tmp_392 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_130 = Companion_getInstance_14().sbm_1;
    var tmp_393 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_130, true);
    var tmp_394 = KProperty1;
    tmp_392.tgt_1 = tmp_393.fbm($this, getPropertyCallableRef('glUniform4fv', 1, tmp_394, OpenGL$_get_glUniform4fv_$ref_2eibq(), null));
    var tmp_395 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_131 = Companion_getInstance_14().sbm_1;
    var tmp_396 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_131, true);
    var tmp_397 = KProperty1;
    tmp_395.ugt_1 = tmp_396.fbm($this, getPropertyCallableRef('glUniform1iv', 1, tmp_397, OpenGL$_get_glUniform1iv_$ref_sj0z4w(), null));
    var tmp_398 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_132 = Companion_getInstance_14().sbm_1;
    var tmp_399 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_132, true);
    var tmp_400 = KProperty1;
    tmp_398.vgt_1 = tmp_399.fbm($this, getPropertyCallableRef('glUniform2iv', 1, tmp_400, OpenGL$_get_glUniform2iv_$ref_dogls1(), null));
    var tmp_401 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_133 = Companion_getInstance_14().sbm_1;
    var tmp_402 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_133, true);
    var tmp_403 = KProperty1;
    tmp_401.wgt_1 = tmp_402.fbm($this, getPropertyCallableRef('glUniform3iv', 1, tmp_403, OpenGL$_get_glUniform3iv_$ref_f55va6(), null));
    var tmp_404 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_134 = Companion_getInstance_14().sbm_1;
    var tmp_405 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_134, true);
    var tmp_406 = KProperty1;
    tmp_404.xgt_1 = tmp_405.fbm($this, getPropertyCallableRef('glUniform4iv', 1, tmp_406, OpenGL$_get_glUniform4iv_$ref_r2bpmr(), null));
    var tmp_407 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_135 = Companion_getInstance_14().sbm_1;
    var tmp_408 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_135, true);
    var tmp_409 = KProperty1;
    tmp_407.ygt_1 = tmp_408.fbm($this, getPropertyCallableRef('glUniformMatrix2fv', 1, tmp_409, OpenGL$_get_glUniformMatrix2fv_$ref_y0qw9v(), null));
    var tmp_410 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_136 = Companion_getInstance_14().sbm_1;
    var tmp_411 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_136, true);
    var tmp_412 = KProperty1;
    tmp_410.zgt_1 = tmp_411.fbm($this, getPropertyCallableRef('glUniformMatrix3fv', 1, tmp_412, OpenGL$_get_glUniformMatrix3fv_$ref_574f7o(), null));
    var tmp_413 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_137 = Companion_getInstance_14().sbm_1;
    var tmp_414 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_137, true);
    var tmp_415 = KProperty1;
    tmp_413.agu_1 = tmp_414.fbm($this, getPropertyCallableRef('glUniformMatrix4fv', 1, tmp_415, OpenGL$_get_glUniformMatrix4fv_$ref_nmi1uj(), null));
    var tmp_416 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_138 = Companion_getInstance_14().sbm_1;
    var tmp_417 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_138, true);
    var tmp_418 = KProperty1;
    tmp_416.bgu_1 = tmp_417.fbm($this, getPropertyCallableRef('glUseProgram', 1, tmp_418, OpenGL$_get_glUseProgram_$ref_z5av1p(), null));
    var tmp_419 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_139 = Companion_getInstance_14().sbm_1;
    var tmp_420 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_139, true);
    var tmp_421 = KProperty1;
    tmp_419.cgu_1 = tmp_420.fbm($this, getPropertyCallableRef('glValidateProgram', 1, tmp_421, OpenGL$_get_glValidateProgram_$ref_pm5azi(), null));
    var tmp_422 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_140 = Companion_getInstance_14().sbm_1;
    var tmp_423 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_140, true);
    var tmp_424 = KProperty1;
    tmp_422.dgu_1 = tmp_423.fbm($this, getPropertyCallableRef('glVertexAttrib1f', 1, tmp_424, OpenGL$_get_glVertexAttrib1f_$ref_9y45mh(), null));
    var tmp_425 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_141 = Companion_getInstance_14().sbm_1;
    var tmp_426 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_141, true);
    var tmp_427 = KProperty1;
    tmp_425.egu_1 = tmp_426.fbm($this, getPropertyCallableRef('glVertexAttrib2f', 1, tmp_427, OpenGL$_get_glVertexAttrib2f_$ref_4qa4lk(), null));
    var tmp_428 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_142 = Companion_getInstance_14().sbm_1;
    var tmp_429 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_142, true);
    var tmp_430 = KProperty1;
    tmp_428.fgu_1 = tmp_429.fbm($this, getPropertyCallableRef('glVertexAttrib3f', 1, tmp_430, OpenGL$_get_glVertexAttrib3f_$ref_jeoetl(), null));
    var tmp_431 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_143 = Companion_getInstance_14().sbm_1;
    var tmp_432 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().pg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_143, true);
    var tmp_433 = KProperty1;
    tmp_431.ggu_1 = tmp_432.fbm($this, getPropertyCallableRef('glVertexAttrib4f', 1, tmp_433, OpenGL$_get_glVertexAttrib4f_$ref_y32p1m(), null));
    var tmp_434 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_144 = Companion_getInstance_14().sbm_1;
    var tmp_435 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_144, true);
    var tmp_436 = KProperty1;
    tmp_434.hgu_1 = tmp_435.fbm($this, getPropertyCallableRef('glVertexAttrib1fv', 1, tmp_436, OpenGL$_get_glVertexAttrib1fv_$ref_2mbbrx(), null));
    var tmp_437 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_145 = Companion_getInstance_14().sbm_1;
    var tmp_438 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_145, true);
    var tmp_439 = KProperty1;
    tmp_437.igu_1 = tmp_438.fbm($this, getPropertyCallableRef('glVertexAttrib2fv', 1, tmp_439, OpenGL$_get_glVertexAttrib2fv_$ref_vfxsu4(), null));
    var tmp_440 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_146 = Companion_getInstance_14().sbm_1;
    var tmp_441 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_146, true);
    var tmp_442 = KProperty1;
    tmp_440.jgu_1 = tmp_441.fbm($this, getPropertyCallableRef('glVertexAttrib3fv', 1, tmp_442, OpenGL$_get_glVertexAttrib3fv_$ref_arjs2t(), null));
    var tmp_443 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_147 = Companion_getInstance_14().sbm_1;
    var tmp_444 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_147, true);
    var tmp_445 = KProperty1;
    tmp_443.kgu_1 = tmp_444.fbm($this, getPropertyCallableRef('glBindBufferRange', 1, tmp_445, OpenGL$_get_glBindBufferRange_$ref_r4scc0(), null));
    var tmp_446 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_148 = Companion_getInstance_14().sbm_1;
    var tmp_447 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false))]), false), null, config_148, true);
    var tmp_448 = KProperty1;
    tmp_446.lgu_1 = tmp_447.fbm($this, getPropertyCallableRef('glGetUniformBlockIndex', 1, tmp_448, OpenGL$_get_glGetUniformBlockIndex_$ref_dpyqt5(), null));
    var tmp_449 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_149 = Companion_getInstance_14().sbm_1;
    var tmp_450 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_149, true);
    var tmp_451 = KProperty1;
    tmp_449.mgu_1 = tmp_450.fbm($this, getPropertyCallableRef('glUniformBlockBinding', 1, tmp_451, OpenGL$_get_glUniformBlockBinding_$ref_jngaho(), null));
    var tmp_452 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_150 = Companion_getInstance_14().sbm_1;
    var tmp_453 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_150, true);
    var tmp_454 = KProperty1;
    tmp_452.ngu_1 = tmp_453.fbm($this, getPropertyCallableRef('glGenVertexArrays', 1, tmp_454, OpenGL$_get_glGenVertexArrays_$ref_k7b1ku(), null));
    var tmp_455 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_151 = Companion_getInstance_14().sbm_1;
    var tmp_456 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_151, true);
    var tmp_457 = KProperty1;
    tmp_455.ogu_1 = tmp_456.fbm($this, getPropertyCallableRef('glDeleteVertexArrays', 1, tmp_457, OpenGL$_get_glDeleteVertexArrays_$ref_ghimfz(), null));
    var tmp_458 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_152 = Companion_getInstance_14().sbm_1;
    var tmp_459 = new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_152, true);
    var tmp_460 = KProperty1;
    tmp_458.pgu_1 = tmp_459.fbm($this, getPropertyCallableRef('glBindVertexArray', 1, tmp_460, OpenGL$_get_glBindVertexArray_$ref_84c148(), null));
    return $this;
  }
  agy() {
    var tmp = KProperty1;
    return this.sgo_1.zq(this, getPropertyCallableRef('glDrawArraysInstanced', 1, tmp, OpenGL$_get_glDrawArraysInstanced_$ref_u1p2u7(), null));
  }
  bgy() {
    var tmp = KProperty1;
    return this.tgo_1.zq(this, getPropertyCallableRef('glDrawElementsInstanced', 1, tmp, OpenGL$_get_glDrawElementsInstanced_$ref_ngtsf8(), null));
  }
  cgy() {
    var tmp = KProperty1;
    return this.ugo_1.zq(this, getPropertyCallableRef('glVertexAttribDivisor', 1, tmp, OpenGL$_get_glVertexAttribDivisor_$ref_e0aam8(), null));
  }
  jgy() {
    var tmp = KProperty1;
    return this.vgo_1.zq(this, getPropertyCallableRef('glTexSubImage2D', 1, tmp, OpenGL$_get_glTexSubImage2D_$ref_ot6p7g(), null));
  }
  jgx() {
    var tmp = KProperty1;
    return this.wgo_1.zq(this, getPropertyCallableRef('glTexImage2D', 1, tmp, OpenGL$_get_glTexImage2D_$ref_hd9bwc(), null));
  }
  kgx() {
    var tmp = KProperty1;
    return this.xgo_1.zq(this, getPropertyCallableRef('glTexParameteri', 1, tmp, OpenGL$_get_glTexParameteri_$ref_6ujtm1(), null));
  }
  kgy() {
    var tmp = KProperty1;
    return this.ygo_1.zq(this, getPropertyCallableRef('glTexParameterf', 1, tmp, OpenGL$_get_glTexParameterf_$ref_5feyfg(), null));
  }
  lgy() {
    var tmp = KProperty1;
    return this.zgo_1.zq(this, getPropertyCallableRef('glTexParameterfv', 1, tmp, OpenGL$_get_glTexParameterfv_$ref_hy0keg(), null));
  }
  mgy() {
    var tmp = KProperty1;
    return this.agp_1.zq(this, getPropertyCallableRef('glTexParameteriv', 1, tmp, OpenGL$_get_glTexParameteriv_$ref_q36a9n(), null));
  }
  hgx() {
    var tmp = KProperty1;
    return this.bgp_1.zq(this, getPropertyCallableRef('glStencilOp', 1, tmp, OpenGL$_get_glStencilOp_$ref_xgguj7(), null));
  }
  fgx() {
    var tmp = KProperty1;
    return this.cgp_1.zq(this, getPropertyCallableRef('glStencilMask', 1, tmp, OpenGL$_get_glStencilMask_$ref_cflgew(), null));
  }
  zgw() {
    var tmp = KProperty1;
    return this.dgp_1.zq(this, getPropertyCallableRef('glReadPixels', 1, tmp, OpenGL$_get_glReadPixels_$ref_oohu9z(), null));
  }
  dgx() {
    var tmp = KProperty1;
    return this.egp_1.zq(this, getPropertyCallableRef('glStencilFunc', 1, tmp, OpenGL$_get_glStencilFunc_$ref_e7srow(), null));
  }
  bgx() {
    var tmp = KProperty1;
    return this.fgp_1.zq(this, getPropertyCallableRef('glScissor', 1, tmp, OpenGL$_get_glScissor_$ref_e6ft78(), null));
  }
  ngy() {
    var tmp = KProperty1;
    return this.ggp_1.zq(this, getPropertyCallableRef('glPolygonOffset', 1, tmp, OpenGL$_get_glPolygonOffset_$ref_oqmkwz(), null));
  }
  ygw() {
    var tmp = KProperty1;
    return this.hgp_1.zq(this, getPropertyCallableRef('glPixelStorei', 1, tmp, OpenGL$_get_glPixelStorei_$ref_ywwdb6(), null));
  }
  ogy() {
    var tmp = KProperty1;
    return this.igp_1.zq(this, getPropertyCallableRef('glLineWidth', 1, tmp, OpenGL$_get_glLineWidth_$ref_1ljuf6(), null));
  }
  pgy() {
    var tmp = KProperty1;
    return this.jgp_1.zq(this, getPropertyCallableRef('glGetTexParameterfv', 1, tmp, OpenGL$_get_glGetTexParameterfv_$ref_gfvs8(), null));
  }
  qgy() {
    var tmp = KProperty1;
    return this.kgp_1.zq(this, getPropertyCallableRef('glGetTexParameteriv', 1, tmp, OpenGL$_get_glGetTexParameteriv_$ref_qjhbit(), null));
  }
  rgw() {
    var tmp = KProperty1;
    return this.lgp_1.zq(this, getPropertyCallableRef('glGetError', 1, tmp, OpenGL$_get_glGetError_$ref_48ki14(), null));
  }
  rgy() {
    var tmp = KProperty1;
    return this.mgp_1.zq(this, getPropertyCallableRef('glGetFloatv', 1, tmp, OpenGL$_get_glGetFloatv_$ref_qyzna8(), null));
  }
  sgw() {
    var tmp = KProperty1;
    return this.ngp_1.zq(this, getPropertyCallableRef('glGetIntegerv', 1, tmp, OpenGL$_get_glGetIntegerv_$ref_oigptu(), null));
  }
  sgy() {
    var tmp = KProperty1;
    return this.ogp_1.zq(this, getPropertyCallableRef('glGetBooleanv', 1, tmp, OpenGL$_get_glGetBooleanv_$ref_17fmss(), null));
  }
  pgw() {
    var tmp = KProperty1;
    return this.pgp_1.zq(this, getPropertyCallableRef('glGenTextures', 1, tmp, OpenGL$_get_glGenTextures_$ref_omr6fc(), null));
  }
  tgy() {
    var tmp = KProperty1;
    return this.qgp_1.zq(this, getPropertyCallableRef('glDepthRange', 1, tmp, OpenGL$_get_glDepthRange_$ref_7h8k9c(), null));
  }
  agw() {
    var tmp = KProperty1;
    return this.rgp_1.zq(this, getPropertyCallableRef('glDepthRangef', 1, tmp, OpenGL$_get_glDepthRangef_$ref_wzcry4(), null));
  }
  ugy() {
    var tmp = KProperty1;
    return this.sgp_1.zq(this, getPropertyCallableRef('glClearDepth', 1, tmp, OpenGL$_get_glClearDepth_$ref_sjvems(), null));
  }
  lgv() {
    var tmp = KProperty1;
    return this.tgp_1.zq(this, getPropertyCallableRef('glClearDepthf', 1, tmp, OpenGL$_get_glClearDepthf_$ref_izp45c(), null));
  }
  dgw() {
    var tmp = KProperty1;
    return this.ugp_1.zq(this, getPropertyCallableRef('glDrawArrays', 1, tmp, OpenGL$_get_glDrawArrays_$ref_58aslw(), null));
  }
  egw() {
    var tmp = KProperty1;
    return this.vgp_1.zq(this, getPropertyCallableRef('glDrawElements', 1, tmp, OpenGL$_get_glDrawElements_$ref_j22jw1(), null));
  }
  kgw() {
    var tmp = KProperty1;
    return this.wgp_1.zq(this, getPropertyCallableRef('glFrontFace', 1, tmp, OpenGL$_get_glFrontFace_$ref_10zhh2(), null));
  }
  vgy() {
    var tmp = KProperty1;
    return this.xgp_1.zq(this, getPropertyCallableRef('glFinish', 1, tmp, OpenGL$_get_glFinish_$ref_a9jkgn(), null));
  }
  hgw() {
    var tmp = KProperty1;
    return this.ygp_1.zq(this, getPropertyCallableRef('glFlush', 1, tmp, OpenGL$_get_glFlush_$ref_hbpd7w(), null));
  }
  fgw() {
    var tmp = KProperty1;
    return this.zgp_1.zq(this, getPropertyCallableRef('glEnable', 1, tmp, OpenGL$_get_glEnable_$ref_zdgp5z(), null));
  }
  wgy() {
    var tmp = KProperty1;
    return this.agq_1.zq(this, getPropertyCallableRef('glIsEnabled', 1, tmp, OpenGL$_get_glIsEnabled_$ref_ibwkwp(), null));
  }
  bgw() {
    var tmp = KProperty1;
    return this.bgq_1.zq(this, getPropertyCallableRef('glDisable', 1, tmp, OpenGL$_get_glDisable_$ref_hoj2m0(), null));
  }
  zgv() {
    var tmp = KProperty1;
    return this.cgq_1.zq(this, getPropertyCallableRef('glDepthMask', 1, tmp, OpenGL$_get_glDepthMask_$ref_tykd6n(), null));
  }
  ygv() {
    var tmp = KProperty1;
    return this.dgq_1.zq(this, getPropertyCallableRef('glDepthFunc', 1, tmp, OpenGL$_get_glDepthFunc_$ref_vqrogn(), null));
  }
  xgv() {
    var tmp = KProperty1;
    return this.egq_1.zq(this, getPropertyCallableRef('glDeleteTextures', 1, tmp, OpenGL$_get_glDeleteTextures_$ref_vpf7h5(), null));
  }
  rgv() {
    var tmp = KProperty1;
    return this.fgq_1.zq(this, getPropertyCallableRef('glCullFace', 1, tmp, OpenGL$_get_glCullFace_$ref_lyfha3(), null));
  }
  xgy() {
    var tmp = KProperty1;
    return this.ggq_1.zq(this, getPropertyCallableRef('glCopyTexImage2D', 1, tmp, OpenGL$_get_glCopyTexImage2D_$ref_12iy8f(), null));
  }
  ygy() {
    var tmp = KProperty1;
    return this.hgq_1.zq(this, getPropertyCallableRef('glCopyTexSubImage2D', 1, tmp, OpenGL$_get_glCopyTexSubImage2D_$ref_r7972n(), null));
  }
  ngv() {
    var tmp = KProperty1;
    return this.igq_1.zq(this, getPropertyCallableRef('glColorMask', 1, tmp, OpenGL$_get_glColorMask_$ref_xlmwdb(), null));
  }
  mgv() {
    var tmp = KProperty1;
    return this.jgq_1.zq(this, getPropertyCallableRef('glClearStencil', 1, tmp, OpenGL$_get_glClearStencil_$ref_cyn4zp(), null));
  }
  kgv() {
    var tmp = KProperty1;
    return this.kgq_1.zq(this, getPropertyCallableRef('glClearColor', 1, tmp, OpenGL$_get_glClearColor_$ref_ovlm18(), null));
  }
  jgv() {
    var tmp = KProperty1;
    return this.lgq_1.zq(this, getPropertyCallableRef('glClear', 1, tmp, OpenGL$_get_glClear_$ref_gr5car(), null));
  }
  egv() {
    var tmp = KProperty1;
    return this.mgq_1.zq(this, getPropertyCallableRef('glBindTexture', 1, tmp, OpenGL$_get_glBindTexture_$ref_ikazn2(), null));
  }
  zgy() {
    var tmp = KProperty1;
    return this.ngq_1.zq(this, getPropertyCallableRef('glHint', 1, tmp, OpenGL$_get_glHint_$ref_o1skrn(), null));
  }
  zgx() {
    var tmp = KProperty1;
    return this.ogq_1.zq(this, getPropertyCallableRef('glViewport', 1, tmp, OpenGL$_get_glViewport_$ref_jzsdt0(), null));
  }
  wgw() {
    var tmp = KProperty1;
    return this.pgq_1.zq(this, getPropertyCallableRef('glGetString', 1, tmp, OpenGL$_get_glGetString_$ref_fj04nd(), null));
  }
  agz() {
    var tmp = KProperty1;
    return this.qgq_1.zq(this, getPropertyCallableRef('glGetStringi', 1, tmp, OpenGL$_get_glGetStringi_$ref_4v6he0(), null));
  }
  ygx() {
    var tmp = KProperty1;
    return this.rgq_1.zq(this, getPropertyCallableRef('glVertexAttribPointer', 1, tmp, OpenGL$_get_glVertexAttribPointer_$ref_8ozh8f(), null));
  }
  bgz() {
    var tmp = KProperty1;
    return this.sgq_1.zq(this, getPropertyCallableRef('glVertexAttrib4fv', 1, tmp, OpenGL$_get_glVertexAttrib4fv_$ref_i22oze(), null));
  }
  ygu() {
    var tmp = KProperty1;
    return this.tgq_1.zq(this, getPropertyCallableRef('glActiveTexture', 1, tmp, OpenGL$_get_glActiveTexture_$ref_6v6wm3(), null));
  }
  zgu() {
    var tmp = KProperty1;
    return this.ugq_1.zq(this, getPropertyCallableRef('glAttachShader', 1, tmp, OpenGL$_get_glAttachShader_$ref_5wudxc(), null));
  }
  agv() {
    var tmp = KProperty1;
    return this.vgq_1.zq(this, getPropertyCallableRef('glBindAttribLocation', 1, tmp, OpenGL$_get_glBindAttribLocation_$ref_dl103y(), null));
  }
  bgv() {
    var tmp = KProperty1;
    return this.wgq_1.zq(this, getPropertyCallableRef('glBindBuffer', 1, tmp, OpenGL$_get_glBindBuffer_$ref_esyx8t(), null));
  }
  cgv() {
    var tmp = KProperty1;
    return this.xgq_1.zq(this, getPropertyCallableRef('glBindFramebuffer', 1, tmp, OpenGL$_get_glBindFramebuffer_$ref_ravdz4(), null));
  }
  dgv() {
    var tmp = KProperty1;
    return this.ygq_1.zq(this, getPropertyCallableRef('glBindRenderbuffer', 1, tmp, OpenGL$_get_glBindRenderbuffer_$ref_aricg9(), null));
  }
  cgz() {
    var tmp = KProperty1;
    return this.zgq_1.zq(this, getPropertyCallableRef('glBlendColor', 1, tmp, OpenGL$_get_glBlendColor_$ref_w6qdhk(), null));
  }
  dgz() {
    var tmp = KProperty1;
    return this.agr_1.zq(this, getPropertyCallableRef('glBlendEquation', 1, tmp, OpenGL$_get_glBlendEquation_$ref_oeso43(), null));
  }
  fgv() {
    var tmp = KProperty1;
    return this.bgr_1.zq(this, getPropertyCallableRef('glBlendEquationSeparate', 1, tmp, OpenGL$_get_glBlendEquationSeparate_$ref_r5jrrk(), null));
  }
  egz() {
    var tmp = KProperty1;
    return this.cgr_1.zq(this, getPropertyCallableRef('glBlendFunc', 1, tmp, OpenGL$_get_glBlendFunc_$ref_n80uw5(), null));
  }
  ggv() {
    var tmp = KProperty1;
    return this.dgr_1.zq(this, getPropertyCallableRef('glBlendFuncSeparate', 1, tmp, OpenGL$_get_glBlendFuncSeparate_$ref_bapj9k(), null));
  }
  hgv() {
    var tmp = KProperty1;
    return this.egr_1.zq(this, getPropertyCallableRef('glBufferData', 1, tmp, OpenGL$_get_glBufferData_$ref_bi09ts(), null));
  }
  igv() {
    var tmp = KProperty1;
    return this.fgr_1.zq(this, getPropertyCallableRef('glBufferSubData', 1, tmp, OpenGL$_get_glBufferSubData_$ref_ypz5y(), null));
  }
  fgz() {
    var tmp = KProperty1;
    return this.ggr_1.zq(this, getPropertyCallableRef('glCheckFramebufferStatus', 1, tmp, OpenGL$_get_glCheckFramebufferStatus_$ref_n8hay5(), null));
  }
  ogv() {
    var tmp = KProperty1;
    return this.hgr_1.zq(this, getPropertyCallableRef('glCompileShader', 1, tmp, OpenGL$_get_glCompileShader_$ref_1vlby0(), null));
  }
  ggz() {
    var tmp = KProperty1;
    return this.igr_1.zq(this, getPropertyCallableRef('glCompressedTexImage2D', 1, tmp, OpenGL$_get_glCompressedTexImage2D_$ref_6a7ukj(), null));
  }
  hgz() {
    var tmp = KProperty1;
    return this.jgr_1.zq(this, getPropertyCallableRef('glCompressedTexSubImage2D', 1, tmp, OpenGL$_get_glCompressedTexSubImage2D_$ref_j9i56l(), null));
  }
  pgv() {
    var tmp = KProperty1;
    return this.kgr_1.zq(this, getPropertyCallableRef('glCreateProgram', 1, tmp, OpenGL$_get_glCreateProgram_$ref_fbgki0(), null));
  }
  qgv() {
    var tmp = KProperty1;
    return this.lgr_1.zq(this, getPropertyCallableRef('glCreateShader', 1, tmp, OpenGL$_get_glCreateShader_$ref_j1n6qx(), null));
  }
  sgv() {
    var tmp = KProperty1;
    return this.mgr_1.zq(this, getPropertyCallableRef('glDeleteBuffers', 1, tmp, OpenGL$_get_glDeleteBuffers_$ref_7jx1zs(), null));
  }
  tgv() {
    var tmp = KProperty1;
    return this.ngr_1.zq(this, getPropertyCallableRef('glDeleteFramebuffers', 1, tmp, OpenGL$_get_glDeleteFramebuffers_$ref_s5tsqh(), null));
  }
  ugv() {
    var tmp = KProperty1;
    return this.ogr_1.zq(this, getPropertyCallableRef('glDeleteProgram', 1, tmp, OpenGL$_get_glDeleteProgram_$ref_wmd3hz(), null));
  }
  vgv() {
    var tmp = KProperty1;
    return this.pgr_1.zq(this, getPropertyCallableRef('glDeleteRenderbuffers', 1, tmp, OpenGL$_get_glDeleteRenderbuffers_$ref_fnagu6(), null));
  }
  wgv() {
    var tmp = KProperty1;
    return this.qgr_1.zq(this, getPropertyCallableRef('glDeleteShader', 1, tmp, OpenGL$_get_glDeleteShader_$ref_85at3u(), null));
  }
  igz() {
    var tmp = KProperty1;
    return this.rgr_1.zq(this, getPropertyCallableRef('glDetachShader', 1, tmp, OpenGL$_get_glDetachShader_$ref_p7me4u(), null));
  }
  cgw() {
    var tmp = KProperty1;
    return this.sgr_1.zq(this, getPropertyCallableRef('glDisableVertexAttribArray', 1, tmp, OpenGL$_get_glDisableVertexAttribArray_$ref_canr21(), null));
  }
  ggw() {
    var tmp = KProperty1;
    return this.tgr_1.zq(this, getPropertyCallableRef('glEnableVertexAttribArray', 1, tmp, OpenGL$_get_glEnableVertexAttribArray_$ref_mrvgzs(), null));
  }
  igw() {
    var tmp = KProperty1;
    return this.ugr_1.zq(this, getPropertyCallableRef('glFramebufferRenderbuffer', 1, tmp, OpenGL$_get_glFramebufferRenderbuffer_$ref_hhwykz(), null));
  }
  jgw() {
    var tmp = KProperty1;
    return this.vgr_1.zq(this, getPropertyCallableRef('glFramebufferTexture2D', 1, tmp, OpenGL$_get_glFramebufferTexture2D_$ref_g6yiuu(), null));
  }
  lgw() {
    var tmp = KProperty1;
    return this.wgr_1.zq(this, getPropertyCallableRef('glGenBuffers', 1, tmp, OpenGL$_get_glGenBuffers_$ref_3fgg4n(), null));
  }
  mgw() {
    var tmp = KProperty1;
    return this.xgr_1.zq(this, getPropertyCallableRef('glGenerateMipmap', 1, tmp, OpenGL$_get_glGenerateMipmap_$ref_75ep0z(), null));
  }
  ngw() {
    var tmp = KProperty1;
    return this.ygr_1.zq(this, getPropertyCallableRef('glGenFramebuffers', 1, tmp, OpenGL$_get_glGenFramebuffers_$ref_og1dlm(), null));
  }
  ogw() {
    var tmp = KProperty1;
    return this.zgr_1.zq(this, getPropertyCallableRef('glGenRenderbuffers', 1, tmp, OpenGL$_get_glGenRenderbuffers_$ref_sj2idf(), null));
  }
  jgz() {
    var tmp = KProperty1;
    return this.ags_1.zq(this, getPropertyCallableRef('glGetActiveAttrib', 1, tmp, OpenGL$_get_glGetActiveAttrib_$ref_hic01i(), null));
  }
  kgz() {
    var tmp = KProperty1;
    return this.bgs_1.zq(this, getPropertyCallableRef('glGetActiveUniform', 1, tmp, OpenGL$_get_glGetActiveUniform_$ref_5ujg6q(), null));
  }
  lgz() {
    var tmp = KProperty1;
    return this.cgs_1.zq(this, getPropertyCallableRef('glGetAttachedShaders', 1, tmp, OpenGL$_get_glGetAttachedShaders_$ref_tulvfa(), null));
  }
  mgz() {
    var tmp = KProperty1;
    return this.dgs_1.zq(this, getPropertyCallableRef('glGetAttribLocation', 1, tmp, OpenGL$_get_glGetAttribLocation_$ref_lv3vph(), null));
  }
  qgw() {
    var tmp = KProperty1;
    return this.egs_1.zq(this, getPropertyCallableRef('glGetUniformLocation', 1, tmp, OpenGL$_get_glGetUniformLocation_$ref_fup42x(), null));
  }
  ngz() {
    var tmp = KProperty1;
    return this.fgs_1.zq(this, getPropertyCallableRef('glGetBufferParameteriv', 1, tmp, OpenGL$_get_glGetBufferParameteriv_$ref_xxl2a2(), null));
  }
  ogz() {
    var tmp = KProperty1;
    return this.ggs_1.zq(this, getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, tmp, OpenGL$_get_glGetFramebufferAttachmentParameteriv_$ref_sjmcxg(), null));
  }
  pgz() {
    var tmp = KProperty1;
    return this.hgs_1.zq(this, getPropertyCallableRef('glGetProgramInfoLog', 1, tmp, OpenGL$_get_glGetProgramInfoLog_$ref_js6e94(), null));
  }
  qgz() {
    var tmp = KProperty1;
    return this.igs_1.zq(this, getPropertyCallableRef('glGetRenderbufferParameteriv', 1, tmp, OpenGL$_get_glGetRenderbufferParameteriv_$ref_r8jfj4(), null));
  }
  tgw() {
    var tmp = KProperty1;
    return this.jgs_1.zq(this, getPropertyCallableRef('glGetProgramiv', 1, tmp, OpenGL$_get_glGetProgramiv_$ref_wgrcbz(), null));
  }
  ugw() {
    var tmp = KProperty1;
    return this.kgs_1.zq(this, getPropertyCallableRef('glGetShaderiv', 1, tmp, OpenGL$_get_glGetShaderiv_$ref_iwrqoo(), null));
  }
  vgw() {
    var tmp = KProperty1;
    return this.lgs_1.zq(this, getPropertyCallableRef('glGetShaderInfoLog', 1, tmp, OpenGL$_get_glGetShaderInfoLog_$ref_fszgwf(), null));
  }
  rgz() {
    var tmp = KProperty1;
    return this.mgs_1.zq(this, getPropertyCallableRef('glGetShaderPrecisionFormat', 1, tmp, OpenGL$_get_glGetShaderPrecisionFormat_$ref_jq4d3k(), null));
  }
  sgz() {
    var tmp = KProperty1;
    return this.ngs_1.zq(this, getPropertyCallableRef('glGetShaderSource', 1, tmp, OpenGL$_get_glGetShaderSource_$ref_pj8uze(), null));
  }
  tgz() {
    var tmp = KProperty1;
    return this.ogs_1.zq(this, getPropertyCallableRef('glGetUniformfv', 1, tmp, OpenGL$_get_glGetUniformfv_$ref_i91n0k(), null));
  }
  ugz() {
    var tmp = KProperty1;
    return this.pgs_1.zq(this, getPropertyCallableRef('glGetUniformiv', 1, tmp, OpenGL$_get_glGetUniformiv_$ref_ps57nj(), null));
  }
  vgz() {
    var tmp = KProperty1;
    return this.qgs_1.zq(this, getPropertyCallableRef('glGetVertexAttribfv', 1, tmp, OpenGL$_get_glGetVertexAttribfv_$ref_cluoyk(), null));
  }
  wgz() {
    var tmp = KProperty1;
    return this.rgs_1.zq(this, getPropertyCallableRef('glGetVertexAttribiv', 1, tmp, OpenGL$_get_glGetVertexAttribiv_$ref_ee2ich(), null));
  }
  xgz() {
    var tmp = KProperty1;
    return this.sgs_1.zq(this, getPropertyCallableRef('glGetVertexAttribPointerv', 1, tmp, OpenGL$_get_glGetVertexAttribPointerv_$ref_dobxt9(), null));
  }
  ygz() {
    var tmp = KProperty1;
    return this.tgs_1.zq(this, getPropertyCallableRef('glIsBuffer', 1, tmp, OpenGL$_get_glIsBuffer_$ref_4dxhq8(), null));
  }
  zgz() {
    var tmp = KProperty1;
    return this.ugs_1.zq(this, getPropertyCallableRef('glIsFramebuffer', 1, tmp, OpenGL$_get_glIsFramebuffer_$ref_44fxeb(), null));
  }
  ah0() {
    var tmp = KProperty1;
    return this.vgs_1.zq(this, getPropertyCallableRef('glIsProgram', 1, tmp, OpenGL$_get_glIsProgram_$ref_bgwnt6(), null));
  }
  bh0() {
    var tmp = KProperty1;
    return this.wgs_1.zq(this, getPropertyCallableRef('glIsRenderbuffer', 1, tmp, OpenGL$_get_glIsRenderbuffer_$ref_2jbmae(), null));
  }
  ch0() {
    var tmp = KProperty1;
    return this.xgs_1.zq(this, getPropertyCallableRef('glIsTexture', 1, tmp, OpenGL$_get_glIsTexture_$ref_dn0x8f(), null));
  }
  dh0() {
    var tmp = KProperty1;
    return this.ygs_1.zq(this, getPropertyCallableRef('glIsShader', 1, tmp, OpenGL$_get_glIsShader_$ref_blsvid(), null));
  }
  xgw() {
    var tmp = KProperty1;
    return this.zgs_1.zq(this, getPropertyCallableRef('glLinkProgram', 1, tmp, OpenGL$_get_glLinkProgram_$ref_k0e64a(), null));
  }
  eh0() {
    var tmp = KProperty1;
    return this.agt_1.zq(this, getPropertyCallableRef('glReleaseShaderCompiler', 1, tmp, OpenGL$_get_glReleaseShaderCompiler_$ref_8da41x(), null));
  }
  agx() {
    var tmp = KProperty1;
    return this.bgt_1.zq(this, getPropertyCallableRef('glRenderbufferStorage', 1, tmp, OpenGL$_get_glRenderbufferStorage_$ref_qen0i3(), null));
  }
  fh0() {
    var tmp = KProperty1;
    return this.cgt_1.zq(this, getPropertyCallableRef('glSampleCoverage', 1, tmp, OpenGL$_get_glSampleCoverage_$ref_sixmzc(), null));
  }
  gh0() {
    var tmp = KProperty1;
    return this.dgt_1.zq(this, getPropertyCallableRef('glShaderBinary', 1, tmp, OpenGL$_get_glShaderBinary_$ref_j1pcqs(), null));
  }
  cgx() {
    var tmp = KProperty1;
    return this.egt_1.zq(this, getPropertyCallableRef('glShaderSource', 1, tmp, OpenGL$_get_glShaderSource_$ref_sd8a3a(), null));
  }
  egx() {
    var tmp = KProperty1;
    return this.fgt_1.zq(this, getPropertyCallableRef('glStencilFuncSeparate', 1, tmp, OpenGL$_get_glStencilFuncSeparate_$ref_f9hv8t(), null));
  }
  ggx() {
    var tmp = KProperty1;
    return this.ggt_1.zq(this, getPropertyCallableRef('glStencilMaskSeparate', 1, tmp, OpenGL$_get_glStencilMaskSeparate_$ref_rm3vsr(), null));
  }
  igx() {
    var tmp = KProperty1;
    return this.hgt_1.zq(this, getPropertyCallableRef('glStencilOpSeparate', 1, tmp, OpenGL$_get_glStencilOpSeparate_$ref_65dhkg(), null));
  }
  hh0() {
    var tmp = KProperty1;
    return this.igt_1.zq(this, getPropertyCallableRef('glUniform1f', 1, tmp, OpenGL$_get_glUniform1f_$ref_5y6rsp(), null));
  }
  ih0() {
    var tmp = KProperty1;
    return this.jgt_1.zq(this, getPropertyCallableRef('glUniform2f', 1, tmp, OpenGL$_get_glUniform2f_$ref_8q7ifc(), null));
  }
  jh0() {
    var tmp = KProperty1;
    return this.kgt_1.zq(this, getPropertyCallableRef('glUniform3f', 1, tmp, OpenGL$_get_glUniform3f_$ref_nelsnd(), null));
  }
  kh0() {
    var tmp = KProperty1;
    return this.lgt_1.zq(this, getPropertyCallableRef('glUniform4f', 1, tmp, OpenGL$_get_glUniform4f_$ref_wy3z3q(), null));
  }
  mgx() {
    var tmp = KProperty1;
    return this.mgt_1.zq(this, getPropertyCallableRef('glUniform1i', 1, tmp, OpenGL$_get_glUniform1i_$ref_4j1wm4(), null));
  }
  lh0() {
    var tmp = KProperty1;
    return this.ngt_1.zq(this, getPropertyCallableRef('glUniform2i', 1, tmp, OpenGL$_get_glUniform2i_$ref_a5cdlx(), null));
  }
  mh0() {
    var tmp = KProperty1;
    return this.ogt_1.zq(this, getPropertyCallableRef('glUniform3i', 1, tmp, OpenGL$_get_glUniform3i_$ref_otqnty(), null));
  }
  nh0() {
    var tmp = KProperty1;
    return this.pgt_1.zq(this, getPropertyCallableRef('glUniform4i', 1, tmp, OpenGL$_get_glUniform4i_$ref_viz3x5(), null));
  }
  lgx() {
    var tmp = KProperty1;
    return this.qgt_1.zq(this, getPropertyCallableRef('glUniform1fv', 1, tmp, OpenGL$_get_glUniform1fv_$ref_fi5vj7(), null));
  }
  ogx() {
    var tmp = KProperty1;
    return this.rgt_1.zq(this, getPropertyCallableRef('glUniform2fv', 1, tmp, OpenGL$_get_glUniform2fv_$ref_dbglj0(), null));
  }
  qgx() {
    var tmp = KProperty1;
    return this.sgt_1.zq(this, getPropertyCallableRef('glUniform3fv', 1, tmp, OpenGL$_get_glUniform3fv_$ref_sw0zdx(), null));
  }
  sgx() {
    var tmp = KProperty1;
    return this.tgt_1.zq(this, getPropertyCallableRef('glUniform4fv', 1, tmp, OpenGL$_get_glUniform4fv_$ref_2eibq(), null));
  }
  ngx() {
    var tmp = KProperty1;
    return this.ugt_1.zq(this, getPropertyCallableRef('glUniform1iv', 1, tmp, OpenGL$_get_glUniform1iv_$ref_sj0z4w(), null));
  }
  pgx() {
    var tmp = KProperty1;
    return this.vgt_1.zq(this, getPropertyCallableRef('glUniform2iv', 1, tmp, OpenGL$_get_glUniform2iv_$ref_dogls1(), null));
  }
  rgx() {
    var tmp = KProperty1;
    return this.wgt_1.zq(this, getPropertyCallableRef('glUniform3iv', 1, tmp, OpenGL$_get_glUniform3iv_$ref_f55va6(), null));
  }
  tgx() {
    var tmp = KProperty1;
    return this.xgt_1.zq(this, getPropertyCallableRef('glUniform4iv', 1, tmp, OpenGL$_get_glUniform4iv_$ref_r2bpmr(), null));
  }
  ugx() {
    var tmp = KProperty1;
    return this.ygt_1.zq(this, getPropertyCallableRef('glUniformMatrix2fv', 1, tmp, OpenGL$_get_glUniformMatrix2fv_$ref_y0qw9v(), null));
  }
  vgx() {
    var tmp = KProperty1;
    return this.zgt_1.zq(this, getPropertyCallableRef('glUniformMatrix3fv', 1, tmp, OpenGL$_get_glUniformMatrix3fv_$ref_574f7o(), null));
  }
  wgx() {
    var tmp = KProperty1;
    return this.agu_1.zq(this, getPropertyCallableRef('glUniformMatrix4fv', 1, tmp, OpenGL$_get_glUniformMatrix4fv_$ref_nmi1uj(), null));
  }
  xgx() {
    var tmp = KProperty1;
    return this.bgu_1.zq(this, getPropertyCallableRef('glUseProgram', 1, tmp, OpenGL$_get_glUseProgram_$ref_z5av1p(), null));
  }
  oh0() {
    var tmp = KProperty1;
    return this.cgu_1.zq(this, getPropertyCallableRef('glValidateProgram', 1, tmp, OpenGL$_get_glValidateProgram_$ref_pm5azi(), null));
  }
  ph0() {
    var tmp = KProperty1;
    return this.dgu_1.zq(this, getPropertyCallableRef('glVertexAttrib1f', 1, tmp, OpenGL$_get_glVertexAttrib1f_$ref_9y45mh(), null));
  }
  qh0() {
    var tmp = KProperty1;
    return this.egu_1.zq(this, getPropertyCallableRef('glVertexAttrib2f', 1, tmp, OpenGL$_get_glVertexAttrib2f_$ref_4qa4lk(), null));
  }
  rh0() {
    var tmp = KProperty1;
    return this.fgu_1.zq(this, getPropertyCallableRef('glVertexAttrib3f', 1, tmp, OpenGL$_get_glVertexAttrib3f_$ref_jeoetl(), null));
  }
  sh0() {
    var tmp = KProperty1;
    return this.ggu_1.zq(this, getPropertyCallableRef('glVertexAttrib4f', 1, tmp, OpenGL$_get_glVertexAttrib4f_$ref_y32p1m(), null));
  }
  th0() {
    var tmp = KProperty1;
    return this.hgu_1.zq(this, getPropertyCallableRef('glVertexAttrib1fv', 1, tmp, OpenGL$_get_glVertexAttrib1fv_$ref_2mbbrx(), null));
  }
  uh0() {
    var tmp = KProperty1;
    return this.igu_1.zq(this, getPropertyCallableRef('glVertexAttrib2fv', 1, tmp, OpenGL$_get_glVertexAttrib2fv_$ref_vfxsu4(), null));
  }
  vh0() {
    var tmp = KProperty1;
    return this.jgu_1.zq(this, getPropertyCallableRef('glVertexAttrib3fv', 1, tmp, OpenGL$_get_glVertexAttrib3fv_$ref_arjs2t(), null));
  }
  dgy() {
    var tmp = KProperty1;
    return this.kgu_1.zq(this, getPropertyCallableRef('glBindBufferRange', 1, tmp, OpenGL$_get_glBindBufferRange_$ref_r4scc0(), null));
  }
  egy() {
    var tmp = KProperty1;
    return this.lgu_1.zq(this, getPropertyCallableRef('glGetUniformBlockIndex', 1, tmp, OpenGL$_get_glGetUniformBlockIndex_$ref_dpyqt5(), null));
  }
  fgy() {
    var tmp = KProperty1;
    return this.mgu_1.zq(this, getPropertyCallableRef('glUniformBlockBinding', 1, tmp, OpenGL$_get_glUniformBlockBinding_$ref_jngaho(), null));
  }
  ggy() {
    var tmp = KProperty1;
    return this.ngu_1.zq(this, getPropertyCallableRef('glGenVertexArrays', 1, tmp, OpenGL$_get_glGenVertexArrays_$ref_k7b1ku(), null));
  }
  wh0() {
    var tmp = KProperty1;
    return this.ogu_1.zq(this, getPropertyCallableRef('glDeleteVertexArrays', 1, tmp, OpenGL$_get_glDeleteVertexArrays_$ref_ghimfz(), null));
  }
  hgy() {
    var tmp = KProperty1;
    return this.pgu_1.zq(this, getPropertyCallableRef('glBindVertexArray', 1, tmp, OpenGL$_get_glBindVertexArray_$ref_84c148(), null));
  }
}
class SDLGameWindow$ag$1 extends KmlGlContext {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.ah1_1 = this$0;
    super(this$0.ph3_1, new KmlGlOpenGL(), VOID, $box);
  }
  tf8() {
    var tmp = this.ah1_1.oh3_1.kgo();
    var tmp_0 = this.mf7_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), this.ah1_1.qh3_1);
  }
  vf8() {
    var tmp = this.ah1_1.oh3_1.kgo();
    var tmp_0 = this.mf7_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), null);
  }
  f7() {
    this.ah1_1.oh3_1.jgo()(this.ah1_1.qh3_1);
  }
}
class SDLGameWindow extends GameWindow {
  static vh3(size, config) {
    size = size === VOID ? Size2D.l9i(640, 480) : size;
    config = config === VOID ? Companion_getInstance_76().ogl_1 : config;
    var $this = this.ggj();
    $this.mh3_1 = size;
    $this.nh3_1 = config;
    $this.oh3_1 = SDL.mgo();
    $this.ph3_1 = $this.oh3_1.ago()($this.nh3_1.zgl_1, 805240832, 805240832, numberToInt($this.mh3_1.j9i_1), numberToInt($this.mh3_1.k9i_1), 34);
    $this.qh3_1 = $this.oh3_1.igo()($this.ph3_1);
    $this.oh3_1.ego()($this.ph3_1);
    var tmp = $this;
    tmp.rh3_1 = AGOpengl.lf7(new SDLGameWindow$ag$1($this));
    $this.sh3_1 = $this.bgk().af2_1;
    $this.th3_1 = '';
    $this.uh3_1 = CreateFFIMemory(1024);
    return $this;
  }
  bgk() {
    return this.rh3_1;
  }
  kgk(value) {
    this.th3_1 = value;
    this.oh3_1.bgo()(this.ph3_1, this.m5z());
  }
  m5z() {
    return this.th3_1;
  }
  tgk(width, height) {
    this.oh3_1.cgo()(this.ph3_1, width, height);
    this.oh3_1.dgo()(this.ph3_1, 805240832, 805240832);
  }
  wh3() {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = this.uh3_1;
    var it = get_pointer(Deno.UnsafePointer.of(this_0));
    while (this.oh3_1.ggo()(it)) {
      var type = getS32(it, 0);
      switch (type) {
        case 512:
          println('WINDOW EVENT');
          break;
        case 1024:
          println('MOUSE MOTION');
          break;
        case 1025:
          println('MOUSE DOWN');
          break;
        case 1026:
          println('MOUSE UP');
          break;
        case 256:
          this.wgk();
          break;
        default:
          println('EVENT: type=' + type);
          break;
      }
    }
    this.oh3_1.kgo()(this.ph3_1, this.qh3_1);
    this.sh3_1.uf7(1.0, 0.0, 0.0, 1.0);
    this.sh3_1.zf7(16384);
  }
  xh3() {
    this.oh3_1.lgo()(this.ph3_1);
  }
  y1v(exitCode) {
    super.y1v(exitCode);
    this.oh3_1.jgo()(this.qh3_1);
    this.oh3_1.hgo()();
  }
}
class Size3D {
  constructor(width, height, depthOrArrayLayers) {
    height = height === VOID ? 1 : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? 1 : depthOrArrayLayers;
    this.width = width;
    this.height = height;
    this.depthOrArrayLayers = depthOrArrayLayers;
  }
  xg6(_set____db54di) {
    this.width = _set____db54di;
  }
  w9z() {
    return this.width;
  }
  yg6(_set____db54di) {
    this.height = _set____db54di;
  }
  x9z() {
    return this.height;
  }
  yh3(_set____db54di) {
    this.depthOrArrayLayers = _set____db54di;
  }
  zh3() {
    return this.depthOrArrayLayers;
  }
  toArray() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.width, this.height, this.depthOrArrayLayers];
  }
  jm() {
    return this.width;
  }
  km() {
    return this.height;
  }
  fx() {
    return this.depthOrArrayLayers;
  }
  p4g(width, height, depthOrArrayLayers) {
    return new Size3D(width, height, depthOrArrayLayers);
  }
  copy(width, height, depthOrArrayLayers, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? this.depthOrArrayLayers : depthOrArrayLayers;
    return $super === VOID ? this.p4g(width, height, depthOrArrayLayers) : $super.p4g.call(this, width, height, depthOrArrayLayers);
  }
  toString() {
    return 'Size3D(width=' + this.width + ', height=' + this.height + ', depthOrArrayLayers=' + this.depthOrArrayLayers + ')';
  }
  hashCode() {
    var result = this.width;
    result = imul(result, 31) + this.height | 0;
    result = imul(result, 31) + this.depthOrArrayLayers | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size3D))
      return false;
    var tmp0_other_with_cast = other instanceof Size3D ? other : THROW_CCE();
    if (!(this.width === tmp0_other_with_cast.width))
      return false;
    if (!(this.height === tmp0_other_with_cast.height))
      return false;
    if (!(this.depthOrArrayLayers === tmp0_other_with_cast.depthOrArrayLayers))
      return false;
    return true;
  }
}
class AGOpenglFactory {
  ng5() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.eh4_1 = canvas;
    this.fh4_1 = glOpts;
    this.gh4_1 = 1;
    var tmp = this;
    var tmp_0;
    if (null == null) {
      var tmp1_safe_receiver = this.eh4_1.getContext('webgl2', this.fh4_1);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        this.gh4_1 = 2;
        tmp_1 = tmp1_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.eh4_1.getContext('webgl', this.fh4_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.eh4_1.getContext('experimental-webgl', this.fh4_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      println('Created WebGL version=' + this.gh4_1 + ', opts=' + JSON.stringify(this.fh4_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      try {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp_5 = document.createElement('div');
          // Inline function 'kotlin.apply' call
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      // Inline function 'kotlin.error' call
      var message = "Can't get webgl context";
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.hh4_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.ih4_1 = Array(8192);
    this.jh4_1 = toMutableList(reversed_0(until(1, this.ih4_1.length)));
    var tmp_7 = this;
    tmp_7.kh4_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.lh4_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.mh4_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.nh4_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  wf6() {
    return Companion_instance_55.hfe(this.gh4_1);
  }
  vf6(texture) {
    return this.hh4_1.activeTexture(texture);
  }
  bfb(program, shader) {
    return this.hh4_1.attachShader(get_5(this, program), get_5(this, shader));
  }
  afb(program, index, name) {
    return this.hh4_1.bindAttribLocation(get_5(this, program), index, name);
  }
  pf5(target, buffer) {
    return this.hh4_1.bindBuffer(target, get_5(this, buffer));
  }
  tf9(target, framebuffer) {
    return this.hh4_1.bindFramebuffer(target, get_5(this, framebuffer));
  }
  afa(target, renderbuffer) {
    return this.hh4_1.bindRenderbuffer(target, get_5(this, renderbuffer));
  }
  rf9(target, texture) {
    return this.hh4_1.bindTexture(target, get_5(this, texture));
  }
  df8(modeRGB, modeAlpha) {
    return this.hh4_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  ef8(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.hh4_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  zf6(target, size, data, usage) {
    return this.hh4_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  yf6(target, offset, size, data) {
    return this.hh4_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  zf7(mask) {
    return this.hh4_1.clear(mask);
  }
  uf7(red, green, blue, alpha) {
    return this.hh4_1.clearColor(red, green, blue, alpha);
  }
  wf7(d) {
    return this.hh4_1.clearDepth(d);
  }
  yf7(s) {
    return this.hh4_1.clearStencil(s);
  }
  hfa(red, green, blue, alpha) {
    return this.hh4_1.colorMask(red, green, blue, alpha);
  }
  sfa(shader) {
    return this.hh4_1.compileShader(get_5(this, shader));
  }
  ufa() {
    return alloc(this, this.hh4_1.createProgram());
  }
  qfa(type) {
    return alloc(this, this.hh4_1.createShader(type));
  }
  wf8(mode) {
    return this.hh4_1.cullFace(mode);
  }
  rfz(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = get_arrayInt(items)[p];
        this.hh4_1.deleteBuffer(free(this, tmp$ret$0));
      }
       while (inductionVariable < n);
  }
  sfz(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = get_arrayInt(items)[p];
        this.hh4_1.deleteFramebuffer(free(this, tmp$ret$0));
      }
       while (inductionVariable < n);
  }
  pfa(program) {
    return this.hh4_1.deleteProgram(get_5(this, program));
  }
  tfz(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = get_arrayInt(items)[p];
        this.hh4_1.deleteRenderbuffer(free(this, tmp$ret$0));
      }
       while (inductionVariable < n);
  }
  ofa(shader) {
    return this.hh4_1.deleteShader(get_5(this, shader));
  }
  ufz(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = get_arrayInt(items)[p];
        this.hh4_1.deleteTexture(free(this, tmp$ret$0));
      }
       while (inductionVariable < n);
  }
  gfa(func) {
    return this.hh4_1.depthFunc(func);
  }
  vf7(flag) {
    return this.hh4_1.depthMask(flag);
  }
  ffa(n, f) {
    return this.hh4_1.depthRange(n, f);
  }
  if8(cap) {
    return this.hh4_1.disable(cap);
  }
  yf8(index) {
    return this.hh4_1.disableVertexAttribArray(index);
  }
  pf8(mode, first, count) {
    return this.hh4_1.drawArrays(mode, first, count);
  }
  rf8(mode, count, type, indices) {
    return this.hh4_1.drawElements(mode, count, type, indices);
  }
  jf8(cap) {
    return this.hh4_1.enable(cap);
  }
  cf9(index) {
    return this.hh4_1.enableVertexAttribArray(index);
  }
  nd() {
    return this.hh4_1.flush();
  }
  dfa(target, attachment, renderbuffertarget, renderbuffer) {
    return this.hh4_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_5(this, renderbuffer));
  }
  cfa(target, attachment, textarget, texture, level) {
    return this.hh4_1.framebufferTexture2D(target, attachment, textarget, get_5(this, texture), level);
  }
  efa(mode) {
    return this.hh4_1.frontFace(mode);
  }
  vfz(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this, this.hh4_1.createBuffer());
      }
       while (inductionVariable < n);
  }
  df7(target) {
    return this.hh4_1.generateMipmap(target);
  }
  wfz(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this, this.hh4_1.createFramebuffer());
      }
       while (inductionVariable < n);
  }
  xfz(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this, this.hh4_1.createRenderbuffer());
      }
       while (inductionVariable < n);
  }
  yfz(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this, this.hh4_1.createTexture());
      }
       while (inductionVariable < n);
  }
  mfa(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_5(this, program);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this, this.hh4_1.getUniformLocation(prg, name));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  tfa() {
    return this.hh4_1.getError();
  }
  zfz(pname, data) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.hh4_1.getParameter(pname);
  }
  ag0(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      var tmp0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.hh4_1.getProgramInfoLog(get_5(this, program));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.hh4_1.getProgramParameter(get_5(this, program), pname);
    }
  }
  bg0(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      var tmp0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.hh4_1.getShaderInfoLog(get_5(this, shader));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.hh4_1.getShaderParameter(get_5(this, shader), pname);
    }
  }
  cg0(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.hh4_1.getShaderInfoLog(get_5(this, shader));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  kf3(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.hh4_1.getParameter(name);
  }
  cfb(program) {
    return this.hh4_1.linkProgram(get_5(this, program));
  }
  af7(pname, param) {
    return this.hh4_1.pixelStorei(pname, param);
  }
  qf9(x, y, width, height, format, type, pixels) {
    return this.hh4_1.readPixels(x, y, width, height, format, type, get_arrayUByte(pixels));
  }
  bfa(target, internalformat, width, height) {
    return this.hh4_1.renderbufferStorage(target, internalformat, width, height);
  }
  ifa(x, y, width, height) {
    return this.hh4_1.scissor(x, y, width, height);
  }
  rfa(shader, string) {
    return this.hh4_1.shaderSource(get_5(this, shader), string);
  }
  lf8(func, ref, mask) {
    return this.hh4_1.stencilFunc(func, ref, mask);
  }
  kf8(face, func, ref, mask) {
    return this.hh4_1.stencilFuncSeparate(face, func, ref, mask);
  }
  xf7(mask) {
    return this.hh4_1.stencilMask(mask);
  }
  of8(face, mask) {
    return this.hh4_1.stencilMaskSeparate(face, mask);
  }
  nf8(fail, zfail, zpass) {
    return this.hh4_1.stencilOp(fail, zfail, zpass);
  }
  mf8(face, sfail, dpfail, dppass) {
    return this.hh4_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  bf7(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.hh4_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  cf7(target, level, internalformat, format, type, data) {
    if (data instanceof HtmlNativeImage) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = !data.zc1_1 && data.yc1_1 ? 1 : 0;
      this.hh4_1.pixelStorei(37441, tmp$ret$0);
      this.hh4_1.texImage2D(target, level, internalformat, format, type, data.fdu_1);
      this.hh4_1.pixelStorei(37441, 0);
    } else {
      return super.cf7(target, level, internalformat, format, type, data);
    }
  }
  uf6(target, pname, param) {
    return this.hh4_1.texParameteri(target, pname, param);
  }
  qf6(location, count, value) {
    return this.hh4_1.uniform1fv(get_5(this, location), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  of4(location, v0) {
    return this.hh4_1.uniform1i(get_5(this, location), v0);
  }
  jf6(location, count, value) {
    return this.hh4_1.uniform1iv(get_5(this, location), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  rf6(location, count, value) {
    return this.hh4_1.uniform2fv(get_5(this, location), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  kf6(location, count, value) {
    return this.hh4_1.uniform2iv(get_5(this, location), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  sf6(location, count, value) {
    return this.hh4_1.uniform3fv(get_5(this, location), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  lf6(location, count, value) {
    return this.hh4_1.uniform3iv(get_5(this, location), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  tf6(location, count, value) {
    return this.hh4_1.uniform4fv(get_5(this, location), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  mf6(location, count, value) {
    return this.hh4_1.uniform4iv(get_5(this, location), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  nf6(location, count, transpose, value) {
    return this.hh4_1.uniformMatrix2fv(get_5(this, location), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  of6(location, count, transpose, value) {
    return this.hh4_1.uniformMatrix3fv(get_5(this, location), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  pf6(location, count, transpose, value) {
    return this.hh4_1.uniformMatrix4fv(get_5(this, location), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  nfa(program) {
    return this.hh4_1.useProgram(get_5(this, program));
  }
  df9(index, size, type, normalized, stride, pointer) {
    return this.hh4_1.vertexAttribPointer(index, size, type, normalized, stride, convertToInt(pointer));
  }
  sf9(x, y, width, height) {
    return this.hh4_1.viewport(x, y, width, height);
  }
  g81() {
    var tmp0 = this.kh4_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('extensions', 1, tmp, KmlGlJsCanvas$_get_extensions_$ref_uojgl6(), null);
    return tmp0.k3();
  }
  qf8(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.hh4_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  sf8(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.hh4_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  xf8(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.hh4_1.vertexAttribDivisor(index, divisor);
  }
  heh() {
    return get_versionInt(this) >= 2;
  }
  kf9(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.hh4_1.bindBufferRange(target, index, get_5(this, buffer), offset, size);
  }
  pf4(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.hh4_1.getUniformBlockIndex(get_5(this, program), name);
  }
  qf4(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.hh4_1.uniformBlockBinding(get_5(this, program), uniformBlockIndex, uniformBlockBinding);
  }
  ieh() {
    return this.nh4_1.vh4();
  }
  dg0(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$1 = this.hh4_1.createVertexArray();
        setInt32(arrays, i, alloc(this, tmp$ret$1));
      }
       while (inductionVariable < n);
  }
  zf8(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.hh4_1.bindVertexArray(get_5(this, array));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.oh4_1 = canvas;
    this.ph4_1 = name;
    this.qh4_1 = coreSince;
    this.rh4_1 = functions;
    this.sh4_1 = suffix;
    this.th4_1 = false;
    this.uh4_1 = null;
  }
  k3() {
    if (!this.th4_1) {
      this.th4_1 = true;
      this.uh4_1 = this.oh4_1.hh4_1.getExtension(this.ph4_1);
      var _iterator__ex2g4s = this.rh4_1.p1();
      while (_iterator__ex2g4s.q1()) {
        var func = _iterator__ex2g4s.r1();
        var base = removeSuffix(func, this.sh4_1);
        var vfunc = this.uh4_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.oh4_1.hh4_1[base] = vfunc.bind(this.uh4_1);
        }
      }
    }
    return this.uh4_1;
  }
  vh4() {
    return this.oh4_1.gh4_1 >= this.qh4_1 || this.k3() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class JsGameWindow extends GameWindow {
  static phf() {
    return this.ggj();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  constructor() {
    return new.target.iha();
  }
  static iha() {
    return this.phf();
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  constructor(canvas) {
    return new.target.wh7(canvas);
  }
  static wh7(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.phf();
    $this.hh7_1 = canvas;
    $this.ih7_1 = AGWebgl(new AGConfig(), $this.hh7_1);
    $this.jh7_1 = new DialogInterfaceJs();
    $this.kh7_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.lh7_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.mh7_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.nh7_1 = new GamepadInfo();
    $this.oh7_1 = Quality_AUTOMATIC_getInstance();
    $this.ph7_1 = 1.0;
    $this.qh7_1 = new TouchBuilder();
    $this.rh7_1 = Cursor_DEFAULT_getInstance();
    $this.sh7_1 = null;
    $this.th7_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.hh7_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.bgk();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.bgk().af2_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($this.hh7_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.hh7_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.hh7_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.hh7_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.hh7_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.hh7_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.hh7_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.hh7_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.hh7_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.hh7_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.hh7_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.hh7_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.hh7_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.hh7_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.hh7_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.hh7_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.hh7_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.hh7_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.hh7_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.hh7_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.uh7_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.vh7_1 = null;
    return $this;
  }
  rhf() {
    return window.devicePixelRatio;
  }
  wgc() {
    return this.rhf() <= 0.0 ? 1.0 : isNaN_0(this.rhf()) ? 1.0 : isInfinite(this.rhf()) ? 1.0 : this.rhf();
  }
  bgk() {
    return this.ih7_1;
  }
  qhf() {
    if (this.kh7_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.kh7_1 = tmp_0;
    }
    return ensureNotNull(this.kh7_1);
  }
  hgl() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.nee();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.nh7_1;
            gamepad.ied_1 = controller.id;
            var inductionVariable_0 = 0;
            var tmp0 = controller.buttons.length;
            // Inline function 'kotlin.math.min' call
            var b = this.lh7_1.length;
            var last_0 = Math.min(tmp0, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.jed_1;
                var tmp_1 = this.lh7_1[n].yed();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            var tmp0_0 = controller.axes.length;
            // Inline function 'kotlin.math.min' call
            var b_0 = this.mh7_1.length;
            var last_1 = Math.min(tmp0_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_25.sed(value, VOID, n_0 <= 3);
                gamepad.jed_1[this.mh7_1[n_0].yed()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.oee(gamepad);
          }
           while (inductionVariable < last);
        this.lgl();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var tmp0_1 = CoroutineKey_getInstance().hgg_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level = Level_ERROR_getInstance();
      if (tmp0_1.obj(level)) {
        tmp0_1.pbj(level, e);
      }
    }
  }
  qgk(value) {
    if (!this.oh7_1.equals(value)) {
      this.oh7_1 = value;
      onResized(this);
    }
  }
  fgc() {
    return this.oh7_1;
  }
  kgk(value) {
    document.title = value;
  }
  w9z() {
    return this.hh7_1.clientWidth;
  }
  x9z() {
    return this.hh7_1.clientHeight;
  }
  zgj(value) {
    this.rh7_1 = value;
    var tmp = this.hh7_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.w1_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  agk() {
    return this.rh7_1;
  }
  lgk(value) {
    this.sh7_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).tdu();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  }
  mgk(value) {
    if (!(this.shf() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        var tmp_0;
        if (value) {
          tmp_0 = this.hh7_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        // Inline function 'kotlin.Companion.success' call
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  shf() {
    return !(document.fullscreenElement == null);
  }
  ngk(value) {
    this.hh7_1.style.visibility = value ? 'visible' : 'hidden';
  }
  tgk(width, height) {
  }
  y1v(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda(this));
    this.th7_1 = null;
  }
  *ygk(entry, $completion) {
    var tmp = this;
    var tmp_0 = yield* this.egk($completion);
    tmp.th7_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda(entry, this));
    _get_jsFrame__gugpar(this)(0.0);
    return Unit_instance;
  }
  *mgl(data, $completion) {
    try {
      var tmp = _get_navigatorClipboard__ni2gks(this);
      tmp.writeText((data instanceof TextClipboardData ? data : THROW_CCE()).dgm_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        console.error('Failed to write to clipboard: ' + e.message);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  *ngl($completion) {
    var text = yield* await_0(_get_navigatorClipboard__ni2gks(this).readText(), $completion);
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(text) > 0) {
      tmp = new TextClipboardData(text);
    } else {
      tmp = null;
    }
    return tmp;
  }
  vgj(windowRect) {
    ensureSoftKeyboardInput(this);
    var tmp0_safe_receiver = this.vh7_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.style;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp1_safe_receiver.left = '' + windowRect.v9h() / this.ph7_1 + 'px';
      tmp1_safe_receiver.top = '' + (windowRect.x9h() / this.ph7_1 - 16) + 'px';
      tmp1_safe_receiver.width = '' + windowRect.q9h_1 / this.ph7_1 + 'px';
      tmp1_safe_receiver.font = '32px Arial';
      tmp1_safe_receiver.height = '1px';
      tmp1_safe_receiver.opacity = '0';
      tmp1_safe_receiver.background = 'transparent';
      tmp1_safe_receiver.color = 'transparent';
      println('BOUNDS.setInputRectangle:' + tmp1_safe_receiver.left + ',' + tmp1_safe_receiver.top + ',' + tmp1_safe_receiver.width + ',' + tmp1_safe_receiver.height);
    }
  }
  wgj(force, config) {
    var tmp0_safe_receiver = document.body;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.appendChild(ensureNotNull(this.vh7_1));
    var tmp1_safe_receiver = this.vh7_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.focus();
    }
  }
  ygj() {
    var tmp0_safe_receiver = this.vh7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.blur();
    }
    var tmp1_safe_receiver = document.body;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.removeChild(ensureNotNull(this.vh7_1));
  }
}
class DenoJsGameWindow extends SDLGameWindow {
  constructor(size, config) {
    return new.target.dhd(size, config);
  }
  static dhd(size, config) {
    size = size === VOID ? Size2D.l9i(640, 480) : size;
    config = config === VOID ? Companion_getInstance_76().ogl_1 : config;
    return this.vh3(size, config);
  }
  *ygk(entry, $completion) {
    var tmp = yield* this.egk($completion);
    launchImmediately(tmp, DenoJsGameWindow$loop$slambda(entry, this));
    var tmp_0 = get_jsGlobalThis();
    tmp_0.setInterval(DenoJsGameWindow$loop$lambda(this), 16);
    return Unit_instance;
  }
  y1v(exitCode) {
    super.y1v(exitCode);
    Deno.exit(exitCode);
  }
}
class DialogInterfaceJs {}
//endregion
function _get_now__e6dlkr($this) {
  return $this.me6_1().ik_1;
}
function _queueAfter($this, time, interval, task) {
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  var tmp0 = $this.je6_1;
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    tmp0.n9w();
    try {
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.ke6_1) {
        $this.oe6_1.pa4(task_0);
      } else {
        Console_getInstance().vbi(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.je6_1.r9w();
      break $l$block;
    }finally {
      tmp0.p9w();
    }
  }
  return task_0;
}
function SyncPauseable$_get_paused_$ref_1oeebp(p0) {
  return constructCallableReference(() => p0.daa_1, 0, 0, 158, VOID, [p0]);
}
function SyncPauseable$_set_paused_$ref_ddu6tj(p0) {
  return constructCallableReference((p0_0) => {
    p0.eaa(p0_0);
    return Unit_instance;
  }, 1, 0, 159, VOID, [p0]);
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return () => new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.le6_1));
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.ee6(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.ie7_1 == null)
    $this.ie7_1 = FastIdentityMap();
  var tmp0_safe_receiver = $this.ie7_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_elvis_lhs = get_0(ensureNotNull($this.ie7_1), type);
    set(tmp0_safe_receiver, type, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + delta | 0);
  }
  var tmp2_safe_receiver = $this.ge7_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp2_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp0_safe_receiver = child.ie7_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp0_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      var it = v.value;
      var i = ensureNotNull(get_0(tmp0_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_8;
function Companion_getInstance_15() {
  Type_initEntries();
  if (Companion_instance_8 === VOID)
    new Companion();
  return Companion_instance_8;
}
function values() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_MAGNIFY_instance = new Type('MAGNIFY', 0);
  Type_ROTATE_instance = new Type('ROTATE', 1);
  Type_SWIPE_instance = new Type('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type('SMART_MAGNIFY', 3);
  Companion_getInstance_15();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries();
  return Type_SMART_MAGNIFY_instance;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_9;
function Companion_getInstance_16() {
  Type_initEntries_0();
  if (Companion_instance_9 === VOID)
    new Companion_0();
  return Companion_instance_9;
}
function values_0() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_UP_instance = new Type_0('UP', 0);
  Type_DOWN_instance = new Type_0('DOWN', 1);
  Type_TYPE_instance = new Type_0('TYPE', 2);
  Companion_getInstance_16();
}
function Type_UP_getInstance() {
  Type_initEntries_0();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries_0();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries_0();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_10;
function Companion_getInstance_17() {
  Type_initEntries_1();
  if (Companion_instance_10 === VOID)
    new Companion_1();
  return Companion_instance_10;
}
function values_1() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MOVE_instance = new Type_1('MOVE', 0);
  Type_DRAG_instance = new Type_1('DRAG', 1);
  Type_UP_instance_0 = new Type_1('UP', 2);
  Type_DOWN_instance_0 = new Type_1('DOWN', 3);
  Type_CLICK_instance = new Type_1('CLICK', 4);
  Type_ENTER_instance = new Type_1('ENTER', 5);
  Type_EXIT_instance = new Type_1('EXIT', 6);
  Type_SCROLL_instance = new Type_1('SCROLL', 7);
  Companion_getInstance_17();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_1();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_1();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_1();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_1();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_1();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_1();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_1();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_1();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_11;
function Companion_getInstance_18() {
  if (Companion_instance_11 === VOID)
    new Companion_2();
  return Companion_instance_11;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_12;
function Companion_getInstance_19() {
  Type_initEntries_2();
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_MOVE_instance_0 = new Type_2('MOVE', 2);
  Type_HOVER_instance = new Type_2('HOVER', 3);
  Type_UNKNOWN_instance = new Type_2('UNKNOWN', 4);
  Companion_getInstance_19();
}
var Companion_instance_13;
function Companion_getInstance_20() {
  return Companion_instance_13;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_2();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_2();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_2();
  return Type_UNKNOWN_instance;
}
var Companion_instance_14;
function Companion_getInstance_21() {
  return Companion_instance_14;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_DROP_instance;
var Companion_instance_15;
function Companion_getInstance_22() {
  Type_initEntries_3();
  if (Companion_instance_15 === VOID)
    new Companion_6();
  return Companion_instance_15;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_DROP_instance = new Type_3('DROP', 2);
  Companion_getInstance_22();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_DROP_getInstance() {
  Type_initEntries_3();
  return Type_DROP_instance;
}
var Companion_instance_16;
function Companion_getInstance_23() {
  return Companion_instance_16;
}
var Companion_instance_17;
function Companion_getInstance_24() {
  return Companion_instance_17;
}
var Companion_instance_18;
function Companion_getInstance_25() {
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_26() {
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_27() {
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
var Companion_instance_21;
function Companion_getInstance_28() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
var Companion_instance_22;
function Companion_getInstance_29() {
  return Companion_instance_22;
}
var Companion_instance_23;
function Companion_getInstance_30() {
  return Companion_instance_23;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var Companion_instance_24;
function Companion_getInstance_31() {
  return Companion_instance_24;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_25;
function Companion_getInstance_32() {
  return Companion_instance_25;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_33() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_33();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_34() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_34();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_35() {
  Key_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_35();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_29;
function Companion_getInstance_36() {
  MouseButton_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
function values_6() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_36();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var SoftKeyboardType_DEFAULT_instance;
var SoftKeyboardType_ASCII_CAPABLE_instance;
var SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance;
var SoftKeyboardType_URL_instance;
var SoftKeyboardType_NUMBER_PAD_instance;
var SoftKeyboardType_PHONE_PAD_instance;
var SoftKeyboardType_NAME_PHONE_PAD_instance;
var SoftKeyboardType_EMAIL_ADDRESS_instance;
var SoftKeyboardType_DECIMAL_PAD_instance;
var SoftKeyboardType_TWITTER_instance;
var SoftKeyboardType_WEB_SEARCH_instance;
var SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance;
var SoftKeyboardType_ALPHABET_instance;
var SoftKeyboardType_entriesInitialized;
function SoftKeyboardType_initEntries() {
  if (SoftKeyboardType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardType_entriesInitialized = true;
  SoftKeyboardType_DEFAULT_instance = new SoftKeyboardType('DEFAULT', 0);
  SoftKeyboardType_ASCII_CAPABLE_instance = new SoftKeyboardType('ASCII_CAPABLE', 1);
  SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance = new SoftKeyboardType('NUMBERS_AND_PUNCTUATION', 2);
  SoftKeyboardType_URL_instance = new SoftKeyboardType('URL', 3);
  SoftKeyboardType_NUMBER_PAD_instance = new SoftKeyboardType('NUMBER_PAD', 4);
  SoftKeyboardType_PHONE_PAD_instance = new SoftKeyboardType('PHONE_PAD', 5);
  SoftKeyboardType_NAME_PHONE_PAD_instance = new SoftKeyboardType('NAME_PHONE_PAD', 6);
  SoftKeyboardType_EMAIL_ADDRESS_instance = new SoftKeyboardType('EMAIL_ADDRESS', 7);
  SoftKeyboardType_DECIMAL_PAD_instance = new SoftKeyboardType('DECIMAL_PAD', 8);
  SoftKeyboardType_TWITTER_instance = new SoftKeyboardType('TWITTER', 9);
  SoftKeyboardType_WEB_SEARCH_instance = new SoftKeyboardType('WEB_SEARCH', 10);
  SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance = new SoftKeyboardType('ASCII_CAPABLE_NUMBER_PAD', 11);
  SoftKeyboardType_ALPHABET_instance = new SoftKeyboardType('ALPHABET', 12);
}
var SoftKeyboardReturnKeyType_DEFAULT_instance;
var SoftKeyboardReturnKeyType_GO_instance;
var SoftKeyboardReturnKeyType_JOIN_instance;
var SoftKeyboardReturnKeyType_NEXT_instance;
var SoftKeyboardReturnKeyType_ROUTE_instance;
var SoftKeyboardReturnKeyType_SEARCH_instance;
var SoftKeyboardReturnKeyType_DONE_instance;
var SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance;
var SoftKeyboardReturnKeyType_CONTINUE_instance;
var SoftKeyboardReturnKeyType_entriesInitialized;
function SoftKeyboardReturnKeyType_initEntries() {
  if (SoftKeyboardReturnKeyType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardReturnKeyType_entriesInitialized = true;
  SoftKeyboardReturnKeyType_DEFAULT_instance = new SoftKeyboardReturnKeyType('DEFAULT', 0);
  SoftKeyboardReturnKeyType_GO_instance = new SoftKeyboardReturnKeyType('GO', 1);
  SoftKeyboardReturnKeyType_JOIN_instance = new SoftKeyboardReturnKeyType('JOIN', 2);
  SoftKeyboardReturnKeyType_NEXT_instance = new SoftKeyboardReturnKeyType('NEXT', 3);
  SoftKeyboardReturnKeyType_ROUTE_instance = new SoftKeyboardReturnKeyType('ROUTE', 4);
  SoftKeyboardReturnKeyType_SEARCH_instance = new SoftKeyboardReturnKeyType('SEARCH', 5);
  SoftKeyboardReturnKeyType_DONE_instance = new SoftKeyboardReturnKeyType('DONE', 6);
  SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance = new SoftKeyboardReturnKeyType('EMERGENCY_CALL', 7);
  SoftKeyboardReturnKeyType_CONTINUE_instance = new SoftKeyboardReturnKeyType('CONTINUE', 8);
}
function SoftKeyboardType_DEFAULT_getInstance() {
  SoftKeyboardType_initEntries();
  return SoftKeyboardType_DEFAULT_instance;
}
function SoftKeyboardReturnKeyType_DEFAULT_getInstance() {
  SoftKeyboardReturnKeyType_initEntries();
  return SoftKeyboardReturnKeyType_DEFAULT_instance;
}
var Companion_instance_30;
function Companion_getInstance_37() {
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function draw(_this__u8e3s4, batch) {
  return batch.cei(_this__u8e3s4);
}
function draw_0(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_51().mei_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_50().qei_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_61().uei_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_32.wei() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_43().yei_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_42().aej_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_45().eej_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_52().iej_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_41().mej_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_48().oej_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.eeh(frameBuffer.leg_1, frameBuffer.sej(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function draw_1(_this__u8e3s4, batch) {
  return batch.cei(_this__u8e3s4);
}
function readColor(_this__u8e3s4, frameBuffer, bitmap, x, y) {
  x = x === VOID ? 0 : x;
  y = y === VOID ? 0 : y;
  return _this__u8e3s4.feh(frameBuffer.leg_1, frameBuffer.sej(), x, y, bitmap.sc1_1, bitmap.tc1_1, bitmap.ic1_1, Companion_getInstance_53().uej_1);
}
var Companion_instance_31;
function Companion_getInstance_38() {
  return Companion_instance_31;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.yc1_1) {
    // Inline function 'korlibs.logger.Logger.error' call
    var tmp0 = $this.sek_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_ERROR_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      tmp0.pbj(level, tmp$ret$2);
    }
  }
}
var Companion_instance_32;
function Companion_getInstance_39() {
  return Companion_instance_32;
}
function upload($this, data, needClone) {
  var tmp0_safe_receiver = $this.jen_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jb2()) === data.jb2()) {
    if (data.jb2() < 1024 && Companion_instance_4.zb1(data, 0, ensureNotNull($this.jen_1), 0, data.jb2())) {
      return $this;
    }
    Companion_instance_4.yb1(data, 0, ensureNotNull($this.jen_1), 0, data.jb2());
  } else {
    $this.jen_1 = needClone ? clone(data) : data;
  }
  $this.eem();
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_40().pem_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_40().qen(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$0);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_33;
function Companion_getInstance_40() {
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function AGTextureUnitInfo__toString_impl_7im6je($this) {
  return 'AGTextureUnitInfo(wrap=' + AGWrapMode__toString_impl_8bjnw2(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + AGTextureTargetKind__toString_impl_68648p(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
}
function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
  return $this;
}
function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
  if (!(other instanceof AGTextureUnitInfo))
    return false;
  if (!($this === (other instanceof AGTextureUnitInfo ? other.wen_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_34;
function Companion_getInstance_41() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_35;
function Companion_getInstance_42() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).ber.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).aer_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).cer.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).aer_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).der.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).aer_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.aer_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = bitwiseOr(bitwiseAnd(fromInt(front), new Long(-1, 0)), shiftLeft(fromInt(back), 32));
  return _AGStencilReference___init__impl__rta8vg(tmp$ret$0);
}
var Companion_instance_36;
function Companion_getInstance_43() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).fer.call(new AGStencilReference($this), referenceValue, referenceValueBack).eer_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).ger.call(new AGStencilReference($this), readMask, readMaskBack).eer_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).her.call(new AGStencilReference($this), writeMask, writeMaskBack).eer_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.eer_1 : THROW_CCE();
  if (!equalsLong($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_37;
function Companion_getInstance_44() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_44().ier_1 ? 'POINTS' : $this === Companion_getInstance_44().jer_1 ? 'LINE_STRIP' : $this === Companion_getInstance_44().ker_1 ? 'LINE_LOOP' : $this === Companion_getInstance_44().ler_1 ? 'LINES' : $this === Companion_getInstance_44().mer_1 ? 'TRIANGLES' : $this === Companion_getInstance_44().ner_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_44().oer_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function AGDrawType__equals_impl_rtafo6($this, other) {
  if (!(other instanceof AGDrawType))
    return false;
  if (!($this === (other instanceof AGDrawType ? other.per_1 : THROW_CCE())))
    return false;
  return true;
}
function toAGScissor(_this__u8e3s4) {
  if (_this__u8e3s4 == null)
    return Companion_getInstance_41().mej_1;
  return AGScissor.beq(numberToInt(_this__u8e3s4.o9h_1), numberToInt(_this__u8e3s4.p9h_1), numberToInt(_this__u8e3s4.q9h_1), numberToInt(_this__u8e3s4.r9h_1));
}
function plus_5(_this__u8e3s4, scissor) {
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D.a9k(scissor.v9h(), scissor.x9h())), Vector2D.a9k(scissor.w9h(), scissor.y9h()));
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.l1();
  this_0.m1('AGColorMask(');
  this_0.m1(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.m1(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.m1(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.m1(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.m1(')');
  return this_0.toString();
}
var Companion_instance_38;
function Companion_getInstance_45() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function AGColorMask__equals_impl_mrih8l($this, other) {
  if (!(other instanceof AGColorMask))
    return false;
  if (!($this === (other instanceof AGColorMask ? other.qer_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_39;
function Companion_getInstance_46() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_46().keq_1 ? 'ALWAYS' : $this === Companion_getInstance_46().leq_1 ? 'EQUAL' : $this === Companion_getInstance_46().meq_1 ? 'GREATER' : $this === Companion_getInstance_46().neq_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_46().oeq_1 ? 'LESS' : $this === Companion_getInstance_46().peq_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_46().qeq_1 ? 'NEVER' : $this === Companion_getInstance_46().req_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__inverted_impl_7xxk8m($this) {
  return $this === Companion_getInstance_46().keq_1 ? Companion_getInstance_46().qeq_1 : $this === Companion_getInstance_46().leq_1 ? Companion_getInstance_46().req_1 : $this === Companion_getInstance_46().meq_1 ? Companion_getInstance_46().peq_1 : $this === Companion_getInstance_46().neq_1 ? Companion_getInstance_46().oeq_1 : $this === Companion_getInstance_46().oeq_1 ? Companion_getInstance_46().neq_1 : $this === Companion_getInstance_46().peq_1 ? Companion_getInstance_46().meq_1 : $this === Companion_getInstance_46().qeq_1 ? Companion_getInstance_46().keq_1 : $this === Companion_getInstance_46().req_1 ? Companion_getInstance_46().leq_1 : Companion_getInstance_46().qeq_1;
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.rer_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_40;
function Companion_getInstance_47() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_47().seq_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_47().teq_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_47().ueq_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_47().veq_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_47().weq_1 ? 'INVERT' : $this === Companion_getInstance_47().xeq_1 ? 'KEEP' : $this === Companion_getInstance_47().yeq_1 ? 'SET' : $this === Companion_getInstance_47().zeq_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.ser_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_41;
function Companion_getInstance_48() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_48().oej_1 ? 'NONE' : $this === Companion_getInstance_48().rej_1 ? 'BOTH' : $this === Companion_getInstance_48().pej_1 ? 'FRONT' : $this === Companion_getInstance_48().qej_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function AGCullFace__equals_impl_wgngjr($this, other) {
  if (!(other instanceof AGCullFace))
    return false;
  if (!($this === (other instanceof AGCullFace ? other.ter_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = bitwiseOr(bitwiseAnd(fromInt(data), new Long(-1, 0)), shiftLeft(fromInt(data2), 32));
  return _AGFrameBufferInfo___init__impl__dbxiro(tmp$ret$0);
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_49.get(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_42;
function Companion_getInstance_49() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
function applyMatrixBounds(_this__u8e3s4, m) {
  var x0 = m.q9l(_this__u8e3s4.v9h(), _this__u8e3s4.x9h());
  var x1 = m.q9l(_this__u8e3s4.w9h(), _this__u8e3s4.x9h());
  var x2 = m.q9l(_this__u8e3s4.v9h(), _this__u8e3s4.y9h());
  var x3 = m.q9l(_this__u8e3s4.w9h(), _this__u8e3s4.y9h());
  var y0 = m.r9l(_this__u8e3s4.v9h(), _this__u8e3s4.x9h());
  var y1 = m.r9l(_this__u8e3s4.w9h(), _this__u8e3s4.x9h());
  var y2 = m.r9l(_this__u8e3s4.v9h(), _this__u8e3s4.y9h());
  var y3 = m.r9l(_this__u8e3s4.w9h(), _this__u8e3s4.y9h());
  return Companion_getInstance_41().v9p(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max_0(x0, x1, x2, x3)), numberToInt(max_0(y0, y1, y2, y3)));
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).ket.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).jet_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).let.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).jet_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).met.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).jet_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_50().pei_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_43;
function Companion_getInstance_50() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.jet_1 : THROW_CCE())))
    return false;
  return true;
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
var Companion_instance_44;
function Companion_getInstance_51() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_51().kei_1 ? 'null' : $this === Companion_getInstance_51().lei_1 ? 'UBYTE' : $this === Companion_getInstance_51().mei_1 ? 'USHORT' : $this === Companion_getInstance_51().nei_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_45;
function Companion_getInstance_52() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGReadKind___init__impl__sw15xt(ordinal) {
  return ordinal;
}
var Companion_instance_46;
function Companion_getInstance_53() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_54().eel_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_54().fel_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_54().gel_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_54().hel_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_54().eel_1 ? 2 : $this === Companion_getInstance_54().fel_1 ? 3 : $this === Companion_getInstance_54().gel_1 ? 3 : $this === Companion_getInstance_54().hel_1 ? 3 : 0;
}
var Companion_instance_47;
function Companion_getInstance_54() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.jel_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_48;
function Companion_getInstance_55() {
  if (Companion_instance_48 === VOID)
    new Companion_39();
  return Companion_instance_48;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_55().ren_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_55().sen_1 ? 'REPEAT' : $this === Companion_getInstance_55().ten_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.peu_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_49;
function Companion_getInstance_56() {
  return Companion_instance_49;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_57() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_57().net_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_57().oet_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_57().pet_1 ? 'ONE' : $this === Companion_getInstance_57().qet_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_57().ret_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_57().set_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_57().tet_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_57().uet_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_57().vet_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_57().wet_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_57().net_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_57().oet_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_57().pet_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_57().qet_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_57().ret_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_57().set_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_57().tet_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_57().uet_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_57().vet_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_57().wet_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.reu_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_58() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_58().aeu_1 ? 'ADD' : $this === Companion_getInstance_58().beu_1 ? 'SUBTRACT' : $this === Companion_getInstance_58().ceu_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_58().aeu_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_58().beu_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_58().ceu_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.seu_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_52;
function Companion_getInstance_59() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
function DefaultShaders$ProjViewUB$_get_u_ProjMat_$ref_f2hall() {
  return constructCallableReference((p0) => p0.jev(), 1, 0, 160);
}
function DefaultShaders$ProjViewUB$_get_u_ViewMat_$ref_a9z0a9() {
  return constructCallableReference((p0) => p0.kev(), 1, 0, 161);
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
function DefaultShaders$_get_u_Tex_$ref_n7dx9w() {
  return constructCallableReference((p0) => p0.iew(), 1, 0, 162);
}
function DefaultShaders$_get_u_TexEx_$ref_359me1() {
  return constructCallableReference((p0) => p0.jew(), 1, 0, 163);
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp0 = gl$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_gl_$ref_w0fg7f();
  // Inline function 'korlibs.datastructure.PropertyThis.setValue' call
  var tmp4 = getPropertyCallableRef('gl', 1, tmp, tmp_0, _set_gl_$ref_xh60u7());
  // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
  var value = tmp0.u9u_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = tmp0.s9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp0 = gl$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_gl_$ref_w0fg7f();
  var tmp4 = getPropertyCallableRef('gl', 1, tmp, tmp_0, _set_gl_$ref_xh60u7());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.af2_1;
  var map = $this.ef2_1;
  if ($this.ff2_1 == null) {
    $this.ff2_1 = gl.kf3(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0 = Companion_getInstance_37().eeg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_INFO_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'GL_VERSION=' + gl.kf3(7938);
      tmp0.pbj(level, tmp$ret$2);
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0_0 = Companion_getInstance_37().eeg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level_0 = Level_INFO_getInstance();
    if (tmp0_0.obj(level_0)) {
      var tmp$ret$5 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.ff2_1;
      tmp0_0.pbj(level_0, tmp$ret$5);
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0_1 = Companion_getInstance_37().eeg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level_1 = Level_INFO_getInstance();
    if (tmp0_1.obj(level_1)) {
      var tmp$ret$8 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      tmp0_1.pbj(level_1, tmp$ret$8);
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0_2 = Companion_getInstance_37().eeg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level_2 = Level_INFO_getInstance();
    if (tmp0_2.obj(level_2)) {
      var tmp$ret$11 = 'gl.versionString=' + get_versionString(gl);
      tmp0_2.pbj(level_2, tmp$ret$11);
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0_3 = Companion_getInstance_37().eeg_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level_3 = Level_INFO_getInstance();
    if (tmp0_3.obj(level_3)) {
      var tmp$ret$14 = 'gl.versionInt=' + get_versionInt(gl);
      tmp0_3.pbj(level_3, tmp$ret$14);
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.w4(program);
  var tmp;
  if (value == null) {
    // Inline function 'kotlin.also' call
    var this_0 = new GLBaseProgram($this.df2_1, GLShaderCompiler_getInstance().nf3(gl, $this.lf3(), program, program.ueo_1));
    this_0.rf3();
    var programInfo = this_0.qf3_1;
    var programId = programInfo.sf3_1;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = program.yeo_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var location = programInfo.nf4(gl, element.if4_1);
      gl.of4(location, element.cen_1);
    }
    if (programInfo.wf3_1.vf4()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = program.xeo_1;
      var n = 0;
      while (n < this_1.s2()) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_1.u2(_unary__edvuaz);
        var index = gl.pf4(programId, it.h1());
        gl.qf4(programId, index, it.sep_1);
      }
    }
    var answer = this_0;
    map.b5(program, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  var nprogram = tmp;
  if (!equals($this.of2_1, nprogram)) {
    $this.of2_1 = nprogram;
    nprogram.rf3();
  }
}
function resetObjects($this) {
  $this.hf2_1 = null;
  $this.sf2_1 = Companion_getInstance_41().lej_1;
  $this.if2_1 = Companion_getInstance_50().oei_1;
  $this.jf2_1 = Companion_getInstance_48().nej_1;
  $this.kf2_1 = Companion_getInstance_42().zei_1;
  $this.lf2_1 = Companion_getInstance_43().xei_1;
  $this.mf2_1 = Companion_getInstance_45().bej_1;
  $this.nf2_1 = Companion_getInstance_52().hej_1;
  $this.pf2_1.a5();
  $this.of2_1 = null;
  $this.df3_1 = -1;
  $this.bf3_1 = 0;
  $this.cf3_1 = Companion_instance_49.qeu();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.yf2_1;
  var n = 0;
  while (n < this_0.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].ra8();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0 = $this.df2_1.kf5_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0.n9w();
      try {
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.df2_1.lf5_1.n1()) {
          // Inline function 'kotlin.also' call
          var this_0 = toList($this.df2_1.lf5_1);
          $this.df2_1.lf5_1.a5();
          tmp = this_0;
        } else {
          return Unit_instance;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      }finally {
        tmp0.p9w();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp$ret$1.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$1.u2(_unary__edvuaz).of5();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  var gl = $this.af2_1;
  if (reallocated == null)
    null;
  else {
    reallocated.pa9(false);
  }
  if (updated == null)
    null;
  else {
    updated.pa9(false);
  }
  if (buffer == null) {
    gl.pf5(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty($this, buffer);
  if (!onlyUpdate) {
    gl.pf5(toGl_6(target), bufferInfo.sf5_1);
  }
  $this.vf5(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.af2_1;
  var location = programInfo.nf4(gl, uniform.if4_1);
  var uniformType = uniform.d8o();
  var arrayCount = uniform.yf5_1;
  if (uniformType.ff6_1.w1_1 === 6) {
    switch (uniformType.w1_1) {
      case 1:
        gl.nf6(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.xf2_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.of6(location, arrayCount, false, $this.xf2_1);
        break;
      case 3:
        gl.pf6(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.gf6_1) {
          case 1:
            gl.qf6(location, arrayCount, data);
            break;
          case 2:
            gl.rf6(location, arrayCount, data);
            break;
          case 3:
            gl.sf6(location, arrayCount, data);
            break;
          case 4:
            gl.tf6(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.gf6_1) {
      case 1:
        gl.jf6(location, arrayCount, data);
        break;
      case 2:
        gl.kf6(location, arrayCount, data);
        break;
      case 3:
        gl.lf6(location, arrayCount, data);
        break;
      case 4:
        gl.mf6(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.af2_1;
  var params = $this.yf2_1[$this.bf3_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.xf4_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.uf6(glTarget, 10242, glWrap);
  gl.uf6(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.uf6(glTarget, 32882, glWrap);
  }
  params.yf4_1 = minFilter;
  params.zf4_1 = magFilter;
  gl.uf6(glTarget, 10241, minFilter);
  gl.uf6(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.eb2(bmp.g9r());
        arraycopy_3(bmp.x8s(), 0, get_i8(this_0), 0, bmp.g9r());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.eb2(imul(imul(bmp.g9r(), 4), 4));
          arraycopy_2(bmp.kce_1, 0, get_f32(this_1), 0, imul(bmp.g9r(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.eb2(imul(bmp.g9r(), 4));
          var abmp = bmp.yc1_1 ? bmp.pc9().scc() : bmp.pc9().tcc();
          arraycopy_1(abmp.ic1_1, 0, get_i32(this_2), 0, abmp.g9r());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.bf3_1;
  if (!($this.bf3_1 === index)) {
    $this.bf3_1 = index;
    if (index >= 0) {
      $this.af2_1.vf6(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty($this, $receiver) {
  return gl($receiver, $this.df2_1);
}
function _get_gl__ndc1ty_0($this, $receiver) {
  return gl_0($receiver, $this.df2_1);
}
function _get_gl__ndc1ty_1($this, $receiver) {
  return gl_1($receiver, $this.df2_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return () => new GlslConfig(this$0.af2_1.wf6(), this$0.af2_1);
}
function AGOpengl$_get_glslConfig_$ref_sx7q53() {
  return constructCallableReference((p0) => p0.lf3(), 1, 0, 164);
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return (it) => {
    var tmp0_elvis_lhs = $buffer.jen_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.eb2(0) : tmp0_elvis_lhs;
    $bufferInfo.xf6(mem.jb2());
    var tmp;
    if ($onlyUpdate) {
      $gl.pf5(toGl_6($target), $bufferInfo.sf5_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.tf5_1 < mem.jb2()) {
      $bufferInfo.tf5_1 = mem.jb2();
      $gl.zf6(toGl_6($target), mem.jb2(), mem, 35048);
      var tmp1_safe_receiver = $reallocated;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.pa9(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.yf6(toGl_6($target), 0, mem.jb2(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp2_safe_receiver = $updated;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.pa9(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return (it) => {
    var rbmp = $tex.xek_1;
    var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.yel_1;
    var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
    var requestMipmaps = $tex.uek_1;
    $tex.yek_1 = $tex.fem(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.p1();
    var index = 0;
    while (iterator.q1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.r1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_54().gel_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.wf6()) && _GLVariant___get_version__impl__9nyfwa($gl.wf6()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.wf6()).rb0()) {
        $gl.af7(3313, 0);
        $gl.af7(3312, 1);
      }
      if (bmp == null) {
        $gl.bf7(toGl_8($target), 0, type, $tex.w9z(), $tex.x9z(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.g9r() === 0)) {
            $gl.cf7(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.bf7(texTarget, 0, internalFormat, bmp.sc1_1, bmp.tc1_1, 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.sc1_1 === 0) && !(bmp.tc1_1 === 0) && !(get_size_0(buffer) === 0)) {
              $gl.bf7(texTarget, 0, internalFormat, bmp.sc1_1, bmp.tc1_1, 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.w9z(), $tex.x9z()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.wf6())) {
        var tmp_0;
        if ($tex.yek_1) {
          var tmp4_elvis_lhs = $tex.vek_1;
          tmp_0 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.uf6(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.yek_1) {
          var tmp5_elvis_lhs = $tex.wek_1;
          tmp_1 = tmp5_elvis_lhs == null ? 1000 : tmp5_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.uf6(3553, 33085, tmp_1);
      }
      if ($tex.yek_1) {
        $gl.df7(texTarget);
      }
    }
    $glTex.xf6(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function _get_gl_$ref_w0fg7f() {
  return constructCallableReference((p0) => get_gl(p0), 1, 0, 165);
}
function _set_gl_$ref_xh60u7() {
  return constructCallableReference((p0, p1) => {
    set_gl(p0, p1);
    return Unit_instance;
  }, 2, 0, 166);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.wi('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.wi('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_54().eel_1;
      break;
    case 32879:
      tmp = Companion_getInstance_54().fel_1;
      break;
    case 34067:
      tmp = Companion_getInstance_54().gel_1;
      break;
    case 36197:
      tmp = Companion_getInstance_54().hel_1;
      break;
    case 34069:
      tmp = Companion_getInstance_54().gel_1;
      break;
    case 34070:
      tmp = Companion_getInstance_54().gel_1;
      break;
    case 34071:
      tmp = Companion_getInstance_54().gel_1;
      break;
    case 34072:
      tmp = Companion_getInstance_54().gel_1;
      break;
    case 34073:
      tmp = Companion_getInstance_54().gel_1;
      break;
    case 34074:
      tmp = Companion_getInstance_54().gel_1;
      break;
    default:
      // Inline function 'kotlin.TODO' call

      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.le('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_58().aeu_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_58().beu_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_58().ceu_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_57().net_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_57().oet_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_57().pet_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_57().qet_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_57().ret_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_57().set_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_57().tet_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_57().uet_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_57().vet_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_57().wet_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_46().keq_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_46().leq_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_46().meq_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_46().neq_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_46().oeq_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_46().peq_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_46().qeq_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_46().req_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_47().seq_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_47().teq_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_47().ueq_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_47().veq_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_47().weq_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_47().xeq_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_47().yeq_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_47().zeq_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_44().ier_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_44().jer_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_44().ker_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_44().ler_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_44().ner_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_44().oer_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_44().mer_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_51().kei_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_51().lei_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_51().mei_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_51().nei_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_48().rej_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_48().pej_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_48().qej_1) {
    tmp = 1029;
  } else {
    // Inline function 'kotlin.TODO' call
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.le('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.w1_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.ff6_1.w1_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_54().eel_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_54().fel_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_54().gel_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_54().hel_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_55().ren_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_55().sen_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_55().ten_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_59().meu_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_59().oeu_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_59().neu_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.aem_1 == null || !(_this__u8e3s4.bem_1 === state.df5_1.ieg_1)) {
    _this__u8e3s4.bem_1 = state.df5_1.ieg_1;
    _this__u8e3s4.gem();
    _this__u8e3s4.aem_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.aem_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return (it) => new GLBuffer($state);
}
function gl$lambda_0($state, $this_gl) {
  return (it) => new GLFrameBuffer($state, $this_gl);
}
function gl$lambda_1($state) {
  return (it) => new GLTexture($state);
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0 = versionString$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('versionString', 1, tmp, _get_versionString_$ref_gh6h1z(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0 = versionInt$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('versionInt', 1, tmp, _get_versionInt_$ref_c6xzml(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.qfa(type);
  gl.rfa(shaderId, str);
  gl.sfa(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.tfa();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.vf1(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.wf6())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.wf6()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.kf3(35724);
  }
  return tmp;
}
function _get_versionString_$ref_gh6h1z() {
  return constructCallableReference((p0) => get_versionString(p0), 1, 0, 167);
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0_safe_receiver = Regex.hi('(\\d+\\.\\d+)').ji(get_versionString($this$PropertyThis));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k3();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
  return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
}
function _get_versionInt_$ref_c6xzml() {
  return constructCallableReference((p0) => get_versionInt(p0), 1, 0, 168);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_53;
function Companion_getInstance_60() {
  return Companion_instance_53;
}
function _get_bufferSize__mp12kq($this) {
  return $this.deo_1.jb2() / $this.beo_1 | 0;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return () => {
    var tmp0_elvis_lhs = this$0.nev_1;
    // Inline function 'kotlin.also' call
    var this_0 = TypedUniform.wfc(tmp0_elvis_lhs == null ? 'unknown' + this$0.mev_1.zev() : tmp0_elvis_lhs, this$0.oev_1, this$0.pev_1, this$0.mev_1, this$0.qev_1, this$0.rev_1);
    this$0.mev_1.uep_1.d2(this_0);
    return this_0;
  };
}
function UniformBlock$Gen$_get_uniform_$ref_tylxot() {
  return constructCallableReference((p0) => p0.yfd(), 1, 0, 169);
}
var Companion_instance_54;
function Companion_getInstance_61() {
  if (Companion_instance_54 === VOID)
    new Companion_45();
  return Companion_instance_54;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.afe_1;
  tmp.afe_1 = Math.max(a, size);
  while (!(($this.zfd_1 % size | 0) === 0)) {
    $this.zfd_1 = $this.zfd_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return () => {
    align(this$0, this$0.afe_1);
    return this$0.zfd_1;
  };
}
function UBLayoutBuilder$_get_size_$ref_u8lr3t() {
  return constructCallableReference((p0) => p0.s2(), 1, 0, 170);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_3().nb0_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_55;
function Companion_getInstance_62() {
  return Companion_instance_55;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.ffe_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).jfe_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.nfe_1, config)).bff(_this__u8e3s4);
}
var Companion_instance_56;
function Companion_getInstance_63() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.if4_1;
  var tmp$ret$2 = b.if4_1;
  return compareValues(tmp, tmp$ret$2);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return ($this$Indenter) => {
    var tmp;
    if (!this$0.aff_1.uf4_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.aff_1.rf4_1) ? ' es' : '';
      $this$Indenter.vbx('#version ' + this$0.aff_1.tf4_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.zfe_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.vbx('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.vbx('#ifdef GL_ES');
    $this$Indenter.vbx('precision mediump float;');
    $this$Indenter.vbx('#endif');
    var _iterator__ex2g4s = $types.jff_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var it = _iterator__ex2g4s.r1();
      var layout = this$0.aff_1.qff() && this$0.aff_1.tf4_1 >= 410 ? 'layout(location = ' + it.cex_1 + ') ' : '';
      $this$Indenter.vbx(layout + this$0.rff() + ' ' + this$0.sff(it.jf4_1) + this$0.tff(it.d8o()) + ' ' + it.if4_1 + this$0.uff(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.off_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var it_0 = _iterator__ex2g4s_0.r1();
      var layout_0 = this$0.aff_1.qff() ? '' : '';
      $this$Indenter.vbx(layout_0 + this$0.vff() + ' ' + this$0.sff(it_0.jf4_1) + this$0.tff(it_0.d8o()) + ' ' + it_0.if4_1 + this$0.uff(it_0) + ';');
    }
    var tmp_1;
    if (this$0.aff_1.vf4()) {
      var _iterator__ex2g4s_1 = $types.nff_1.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var block = _iterator__ex2g4s_1.r1();
        $this$Indenter.vbx('layout(std140) uniform ' + block.h1() + ' {');
        var _iterator__ex2g4s_2 = block.wev().p1();
        while (_iterator__ex2g4s_2.q1()) {
          var uniform = _iterator__ex2g4s_2.r1();
          $this$Indenter.vbx('  ' + this$0.sff(uniform.jf4_1) + this$0.tff(uniform.d8o()) + ' ' + uniform.if4_1 + this$0.uff(uniform) + ';');
        }
        $this$Indenter.vbx('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.lff_1.p1();
      while (_iterator__ex2g4s_3.q1()) {
        var it_1 = _iterator__ex2g4s_3.r1();
        $this$Indenter.vbx(this$0.vff() + ' ' + this$0.sff(it_1.jf4_1) + this$0.tff(it_1.d8o()) + ' ' + it_1.if4_1 + this$0.uff(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.kff_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$1 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$1).p1();
    var index = 0;
    $l$loop: while (iterator.q1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.r1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.aff_1.qff() ? this$0.wff() : it_2.if4_1 === this$0.aff_1.xff() && this$0.zfe_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.wff() : this$0.zfe_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.wff() : this$0.rff();
      $this$Indenter.vbx(INOUT + ' ' + this$0.sff(it_2.jf4_1) + this$0.tff(it_2.d8o()) + ' ' + it_2.if4_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.p1();
    while (_iterator__ex2g4s_4.q1()) {
      var func = _iterator__ex2g4s_4.r1();
      var gen = new GlslBodyGenerator(this$0.zfe_1, this$0.aff_1);
      gen.zff(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.cfg_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s_5 = this_1.p1();
      while (_iterator__ex2g4s_5.q1()) {
        var item = _iterator__ex2g4s_5.r1();
        var tmp$ret$4 = this$0.tff(item.qm_1) + ' ' + item.pm_1;
        destination.d2(tmp$ret$4);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.tff(func.bfg_1) + ' ' + func.afg_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.vbx(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.f2h();
      try {
        var _iterator__ex2g4s_6 = gen.ifg_1.p1();
        while (_iterator__ex2g4s_6.q1()) {
          var temp = _iterator__ex2g4s_6.r1();
          $this$Indenter.vbx(this$0.sff(temp.jf4_1) + this$0.tff(temp.d8o()) + ' ' + temp.if4_1 + ';');
        }
        $this$Indenter.ubx(gen.jfg_1);
      }finally {
        $this$Indenter.wbx();
      }
      $this$Indenter.vbx('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_57;
function Companion_getInstance_64() {
  if (Companion_instance_57 === VOID)
    new Companion_48();
  return Companion_instance_57;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return (it) => this$0.qfh(it);
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return (it) => this$0.qfh(it);
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
var Companion_instance_58;
function Companion_getInstance_65() {
  if (Companion_instance_58 === VOID)
    new Companion_49();
  return Companion_instance_58;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return ($this$FUNC) => {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.xfj_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp$ret$2 = $this$FUNC.dfk('p' + index_0, item);
      destination.d2(tmp$ret$2);
    }
    var args = destination;
    this$0.zfj_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return ($this$FuncProvider, it) => {
    $block($this$FuncProvider, it.u2(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return ($this$FuncProvider, it) => {
    $block($this$FuncProvider, it.u2(0), it.u2(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return ($this$FuncProvider, it) => {
    $block($this$FuncProvider, it.u2(0), it.u2(1), it.u2(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return ($this$ELSE) => {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return ($this$ELSE) => {
    $this$ELSE.pez($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
  return ($this$ELSE) => {
    $this$ELSE.qez($ref, $min + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.pfm();
  return Output_instance;
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_59;
function Companion_getInstance_66() {
  return Companion_instance_59;
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
function ProgramLayout$names$lambda(it) {
  return it.if4_1;
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
function FragmentShader(info) {
  return FragmentShader_0(info.pm_1, info.qm_1);
}
function VertexShader(info) {
  return VertexShader_0(info.pm_1, info.qm_1);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return () => {
    $this_toDisposable.f7();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charCodeAt(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      _this__u8e3s4.sb2(_unary__edvuaz, toByte(tmp$ret$0));
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    _this__u8e3s4.sb2(_unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _this__u8e3s4.xb2(n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_60;
function Companion_getInstance_67() {
  return Companion_instance_60;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return () => this$0.g81().w2('GL_OES_texture_float') || this$0.g81().w2('GL_ARB_texture_float');
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.zfz(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.dg0(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.ag0(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.bg0(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.cg0(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.vfz(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, id);
  _this__u8e3s4.rfz(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.yfz(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, id);
  _this__u8e3s4.ufz(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.xfz(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, 0);
  _this__u8e3s4.wfz(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, id);
  _this__u8e3s4.tfz(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  var it = get_tempNBuffer1();
  setInt32(it, 0, id);
  _this__u8e3s4.sfz(1, it);
  getInt32(it, 0);
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_1().pb5('KmlGlException');
    tempNBufferByte = Buffer.eb2(1, true);
    tempNBuffer1 = Buffer.eb2(4, true);
    tempNBuffer4 = Buffer.eb2(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_61;
function Companion_getInstance_68() {
  return Companion_instance_61;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().v9k_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().zc2_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_69().pg0_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().v9k_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().zc2_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_69().pg0_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.eck();
  var m2 = m.e9m(x, y).w9l(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.hg2_1;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  var this_1 = this_0.qg2_1;
  if (!(this_1.lg2_1 === this_0)) {
    this_1.lg2_1 = this_0;
    this_1.vg3();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  if (inductionVariable <= last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charCodeAt(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.eck();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      var tmp;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp = charSequenceGet(str, index);
      } else {
        tmp = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$4 = tmp;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$4);
      var glyph = _this__u8e3s4.u2(c1);
      var tex = glyph.ucj_1;
      var tmp0_tex = ctx.wg3(tex);
      var tmp1_x = dx + glyph.vcj_1;
      var tmp2_y = dy + glyph.wcj_1;
      var tmp3_width = tex.qaj_1;
      var tmp4_height = tex.raj_1;
      var tmp5_m = get_immutable(m2);
      this_0.xg3(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_m, filtering, colMul, blendMode);
      var tmp6_safe_receiver = _this__u8e3s4.ick().u2(Companion_instance_5.rcj(c1, c2));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.dck_1;
      var kerningOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      dx = dx + (glyph.xcj_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
}
var debugBmpFontOrNull;
function *debugBmpFont($completion) {
  if (debugBmpFontOrNull == null) {
    debugBmpFontOrNull = debugBmpFont_0(slice((yield* readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion)).pc9()));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  var tmp6 = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable = this_0.n3_1;
  var last = this_0.o3_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      var x = it % 16 | 0;
      var y = it / 16 | 0;
      var tmp$ret$2 = new Glyph(fntHeight, it, tex.yak(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.b5(element, tmp$ret$2);
    }
     while (!(element === last));
  var tmp8 = toIntMap(result);
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var kernings = IntMap.fa7();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(tmp6), tmp8, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_62;
function Companion_getInstance_69() {
  if (Companion_instance_62 === VOID)
    new Companion_53();
  return Companion_instance_62;
}
var Companion_instance_63;
function Companion_getInstance_70() {
  return Companion_instance_63;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.fg5_1[n];
      var curr = $this.eg5_1[n];
      $this.kg5_1[n] = (prev && !curr);
      $this.jg5_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.gg5_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.gg5_1[n] = 0.0;
        $this.hg5_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.gg5_1[n]);
      if ($this.gg5_1[n] > 0) {
        var tmp0_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp0_subject ? tmp0_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp0_subject ? tmp0_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp0_subject ? tmp0_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.hg5_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.hg5_1[n] = $this.gg5_1[n];
      }
      $this.ig5_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.eg5_1, 0, $this.fg5_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.ng5();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *configureLoggerFromProperties(file, $completion) {
  try {
    configureLoggerFromProperties_0(yield* file.tbh(VOID, $completion));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_64.ag6(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.j3();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.k3();
    try {
      var tmp = Companion_getInstance_1().pb5(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = value.toUpperCase();
      tmp.ibj(valueOf(tmp$ret$3));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_64;
function Companion_getInstance_71() {
  return Companion_instance_64;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.ra8();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.ig7_1 === bitmap && ensureNotNull($this.jg7_1).rg6_1.vg6_1 === bitmap.bc2_1)
    return ensureNotNull($this.jg7_1);
  if ($this.kg7_1 === bitmap && ensureNotNull($this.lg7_1).rg6_1.vg6_1 === bitmap.bc2_1)
    return ensureNotNull($this.lg7_1);
  $this.cg7_1.oa5(bitmap);
  var tmp0 = $this.hg7_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var res = get_0(tmp0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'kotlin.also' call
    var this_0 = $this.gg7_1.ja8();
    var base = this_0.rg6_1;
    base.vg6_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_54().gel_1;
    } else {
      tmp_0 = Companion_getInstance_54().eel_1;
    }
    tmp.tg6_1 = new AGTexture(tmp_0);
    base.xg6(bitmap.sc1_1);
    base.yg6(bitmap.tc1_1);
    var out = this_0;
    set(tmp0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.kg7_1 = $this.ig7_1;
  $this.lg7_1 = $this.jg7_1;
  var base_0 = textureInfo.rg6_1;
  $this.ig7_1 = bitmap;
  $this.jg7_1 = textureInfo;
  if (!(bitmap.bc2_1 === base_0.vg6_1)) {
    base_0.vg6_1 = bitmap.bc2_1;
    var tmp_1 = $this;
    var tmp0_0 = $this.fg7_1;
    // Inline function 'kotlin.Long.minus' call
    var other = textureInfo.qg6_1;
    tmp_1.fg7_1 = subtract(tmp0_0, fromInt(other));
    try {
      base_0.rg7(bitmap, bitmap.dc2_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.qg6_1 = _get_estimateSizeInBytes__tshb4c($this, bitmap);
      var tmp_2 = $this;
      var tmp0_1 = $this.fg7_1;
      // Inline function 'kotlin.Long.plus' call
      var other_0 = textureInfo.qg6_1;
      tmp_2.fg7_1 = add(tmp0_1, fromInt(other_0));
    }
    bitmap.oc2();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c($this, $receiver) {
  return imul($receiver.tc1_1, imul($receiver.sc1_1, $receiver.uc1_1) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.mg7_1 === slice)
    return ensureNotNull($this.ng7_1);
  if ($this.og7_1 === slice)
    return ensureNotNull($this.pg7_1);
  var info = getTextureInfo($this, slice.qak());
  var tmp0 = info.sg6_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var res = get_0(tmp0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture(info.rg6_1).aal(RectangleInt.s9q(slice.v9h(), slice.x9h(), slice.qaj_1, slice.raj_1));
    } else {
      tmp = Companion_instance_7.oal(info.rg6_1, slice);
    }
    var out = tmp;
    set(tmp0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.og7_1 = $this.mg7_1;
  $this.pg7_1 = $this.ng7_1;
  $this.mg7_1 = slice;
  $this.ng7_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.ig7_1 = null;
  $this.jg7_1 = null;
  $this.kg7_1 = null;
  $this.lg7_1 = null;
  $this.mg7_1 = null;
  $this.ng7_1 = null;
  $this.og7_1 = null;
  $this.pg7_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.ra8();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return ($this$IF_ELSE_BINARY_LOOKUP, n) => {
    $this$IF_ELSE_BINARY_LOOKUP.jey($this$IF_ELSE_BINARY_LOOKUP.mey(), $this$IF_ELSE_BINARY_LOOKUP.tey(Companion_getInstance_72().mg8_1[n], $this$IF_ELSE_BINARY_LOOKUP.sey($$this$apply.fey(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.yg2_1);
  var idx_0 = idx;
  var ma = matrix.a9l_1;
  var mb = matrix.b9l_1;
  var mc = matrix.c9l_1;
  var md = matrix.d9l_1;
  var mtx = matrix.e9l_1;
  var mty = matrix.f9l_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.d9m(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_7().i9l(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.r9g_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.s9g_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.eg3_1 + indices | 0) < $this.xg2_1 && ($this.dg3_1 + vertices | 0) < $this.wg2_1;
}
var Companion_instance_65;
function Companion_getInstance_72() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function BatchBuilder2D$lambda(this$0) {
  return (it) => {
    var tmp;
    switch (it.w1_1) {
      case 0:
        this$0.dg9();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.eg9();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_1().pb5('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_2().rb0() && Companion_getInstance_2().yb0().cb0_1 && Companion_getInstance_2().yb0().hb0() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp0 = debugLineRenderContext$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('debugLineRenderContext', 1, tmp, _get_debugLineRenderContext_$ref_sixae0(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_66;
function Companion_getInstance_73() {
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
function addVertex($this, x, y, color, m) {
  color = color === VOID ? $this.ngb_1 : color;
  m = m === VOID ? $this.wgb_1 : m;
  setFloat32($this.rgb_1, $this.ugb_1 + 0 | 0, m.n9l(x, y));
  setFloat32($this.rgb_1, $this.ugb_1 + 1 | 0, m.o9l(x, y));
  setInt32($this.rgb_1, $this.ugb_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.ugb_1 = $this.ugb_1 + (Companion_getInstance_73().ggb_1.ges_1 / 4 | 0) | 0;
  $this.tgb_1 = $this.tgb_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return (it) => {
    this$0.nd();
    return Unit_instance;
  };
}
function LineRenderBatcher$drawVector$lambda($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function LineRenderBatcher$drawVector$lambda_0(this$0, $lastPos, $m, $emittedCount, $lastPos$1, $prevPos) {
  return (it) => {
    if (!false) {
      this$0.xgb($lastPos._v, it, VOID, VOID, $m);
    }
    $lastPos._v = it;
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos$1._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function LineRenderBatcher$drawVector$lambda_1($lastPos) {
  return (it) => {
    $lastPos._v = it;
    return Unit_instance;
  };
}
function LineRenderBatcher$drawVector$lambda_2(this$0, $lastPos, $m, $emittedCount, $lastPos$1, $prevPos) {
  return (it) => {
    if (!false) {
      this$0.xgb($lastPos._v, it, VOID, VOID, $m);
    }
    $lastPos._v = it;
    var _unary__edvuaz = $emittedCount._v;
    $emittedCount._v = _unary__edvuaz + 1 | 0;
    $lastPos$1._v = $prevPos._v;
    $prevPos._v = it;
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function _get_debugLineRenderContext_$ref_sixae0() {
  return constructCallableReference((p0) => get_debugLineRenderContext(p0), 1, 0, 171);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return () => this$0.ieo(ProjViewUB_getInstance());
}
function RenderContext$_get_projViewMatUB_$ref_e0jwh6() {
  return constructCallableReference((p0) => p0.egc(), 1, 0, 172);
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.yeg(VOID, it);
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_1().pb5('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.uez($this$FUNC.if0(a, b, c));
  return Unit_instance;
}
function SDFShaders$_get_opInterpolate_$ref_4qhkt1() {
  return constructCallableReference((p0) => p0.ege(), 1, 0, 173);
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.uez($this$FUNC.ff0(a, b));
  return Unit_instance;
}
function SDFShaders$_get_opUnion_$ref_cdui7t() {
  return constructCallableReference((p0) => p0.fge(), 1, 0, 174);
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.uez($this$FUNC.gf0(a, b));
  return Unit_instance;
}
function SDFShaders$_get_opIntersect_$ref_u559qh() {
  return constructCallableReference((p0) => p0.gge(), 1, 0, 175);
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.uez($this$FUNC.gf0(a, $this$FUNC.tf0(b)));
  return Unit_instance;
}
function SDFShaders$_get_opSubtract_$ref_p8l300() {
  return constructCallableReference((p0) => p0.hge(), 1, 0, 176);
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.uez($this$FUNC.uf0(d, r));
  return Unit_instance;
}
function SDFShaders$_get_opRound_$ref_9t8c14() {
  return constructCallableReference((p0) => p0.ige(), 1, 0, 177);
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.uez($this$FUNC.uf0($this$FUNC.cf0(d), r));
  return Unit_instance;
}
function SDFShaders$_get_opBorder_$ref_iiclig() {
  return constructCallableReference((p0) => p0.jge(), 1, 0, 178);
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.ufk(d, 0.0);
  var body = $this$FUNC.yey();
  body.uez(d);
  var stmIf = new If(cond, body.aez());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.iey_1.d2(stmIf);
  var tmp = stmIf;
  $this$FUNC.oez(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return ($this$ELSE) => {
    $this$ELSE.uez($this$ELSE.uf0($this$ELSE.cf0($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$_get_opBorderInner_$ref_ygse5o() {
  return constructCallableReference((p0) => p0.kge(), 1, 0, 179);
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.uez($this$FUNC.vf0(1.0, $this$FUNC.ef0($this$FUNC.zf0($this$FUNC.wey(d, $this$FUNC.hf0(d)), 0.5), $this$FUNC.pey(0.0), $this$FUNC.pey(1.0))));
  return Unit_instance;
}
function SDFShaders$_get_opAA_$ref_mqoapw() {
  return constructCallableReference((p0) => p0.lge(), 1, 0, 180);
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.uez($this$FUNC.ef0($this$FUNC.zf0($this$FUNC.wey(d, $this$FUNC.hf0(d)), 0.5), $this$FUNC.pey(0.0), $this$FUNC.pey(1.0)));
  return Unit_instance;
}
function SDFShaders$_get_opAARev_$ref_nlalub() {
  return constructCallableReference((p0) => p0.mge(), 1, 0, 181);
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.kez($this$FUNC.ef0($this$FUNC.yf0(0.5, $this$FUNC.wey($this$FUNC.af1(0.5, $this$FUNC.uf0(d2, d1)), k)), $this$FUNC.pey(0.0), $this$FUNC.pey(1.0)));
  $this$FUNC.uez($this$FUNC.uf0($this$FUNC.if0(d2, d1, h), $this$FUNC.ney($this$FUNC.ney(k, h), $this$FUNC.vf0(1.0, h))));
  return Unit_instance;
}
function SDFShaders$_get_opSmoothUnion_$ref_wprp3p() {
  return constructCallableReference((p0) => p0.nge(), 1, 0, 182);
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.kez($this$FUNC.ef0($this$FUNC.vf0(0.5, $this$FUNC.wey($this$FUNC.af1(0.5, $this$FUNC.xf0(d2, d1)), k)), $this$FUNC.pey(0.0), $this$FUNC.pey(1.0)));
  $this$FUNC.uez($this$FUNC.xf0($this$FUNC.if0(d2, $this$FUNC.tf0(d1), h), $this$FUNC.ney($this$FUNC.ney(k, h), $this$FUNC.vf0(1.0, h))));
  return Unit_instance;
}
function SDFShaders$_get_opSmoothSubtraction_$ref_tx1hqo() {
  return constructCallableReference((p0) => p0.oge(), 1, 0, 183);
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.kez($this$FUNC.ef0($this$FUNC.vf0(0.5, $this$FUNC.wey($this$FUNC.af1(0.5, $this$FUNC.uf0(d2, d1)), k)), $this$FUNC.pey(0.0), $this$FUNC.pey(1.0)));
  $this$FUNC.uez($this$FUNC.xf0($this$FUNC.if0(d2, d1, h), $this$FUNC.ney($this$FUNC.ney(k, h), $this$FUNC.vf0(1.0, h))));
  return Unit_instance;
}
function SDFShaders$_get_opSmoothIntersection_$ref_g7mgmr() {
  return constructCallableReference((p0) => p0.pge(), 1, 0, 184);
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.uez($this$FUNC.uf0($this$FUNC.tfk(p), r));
  return Unit_instance;
}
function SDFShaders$_get_circle_$ref_82iglx() {
  return constructCallableReference((p0) => p0.qge(), 1, 0, 185);
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  $this$FUNC.jey($this$FUNC.sey(r, 'xy'), $this$FUNC.sfk($this$FUNC.ufk($this$FUNC.pf0(p), 0.0), $this$FUNC.sey(r, 'xy'), $this$FUNC.sey(r, 'zw')));
  $this$FUNC.jey($this$FUNC.pf0(r), $this$FUNC.sfk($this$FUNC.ufk($this$FUNC.qf0(p), 0.0), $this$FUNC.pf0(r), $this$FUNC.qf0(r)));
  var q = $this$FUNC.kez($this$FUNC.xf0($this$FUNC.uf0($this$FUNC.cf0(p), b), $this$FUNC.pf0(r)));
  $this$FUNC.uez($this$FUNC.uf0($this$FUNC.xf0($this$FUNC.ff0($this$FUNC.gf0($this$FUNC.pf0(q), $this$FUNC.qf0(q)), $this$FUNC.pey(0.0)), $this$FUNC.tfk($this$FUNC.gf0(q, $this$FUNC.pey(0.0)))), $this$FUNC.pf0(r)));
  return Unit_instance;
}
function SDFShaders$_get_roundedBox_$ref_o204ah() {
  return constructCallableReference((p0) => p0.rge(), 1, 0, 186);
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.kez($this$FUNC.uf0($this$FUNC.cf0(p), b));
  $this$FUNC.uez($this$FUNC.xf0($this$FUNC.tfk($this$FUNC.gf0(d, $this$FUNC.pey(0.0))), $this$FUNC.ff0($this$FUNC.gf0($this$FUNC.pf0(d), $this$FUNC.qf0(d)), $this$FUNC.pey(0.0))));
  return Unit_instance;
}
function SDFShaders$_get_box_$ref_yzz852() {
  return constructCallableReference((p0) => p0.sge(), 1, 0, 187);
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.uez($this$FUNC.xf0(src, $this$FUNC.ney(dst, $this$FUNC.vf0(1.0, $this$FUNC.uey(src)))));
  return Unit_instance;
}
function SDFShaders$_get_opCombinePremultipliedColors_$ref_995q2r() {
  return constructCallableReference((p0) => p0.tge(), 1, 0, 188);
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.uge();
  return SDFShaders_instance;
}
function Texture(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.w9z() : right;
  bottom = bottom === VOID ? base.x9z() : bottom;
  return new RectSlice(base, Companion_instance_2.v9p(left, top, right, bottom));
}
function Texture_0(frameBuffer) {
  return Texture_1(frameBuffer.jek(), frameBuffer.seg_1, frameBuffer.teg_1);
}
function Texture_1(agBase, width, height) {
  return new RectSlice(TextureBase.vge(agBase, SizeInt.q9s(width, height)), RectangleInt.s9q(0, 0, width, height));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_67;
function Companion_getInstance_74() {
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.agf_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.bgf_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function get_2(_this__u8e3s4, initial, end) {
  return new V2(_this__u8e3s4, initial, end, _interpolatePoint$ref(), true);
}
function get_3(_this__u8e3s4, initial, end) {
  return new V2(_this__u8e3s4, initial, end, _interpolateSize$ref(), true);
}
function V2Callback(init, callback) {
  var tmp;
  if (init === VOID) {
    tmp = V2Callback$lambda;
  } else {
    tmp = init;
  }
  init = tmp;
  var tmp0 = V2CallbackSupport_getInstance();
  var tmp_0 = KMutableProperty0;
  var tmp_1 = V2CallbackSupport$_get_dummy_$ref_wgz62m(tmp0);
  var tmp_2 = getPropertyCallableRef('dummy', 0, tmp_0, tmp_1, V2CallbackSupport$_set_dummy_$ref_99afhy(tmp0));
  return new V2(tmp_2, Unit_instance, Unit_instance, V2Callback$lambda_0(callback), true, VOID, VOID, init);
}
function _interpolate(ratio, l, r) {
  return interpolate_0(ratio, l, r);
}
function _interpolateColor(ratio, l, r) {
  return Companion_getInstance_11().ecj(l, r, ratio);
}
function _interpolatePoint(ratio, l, r) {
  return interpolate(ratio, l, r);
}
function _interpolateSize(ratio, l, r) {
  return interpolate_3(ratio, l, r);
}
var V2CallbackSupport_instance;
function V2CallbackSupport_getInstance() {
  if (V2CallbackSupport_instance === VOID)
    new V2CallbackSupport();
  return V2CallbackSupport_instance;
}
function _interpolateRatio(ratio, l, r) {
  return interpolate_1(ratio, l, r);
}
function get_4(_this__u8e3s4, initial, end) {
  return new V2(_this__u8e3s4, initial, end, _interpolateInterpolable$ref(), true);
}
function _interpolateInterpolable(ratio, l, r) {
  return interpolate_2(ratio, l, r);
}
function _interpolateAngle(ratio, l, r) {
  return interpolateAngleNormalized(ratio, l, r);
}
function _interpolatePoint$ref() {
  return constructCallableReference((p0, p1, p2) => _interpolatePoint(p0.v9f_1, p1, p2), 3, 0, 189, '_interpolatePoint');
}
function _interpolateSize$ref() {
  return constructCallableReference((p0, p1, p2) => _interpolateSize(p0.v9f_1, p1, p2), 3, 0, 190, '_interpolateSize');
}
function V2Callback$lambda() {
  return Unit_instance;
}
function V2CallbackSupport$_get_dummy_$ref_wgz62m(p0) {
  return constructCallableReference(() => Unit_instance, 0, 0, 191, VOID, [p0]);
}
function V2CallbackSupport$_set_dummy_$ref_99afhy(p0) {
  return constructCallableReference((p0_0) => {
    p0.agg_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 192, VOID, [p0]);
}
function V2Callback$lambda_0($callback) {
  return (ratio, _unused_var__etf5q3, _unused_var__etf5q3_0) => {
    $callback(ratio);
    return Unit_instance;
  };
}
function _interpolateInterpolable$ref() {
  return constructCallableReference((p0, p1, p2) => _interpolateInterpolable(p0.v9f_1, p1, p2), 3, 0, 193, '_interpolateInterpolable');
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_68;
function Companion_getInstance_75() {
  Cursor_initEntries();
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_75();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  var tmp = KProperty1;
  return $this.hgh_1.yq($this, getPropertyCallableRef('fpsCached', 1, tmp, GameWindow$_get_fpsCached_$ref_sbqskz(), null));
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return () => this$0.agj();
}
function GameWindow$_get_fpsCached_$ref_sbqskz() {
  return constructCallableReference((p0) => _get_fpsCached__581dty(p0), 1, 0, 194);
}
function GameWindow$loop$slambda($entry, this$0) {
  return constructCallableReference(function *($completion) {
    yield* $entry(this$0, $completion);
    return Unit_instance;
  }, 0);
}
function GameWindow$_get_continuousRenderMode_$ref_vajq30() {
  return constructCallableReference((p0) => p0.egj(), 1, 0, 195);
}
function GameWindow$_set_continuousRenderMode_$ref_z8748w() {
  return constructCallableReference((p0, p1) => {
    p0.fgj(p1);
    return Unit_instance;
  }, 2, 0, 196);
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_TEXT_getInstance() {
  Cursor_initEntries();
  return Cursor_TEXT_instance;
}
function Cursor_HAND_getInstance() {
  Cursor_initEntries();
  return Cursor_HAND_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_QUALITY_getInstance() {
  Quality_initEntries();
  return Quality_QUALITY_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_69;
function Companion_getInstance_76() {
  if (Companion_instance_69 === VOID)
    new Companion_60();
  return Companion_instance_69;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().ac3_1 : bgcolor;
  _this__u8e3s4.tgk(numberToInt(size.j9i_1), numberToInt(size.k9i_1));
  if (!(title == null)) {
    _this__u8e3s4.kgk(title);
  }
  _this__u8e3s4.lgk(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.mgk(fullscreen);
  }
  _this__u8e3s4.ogk(bgcolor);
  _this__u8e3s4.ngk(true);
}
var Companion_instance_70;
function Companion_getInstance_77() {
  if (Companion_instance_70 === VOID)
    new Companion_61();
  return Companion_instance_70;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().me5());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.fgm_1, b.fgm_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return (it) => {
    $task.igm_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return () => {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this$0.pgj_1.i9w_1;
    this$0.ogj_1.qa4($task);
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return () => {
    $block.c1t();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return (it) => {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return () => {
    var tmp;
    if (!($cancelled._v == null)) {
      var tmp0 = $continuation;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.qd(tmp$ret$1);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
      this_0.qd(tmp$ret$3);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return () => {
    $block.c1t();
    return Unit_instance;
  };
}
var Companion_instance_71;
function Companion_getInstance_78() {
  return Companion_instance_71;
}
var korgwJvmEngine;
function get_SDLPath() {
  _init_properties_SDL_kt__pqu7sn();
  var tmp0 = SDLPath$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('SDLPath', 0, tmp, _get_SDLPath_$ref_mybl40(), null);
  return tmp0.k3();
}
var SDLPath$delegate;
var Companion_instance_72;
function Companion_getInstance_79() {
  return Companion_instance_72;
}
function SDL$_get_SDL_Init_$ref_fdpb0v() {
  return constructCallableReference((p0) => p0.zgn(), 1, 0, 197);
}
function SDL$_get_SDL_CreateWindow_$ref_e58syb() {
  return constructCallableReference((p0) => p0.ago(), 1, 0, 198);
}
function SDL$_get_SDL_SetWindowTitle_$ref_icmwbr() {
  return constructCallableReference((p0) => p0.bgo(), 1, 0, 199);
}
function SDL$_get_SDL_SetWindowSize_$ref_ckt22g() {
  return constructCallableReference((p0) => p0.cgo(), 1, 0, 200);
}
function SDL$_get_SDL_SetWindowPosition_$ref_2c0hsw() {
  return constructCallableReference((p0) => p0.dgo(), 1, 0, 201);
}
function SDL$_get_SDL_ShowWindow_$ref_83ud82() {
  return constructCallableReference((p0) => p0.ego(), 1, 0, 202);
}
function SDL$_get_SDL_RaiseWindow_$ref_ttmwsf() {
  return constructCallableReference((p0) => p0.fgo(), 1, 0, 203);
}
function SDL$_get_SDL_PollEvent_$ref_uu6x8g() {
  return constructCallableReference((p0) => p0.ggo(), 1, 0, 204);
}
function SDL$_get_SDL_Quit_$ref_lztjv4() {
  return constructCallableReference((p0) => p0.hgo(), 1, 0, 205);
}
function SDL$_get_SDL_GL_CreateContext_$ref_c6mh1i() {
  return constructCallableReference((p0) => p0.igo(), 1, 0, 206);
}
function SDL$_get_SDL_GL_DeleteContext_$ref_thj01h() {
  return constructCallableReference((p0) => p0.jgo(), 1, 0, 207);
}
function SDL$_get_SDL_GL_MakeCurrent_$ref_ivrniq() {
  return constructCallableReference((p0) => p0.kgo(), 1, 0, 208);
}
function SDL$_get_SDL_GL_SwapWindow_$ref_v4dmea() {
  return constructCallableReference((p0) => p0.lgo(), 1, 0, 209);
}
var Companion_instance_73;
function Companion_getInstance_80() {
  return Companion_instance_73;
}
function OpenGL$_get_glDrawArraysInstanced_$ref_u1p2u7() {
  return constructCallableReference((p0) => p0.agy(), 1, 0, 210);
}
function OpenGL$_get_glDrawElementsInstanced_$ref_ngtsf8() {
  return constructCallableReference((p0) => p0.bgy(), 1, 0, 211);
}
function OpenGL$_get_glVertexAttribDivisor_$ref_e0aam8() {
  return constructCallableReference((p0) => p0.cgy(), 1, 0, 212);
}
function OpenGL$_get_glTexSubImage2D_$ref_ot6p7g() {
  return constructCallableReference((p0) => p0.jgy(), 1, 0, 213);
}
function OpenGL$_get_glTexImage2D_$ref_hd9bwc() {
  return constructCallableReference((p0) => p0.jgx(), 1, 0, 214);
}
function OpenGL$_get_glTexParameteri_$ref_6ujtm1() {
  return constructCallableReference((p0) => p0.kgx(), 1, 0, 215);
}
function OpenGL$_get_glTexParameterf_$ref_5feyfg() {
  return constructCallableReference((p0) => p0.kgy(), 1, 0, 216);
}
function OpenGL$_get_glTexParameterfv_$ref_hy0keg() {
  return constructCallableReference((p0) => p0.lgy(), 1, 0, 217);
}
function OpenGL$_get_glTexParameteriv_$ref_q36a9n() {
  return constructCallableReference((p0) => p0.mgy(), 1, 0, 218);
}
function OpenGL$_get_glStencilOp_$ref_xgguj7() {
  return constructCallableReference((p0) => p0.hgx(), 1, 0, 219);
}
function OpenGL$_get_glStencilMask_$ref_cflgew() {
  return constructCallableReference((p0) => p0.fgx(), 1, 0, 220);
}
function OpenGL$_get_glReadPixels_$ref_oohu9z() {
  return constructCallableReference((p0) => p0.zgw(), 1, 0, 221);
}
function OpenGL$_get_glStencilFunc_$ref_e7srow() {
  return constructCallableReference((p0) => p0.dgx(), 1, 0, 222);
}
function OpenGL$_get_glScissor_$ref_e6ft78() {
  return constructCallableReference((p0) => p0.bgx(), 1, 0, 223);
}
function OpenGL$_get_glPolygonOffset_$ref_oqmkwz() {
  return constructCallableReference((p0) => p0.ngy(), 1, 0, 224);
}
function OpenGL$_get_glPixelStorei_$ref_ywwdb6() {
  return constructCallableReference((p0) => p0.ygw(), 1, 0, 225);
}
function OpenGL$_get_glLineWidth_$ref_1ljuf6() {
  return constructCallableReference((p0) => p0.ogy(), 1, 0, 226);
}
function OpenGL$_get_glGetTexParameterfv_$ref_gfvs8() {
  return constructCallableReference((p0) => p0.pgy(), 1, 0, 227);
}
function OpenGL$_get_glGetTexParameteriv_$ref_qjhbit() {
  return constructCallableReference((p0) => p0.qgy(), 1, 0, 228);
}
function OpenGL$_get_glGetError_$ref_48ki14() {
  return constructCallableReference((p0) => p0.rgw(), 1, 0, 229);
}
function OpenGL$_get_glGetFloatv_$ref_qyzna8() {
  return constructCallableReference((p0) => p0.rgy(), 1, 0, 230);
}
function OpenGL$_get_glGetIntegerv_$ref_oigptu() {
  return constructCallableReference((p0) => p0.sgw(), 1, 0, 231);
}
function OpenGL$_get_glGetBooleanv_$ref_17fmss() {
  return constructCallableReference((p0) => p0.sgy(), 1, 0, 232);
}
function OpenGL$_get_glGenTextures_$ref_omr6fc() {
  return constructCallableReference((p0) => p0.pgw(), 1, 0, 233);
}
function OpenGL$_get_glDepthRange_$ref_7h8k9c() {
  return constructCallableReference((p0) => p0.tgy(), 1, 0, 234);
}
function OpenGL$_get_glDepthRangef_$ref_wzcry4() {
  return constructCallableReference((p0) => p0.agw(), 1, 0, 235);
}
function OpenGL$_get_glClearDepth_$ref_sjvems() {
  return constructCallableReference((p0) => p0.ugy(), 1, 0, 236);
}
function OpenGL$_get_glClearDepthf_$ref_izp45c() {
  return constructCallableReference((p0) => p0.lgv(), 1, 0, 237);
}
function OpenGL$_get_glDrawArrays_$ref_58aslw() {
  return constructCallableReference((p0) => p0.dgw(), 1, 0, 238);
}
function OpenGL$_get_glDrawElements_$ref_j22jw1() {
  return constructCallableReference((p0) => p0.egw(), 1, 0, 239);
}
function OpenGL$_get_glFrontFace_$ref_10zhh2() {
  return constructCallableReference((p0) => p0.kgw(), 1, 0, 240);
}
function OpenGL$_get_glFinish_$ref_a9jkgn() {
  return constructCallableReference((p0) => p0.vgy(), 1, 0, 241);
}
function OpenGL$_get_glFlush_$ref_hbpd7w() {
  return constructCallableReference((p0) => p0.hgw(), 1, 0, 242);
}
function OpenGL$_get_glEnable_$ref_zdgp5z() {
  return constructCallableReference((p0) => p0.fgw(), 1, 0, 243);
}
function OpenGL$_get_glIsEnabled_$ref_ibwkwp() {
  return constructCallableReference((p0) => p0.wgy(), 1, 0, 244);
}
function OpenGL$_get_glDisable_$ref_hoj2m0() {
  return constructCallableReference((p0) => p0.bgw(), 1, 0, 245);
}
function OpenGL$_get_glDepthMask_$ref_tykd6n() {
  return constructCallableReference((p0) => p0.zgv(), 1, 0, 246);
}
function OpenGL$_get_glDepthFunc_$ref_vqrogn() {
  return constructCallableReference((p0) => p0.ygv(), 1, 0, 247);
}
function OpenGL$_get_glDeleteTextures_$ref_vpf7h5() {
  return constructCallableReference((p0) => p0.xgv(), 1, 0, 248);
}
function OpenGL$_get_glCullFace_$ref_lyfha3() {
  return constructCallableReference((p0) => p0.rgv(), 1, 0, 249);
}
function OpenGL$_get_glCopyTexImage2D_$ref_12iy8f() {
  return constructCallableReference((p0) => p0.xgy(), 1, 0, 250);
}
function OpenGL$_get_glCopyTexSubImage2D_$ref_r7972n() {
  return constructCallableReference((p0) => p0.ygy(), 1, 0, 251);
}
function OpenGL$_get_glColorMask_$ref_xlmwdb() {
  return constructCallableReference((p0) => p0.ngv(), 1, 0, 252);
}
function OpenGL$_get_glClearStencil_$ref_cyn4zp() {
  return constructCallableReference((p0) => p0.mgv(), 1, 0, 253);
}
function OpenGL$_get_glClearColor_$ref_ovlm18() {
  return constructCallableReference((p0) => p0.kgv(), 1, 0, 254);
}
function OpenGL$_get_glClear_$ref_gr5car() {
  return constructCallableReference((p0) => p0.jgv(), 1, 0, 255);
}
function OpenGL$_get_glBindTexture_$ref_ikazn2() {
  return constructCallableReference((p0) => p0.egv(), 1, 0, 256);
}
function OpenGL$_get_glHint_$ref_o1skrn() {
  return constructCallableReference((p0) => p0.zgy(), 1, 0, 257);
}
function OpenGL$_get_glViewport_$ref_jzsdt0() {
  return constructCallableReference((p0) => p0.zgx(), 1, 0, 258);
}
function OpenGL$_get_glGetString_$ref_fj04nd() {
  return constructCallableReference((p0) => p0.wgw(), 1, 0, 259);
}
function OpenGL$_get_glGetStringi_$ref_4v6he0() {
  return constructCallableReference((p0) => p0.agz(), 1, 0, 260);
}
function OpenGL$_get_glVertexAttribPointer_$ref_8ozh8f() {
  return constructCallableReference((p0) => p0.ygx(), 1, 0, 261);
}
function OpenGL$_get_glVertexAttrib4fv_$ref_i22oze() {
  return constructCallableReference((p0) => p0.bgz(), 1, 0, 262);
}
function OpenGL$_get_glActiveTexture_$ref_6v6wm3() {
  return constructCallableReference((p0) => p0.ygu(), 1, 0, 263);
}
function OpenGL$_get_glAttachShader_$ref_5wudxc() {
  return constructCallableReference((p0) => p0.zgu(), 1, 0, 264);
}
function OpenGL$_get_glBindAttribLocation_$ref_dl103y() {
  return constructCallableReference((p0) => p0.agv(), 1, 0, 265);
}
function OpenGL$_get_glBindBuffer_$ref_esyx8t() {
  return constructCallableReference((p0) => p0.bgv(), 1, 0, 266);
}
function OpenGL$_get_glBindFramebuffer_$ref_ravdz4() {
  return constructCallableReference((p0) => p0.cgv(), 1, 0, 267);
}
function OpenGL$_get_glBindRenderbuffer_$ref_aricg9() {
  return constructCallableReference((p0) => p0.dgv(), 1, 0, 268);
}
function OpenGL$_get_glBlendColor_$ref_w6qdhk() {
  return constructCallableReference((p0) => p0.cgz(), 1, 0, 269);
}
function OpenGL$_get_glBlendEquation_$ref_oeso43() {
  return constructCallableReference((p0) => p0.dgz(), 1, 0, 270);
}
function OpenGL$_get_glBlendEquationSeparate_$ref_r5jrrk() {
  return constructCallableReference((p0) => p0.fgv(), 1, 0, 271);
}
function OpenGL$_get_glBlendFunc_$ref_n80uw5() {
  return constructCallableReference((p0) => p0.egz(), 1, 0, 272);
}
function OpenGL$_get_glBlendFuncSeparate_$ref_bapj9k() {
  return constructCallableReference((p0) => p0.ggv(), 1, 0, 273);
}
function OpenGL$_get_glBufferData_$ref_bi09ts() {
  return constructCallableReference((p0) => p0.hgv(), 1, 0, 274);
}
function OpenGL$_get_glBufferSubData_$ref_ypz5y() {
  return constructCallableReference((p0) => p0.igv(), 1, 0, 275);
}
function OpenGL$_get_glCheckFramebufferStatus_$ref_n8hay5() {
  return constructCallableReference((p0) => p0.fgz(), 1, 0, 276);
}
function OpenGL$_get_glCompileShader_$ref_1vlby0() {
  return constructCallableReference((p0) => p0.ogv(), 1, 0, 277);
}
function OpenGL$_get_glCompressedTexImage2D_$ref_6a7ukj() {
  return constructCallableReference((p0) => p0.ggz(), 1, 0, 278);
}
function OpenGL$_get_glCompressedTexSubImage2D_$ref_j9i56l() {
  return constructCallableReference((p0) => p0.hgz(), 1, 0, 279);
}
function OpenGL$_get_glCreateProgram_$ref_fbgki0() {
  return constructCallableReference((p0) => p0.pgv(), 1, 0, 280);
}
function OpenGL$_get_glCreateShader_$ref_j1n6qx() {
  return constructCallableReference((p0) => p0.qgv(), 1, 0, 281);
}
function OpenGL$_get_glDeleteBuffers_$ref_7jx1zs() {
  return constructCallableReference((p0) => p0.sgv(), 1, 0, 282);
}
function OpenGL$_get_glDeleteFramebuffers_$ref_s5tsqh() {
  return constructCallableReference((p0) => p0.tgv(), 1, 0, 283);
}
function OpenGL$_get_glDeleteProgram_$ref_wmd3hz() {
  return constructCallableReference((p0) => p0.ugv(), 1, 0, 284);
}
function OpenGL$_get_glDeleteRenderbuffers_$ref_fnagu6() {
  return constructCallableReference((p0) => p0.vgv(), 1, 0, 285);
}
function OpenGL$_get_glDeleteShader_$ref_85at3u() {
  return constructCallableReference((p0) => p0.wgv(), 1, 0, 286);
}
function OpenGL$_get_glDetachShader_$ref_p7me4u() {
  return constructCallableReference((p0) => p0.igz(), 1, 0, 287);
}
function OpenGL$_get_glDisableVertexAttribArray_$ref_canr21() {
  return constructCallableReference((p0) => p0.cgw(), 1, 0, 288);
}
function OpenGL$_get_glEnableVertexAttribArray_$ref_mrvgzs() {
  return constructCallableReference((p0) => p0.ggw(), 1, 0, 289);
}
function OpenGL$_get_glFramebufferRenderbuffer_$ref_hhwykz() {
  return constructCallableReference((p0) => p0.igw(), 1, 0, 290);
}
function OpenGL$_get_glFramebufferTexture2D_$ref_g6yiuu() {
  return constructCallableReference((p0) => p0.jgw(), 1, 0, 291);
}
function OpenGL$_get_glGenBuffers_$ref_3fgg4n() {
  return constructCallableReference((p0) => p0.lgw(), 1, 0, 292);
}
function OpenGL$_get_glGenerateMipmap_$ref_75ep0z() {
  return constructCallableReference((p0) => p0.mgw(), 1, 0, 293);
}
function OpenGL$_get_glGenFramebuffers_$ref_og1dlm() {
  return constructCallableReference((p0) => p0.ngw(), 1, 0, 294);
}
function OpenGL$_get_glGenRenderbuffers_$ref_sj2idf() {
  return constructCallableReference((p0) => p0.ogw(), 1, 0, 295);
}
function OpenGL$_get_glGetActiveAttrib_$ref_hic01i() {
  return constructCallableReference((p0) => p0.jgz(), 1, 0, 296);
}
function OpenGL$_get_glGetActiveUniform_$ref_5ujg6q() {
  return constructCallableReference((p0) => p0.kgz(), 1, 0, 297);
}
function OpenGL$_get_glGetAttachedShaders_$ref_tulvfa() {
  return constructCallableReference((p0) => p0.lgz(), 1, 0, 298);
}
function OpenGL$_get_glGetAttribLocation_$ref_lv3vph() {
  return constructCallableReference((p0) => p0.mgz(), 1, 0, 299);
}
function OpenGL$_get_glGetUniformLocation_$ref_fup42x() {
  return constructCallableReference((p0) => p0.qgw(), 1, 0, 300);
}
function OpenGL$_get_glGetBufferParameteriv_$ref_xxl2a2() {
  return constructCallableReference((p0) => p0.ngz(), 1, 0, 301);
}
function OpenGL$_get_glGetFramebufferAttachmentParameteriv_$ref_sjmcxg() {
  return constructCallableReference((p0) => p0.ogz(), 1, 0, 302);
}
function OpenGL$_get_glGetProgramInfoLog_$ref_js6e94() {
  return constructCallableReference((p0) => p0.pgz(), 1, 0, 303);
}
function OpenGL$_get_glGetRenderbufferParameteriv_$ref_r8jfj4() {
  return constructCallableReference((p0) => p0.qgz(), 1, 0, 304);
}
function OpenGL$_get_glGetProgramiv_$ref_wgrcbz() {
  return constructCallableReference((p0) => p0.tgw(), 1, 0, 305);
}
function OpenGL$_get_glGetShaderiv_$ref_iwrqoo() {
  return constructCallableReference((p0) => p0.ugw(), 1, 0, 306);
}
function OpenGL$_get_glGetShaderInfoLog_$ref_fszgwf() {
  return constructCallableReference((p0) => p0.vgw(), 1, 0, 307);
}
function OpenGL$_get_glGetShaderPrecisionFormat_$ref_jq4d3k() {
  return constructCallableReference((p0) => p0.rgz(), 1, 0, 308);
}
function OpenGL$_get_glGetShaderSource_$ref_pj8uze() {
  return constructCallableReference((p0) => p0.sgz(), 1, 0, 309);
}
function OpenGL$_get_glGetUniformfv_$ref_i91n0k() {
  return constructCallableReference((p0) => p0.tgz(), 1, 0, 310);
}
function OpenGL$_get_glGetUniformiv_$ref_ps57nj() {
  return constructCallableReference((p0) => p0.ugz(), 1, 0, 311);
}
function OpenGL$_get_glGetVertexAttribfv_$ref_cluoyk() {
  return constructCallableReference((p0) => p0.vgz(), 1, 0, 312);
}
function OpenGL$_get_glGetVertexAttribiv_$ref_ee2ich() {
  return constructCallableReference((p0) => p0.wgz(), 1, 0, 313);
}
function OpenGL$_get_glGetVertexAttribPointerv_$ref_dobxt9() {
  return constructCallableReference((p0) => p0.xgz(), 1, 0, 314);
}
function OpenGL$_get_glIsBuffer_$ref_4dxhq8() {
  return constructCallableReference((p0) => p0.ygz(), 1, 0, 315);
}
function OpenGL$_get_glIsFramebuffer_$ref_44fxeb() {
  return constructCallableReference((p0) => p0.zgz(), 1, 0, 316);
}
function OpenGL$_get_glIsProgram_$ref_bgwnt6() {
  return constructCallableReference((p0) => p0.ah0(), 1, 0, 317);
}
function OpenGL$_get_glIsRenderbuffer_$ref_2jbmae() {
  return constructCallableReference((p0) => p0.bh0(), 1, 0, 318);
}
function OpenGL$_get_glIsTexture_$ref_dn0x8f() {
  return constructCallableReference((p0) => p0.ch0(), 1, 0, 319);
}
function OpenGL$_get_glIsShader_$ref_blsvid() {
  return constructCallableReference((p0) => p0.dh0(), 1, 0, 320);
}
function OpenGL$_get_glLinkProgram_$ref_k0e64a() {
  return constructCallableReference((p0) => p0.xgw(), 1, 0, 321);
}
function OpenGL$_get_glReleaseShaderCompiler_$ref_8da41x() {
  return constructCallableReference((p0) => p0.eh0(), 1, 0, 322);
}
function OpenGL$_get_glRenderbufferStorage_$ref_qen0i3() {
  return constructCallableReference((p0) => p0.agx(), 1, 0, 323);
}
function OpenGL$_get_glSampleCoverage_$ref_sixmzc() {
  return constructCallableReference((p0) => p0.fh0(), 1, 0, 324);
}
function OpenGL$_get_glShaderBinary_$ref_j1pcqs() {
  return constructCallableReference((p0) => p0.gh0(), 1, 0, 325);
}
function OpenGL$_get_glShaderSource_$ref_sd8a3a() {
  return constructCallableReference((p0) => p0.cgx(), 1, 0, 326);
}
function OpenGL$_get_glStencilFuncSeparate_$ref_f9hv8t() {
  return constructCallableReference((p0) => p0.egx(), 1, 0, 327);
}
function OpenGL$_get_glStencilMaskSeparate_$ref_rm3vsr() {
  return constructCallableReference((p0) => p0.ggx(), 1, 0, 328);
}
function OpenGL$_get_glStencilOpSeparate_$ref_65dhkg() {
  return constructCallableReference((p0) => p0.igx(), 1, 0, 329);
}
function OpenGL$_get_glUniform1f_$ref_5y6rsp() {
  return constructCallableReference((p0) => p0.hh0(), 1, 0, 330);
}
function OpenGL$_get_glUniform2f_$ref_8q7ifc() {
  return constructCallableReference((p0) => p0.ih0(), 1, 0, 331);
}
function OpenGL$_get_glUniform3f_$ref_nelsnd() {
  return constructCallableReference((p0) => p0.jh0(), 1, 0, 332);
}
function OpenGL$_get_glUniform4f_$ref_wy3z3q() {
  return constructCallableReference((p0) => p0.kh0(), 1, 0, 333);
}
function OpenGL$_get_glUniform1i_$ref_4j1wm4() {
  return constructCallableReference((p0) => p0.mgx(), 1, 0, 334);
}
function OpenGL$_get_glUniform2i_$ref_a5cdlx() {
  return constructCallableReference((p0) => p0.lh0(), 1, 0, 335);
}
function OpenGL$_get_glUniform3i_$ref_otqnty() {
  return constructCallableReference((p0) => p0.mh0(), 1, 0, 336);
}
function OpenGL$_get_glUniform4i_$ref_viz3x5() {
  return constructCallableReference((p0) => p0.nh0(), 1, 0, 337);
}
function OpenGL$_get_glUniform1fv_$ref_fi5vj7() {
  return constructCallableReference((p0) => p0.lgx(), 1, 0, 338);
}
function OpenGL$_get_glUniform2fv_$ref_dbglj0() {
  return constructCallableReference((p0) => p0.ogx(), 1, 0, 339);
}
function OpenGL$_get_glUniform3fv_$ref_sw0zdx() {
  return constructCallableReference((p0) => p0.qgx(), 1, 0, 340);
}
function OpenGL$_get_glUniform4fv_$ref_2eibq() {
  return constructCallableReference((p0) => p0.sgx(), 1, 0, 341);
}
function OpenGL$_get_glUniform1iv_$ref_sj0z4w() {
  return constructCallableReference((p0) => p0.ngx(), 1, 0, 342);
}
function OpenGL$_get_glUniform2iv_$ref_dogls1() {
  return constructCallableReference((p0) => p0.pgx(), 1, 0, 343);
}
function OpenGL$_get_glUniform3iv_$ref_f55va6() {
  return constructCallableReference((p0) => p0.rgx(), 1, 0, 344);
}
function OpenGL$_get_glUniform4iv_$ref_r2bpmr() {
  return constructCallableReference((p0) => p0.tgx(), 1, 0, 345);
}
function OpenGL$_get_glUniformMatrix2fv_$ref_y0qw9v() {
  return constructCallableReference((p0) => p0.ugx(), 1, 0, 346);
}
function OpenGL$_get_glUniformMatrix3fv_$ref_574f7o() {
  return constructCallableReference((p0) => p0.vgx(), 1, 0, 347);
}
function OpenGL$_get_glUniformMatrix4fv_$ref_nmi1uj() {
  return constructCallableReference((p0) => p0.wgx(), 1, 0, 348);
}
function OpenGL$_get_glUseProgram_$ref_z5av1p() {
  return constructCallableReference((p0) => p0.xgx(), 1, 0, 349);
}
function OpenGL$_get_glValidateProgram_$ref_pm5azi() {
  return constructCallableReference((p0) => p0.oh0(), 1, 0, 350);
}
function OpenGL$_get_glVertexAttrib1f_$ref_9y45mh() {
  return constructCallableReference((p0) => p0.ph0(), 1, 0, 351);
}
function OpenGL$_get_glVertexAttrib2f_$ref_4qa4lk() {
  return constructCallableReference((p0) => p0.qh0(), 1, 0, 352);
}
function OpenGL$_get_glVertexAttrib3f_$ref_jeoetl() {
  return constructCallableReference((p0) => p0.rh0(), 1, 0, 353);
}
function OpenGL$_get_glVertexAttrib4f_$ref_y32p1m() {
  return constructCallableReference((p0) => p0.sh0(), 1, 0, 354);
}
function OpenGL$_get_glVertexAttrib1fv_$ref_2mbbrx() {
  return constructCallableReference((p0) => p0.th0(), 1, 0, 355);
}
function OpenGL$_get_glVertexAttrib2fv_$ref_vfxsu4() {
  return constructCallableReference((p0) => p0.uh0(), 1, 0, 356);
}
function OpenGL$_get_glVertexAttrib3fv_$ref_arjs2t() {
  return constructCallableReference((p0) => p0.vh0(), 1, 0, 357);
}
function OpenGL$_get_glBindBufferRange_$ref_r4scc0() {
  return constructCallableReference((p0) => p0.dgy(), 1, 0, 358);
}
function OpenGL$_get_glGetUniformBlockIndex_$ref_dpyqt5() {
  return constructCallableReference((p0) => p0.egy(), 1, 0, 359);
}
function OpenGL$_get_glUniformBlockBinding_$ref_jngaho() {
  return constructCallableReference((p0) => p0.fgy(), 1, 0, 360);
}
function OpenGL$_get_glGenVertexArrays_$ref_k7b1ku() {
  return constructCallableReference((p0) => p0.ggy(), 1, 0, 361);
}
function OpenGL$_get_glDeleteVertexArrays_$ref_ghimfz() {
  return constructCallableReference((p0) => p0.wh0(), 1, 0, 362);
}
function OpenGL$_get_glBindVertexArray_$ref_84c148() {
  return constructCallableReference((p0) => p0.hgy(), 1, 0, 363);
}
function SDLPath$delegate$lambda() {
  _init_properties_SDL_kt__pqu7sn();
  return Companion_getInstance_2().sb0() ? '/Library/Frameworks/SDL2.framework/SDL2' : 'SDL2.dll';
}
function _get_SDLPath_$ref_mybl40() {
  return constructCallableReference(() => get_SDLPath(), 0, 0, 364);
}
var properties_initialized_SDL_kt_s4ko39;
function _init_properties_SDL_kt__pqu7sn() {
  if (!properties_initialized_SDL_kt_s4ko39) {
    properties_initialized_SDL_kt_s4ko39 = true;
    SDLPath$delegate = lazy(SDLPath$delegate$lambda);
  }
}
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0 = korgwCanvasQuery$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('korgwCanvasQuery', 0, tmp, _get_korgwCanvasQuery_$ref_xfkbuw(), null);
  return tmp0.k3();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.jm();
    var v = _destruct__k2r9zo.km();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = AGOpengl.kf7(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.teu_1)])));
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0 = document.querySelector(tmp0_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  return window.korgwCanvasQuery;
}
function _get_korgwCanvasQuery_$ref_xfkbuw() {
  return constructCallableReference(() => get_korgwCanvasQuery(), 0, 0, 365);
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return (e) => {
    $ag.aeh();
    return Unit_instance;
  };
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc($this, $receiver) {
  if ($receiver === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if ($receiver.id === undefined) {
    if ($this.jh4_1.n1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.o(toString(message));
    }
    var index = $this.jh4_1.g5($this.jh4_1.s2() - 1 | 0);
    $this.ih4_1[index] = $receiver;
    // Inline function 'kotlin.js.asDynamic' call
    $receiver.id = index;
  }
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  return $receiver.id;
}
function get_5($this, $receiver) {
  var tmp;
  if (!($receiver === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.ih4_1[$receiver];
  } else {
    tmp = null;
  }
  return tmp;
}
function free($this, $receiver) {
  var tmp;
  if (!($receiver === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.ih4_1[$receiver];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.jh4_1.d2($receiver);
    $this.ih4_1[$receiver] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return () => {
    var tmp0_elvis_lhs = this$0.hh4_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$_get_extensions_$ref_uojgl6() {
  return constructCallableReference((p0) => p0.g81(), 1, 0, 366);
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return () => this$0.hh4_1.getExtension('OES_texture_float_linear') != null || this$0.hh4_1.getExtension('OES_texture_float') != null || this$0.gh4_1 >= 2;
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_2().hb1() ? DenoJsGameWindow.dhd(VOID, config) : Companion_getInstance_2().gb1() ? NodeJsGameWindow.iha() : BrowserCanvasJsGameWindow.wh7();
}
function onResized($this) {
  $this.kh7_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.fgc().zgi(window.innerWidth, window.innerHeight, $this.wgc());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.hh7_1.width = canvasWidth;
    $this.hh7_1.height = canvasHeight;
    $this.hh7_1.style.position = 'absolute';
    $this.hh7_1.style.left = '0';
    $this.hh7_1.style.right = '0';
    $this.hh7_1.style.width = '' + window.innerWidth + 'px';
    $this.hh7_1.style.height = '' + window.innerHeight + 'px';
    $this.ph7_1 = scale;
  } else {
    $this.ph7_1 = $this.hh7_1.width / $this.hh7_1.clientWidth;
  }
  $this.egl(0, 0, $this.hh7_1.width, $this.hh7_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_35().ief();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_35().jef();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_35().eef();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_35().fef();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_35().cef();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_35().def();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_35().gef();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_35().hef();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var tmp0 = CoroutineKey_getInstance().hgg_1;
            // Inline function 'korlibs.logger.Logger.log' call
            var level = Level_INFO_getInstance();
            if (tmp0.obj(level)) {
              var tmp$ret$3 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              tmp0.pbj(level, tmp$ret$3);
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.we7(invoke_0($this.dgh_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.mef()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.hh7_1.getBoundingClientRect();
  var tmp0 = $this.qh7_1;
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  tmp0.xec_1 = Mode_JS_getInstance();
  tmp0.yec(type, false);
  try {
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.ph7_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$3 = (touch.clientY - canvasBounds.top) * $this.ph7_1;
        var tmp_1 = Vector2D.d9m(tmp_0, tmp$ret$3);
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp1_elvis_lhs = touch.force;
        tmp0.bed(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    tmp0.zec();
  }
  // Inline function 'kotlin.also' call
  var this_0 = tmp0.wec_1;
  $this.we7(this_0);
}
function mouseEvent($this, e, type, pressingType) {
  pressingType = pressingType === VOID ? type : pressingType;
  var canvasBounds = $this.hh7_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.ph7_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.ph7_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.egh_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.qhf() || type.equals(Type_SCROLL_getInstance())) {
    $this.we7($this.egh_1);
  }
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.uh7_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function ensureSoftKeyboardInput($this) {
  if ($this.vh7_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.vh7_1 = document.createElement('input');
    var tmp0_safe_receiver = $this.vh7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.id = 'softKeyboardInput';
    }
    var tmp1_safe_receiver = $this.vh7_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.type = 'input';
    }
    var tmp2_safe_receiver = $this.vh7_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp3_safe_receiver.zIndex = '10000000';
      tmp3_safe_receiver.position = 'absolute';
      tmp3_safe_receiver.top = '0';
      tmp3_safe_receiver.left = '0';
      tmp3_safe_receiver.width = '200px';
      tmp3_safe_receiver.height = '24px';
      tmp3_safe_receiver.background = 'transparent';
    }
  }
}
function _get_navigatorClipboard__ni2gks($this) {
  // Inline function 'kotlin.js.unsafeCast' call
  return navigator.clipboard;
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return ($this$keyEvent) => {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.o(toString(message));
    }
    tmp.ye8_1 = tmp_0;
    $this$keyEvent.ze8_1 = 0;
    $this$keyEvent.be9_1 = $me.keyCode;
    $this$keyEvent.ae9_1 = $key;
    $this$keyEvent.de9_1 = $me.shiftKey;
    $this$keyEvent.ee9_1 = $me.ctrlKey;
    $this$keyEvent.fe9_1 = $me.altKey;
    $this$keyEvent.ge9_1 = $me.metaKey;
    $this$keyEvent.ce9_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return ($this$mouseEvent) => {
    $this$mouseEvent.se9_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.fea_1 = false;
    $this$mouseEvent.te9_1 = 0;
    $this$mouseEvent.ue9_1 = $tx;
    $this$mouseEvent.ve9_1 = $ty;
    $this$mouseEvent.we9_1 = Companion_getInstance_36().u2($e.button);
    $this$mouseEvent.xe9_1 = $e.buttons;
    $this$mouseEvent.bea_1 = $e.shiftKey;
    $this$mouseEvent.cea_1 = $e.ctrlKey;
    $this$mouseEvent.dea_1 = $e.altKey;
    $this$mouseEvent.eea_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp0_subject = we.deltaMode;
      var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.mea(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    var tmp0_safe_receiver = this$0.th7_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      yield* cancelAndJoin(tmp0_safe_receiver, $completion);
    window.close();
    return Unit_instance;
  }, 0);
}
function BrowserCanvasJsGameWindow$loop$slambda($entry, this$0) {
  return constructCallableReference(function *($completion) {
    yield* $entry(this$0, $completion);
    return Unit_instance;
  }, 0);
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return (it) => {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return (it) => this$0.jgl(Type_START_getInstance_0(), null);
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return (it) => this$0.jgl(Type_END_getInstance_0(), null);
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return (it) => this$0.jgl(Type_END_getInstance_0(), null);
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return (it) => this$0.jgl(Type_START_getInstance_0(), null);
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return (it) => this$0.jgl(Type_END_getInstance_0(), null);
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return (it) => {
    it.preventDefault();
    this$0.jgl(Type_END_getInstance_0(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = until(0, items.length);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = tmp0.n3_1;
    var last = tmp0.o3_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.d2(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var files = destination;
    return this$0.jgl(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return (step) => {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.zgk();
    return Unit_instance;
  };
}
function DenoJsGameWindow$loop$slambda($entry, this$0) {
  return constructCallableReference(function *($completion) {
    yield* $entry(this$0, $completion);
    return Unit_instance;
  }, 0);
}
function DenoJsGameWindow$loop$lambda(this$0) {
  return () => {
    this$0.wh3();
    this$0.zgk();
    this$0.xh3();
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).say = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).ve7 = dispatch$default;
protoOf(BaseEventListener).xe7 = onEvents;
protoOf(BaseEventListener).ye7 = dispatchDown;
protoOf(BaseEventListener).ze7 = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.je7, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForCompanion(Companion);
initMetadataForClass(Type, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_3);
initMetadataForClass(Type_2, 'Type');
initMetadataForCompanion(Companion_4);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForCompanion(Companion_5);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.ne8);
initMetadataForCompanion(Companion_6);
initMetadataForClass(Type_3, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_12);
initMetadataForCompanion(Companion_13);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_14);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_20);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForInterface(ISoftKeyboardConfig, 'ISoftKeyboardConfig');
initMetadataForClass(SoftKeyboardType, 'SoftKeyboardType');
initMetadataForClass(SoftKeyboardReturnKeyType, 'SoftKeyboardReturnKeyType');
initMetadataForClass(SoftKeyboardConfig, 'SoftKeyboardConfig', SoftKeyboardConfig, VOID, [ISoftKeyboardConfig]);
initMetadataForCompanion(Companion_21);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).geh = get_parentFeatures;
protoOf(AG).heh = get_isUniformBuffersSupported;
protoOf(AG).ieh = get_isVertexArraysSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForCompanion(Companion_22);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.yeg, VOID, [AutoCloseable]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.jem);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_24);
initMetadataForClass(AGTextureUnitInfo, 'AGTextureUnitInfo');
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForCompanion(Companion_25);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_26);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGDrawType, 'AGDrawType');
initMetadataForCompanion(Companion_29);
initMetadataForClass(AGColorMask, 'AGColorMask');
initMetadataForCompanion(Companion_30);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_32);
initMetadataForClass(AGCullFace, 'AGCullFace');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData);
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_35);
initMetadataForCompanion(Companion_36);
initMetadataForCompanion(Companion_37);
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_39);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_40);
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_43);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).xez = get_Float1;
protoOf(Builder).tfl = get_Float2;
protoOf(Builder).ufl = get_Float4;
protoOf(Builder).mey = get_out;
protoOf(Builder).yez = atan;
protoOf(Builder).tey = texture2D;
protoOf(Builder).sfk = TERNARY;
protoOf(Builder).zez = pow;
protoOf(Builder).af0 = exp;
protoOf(Builder).bf0 = sqrt;
protoOf(Builder).cf0 = abs;
protoOf(Builder).df0 = fract;
protoOf(Builder).ef0 = clamp;
protoOf(Builder).ff0 = min_0;
protoOf(Builder).gf0 = max_1;
protoOf(Builder).hf0 = fwidth;
protoOf(Builder).if0 = mix;
protoOf(Builder).jf0 = smoothstep;
protoOf(Builder).tfk = length;
protoOf(Builder).kf0 = dot;
protoOf(Builder).pey = get_lit;
protoOf(Builder).lf0 = vec2;
protoOf(Builder).mf0 = vec2_0;
protoOf(Builder).nf0 = vec3;
protoOf(Builder).of0 = vec3_0;
protoOf(Builder).qey = vec4;
protoOf(Builder).sey = get_1;
protoOf(Builder).pf0 = get_x;
protoOf(Builder).qf0 = get_y;
protoOf(Builder).rf0 = get_z;
protoOf(Builder).sf0 = get_w;
protoOf(Builder).uey = get_a;
protoOf(Builder).tf0 = unaryMinus;
protoOf(Builder).uf0 = minus_0;
protoOf(Builder).vf0 = minus_1;
protoOf(Builder).wf0 = minus_2;
protoOf(Builder).xf0 = plus_2;
protoOf(Builder).yf0 = plus_3;
protoOf(Builder).zf0 = plus_4;
protoOf(Builder).ney = times;
protoOf(Builder).af1 = times_0;
protoOf(Builder).bf1 = times_1;
protoOf(Builder).wey = div;
protoOf(Builder).cf1 = div_0;
protoOf(Builder).df1 = eq;
protoOf(Builder).ef1 = lt;
protoOf(Builder).ff1 = le;
protoOf(Builder).gf1 = gt;
protoOf(Builder).ufk = gt_0;
initMetadataForClass(Builder, 'Builder', Builder.xey, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).iew = get_u_Tex;
protoOf(ProgramBuilderDefault).jev = get_u_ProjMat;
protoOf(ProgramBuilderDefault).kev = get_u_ViewMat;
protoOf(ProgramBuilderDefault).oey = get_a_Pos;
protoOf(ProgramBuilderDefault).gey = get_a_Tex;
protoOf(ProgramBuilderDefault).ley = get_a_Col;
protoOf(ProgramBuilderDefault).fey = get_v_Tex;
protoOf(ProgramBuilderDefault).key = get_v_Col;
protoOf(ProgramBuilderDefault).vey = get_t_Temp0;
protoOf(ProgramBuilderDefault).hf1 = get_t_Temp1;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.eey, VOID, [IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy.hfb);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog.bfc);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint.rfb);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForClass(Gen, 'Gen');
initMetadataForCompanion(Companion_45);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForCompanion(Companion_46);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForCompanion(Companion_47);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).sff = precToString;
protoOf(GlslGenerator).tff = typeToString;
protoOf(GlslGenerator).uff = get_arrayDecl;
protoOf(GlslGenerator).rff = get_IN;
protoOf(GlslGenerator).wff = get_OUT;
protoOf(GlslGenerator).vff = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(GlslConfig, 'GlslConfig');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
protoOf(GlslBodyGenerator).tff = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).tey = texture2D;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).zez = pow;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).pey = get_lit;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).sey = get_1;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).uf0 = minus_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).xf0 = plus_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).ney = times;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).wey = div;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).gf1 = gt;
initMetadataForClass(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, VOID, VOID, [ExpressionBuilder]);
initMetadataForCompanion(Companion_49);
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForCompanion(Companion_50);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_51);
protoOf(KmlGl).geh = get_parentFeatures;
protoOf(KmlGl).heh = get_isUniformBuffersSupported;
protoOf(KmlGl).ieh = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KmlGlContext, 'KmlGlContext', VOID, VOID, [AutoCloseable]);
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_52);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForCompanion(Companion_53);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_54);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_55);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(AgCachedBuffer, 'AgCachedBuffer');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_56);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).dgb = get_windowToGlobalScaleAvg;
protoOf(Base).egb = get_globalToWindowScaleAvg;
protoOf(Base).fgb = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_58);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
initMetadataForObject(V2CallbackSupport, 'V2CallbackSupport');
protoOf(DEFAULT).wgc = get_devicePixelRatio;
protoOf(DEFAULT).xgc = get_pixelsPerInch;
protoOf(DEFAULT).ygc = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).hgc = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForCompanion(Companion_59);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForClass(GameWindow$continuousRenderMode$$inlined$observable$1);
protoOf(GameWindow).wgc = get_devicePixelRatio;
protoOf(GameWindow).xgc = get_pixelsPerInch;
protoOf(GameWindow).ygc = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).hgc = get_computedPixelRatio;
protoOf(GameWindow).ae = get;
protoOf(GameWindow).dp = fold;
protoOf(GameWindow).cp = minusKey;
protoOf(GameWindow).ep = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.ggj, VOID, [DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_60);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForClass(TextClipboardData, 'TextClipboardData');
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_61);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.ugj, VOID, [Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.jgj, VOID, [Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_62);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForCompanion(Companion_63);
initMetadataForClass(SDL, 'SDL', SDL.mgo);
initMetadataForClass(KmlGlOpenGL, 'KmlGlOpenGL', KmlGlOpenGL);
initMetadataForCompanion(Companion_64);
initMetadataForClass(OpenGL, 'OpenGL', OpenGL.qgu);
initMetadataForClass(SDLGameWindow$ag$1);
initMetadataForClass(SDLGameWindow, 'SDLGameWindow', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(Size3D, 'Size3D');
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.phf, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.iha, VOID, VOID, [0, 1]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.wh7, VOID, VOID, [1, 0]);
initMetadataForClass(DenoJsGameWindow, 'DenoJsGameWindow', DenoJsGameWindow.dhd, VOID, VOID, [1, 0]);
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
//endregion
//region block: init
Companion_instance_13 = new Companion_4();
Companion_instance_14 = new Companion_5();
Companion_instance_16 = new Companion_7();
Companion_instance_17 = new Companion_8();
Companion_instance_18 = new Companion_9();
Companion_instance_19 = new Companion_10();
Companion_instance_22 = new Companion_13();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_31 = new Companion_22();
Companion_instance_32 = new Companion_23();
AGFinish_instance = new AGFinish();
Companion_instance_49 = new Companion_40();
Companion_instance_53 = new Companion_44();
Companion_instance_55 = new Companion_46();
Companion_instance_59 = new Companion_50();
Companion_instance_60 = new Companion_51();
Companion_instance_61 = new Companion_52();
debugBmpFontOrNull = null;
Companion_instance_63 = new Companion_54();
Companion_instance_64 = new Companion_55();
DEFAULT_instance = new DEFAULT();
GLOBAL_CHECK_GL = false;
Companion_instance_71 = new Companion_62();
korgwJvmEngine = null;
Companion_instance_72 = new Companion_63();
Companion_instance_73 = new Companion_64();
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Size3D as Size3D,
};
export {
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo1zgbj1t8zikfh,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv as AGStencilOpFunc__withCompareMode$default_impl_rzbauvyc76n84yfp4k,
  AGStencilReference__withReadMask$default_impl_7mdffx as AGStencilReference__withReadMask$default_impl_7mdffxa0e2emtywmjh,
  AGStencilReference__withReferenceValue$default_impl_2trj0v as AGStencilReference__withReferenceValue$default_impl_2trj0v3agbr22op2t8g,
  AGStencilReference__withWriteMask$default_impl_b7j7b4 as AGStencilReference__withWriteMask$default_impl_b7j7b4hm1mwnctf37u,
  _AGColorMask___init__impl__j38ai8_0 as _AGColorMask___init__impl__j38ai82w30b7s8593rm,
  _AGColorMask___init__impl__j38ai8_1 as _AGColorMask___init__impl__j38ai82qe91ijdfrylk,
  AGColorMask__hashCode_impl_g9082f as AGColorMask__hashCode_impl_g9082f1zaksn33gbzdg,
  AGColorMask__toString_impl_5i5oqg as AGColorMask__toString_impl_5i5oqg10xq65e13pz30,
  AGCompareMode__inverted_impl_7xxk8m as AGCompareMode__inverted_impl_7xxk8ma7g7zt6g3nw5,
  AGCullFace__hashCode_impl_t4e5ur as AGCullFace__hashCode_impl_t4e5ur3uo5n0bzij5mg,
  AGCullFace__toString_impl_7d891w as AGCullFace__toString_impl_7d891w1jhxypgdz5p99,
  AGDrawType__hashCode_impl_ylaury as AGDrawType__hashCode_impl_ylaury1blp8g6ll0lbo,
  AGDrawType__toString_impl_eonaeb as AGDrawType__toString_impl_eonaebdd0n7y5vu3mm,
  AGStencilOpFunc__hashCode_impl_nopebb as AGStencilOpFunc__hashCode_impl_nopebb5539bqxl21c7,
  AGStencilOpFunc__toString_impl_pl8quy as AGStencilOpFunc__toString_impl_pl8quy3j4r6zq6vwdjv,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1u2ioolcor1me,
  AGStencilOpFunc__withEnabled_impl_mpcwmr as AGStencilOpFunc__withEnabled_impl_mpcwmr57jgxrqegp7r,
  AGStencilReference__hashCode_impl_52zufx as AGStencilReference__hashCode_impl_52zufxm053tcvjdifs,
  AGStencilReference__toString_impl_qu5r8s as AGStencilReference__toString_impl_qu5r8s2jilbrqjeg0uw,
  AGTextureUnitInfoArray__get_impl_xhvpef as AGTextureUnitInfoArray__get_impl_xhvpef1xgn39fbn1382,
  Companion_instance_19 as Companion_instance13unj2cvktx31,
  Companion_getInstance_22 as Companion_getInstance2l33cri3w6n7a,
  Companion_getInstance_33 as Companion_getInstance2zuktdr3slbid,
  Companion_instance_24 as Companion_instance3oj1nwe2awbwp,
  Companion_getInstance_15 as Companion_getInstance17vhopkgtvy8p,
  Companion_getInstance_16 as Companion_getInstance3hkuu8u35mryl,
  Companion_getInstance_17 as Companion_getInstance1e8yqc9bjwiaq,
  Companion_instance_17 as Companion_instance2rq2pzgkkg46w,
  Companion_instance_14 as Companion_instance2wc05lywres1,
  Companion_instance_16 as Companion_instance3hz0cj4x3xzg2,
  Companion_instance_18 as Companion_instance2no0g6htzdf80,
  Companion_getInstance_19 as Companion_getInstance13eln6edm6kap,
  Companion_getInstance_65 as Companion_getInstance2r3jwgds6cn6e,
  Companion_instance_53 as Companion_instancee8uibjhp9pv1,
  Companion_getInstance_45 as Companion_getInstancect9znwr3ou7n,
  Companion_getInstance_46 as Companion_getInstance32c4i1xfyu66k,
  Companion_getInstance_48 as Companion_getInstance17xx2usq1zl9n,
  Companion_getInstance_44 as Companion_getInstance13vwvgsvlnrt4,
  Companion_getInstance_41 as Companion_getInstance3jm093zk2b8vy,
  Companion_getInstance_47 as Companion_getInstance1zv0hzefhsdqw,
  Companion_getInstance_42 as Companion_getInstance235mak5rqifor,
  Companion_getInstance_43 as Companion_getInstance31zf32wjjcu7m,
  Companion_getInstance_40 as Companion_getInstance2h8aei8glh02n,
  ProjViewUB_getInstance as ProjViewUB_getInstance33tqqx5ip0jsm,
  DefaultShaders_getInstance as DefaultShaders_getInstance5rngqjolrj76,
  Companion_getInstance_69 as Companion_getInstance2ux5z7lx1e789,
  DefaultViewport_getInstance as DefaultViewport_getInstance1yi7see0bwoat,
  Companion_getInstance_72 as Companion_getInstance3szcobow9wmlz,
  SDFShaders_getInstance as SDFShaders_getInstance36frvn0k1jot,
  Companion_getInstance_74 as Companion_getInstance3nsxj9pk2lmwe,
  KorgeReload_getInstance as KorgeReload_getInstance24edc14rslav7,
  Companion_instance_61 as Companion_instance2vknezzs3nrp5,
  Companion_instance_71 as Companion_instancexdmb8g1de35k,
  CoroutineKey_getInstance as CoroutineKey_getInstance2zy7rqmvlms8,
  Key_A_getInstance as Key_A_getInstancetdikhj2xu69a,
  Key_BACKSPACE_getInstance as Key_BACKSPACE_getInstance2aui6g2v624ea,
  Key_B_getInstance as Key_B_getInstance3vqbr947ty93s,
  Key_DOWN_getInstance as Key_DOWN_getInstance3ax9ubgau4vvs,
  Key_F12_getInstance as Key_F12_getInstance3u37pwqnwwqw2,
  Key_F7_getInstance as Key_F7_getInstance34esru10opwar,
  Key_H_getInstance as Key_H_getInstancepl0m56eerxl9,
  Key_I_getInstance as Key_I_getInstance30f2ckkjb8q5o,
  Key_LEFT_getInstance as Key_LEFT_getInstance29zwyh1fmlq32,
  Key_L_getInstance as Key_L_getInstance2fxxzbm4b446d,
  Key_M_getInstance as Key_M_getInstance1yosu7g51o3lh,
  Key_N_getInstance as Key_N_getInstance2p8cnpwrjvt2i,
  Key_P_getInstance as Key_P_getInstance268wrcumhzni3,
  Key_Q_getInstance as Key_Q_getInstance2wl544h8onckd,
  Key_RIGHT_getInstance as Key_RIGHT_getInstance328pcefkf4k6z,
  Key_R_getInstance as Key_R_getInstance2u2y4f0iaj45e,
  Key_TAB_getInstance as Key_TAB_getInstance29pqd1wanq7uj,
  Key_UP_getInstance as Key_UP_getInstances4e142e2o5i8,
  Key_W_getInstance as Key_W_getInstancegb6gidgzz09l,
  Key_X_getInstance as Key_X_getInstance3858vbsixd1dp,
  Type_DOWN_getInstance as Type_DOWN_getInstance2fsfrrfnfdnkv,
  Type_TYPE_getInstance as Type_TYPE_getInstance1t3x0tyak50a5,
  Type_UP_getInstance as Type_UP_getInstance1jmusuq8uymiu,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2rob4difvxgbp,
  ScrollDeltaMode_LINE_getInstance as ScrollDeltaMode_LINE_getInstancehzvmxoik4o8m,
  ScrollDeltaMode_PIXEL_getInstance as ScrollDeltaMode_PIXEL_getInstancev6fz8gd6s4o9,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance399xdvliykbx6,
  Type_DRAG_getInstance as Type_DRAG_getInstance12o3o4jlcpnyg,
  Type_UP_getInstance_0 as Type_UP_getInstance1o1bb50fkh1c5,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance1jabstzrk0ec6,
  Status_ADD_getInstance as Status_ADD_getInstance2usauldltvrb6,
  Status_KEEP_getInstance as Status_KEEP_getInstance159wlrdco02qg,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance1xhwemaqv4oj4,
  Type_END_getInstance as Type_END_getInstance3eao74sd1qd1b,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstance7m6d8mwpvzbf,
  Type_START_getInstance as Type_START_getInstance2e0jinmwna1tz,
  Precision_MEDIUM_getInstance as Precision_MEDIUM_getInstance359tjdlsi6b5f,
  VarType_Float1_getInstance as VarType_Float1_getInstance3muhdxpni8m3z,
  VarType_Float2_getInstance as VarType_Float2_getInstance2zfvb5etur38n,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstance2mvsp8zxmuifx,
  Cursor_HAND_getInstance as Cursor_HAND_getInstance1fp92l7zmq1m4,
  Cursor_TEXT_getInstance as Cursor_TEXT_getInstance1jekov1zaao91,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstancewqiidhb1r9s,
  Quality_QUALITY_getInstance as Quality_QUALITY_getInstance2y19g1gn64f0j,
  debugBmpFont as debugBmpFont3k115pzz5m7bj,
  configureLoggerFromProperties as configureLoggerFromPropertiesu0dqbv9031m1,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  ISoftKeyboardConfig as ISoftKeyboardConfige7b4czi6ukd7,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  SoftKeyboardConfig as SoftKeyboardConfig3ue4h4egpkqhq,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  AGPrint as AGPrint2do8iynklt71b,
  Attribute as Attribute3obvnbxr5w4xd,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  If as If1av5krmfyt44s,
  ProgramLayout as ProgramLayout373hh4xkth3qt,
  Program as Program1hnygp9hph4ry,
  Shader as Shader39o79ur9unxav,
  UniformBlockBuffer as UniformBlockBuffer2p2oao2ic417b,
  UniformBlock as UniformBlock2qoqszhm3r9i2,
  Varying as Varying105nnu9x9j75f,
  VertexShader as VertexShader26kcg39ndf3s1,
  AGBatch as AGBatch2bse24318tbhc,
  AGColorMask as AGColorMaskwqd86t1dhpnk,
  AGCullFace as AGCullFaceff7di2v9k2ne,
  AGDrawType as AGDrawType11vxw4gf0yugk,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AGStencilOpFunc as AGStencilOpFunc1juigl5mvjr07,
  AGStencilReference as AGStencilReference8at184sv64zi,
  AGTextureUnits as AGTextureUnits3k80ikbk5qbv9,
  AGVertexArrayObject as AGVertexArrayObjectp6l6cor3jhq8,
  AGVertexData as AGVertexDatawn78bdwnwjab,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  applyMatrixBounds as applyMatrixBounds3j13fpymjibm6,
  draw_0 as drawfyi5eaogony1,
  draw as draw3n7i8s75fp58g,
  plus_5 as plus3tmekjwnqrsa6,
  readColor as readColor21xoh99px3uyk,
  toAGScissor as toAGScissor50oxbqy8vpfx,
  drawText as drawText2ld6eqw3mc9xd,
  Input as Input3ljaq07eyi73v,
  AgCachedBuffer as AgCachedBuffer8k1i505isl6b,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TextureBase as TextureBase31xvoisoo1pp7,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture_0 as Texture2obedkmljq67n,
  Texture as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  Stats as Statslnkcsgem8jjl,
  V2Callback as V2Callback2d6dtckx13wqz,
  V2 as V22su20mpwty0v0,
  _interpolateAngle as _interpolateAngle308nqn33qn9pa,
  _interpolateColor as _interpolateColor3ps0kri0tazz4,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  _interpolate as _interpolated0idy8l9id9j,
  get_2 as get180k0um3w6tn5,
  get_3 as getz0kndyh9g55h,
  get_4 as gettu4yrnc3vnyf,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  TextClipboardData as TextClipboardDatafimoftc14pmm,
  configure as configure1a7py4k2lj4vi,
};
//endregion
